/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> }
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never
}
export type Incremental<T> =
  T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  bigint: { input: number; output: number }
  bytea: { input: any; output: any }
  citext: { input: any; output: any }
  date: { input: string; output: string }
  jsonb: { input: unknown; output: unknown }
  timestamptz: { input: string; output: string }
  uuid: { input: string; output: string }
}

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']['input']>
  _gt?: InputMaybe<Scalars['Boolean']['input']>
  _gte?: InputMaybe<Scalars['Boolean']['input']>
  _in?: InputMaybe<Array<Scalars['Boolean']['input']>>
  _is_null?: InputMaybe<Scalars['Boolean']['input']>
  _lt?: InputMaybe<Scalars['Boolean']['input']>
  _lte?: InputMaybe<Scalars['Boolean']['input']>
  _neq?: InputMaybe<Scalars['Boolean']['input']>
  _nin?: InputMaybe<Array<Scalars['Boolean']['input']>>
}

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']['input']>
  _gt?: InputMaybe<Scalars['Int']['input']>
  _gte?: InputMaybe<Scalars['Int']['input']>
  _in?: InputMaybe<Array<Scalars['Int']['input']>>
  _is_null?: InputMaybe<Scalars['Boolean']['input']>
  _lt?: InputMaybe<Scalars['Int']['input']>
  _lte?: InputMaybe<Scalars['Int']['input']>
  _neq?: InputMaybe<Scalars['Int']['input']>
  _nin?: InputMaybe<Array<Scalars['Int']['input']>>
}

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Array_Comparison_Exp = {
  /** is the array contained in the given array value */
  _contained_in?: InputMaybe<Array<Scalars['String']['input']>>
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['String']['input']>>
  _eq?: InputMaybe<Array<Scalars['String']['input']>>
  _gt?: InputMaybe<Array<Scalars['String']['input']>>
  _gte?: InputMaybe<Array<Scalars['String']['input']>>
  _in?: InputMaybe<Array<Array<Scalars['String']['input']>>>
  _is_null?: InputMaybe<Scalars['Boolean']['input']>
  _lt?: InputMaybe<Array<Scalars['String']['input']>>
  _lte?: InputMaybe<Array<Scalars['String']['input']>>
  _neq?: InputMaybe<Array<Scalars['String']['input']>>
  _nin?: InputMaybe<Array<Array<Scalars['String']['input']>>>
}

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']['input']>
  _gt?: InputMaybe<Scalars['String']['input']>
  _gte?: InputMaybe<Scalars['String']['input']>
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']['input']>
  _in?: InputMaybe<Array<Scalars['String']['input']>>
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']['input']>
  _is_null?: InputMaybe<Scalars['Boolean']['input']>
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']['input']>
  _lt?: InputMaybe<Scalars['String']['input']>
  _lte?: InputMaybe<Scalars['String']['input']>
  _neq?: InputMaybe<Scalars['String']['input']>
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']['input']>
  _nin?: InputMaybe<Array<Scalars['String']['input']>>
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']['input']>
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']['input']>
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']['input']>
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']['input']>
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']['input']>
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']['input']>
}

/** columns and relationships of "appointments" */
export type Appointments = {
  __typename?: 'appointments'
  /** An array relationship */
  connected_patients: Array<User_Profiles>
  /** An aggregate relationship */
  connected_patients_aggregate: User_Profiles_Aggregate
  created_at: Scalars['timestamptz']['output']
  end_time: Scalars['timestamptz']['output']
  id: Scalars['uuid']['output']
  patient_user_id?: Maybe<Scalars['uuid']['output']>
  start_time: Scalars['timestamptz']['output']
  user_id: Scalars['uuid']['output']
}

/** columns and relationships of "appointments" */
export type AppointmentsConnected_PatientsArgs = {
  distinct_on?: InputMaybe<Array<User_Profiles_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<User_Profiles_Order_By>>
  where?: InputMaybe<User_Profiles_Bool_Exp>
}

/** columns and relationships of "appointments" */
export type AppointmentsConnected_Patients_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Profiles_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<User_Profiles_Order_By>>
  where?: InputMaybe<User_Profiles_Bool_Exp>
}

/** aggregated selection of "appointments" */
export type Appointments_Aggregate = {
  __typename?: 'appointments_aggregate'
  aggregate?: Maybe<Appointments_Aggregate_Fields>
  nodes: Array<Appointments>
}

/** aggregate fields of "appointments" */
export type Appointments_Aggregate_Fields = {
  __typename?: 'appointments_aggregate_fields'
  count: Scalars['Int']['output']
  max?: Maybe<Appointments_Max_Fields>
  min?: Maybe<Appointments_Min_Fields>
}

/** aggregate fields of "appointments" */
export type Appointments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Appointments_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** Boolean expression to filter rows from the table "appointments". All fields are combined with a logical 'AND'. */
export type Appointments_Bool_Exp = {
  _and?: InputMaybe<Array<Appointments_Bool_Exp>>
  _not?: InputMaybe<Appointments_Bool_Exp>
  _or?: InputMaybe<Array<Appointments_Bool_Exp>>
  connected_patients?: InputMaybe<User_Profiles_Bool_Exp>
  connected_patients_aggregate?: InputMaybe<User_Profiles_Aggregate_Bool_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  end_time?: InputMaybe<Timestamptz_Comparison_Exp>
  id?: InputMaybe<Uuid_Comparison_Exp>
  patient_user_id?: InputMaybe<Uuid_Comparison_Exp>
  start_time?: InputMaybe<Timestamptz_Comparison_Exp>
  user_id?: InputMaybe<Uuid_Comparison_Exp>
}

/** unique or primary key constraints on table "appointments" */
export enum Appointments_Constraint {
  /** unique or primary key constraint on columns "id" */
  AppointmentsPkey = 'appointments_pkey',
}

/** input type for inserting data into table "appointments" */
export type Appointments_Insert_Input = {
  connected_patients?: InputMaybe<User_Profiles_Arr_Rel_Insert_Input>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  end_time?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  patient_user_id?: InputMaybe<Scalars['uuid']['input']>
  start_time?: InputMaybe<Scalars['timestamptz']['input']>
  user_id?: InputMaybe<Scalars['uuid']['input']>
}

/** aggregate max on columns */
export type Appointments_Max_Fields = {
  __typename?: 'appointments_max_fields'
  created_at?: Maybe<Scalars['timestamptz']['output']>
  end_time?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['uuid']['output']>
  patient_user_id?: Maybe<Scalars['uuid']['output']>
  start_time?: Maybe<Scalars['timestamptz']['output']>
  user_id?: Maybe<Scalars['uuid']['output']>
}

/** aggregate min on columns */
export type Appointments_Min_Fields = {
  __typename?: 'appointments_min_fields'
  created_at?: Maybe<Scalars['timestamptz']['output']>
  end_time?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['uuid']['output']>
  patient_user_id?: Maybe<Scalars['uuid']['output']>
  start_time?: Maybe<Scalars['timestamptz']['output']>
  user_id?: Maybe<Scalars['uuid']['output']>
}

/** response of any mutation on the table "appointments" */
export type Appointments_Mutation_Response = {
  __typename?: 'appointments_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Appointments>
}

/** on_conflict condition type for table "appointments" */
export type Appointments_On_Conflict = {
  constraint: Appointments_Constraint
  update_columns?: Array<Appointments_Update_Column>
  where?: InputMaybe<Appointments_Bool_Exp>
}

/** Ordering options when selecting data from "appointments". */
export type Appointments_Order_By = {
  connected_patients_aggregate?: InputMaybe<User_Profiles_Aggregate_Order_By>
  created_at?: InputMaybe<Order_By>
  end_time?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  patient_user_id?: InputMaybe<Order_By>
  start_time?: InputMaybe<Order_By>
  user_id?: InputMaybe<Order_By>
}

/** primary key columns input for table: appointments */
export type Appointments_Pk_Columns_Input = {
  id: Scalars['uuid']['input']
}

/** select columns of table "appointments" */
export enum Appointments_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndTime = 'end_time',
  /** column name */
  Id = 'id',
  /** column name */
  PatientUserId = 'patient_user_id',
  /** column name */
  StartTime = 'start_time',
  /** column name */
  UserId = 'user_id',
}

/** input type for updating data in table "appointments" */
export type Appointments_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  end_time?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  patient_user_id?: InputMaybe<Scalars['uuid']['input']>
  start_time?: InputMaybe<Scalars['timestamptz']['input']>
  user_id?: InputMaybe<Scalars['uuid']['input']>
}

/** Streaming cursor of the table "appointments" */
export type Appointments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Appointments_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Appointments_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  end_time?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  patient_user_id?: InputMaybe<Scalars['uuid']['input']>
  start_time?: InputMaybe<Scalars['timestamptz']['input']>
  user_id?: InputMaybe<Scalars['uuid']['input']>
}

/** update columns of table "appointments" */
export enum Appointments_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndTime = 'end_time',
  /** column name */
  Id = 'id',
  /** column name */
  PatientUserId = 'patient_user_id',
  /** column name */
  StartTime = 'start_time',
  /** column name */
  UserId = 'user_id',
}

export type Appointments_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Appointments_Set_Input>
  /** filter the rows which have to be updated */
  where: Appointments_Bool_Exp
}

/** columns and relationships of "article_progress" */
export type Article_Progress = {
  __typename?: 'article_progress'
  article_slug: Scalars['String']['output']
  chapter_slug: Scalars['String']['output']
  completed_at: Scalars['timestamptz']['output']
  id: Scalars['uuid']['output']
  user_id: Scalars['uuid']['output']
}

/** aggregated selection of "article_progress" */
export type Article_Progress_Aggregate = {
  __typename?: 'article_progress_aggregate'
  aggregate?: Maybe<Article_Progress_Aggregate_Fields>
  nodes: Array<Article_Progress>
}

/** aggregate fields of "article_progress" */
export type Article_Progress_Aggregate_Fields = {
  __typename?: 'article_progress_aggregate_fields'
  count: Scalars['Int']['output']
  max?: Maybe<Article_Progress_Max_Fields>
  min?: Maybe<Article_Progress_Min_Fields>
}

/** aggregate fields of "article_progress" */
export type Article_Progress_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Article_Progress_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** Boolean expression to filter rows from the table "article_progress". All fields are combined with a logical 'AND'. */
export type Article_Progress_Bool_Exp = {
  _and?: InputMaybe<Array<Article_Progress_Bool_Exp>>
  _not?: InputMaybe<Article_Progress_Bool_Exp>
  _or?: InputMaybe<Array<Article_Progress_Bool_Exp>>
  article_slug?: InputMaybe<String_Comparison_Exp>
  chapter_slug?: InputMaybe<String_Comparison_Exp>
  completed_at?: InputMaybe<Timestamptz_Comparison_Exp>
  id?: InputMaybe<Uuid_Comparison_Exp>
  user_id?: InputMaybe<Uuid_Comparison_Exp>
}

/** unique or primary key constraints on table "article_progress" */
export enum Article_Progress_Constraint {
  /** unique or primary key constraint on columns "id" */
  ArticleProgressPkey = 'article_progress_pkey',
  /** unique or primary key constraint on columns "user_id", "article_slug" */
  ArticleProgressUserIdArticleSlugKey = 'article_progress_user_id_article_slug_key',
}

/** input type for inserting data into table "article_progress" */
export type Article_Progress_Insert_Input = {
  article_slug?: InputMaybe<Scalars['String']['input']>
  chapter_slug?: InputMaybe<Scalars['String']['input']>
  completed_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  user_id?: InputMaybe<Scalars['uuid']['input']>
}

/** aggregate max on columns */
export type Article_Progress_Max_Fields = {
  __typename?: 'article_progress_max_fields'
  article_slug?: Maybe<Scalars['String']['output']>
  chapter_slug?: Maybe<Scalars['String']['output']>
  completed_at?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['uuid']['output']>
  user_id?: Maybe<Scalars['uuid']['output']>
}

/** aggregate min on columns */
export type Article_Progress_Min_Fields = {
  __typename?: 'article_progress_min_fields'
  article_slug?: Maybe<Scalars['String']['output']>
  chapter_slug?: Maybe<Scalars['String']['output']>
  completed_at?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['uuid']['output']>
  user_id?: Maybe<Scalars['uuid']['output']>
}

/** response of any mutation on the table "article_progress" */
export type Article_Progress_Mutation_Response = {
  __typename?: 'article_progress_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Article_Progress>
}

/** on_conflict condition type for table "article_progress" */
export type Article_Progress_On_Conflict = {
  constraint: Article_Progress_Constraint
  update_columns?: Array<Article_Progress_Update_Column>
  where?: InputMaybe<Article_Progress_Bool_Exp>
}

/** Ordering options when selecting data from "article_progress". */
export type Article_Progress_Order_By = {
  article_slug?: InputMaybe<Order_By>
  chapter_slug?: InputMaybe<Order_By>
  completed_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  user_id?: InputMaybe<Order_By>
}

/** primary key columns input for table: article_progress */
export type Article_Progress_Pk_Columns_Input = {
  id: Scalars['uuid']['input']
}

/** select columns of table "article_progress" */
export enum Article_Progress_Select_Column {
  /** column name */
  ArticleSlug = 'article_slug',
  /** column name */
  ChapterSlug = 'chapter_slug',
  /** column name */
  CompletedAt = 'completed_at',
  /** column name */
  Id = 'id',
  /** column name */
  UserId = 'user_id',
}

/** input type for updating data in table "article_progress" */
export type Article_Progress_Set_Input = {
  article_slug?: InputMaybe<Scalars['String']['input']>
  chapter_slug?: InputMaybe<Scalars['String']['input']>
  completed_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  user_id?: InputMaybe<Scalars['uuid']['input']>
}

/** Streaming cursor of the table "article_progress" */
export type Article_Progress_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Article_Progress_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Article_Progress_Stream_Cursor_Value_Input = {
  article_slug?: InputMaybe<Scalars['String']['input']>
  chapter_slug?: InputMaybe<Scalars['String']['input']>
  completed_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  user_id?: InputMaybe<Scalars['uuid']['input']>
}

/** update columns of table "article_progress" */
export enum Article_Progress_Update_Column {
  /** column name */
  ArticleSlug = 'article_slug',
  /** column name */
  ChapterSlug = 'chapter_slug',
  /** column name */
  CompletedAt = 'completed_at',
  /** column name */
  Id = 'id',
  /** column name */
  UserId = 'user_id',
}

export type Article_Progress_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Article_Progress_Set_Input>
  /** filter the rows which have to be updated */
  where: Article_Progress_Bool_Exp
}

/** columns and relationships of "article_sections" */
export type Article_Sections = {
  __typename?: 'article_sections'
  /** An object relationship */
  article: Articles
  article_id: Scalars['uuid']['output']
  audio?: Maybe<Scalars['uuid']['output']>
  content_markdown?: Maybe<Scalars['String']['output']>
  created_at: Scalars['timestamptz']['output']
  duration?: Maybe<Scalars['Int']['output']>
  id: Scalars['uuid']['output']
  images: Scalars['jsonb']['output']
  position: Scalars['Int']['output']
  section_type: Scalars['String']['output']
  topic?: Maybe<Scalars['String']['output']>
}

/** columns and relationships of "article_sections" */
export type Article_SectionsImagesArgs = {
  path?: InputMaybe<Scalars['String']['input']>
}

/** aggregated selection of "article_sections" */
export type Article_Sections_Aggregate = {
  __typename?: 'article_sections_aggregate'
  aggregate?: Maybe<Article_Sections_Aggregate_Fields>
  nodes: Array<Article_Sections>
}

export type Article_Sections_Aggregate_Bool_Exp = {
  count?: InputMaybe<Article_Sections_Aggregate_Bool_Exp_Count>
}

export type Article_Sections_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Article_Sections_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Article_Sections_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "article_sections" */
export type Article_Sections_Aggregate_Fields = {
  __typename?: 'article_sections_aggregate_fields'
  avg?: Maybe<Article_Sections_Avg_Fields>
  count: Scalars['Int']['output']
  max?: Maybe<Article_Sections_Max_Fields>
  min?: Maybe<Article_Sections_Min_Fields>
  stddev?: Maybe<Article_Sections_Stddev_Fields>
  stddev_pop?: Maybe<Article_Sections_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Article_Sections_Stddev_Samp_Fields>
  sum?: Maybe<Article_Sections_Sum_Fields>
  var_pop?: Maybe<Article_Sections_Var_Pop_Fields>
  var_samp?: Maybe<Article_Sections_Var_Samp_Fields>
  variance?: Maybe<Article_Sections_Variance_Fields>
}

/** aggregate fields of "article_sections" */
export type Article_Sections_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Article_Sections_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** order by aggregate values of table "article_sections" */
export type Article_Sections_Aggregate_Order_By = {
  avg?: InputMaybe<Article_Sections_Avg_Order_By>
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Article_Sections_Max_Order_By>
  min?: InputMaybe<Article_Sections_Min_Order_By>
  stddev?: InputMaybe<Article_Sections_Stddev_Order_By>
  stddev_pop?: InputMaybe<Article_Sections_Stddev_Pop_Order_By>
  stddev_samp?: InputMaybe<Article_Sections_Stddev_Samp_Order_By>
  sum?: InputMaybe<Article_Sections_Sum_Order_By>
  var_pop?: InputMaybe<Article_Sections_Var_Pop_Order_By>
  var_samp?: InputMaybe<Article_Sections_Var_Samp_Order_By>
  variance?: InputMaybe<Article_Sections_Variance_Order_By>
}

/** append existing jsonb value of filtered columns with new jsonb value */
export type Article_Sections_Append_Input = {
  images?: InputMaybe<Scalars['jsonb']['input']>
}

/** input type for inserting array relation for remote table "article_sections" */
export type Article_Sections_Arr_Rel_Insert_Input = {
  data: Array<Article_Sections_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Article_Sections_On_Conflict>
}

/** aggregate avg on columns */
export type Article_Sections_Avg_Fields = {
  __typename?: 'article_sections_avg_fields'
  duration?: Maybe<Scalars['Float']['output']>
  position?: Maybe<Scalars['Float']['output']>
}

/** order by avg() on columns of table "article_sections" */
export type Article_Sections_Avg_Order_By = {
  duration?: InputMaybe<Order_By>
  position?: InputMaybe<Order_By>
}

/** Boolean expression to filter rows from the table "article_sections". All fields are combined with a logical 'AND'. */
export type Article_Sections_Bool_Exp = {
  _and?: InputMaybe<Array<Article_Sections_Bool_Exp>>
  _not?: InputMaybe<Article_Sections_Bool_Exp>
  _or?: InputMaybe<Array<Article_Sections_Bool_Exp>>
  article?: InputMaybe<Articles_Bool_Exp>
  article_id?: InputMaybe<Uuid_Comparison_Exp>
  audio?: InputMaybe<Uuid_Comparison_Exp>
  content_markdown?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  duration?: InputMaybe<Int_Comparison_Exp>
  id?: InputMaybe<Uuid_Comparison_Exp>
  images?: InputMaybe<Jsonb_Comparison_Exp>
  position?: InputMaybe<Int_Comparison_Exp>
  section_type?: InputMaybe<String_Comparison_Exp>
  topic?: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "article_sections" */
export enum Article_Sections_Constraint {
  /** unique or primary key constraint on columns "topic", "article_id" */
  ArticleSectionsArticleIdTopicKey = 'article_sections_article_id_topic_key',
  /** unique or primary key constraint on columns "id" */
  ArticleSectionsPkey = 'article_sections_pkey',
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Article_Sections_Delete_At_Path_Input = {
  images?: InputMaybe<Array<Scalars['String']['input']>>
}

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Article_Sections_Delete_Elem_Input = {
  images?: InputMaybe<Scalars['Int']['input']>
}

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Article_Sections_Delete_Key_Input = {
  images?: InputMaybe<Scalars['String']['input']>
}

/** input type for incrementing numeric columns in table "article_sections" */
export type Article_Sections_Inc_Input = {
  duration?: InputMaybe<Scalars['Int']['input']>
  position?: InputMaybe<Scalars['Int']['input']>
}

/** input type for inserting data into table "article_sections" */
export type Article_Sections_Insert_Input = {
  article?: InputMaybe<Articles_Obj_Rel_Insert_Input>
  article_id?: InputMaybe<Scalars['uuid']['input']>
  audio?: InputMaybe<Scalars['uuid']['input']>
  content_markdown?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  duration?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  images?: InputMaybe<Scalars['jsonb']['input']>
  position?: InputMaybe<Scalars['Int']['input']>
  section_type?: InputMaybe<Scalars['String']['input']>
  topic?: InputMaybe<Scalars['String']['input']>
}

/** aggregate max on columns */
export type Article_Sections_Max_Fields = {
  __typename?: 'article_sections_max_fields'
  article_id?: Maybe<Scalars['uuid']['output']>
  audio?: Maybe<Scalars['uuid']['output']>
  content_markdown?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  duration?: Maybe<Scalars['Int']['output']>
  id?: Maybe<Scalars['uuid']['output']>
  position?: Maybe<Scalars['Int']['output']>
  section_type?: Maybe<Scalars['String']['output']>
  topic?: Maybe<Scalars['String']['output']>
}

/** order by max() on columns of table "article_sections" */
export type Article_Sections_Max_Order_By = {
  article_id?: InputMaybe<Order_By>
  audio?: InputMaybe<Order_By>
  content_markdown?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  duration?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  position?: InputMaybe<Order_By>
  section_type?: InputMaybe<Order_By>
  topic?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Article_Sections_Min_Fields = {
  __typename?: 'article_sections_min_fields'
  article_id?: Maybe<Scalars['uuid']['output']>
  audio?: Maybe<Scalars['uuid']['output']>
  content_markdown?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  duration?: Maybe<Scalars['Int']['output']>
  id?: Maybe<Scalars['uuid']['output']>
  position?: Maybe<Scalars['Int']['output']>
  section_type?: Maybe<Scalars['String']['output']>
  topic?: Maybe<Scalars['String']['output']>
}

/** order by min() on columns of table "article_sections" */
export type Article_Sections_Min_Order_By = {
  article_id?: InputMaybe<Order_By>
  audio?: InputMaybe<Order_By>
  content_markdown?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  duration?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  position?: InputMaybe<Order_By>
  section_type?: InputMaybe<Order_By>
  topic?: InputMaybe<Order_By>
}

/** response of any mutation on the table "article_sections" */
export type Article_Sections_Mutation_Response = {
  __typename?: 'article_sections_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Article_Sections>
}

/** on_conflict condition type for table "article_sections" */
export type Article_Sections_On_Conflict = {
  constraint: Article_Sections_Constraint
  update_columns?: Array<Article_Sections_Update_Column>
  where?: InputMaybe<Article_Sections_Bool_Exp>
}

/** Ordering options when selecting data from "article_sections". */
export type Article_Sections_Order_By = {
  article?: InputMaybe<Articles_Order_By>
  article_id?: InputMaybe<Order_By>
  audio?: InputMaybe<Order_By>
  content_markdown?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  duration?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  images?: InputMaybe<Order_By>
  position?: InputMaybe<Order_By>
  section_type?: InputMaybe<Order_By>
  topic?: InputMaybe<Order_By>
}

/** primary key columns input for table: article_sections */
export type Article_Sections_Pk_Columns_Input = {
  id: Scalars['uuid']['input']
}

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Article_Sections_Prepend_Input = {
  images?: InputMaybe<Scalars['jsonb']['input']>
}

/** select columns of table "article_sections" */
export enum Article_Sections_Select_Column {
  /** column name */
  ArticleId = 'article_id',
  /** column name */
  Audio = 'audio',
  /** column name */
  ContentMarkdown = 'content_markdown',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Duration = 'duration',
  /** column name */
  Id = 'id',
  /** column name */
  Images = 'images',
  /** column name */
  Position = 'position',
  /** column name */
  SectionType = 'section_type',
  /** column name */
  Topic = 'topic',
}

/** input type for updating data in table "article_sections" */
export type Article_Sections_Set_Input = {
  article_id?: InputMaybe<Scalars['uuid']['input']>
  audio?: InputMaybe<Scalars['uuid']['input']>
  content_markdown?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  duration?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  images?: InputMaybe<Scalars['jsonb']['input']>
  position?: InputMaybe<Scalars['Int']['input']>
  section_type?: InputMaybe<Scalars['String']['input']>
  topic?: InputMaybe<Scalars['String']['input']>
}

/** aggregate stddev on columns */
export type Article_Sections_Stddev_Fields = {
  __typename?: 'article_sections_stddev_fields'
  duration?: Maybe<Scalars['Float']['output']>
  position?: Maybe<Scalars['Float']['output']>
}

/** order by stddev() on columns of table "article_sections" */
export type Article_Sections_Stddev_Order_By = {
  duration?: InputMaybe<Order_By>
  position?: InputMaybe<Order_By>
}

/** aggregate stddev_pop on columns */
export type Article_Sections_Stddev_Pop_Fields = {
  __typename?: 'article_sections_stddev_pop_fields'
  duration?: Maybe<Scalars['Float']['output']>
  position?: Maybe<Scalars['Float']['output']>
}

/** order by stddev_pop() on columns of table "article_sections" */
export type Article_Sections_Stddev_Pop_Order_By = {
  duration?: InputMaybe<Order_By>
  position?: InputMaybe<Order_By>
}

/** aggregate stddev_samp on columns */
export type Article_Sections_Stddev_Samp_Fields = {
  __typename?: 'article_sections_stddev_samp_fields'
  duration?: Maybe<Scalars['Float']['output']>
  position?: Maybe<Scalars['Float']['output']>
}

/** order by stddev_samp() on columns of table "article_sections" */
export type Article_Sections_Stddev_Samp_Order_By = {
  duration?: InputMaybe<Order_By>
  position?: InputMaybe<Order_By>
}

/** Streaming cursor of the table "article_sections" */
export type Article_Sections_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Article_Sections_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Article_Sections_Stream_Cursor_Value_Input = {
  article_id?: InputMaybe<Scalars['uuid']['input']>
  audio?: InputMaybe<Scalars['uuid']['input']>
  content_markdown?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  duration?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  images?: InputMaybe<Scalars['jsonb']['input']>
  position?: InputMaybe<Scalars['Int']['input']>
  section_type?: InputMaybe<Scalars['String']['input']>
  topic?: InputMaybe<Scalars['String']['input']>
}

/** aggregate sum on columns */
export type Article_Sections_Sum_Fields = {
  __typename?: 'article_sections_sum_fields'
  duration?: Maybe<Scalars['Int']['output']>
  position?: Maybe<Scalars['Int']['output']>
}

/** order by sum() on columns of table "article_sections" */
export type Article_Sections_Sum_Order_By = {
  duration?: InputMaybe<Order_By>
  position?: InputMaybe<Order_By>
}

/** update columns of table "article_sections" */
export enum Article_Sections_Update_Column {
  /** column name */
  ArticleId = 'article_id',
  /** column name */
  Audio = 'audio',
  /** column name */
  ContentMarkdown = 'content_markdown',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Duration = 'duration',
  /** column name */
  Id = 'id',
  /** column name */
  Images = 'images',
  /** column name */
  Position = 'position',
  /** column name */
  SectionType = 'section_type',
  /** column name */
  Topic = 'topic',
}

export type Article_Sections_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Article_Sections_Append_Input>
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Article_Sections_Delete_At_Path_Input>
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Article_Sections_Delete_Elem_Input>
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Article_Sections_Delete_Key_Input>
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Article_Sections_Inc_Input>
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Article_Sections_Prepend_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Article_Sections_Set_Input>
  /** filter the rows which have to be updated */
  where: Article_Sections_Bool_Exp
}

/** aggregate var_pop on columns */
export type Article_Sections_Var_Pop_Fields = {
  __typename?: 'article_sections_var_pop_fields'
  duration?: Maybe<Scalars['Float']['output']>
  position?: Maybe<Scalars['Float']['output']>
}

/** order by var_pop() on columns of table "article_sections" */
export type Article_Sections_Var_Pop_Order_By = {
  duration?: InputMaybe<Order_By>
  position?: InputMaybe<Order_By>
}

/** aggregate var_samp on columns */
export type Article_Sections_Var_Samp_Fields = {
  __typename?: 'article_sections_var_samp_fields'
  duration?: Maybe<Scalars['Float']['output']>
  position?: Maybe<Scalars['Float']['output']>
}

/** order by var_samp() on columns of table "article_sections" */
export type Article_Sections_Var_Samp_Order_By = {
  duration?: InputMaybe<Order_By>
  position?: InputMaybe<Order_By>
}

/** aggregate variance on columns */
export type Article_Sections_Variance_Fields = {
  __typename?: 'article_sections_variance_fields'
  duration?: Maybe<Scalars['Float']['output']>
  position?: Maybe<Scalars['Float']['output']>
}

/** order by variance() on columns of table "article_sections" */
export type Article_Sections_Variance_Order_By = {
  duration?: InputMaybe<Order_By>
  position?: InputMaybe<Order_By>
}

/** columns and relationships of "articles" */
export type Articles = {
  __typename?: 'articles'
  article_position?: Maybe<Scalars['Int']['output']>
  audio?: Maybe<Scalars['uuid']['output']>
  /** An object relationship */
  chapter: Chapters
  chapter_slug: Scalars['String']['output']
  content_markdown: Scalars['String']['output']
  created_at: Scalars['timestamptz']['output']
  duration?: Maybe<Scalars['Int']['output']>
  hook?: Maybe<Scalars['String']['output']>
  id: Scalars['uuid']['output']
  image_alt?: Maybe<Scalars['String']['output']>
  image_id?: Maybe<Scalars['String']['output']>
  live: Scalars['Boolean']['output']
  /** An array relationship */
  sections: Array<Article_Sections>
  /** An aggregate relationship */
  sections_aggregate: Article_Sections_Aggregate
  slug: Scalars['String']['output']
  sources?: Maybe<Scalars['String']['output']>
  subtitle?: Maybe<Scalars['String']['output']>
  summary?: Maybe<Scalars['String']['output']>
  takeaway?: Maybe<Scalars['String']['output']>
  title: Scalars['String']['output']
}

/** columns and relationships of "articles" */
export type ArticlesSectionsArgs = {
  distinct_on?: InputMaybe<Array<Article_Sections_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Article_Sections_Order_By>>
  where?: InputMaybe<Article_Sections_Bool_Exp>
}

/** columns and relationships of "articles" */
export type ArticlesSections_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Sections_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Article_Sections_Order_By>>
  where?: InputMaybe<Article_Sections_Bool_Exp>
}

/** aggregated selection of "articles" */
export type Articles_Aggregate = {
  __typename?: 'articles_aggregate'
  aggregate?: Maybe<Articles_Aggregate_Fields>
  nodes: Array<Articles>
}

export type Articles_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Articles_Aggregate_Bool_Exp_Bool_And>
  bool_or?: InputMaybe<Articles_Aggregate_Bool_Exp_Bool_Or>
  count?: InputMaybe<Articles_Aggregate_Bool_Exp_Count>
}

export type Articles_Aggregate_Bool_Exp_Bool_And = {
  arguments: Articles_Select_Column_Articles_Aggregate_Bool_Exp_Bool_And_Arguments_Columns
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Articles_Bool_Exp>
  predicate: Boolean_Comparison_Exp
}

export type Articles_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Articles_Select_Column_Articles_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Articles_Bool_Exp>
  predicate: Boolean_Comparison_Exp
}

export type Articles_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Articles_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Articles_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "articles" */
export type Articles_Aggregate_Fields = {
  __typename?: 'articles_aggregate_fields'
  avg?: Maybe<Articles_Avg_Fields>
  count: Scalars['Int']['output']
  max?: Maybe<Articles_Max_Fields>
  min?: Maybe<Articles_Min_Fields>
  stddev?: Maybe<Articles_Stddev_Fields>
  stddev_pop?: Maybe<Articles_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Articles_Stddev_Samp_Fields>
  sum?: Maybe<Articles_Sum_Fields>
  var_pop?: Maybe<Articles_Var_Pop_Fields>
  var_samp?: Maybe<Articles_Var_Samp_Fields>
  variance?: Maybe<Articles_Variance_Fields>
}

/** aggregate fields of "articles" */
export type Articles_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Articles_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** order by aggregate values of table "articles" */
export type Articles_Aggregate_Order_By = {
  avg?: InputMaybe<Articles_Avg_Order_By>
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Articles_Max_Order_By>
  min?: InputMaybe<Articles_Min_Order_By>
  stddev?: InputMaybe<Articles_Stddev_Order_By>
  stddev_pop?: InputMaybe<Articles_Stddev_Pop_Order_By>
  stddev_samp?: InputMaybe<Articles_Stddev_Samp_Order_By>
  sum?: InputMaybe<Articles_Sum_Order_By>
  var_pop?: InputMaybe<Articles_Var_Pop_Order_By>
  var_samp?: InputMaybe<Articles_Var_Samp_Order_By>
  variance?: InputMaybe<Articles_Variance_Order_By>
}

/** input type for inserting array relation for remote table "articles" */
export type Articles_Arr_Rel_Insert_Input = {
  data: Array<Articles_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Articles_On_Conflict>
}

/** aggregate avg on columns */
export type Articles_Avg_Fields = {
  __typename?: 'articles_avg_fields'
  article_position?: Maybe<Scalars['Float']['output']>
  duration?: Maybe<Scalars['Float']['output']>
}

/** order by avg() on columns of table "articles" */
export type Articles_Avg_Order_By = {
  article_position?: InputMaybe<Order_By>
  duration?: InputMaybe<Order_By>
}

/** Boolean expression to filter rows from the table "articles". All fields are combined with a logical 'AND'. */
export type Articles_Bool_Exp = {
  _and?: InputMaybe<Array<Articles_Bool_Exp>>
  _not?: InputMaybe<Articles_Bool_Exp>
  _or?: InputMaybe<Array<Articles_Bool_Exp>>
  article_position?: InputMaybe<Int_Comparison_Exp>
  audio?: InputMaybe<Uuid_Comparison_Exp>
  chapter?: InputMaybe<Chapters_Bool_Exp>
  chapter_slug?: InputMaybe<String_Comparison_Exp>
  content_markdown?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  duration?: InputMaybe<Int_Comparison_Exp>
  hook?: InputMaybe<String_Comparison_Exp>
  id?: InputMaybe<Uuid_Comparison_Exp>
  image_alt?: InputMaybe<String_Comparison_Exp>
  image_id?: InputMaybe<String_Comparison_Exp>
  live?: InputMaybe<Boolean_Comparison_Exp>
  sections?: InputMaybe<Article_Sections_Bool_Exp>
  sections_aggregate?: InputMaybe<Article_Sections_Aggregate_Bool_Exp>
  slug?: InputMaybe<String_Comparison_Exp>
  sources?: InputMaybe<String_Comparison_Exp>
  subtitle?: InputMaybe<String_Comparison_Exp>
  summary?: InputMaybe<String_Comparison_Exp>
  takeaway?: InputMaybe<String_Comparison_Exp>
  title?: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "articles" */
export enum Articles_Constraint {
  /** unique or primary key constraint on columns "id" */
  ArticlesPkey = 'articles_pkey',
  /** unique or primary key constraint on columns "slug" */
  ArticlesSlugKey = 'articles_slug_key',
}

/** input type for incrementing numeric columns in table "articles" */
export type Articles_Inc_Input = {
  article_position?: InputMaybe<Scalars['Int']['input']>
  duration?: InputMaybe<Scalars['Int']['input']>
}

/** input type for inserting data into table "articles" */
export type Articles_Insert_Input = {
  article_position?: InputMaybe<Scalars['Int']['input']>
  audio?: InputMaybe<Scalars['uuid']['input']>
  chapter?: InputMaybe<Chapters_Obj_Rel_Insert_Input>
  chapter_slug?: InputMaybe<Scalars['String']['input']>
  content_markdown?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  duration?: InputMaybe<Scalars['Int']['input']>
  hook?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  image_alt?: InputMaybe<Scalars['String']['input']>
  image_id?: InputMaybe<Scalars['String']['input']>
  live?: InputMaybe<Scalars['Boolean']['input']>
  sections?: InputMaybe<Article_Sections_Arr_Rel_Insert_Input>
  slug?: InputMaybe<Scalars['String']['input']>
  sources?: InputMaybe<Scalars['String']['input']>
  subtitle?: InputMaybe<Scalars['String']['input']>
  summary?: InputMaybe<Scalars['String']['input']>
  takeaway?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

/** aggregate max on columns */
export type Articles_Max_Fields = {
  __typename?: 'articles_max_fields'
  article_position?: Maybe<Scalars['Int']['output']>
  audio?: Maybe<Scalars['uuid']['output']>
  chapter_slug?: Maybe<Scalars['String']['output']>
  content_markdown?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  duration?: Maybe<Scalars['Int']['output']>
  hook?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['uuid']['output']>
  image_alt?: Maybe<Scalars['String']['output']>
  image_id?: Maybe<Scalars['String']['output']>
  slug?: Maybe<Scalars['String']['output']>
  sources?: Maybe<Scalars['String']['output']>
  subtitle?: Maybe<Scalars['String']['output']>
  summary?: Maybe<Scalars['String']['output']>
  takeaway?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
}

/** order by max() on columns of table "articles" */
export type Articles_Max_Order_By = {
  article_position?: InputMaybe<Order_By>
  audio?: InputMaybe<Order_By>
  chapter_slug?: InputMaybe<Order_By>
  content_markdown?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  duration?: InputMaybe<Order_By>
  hook?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  image_alt?: InputMaybe<Order_By>
  image_id?: InputMaybe<Order_By>
  slug?: InputMaybe<Order_By>
  sources?: InputMaybe<Order_By>
  subtitle?: InputMaybe<Order_By>
  summary?: InputMaybe<Order_By>
  takeaway?: InputMaybe<Order_By>
  title?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Articles_Min_Fields = {
  __typename?: 'articles_min_fields'
  article_position?: Maybe<Scalars['Int']['output']>
  audio?: Maybe<Scalars['uuid']['output']>
  chapter_slug?: Maybe<Scalars['String']['output']>
  content_markdown?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  duration?: Maybe<Scalars['Int']['output']>
  hook?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['uuid']['output']>
  image_alt?: Maybe<Scalars['String']['output']>
  image_id?: Maybe<Scalars['String']['output']>
  slug?: Maybe<Scalars['String']['output']>
  sources?: Maybe<Scalars['String']['output']>
  subtitle?: Maybe<Scalars['String']['output']>
  summary?: Maybe<Scalars['String']['output']>
  takeaway?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
}

/** order by min() on columns of table "articles" */
export type Articles_Min_Order_By = {
  article_position?: InputMaybe<Order_By>
  audio?: InputMaybe<Order_By>
  chapter_slug?: InputMaybe<Order_By>
  content_markdown?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  duration?: InputMaybe<Order_By>
  hook?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  image_alt?: InputMaybe<Order_By>
  image_id?: InputMaybe<Order_By>
  slug?: InputMaybe<Order_By>
  sources?: InputMaybe<Order_By>
  subtitle?: InputMaybe<Order_By>
  summary?: InputMaybe<Order_By>
  takeaway?: InputMaybe<Order_By>
  title?: InputMaybe<Order_By>
}

/** response of any mutation on the table "articles" */
export type Articles_Mutation_Response = {
  __typename?: 'articles_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Articles>
}

/** input type for inserting object relation for remote table "articles" */
export type Articles_Obj_Rel_Insert_Input = {
  data: Articles_Insert_Input
  /** upsert condition */
  on_conflict?: InputMaybe<Articles_On_Conflict>
}

/** on_conflict condition type for table "articles" */
export type Articles_On_Conflict = {
  constraint: Articles_Constraint
  update_columns?: Array<Articles_Update_Column>
  where?: InputMaybe<Articles_Bool_Exp>
}

/** Ordering options when selecting data from "articles". */
export type Articles_Order_By = {
  article_position?: InputMaybe<Order_By>
  audio?: InputMaybe<Order_By>
  chapter?: InputMaybe<Chapters_Order_By>
  chapter_slug?: InputMaybe<Order_By>
  content_markdown?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  duration?: InputMaybe<Order_By>
  hook?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  image_alt?: InputMaybe<Order_By>
  image_id?: InputMaybe<Order_By>
  live?: InputMaybe<Order_By>
  sections_aggregate?: InputMaybe<Article_Sections_Aggregate_Order_By>
  slug?: InputMaybe<Order_By>
  sources?: InputMaybe<Order_By>
  subtitle?: InputMaybe<Order_By>
  summary?: InputMaybe<Order_By>
  takeaway?: InputMaybe<Order_By>
  title?: InputMaybe<Order_By>
}

/** primary key columns input for table: articles */
export type Articles_Pk_Columns_Input = {
  id: Scalars['uuid']['input']
}

/** select columns of table "articles" */
export enum Articles_Select_Column {
  /** column name */
  ArticlePosition = 'article_position',
  /** column name */
  Audio = 'audio',
  /** column name */
  ChapterSlug = 'chapter_slug',
  /** column name */
  ContentMarkdown = 'content_markdown',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Duration = 'duration',
  /** column name */
  Hook = 'hook',
  /** column name */
  Id = 'id',
  /** column name */
  ImageAlt = 'image_alt',
  /** column name */
  ImageId = 'image_id',
  /** column name */
  Live = 'live',
  /** column name */
  Slug = 'slug',
  /** column name */
  Sources = 'sources',
  /** column name */
  Subtitle = 'subtitle',
  /** column name */
  Summary = 'summary',
  /** column name */
  Takeaway = 'takeaway',
  /** column name */
  Title = 'title',
}

/** select "articles_aggregate_bool_exp_bool_and_arguments_columns" columns of table "articles" */
export enum Articles_Select_Column_Articles_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Live = 'live',
}

/** select "articles_aggregate_bool_exp_bool_or_arguments_columns" columns of table "articles" */
export enum Articles_Select_Column_Articles_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Live = 'live',
}

/** input type for updating data in table "articles" */
export type Articles_Set_Input = {
  article_position?: InputMaybe<Scalars['Int']['input']>
  audio?: InputMaybe<Scalars['uuid']['input']>
  chapter_slug?: InputMaybe<Scalars['String']['input']>
  content_markdown?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  duration?: InputMaybe<Scalars['Int']['input']>
  hook?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  image_alt?: InputMaybe<Scalars['String']['input']>
  image_id?: InputMaybe<Scalars['String']['input']>
  live?: InputMaybe<Scalars['Boolean']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  sources?: InputMaybe<Scalars['String']['input']>
  subtitle?: InputMaybe<Scalars['String']['input']>
  summary?: InputMaybe<Scalars['String']['input']>
  takeaway?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

/** aggregate stddev on columns */
export type Articles_Stddev_Fields = {
  __typename?: 'articles_stddev_fields'
  article_position?: Maybe<Scalars['Float']['output']>
  duration?: Maybe<Scalars['Float']['output']>
}

/** order by stddev() on columns of table "articles" */
export type Articles_Stddev_Order_By = {
  article_position?: InputMaybe<Order_By>
  duration?: InputMaybe<Order_By>
}

/** aggregate stddev_pop on columns */
export type Articles_Stddev_Pop_Fields = {
  __typename?: 'articles_stddev_pop_fields'
  article_position?: Maybe<Scalars['Float']['output']>
  duration?: Maybe<Scalars['Float']['output']>
}

/** order by stddev_pop() on columns of table "articles" */
export type Articles_Stddev_Pop_Order_By = {
  article_position?: InputMaybe<Order_By>
  duration?: InputMaybe<Order_By>
}

/** aggregate stddev_samp on columns */
export type Articles_Stddev_Samp_Fields = {
  __typename?: 'articles_stddev_samp_fields'
  article_position?: Maybe<Scalars['Float']['output']>
  duration?: Maybe<Scalars['Float']['output']>
}

/** order by stddev_samp() on columns of table "articles" */
export type Articles_Stddev_Samp_Order_By = {
  article_position?: InputMaybe<Order_By>
  duration?: InputMaybe<Order_By>
}

/** Streaming cursor of the table "articles" */
export type Articles_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Articles_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Articles_Stream_Cursor_Value_Input = {
  article_position?: InputMaybe<Scalars['Int']['input']>
  audio?: InputMaybe<Scalars['uuid']['input']>
  chapter_slug?: InputMaybe<Scalars['String']['input']>
  content_markdown?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  duration?: InputMaybe<Scalars['Int']['input']>
  hook?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  image_alt?: InputMaybe<Scalars['String']['input']>
  image_id?: InputMaybe<Scalars['String']['input']>
  live?: InputMaybe<Scalars['Boolean']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  sources?: InputMaybe<Scalars['String']['input']>
  subtitle?: InputMaybe<Scalars['String']['input']>
  summary?: InputMaybe<Scalars['String']['input']>
  takeaway?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

/** aggregate sum on columns */
export type Articles_Sum_Fields = {
  __typename?: 'articles_sum_fields'
  article_position?: Maybe<Scalars['Int']['output']>
  duration?: Maybe<Scalars['Int']['output']>
}

/** order by sum() on columns of table "articles" */
export type Articles_Sum_Order_By = {
  article_position?: InputMaybe<Order_By>
  duration?: InputMaybe<Order_By>
}

/** update columns of table "articles" */
export enum Articles_Update_Column {
  /** column name */
  ArticlePosition = 'article_position',
  /** column name */
  Audio = 'audio',
  /** column name */
  ChapterSlug = 'chapter_slug',
  /** column name */
  ContentMarkdown = 'content_markdown',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Duration = 'duration',
  /** column name */
  Hook = 'hook',
  /** column name */
  Id = 'id',
  /** column name */
  ImageAlt = 'image_alt',
  /** column name */
  ImageId = 'image_id',
  /** column name */
  Live = 'live',
  /** column name */
  Slug = 'slug',
  /** column name */
  Sources = 'sources',
  /** column name */
  Subtitle = 'subtitle',
  /** column name */
  Summary = 'summary',
  /** column name */
  Takeaway = 'takeaway',
  /** column name */
  Title = 'title',
}

export type Articles_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Articles_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Articles_Set_Input>
  /** filter the rows which have to be updated */
  where: Articles_Bool_Exp
}

/** aggregate var_pop on columns */
export type Articles_Var_Pop_Fields = {
  __typename?: 'articles_var_pop_fields'
  article_position?: Maybe<Scalars['Float']['output']>
  duration?: Maybe<Scalars['Float']['output']>
}

/** order by var_pop() on columns of table "articles" */
export type Articles_Var_Pop_Order_By = {
  article_position?: InputMaybe<Order_By>
  duration?: InputMaybe<Order_By>
}

/** aggregate var_samp on columns */
export type Articles_Var_Samp_Fields = {
  __typename?: 'articles_var_samp_fields'
  article_position?: Maybe<Scalars['Float']['output']>
  duration?: Maybe<Scalars['Float']['output']>
}

/** order by var_samp() on columns of table "articles" */
export type Articles_Var_Samp_Order_By = {
  article_position?: InputMaybe<Order_By>
  duration?: InputMaybe<Order_By>
}

/** aggregate variance on columns */
export type Articles_Variance_Fields = {
  __typename?: 'articles_variance_fields'
  article_position?: Maybe<Scalars['Float']['output']>
  duration?: Maybe<Scalars['Float']['output']>
}

/** order by variance() on columns of table "articles" */
export type Articles_Variance_Order_By = {
  article_position?: InputMaybe<Order_By>
  duration?: InputMaybe<Order_By>
}

/** In-flight OAuth2 authorization requests. */
export type AuthOauth2AuthRequests = {
  __typename?: 'authOauth2AuthRequests'
  authTime?: Maybe<Scalars['timestamptz']['output']>
  /** An array relationship */
  authorizationCodes: Array<AuthOauth2AuthorizationCodes>
  /** An aggregate relationship */
  authorizationCodes_aggregate: AuthOauth2AuthorizationCodes_Aggregate
  /** An object relationship */
  client: AuthOauth2Clients
  clientId: Scalars['String']['output']
  codeChallenge?: Maybe<Scalars['String']['output']>
  codeChallengeMethod?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['timestamptz']['output']
  done: Scalars['Boolean']['output']
  expiresAt: Scalars['timestamptz']['output']
  id: Scalars['uuid']['output']
  nonce?: Maybe<Scalars['String']['output']>
  redirectUri: Scalars['String']['output']
  /** An array relationship */
  refreshTokens: Array<AuthOauth2RefreshTokens>
  /** An aggregate relationship */
  refreshTokens_aggregate: AuthOauth2RefreshTokens_Aggregate
  resource?: Maybe<Scalars['String']['output']>
  responseType: Scalars['String']['output']
  scopes: Array<Scalars['String']['output']>
  state?: Maybe<Scalars['String']['output']>
  /** An object relationship */
  user?: Maybe<Users>
  userId?: Maybe<Scalars['uuid']['output']>
}

/** In-flight OAuth2 authorization requests. */
export type AuthOauth2AuthRequestsAuthorizationCodesArgs = {
  distinct_on?: InputMaybe<Array<AuthOauth2AuthorizationCodes_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<AuthOauth2AuthorizationCodes_Order_By>>
  where?: InputMaybe<AuthOauth2AuthorizationCodes_Bool_Exp>
}

/** In-flight OAuth2 authorization requests. */
export type AuthOauth2AuthRequestsAuthorizationCodes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthOauth2AuthorizationCodes_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<AuthOauth2AuthorizationCodes_Order_By>>
  where?: InputMaybe<AuthOauth2AuthorizationCodes_Bool_Exp>
}

/** In-flight OAuth2 authorization requests. */
export type AuthOauth2AuthRequestsRefreshTokensArgs = {
  distinct_on?: InputMaybe<Array<AuthOauth2RefreshTokens_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<AuthOauth2RefreshTokens_Order_By>>
  where?: InputMaybe<AuthOauth2RefreshTokens_Bool_Exp>
}

/** In-flight OAuth2 authorization requests. */
export type AuthOauth2AuthRequestsRefreshTokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthOauth2RefreshTokens_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<AuthOauth2RefreshTokens_Order_By>>
  where?: InputMaybe<AuthOauth2RefreshTokens_Bool_Exp>
}

/** aggregated selection of "auth.oauth2_auth_requests" */
export type AuthOauth2AuthRequests_Aggregate = {
  __typename?: 'authOauth2AuthRequests_aggregate'
  aggregate?: Maybe<AuthOauth2AuthRequests_Aggregate_Fields>
  nodes: Array<AuthOauth2AuthRequests>
}

export type AuthOauth2AuthRequests_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<AuthOauth2AuthRequests_Aggregate_Bool_Exp_Bool_And>
  bool_or?: InputMaybe<AuthOauth2AuthRequests_Aggregate_Bool_Exp_Bool_Or>
  count?: InputMaybe<AuthOauth2AuthRequests_Aggregate_Bool_Exp_Count>
}

export type AuthOauth2AuthRequests_Aggregate_Bool_Exp_Bool_And = {
  arguments: AuthOauth2AuthRequests_Select_Column_AuthOauth2AuthRequests_Aggregate_Bool_Exp_Bool_And_Arguments_Columns
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<AuthOauth2AuthRequests_Bool_Exp>
  predicate: Boolean_Comparison_Exp
}

export type AuthOauth2AuthRequests_Aggregate_Bool_Exp_Bool_Or = {
  arguments: AuthOauth2AuthRequests_Select_Column_AuthOauth2AuthRequests_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<AuthOauth2AuthRequests_Bool_Exp>
  predicate: Boolean_Comparison_Exp
}

export type AuthOauth2AuthRequests_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<AuthOauth2AuthRequests_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<AuthOauth2AuthRequests_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "auth.oauth2_auth_requests" */
export type AuthOauth2AuthRequests_Aggregate_Fields = {
  __typename?: 'authOauth2AuthRequests_aggregate_fields'
  count: Scalars['Int']['output']
  max?: Maybe<AuthOauth2AuthRequests_Max_Fields>
  min?: Maybe<AuthOauth2AuthRequests_Min_Fields>
}

/** aggregate fields of "auth.oauth2_auth_requests" */
export type AuthOauth2AuthRequests_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AuthOauth2AuthRequests_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** order by aggregate values of table "auth.oauth2_auth_requests" */
export type AuthOauth2AuthRequests_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>
  max?: InputMaybe<AuthOauth2AuthRequests_Max_Order_By>
  min?: InputMaybe<AuthOauth2AuthRequests_Min_Order_By>
}

/** input type for inserting array relation for remote table "auth.oauth2_auth_requests" */
export type AuthOauth2AuthRequests_Arr_Rel_Insert_Input = {
  data: Array<AuthOauth2AuthRequests_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<AuthOauth2AuthRequests_On_Conflict>
}

/** Boolean expression to filter rows from the table "auth.oauth2_auth_requests". All fields are combined with a logical 'AND'. */
export type AuthOauth2AuthRequests_Bool_Exp = {
  _and?: InputMaybe<Array<AuthOauth2AuthRequests_Bool_Exp>>
  _not?: InputMaybe<AuthOauth2AuthRequests_Bool_Exp>
  _or?: InputMaybe<Array<AuthOauth2AuthRequests_Bool_Exp>>
  authTime?: InputMaybe<Timestamptz_Comparison_Exp>
  authorizationCodes?: InputMaybe<AuthOauth2AuthorizationCodes_Bool_Exp>
  authorizationCodes_aggregate?: InputMaybe<AuthOauth2AuthorizationCodes_Aggregate_Bool_Exp>
  client?: InputMaybe<AuthOauth2Clients_Bool_Exp>
  clientId?: InputMaybe<String_Comparison_Exp>
  codeChallenge?: InputMaybe<String_Comparison_Exp>
  codeChallengeMethod?: InputMaybe<String_Comparison_Exp>
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>
  done?: InputMaybe<Boolean_Comparison_Exp>
  expiresAt?: InputMaybe<Timestamptz_Comparison_Exp>
  id?: InputMaybe<Uuid_Comparison_Exp>
  nonce?: InputMaybe<String_Comparison_Exp>
  redirectUri?: InputMaybe<String_Comparison_Exp>
  refreshTokens?: InputMaybe<AuthOauth2RefreshTokens_Bool_Exp>
  refreshTokens_aggregate?: InputMaybe<AuthOauth2RefreshTokens_Aggregate_Bool_Exp>
  resource?: InputMaybe<String_Comparison_Exp>
  responseType?: InputMaybe<String_Comparison_Exp>
  scopes?: InputMaybe<String_Array_Comparison_Exp>
  state?: InputMaybe<String_Comparison_Exp>
  user?: InputMaybe<Users_Bool_Exp>
  userId?: InputMaybe<Uuid_Comparison_Exp>
}

/** unique or primary key constraints on table "auth.oauth2_auth_requests" */
export enum AuthOauth2AuthRequests_Constraint {
  /** unique or primary key constraint on columns "id" */
  Oauth2AuthRequestsPkey = 'oauth2_auth_requests_pkey',
}

/** input type for inserting data into table "auth.oauth2_auth_requests" */
export type AuthOauth2AuthRequests_Insert_Input = {
  authTime?: InputMaybe<Scalars['timestamptz']['input']>
  authorizationCodes?: InputMaybe<AuthOauth2AuthorizationCodes_Arr_Rel_Insert_Input>
  client?: InputMaybe<AuthOauth2Clients_Obj_Rel_Insert_Input>
  clientId?: InputMaybe<Scalars['String']['input']>
  codeChallenge?: InputMaybe<Scalars['String']['input']>
  codeChallengeMethod?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>
  done?: InputMaybe<Scalars['Boolean']['input']>
  expiresAt?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  nonce?: InputMaybe<Scalars['String']['input']>
  redirectUri?: InputMaybe<Scalars['String']['input']>
  refreshTokens?: InputMaybe<AuthOauth2RefreshTokens_Arr_Rel_Insert_Input>
  resource?: InputMaybe<Scalars['String']['input']>
  responseType?: InputMaybe<Scalars['String']['input']>
  scopes?: InputMaybe<Array<Scalars['String']['input']>>
  state?: InputMaybe<Scalars['String']['input']>
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>
  userId?: InputMaybe<Scalars['uuid']['input']>
}

/** aggregate max on columns */
export type AuthOauth2AuthRequests_Max_Fields = {
  __typename?: 'authOauth2AuthRequests_max_fields'
  authTime?: Maybe<Scalars['timestamptz']['output']>
  clientId?: Maybe<Scalars['String']['output']>
  codeChallenge?: Maybe<Scalars['String']['output']>
  codeChallengeMethod?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['timestamptz']['output']>
  expiresAt?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['uuid']['output']>
  nonce?: Maybe<Scalars['String']['output']>
  redirectUri?: Maybe<Scalars['String']['output']>
  resource?: Maybe<Scalars['String']['output']>
  responseType?: Maybe<Scalars['String']['output']>
  scopes?: Maybe<Array<Scalars['String']['output']>>
  state?: Maybe<Scalars['String']['output']>
  userId?: Maybe<Scalars['uuid']['output']>
}

/** order by max() on columns of table "auth.oauth2_auth_requests" */
export type AuthOauth2AuthRequests_Max_Order_By = {
  authTime?: InputMaybe<Order_By>
  clientId?: InputMaybe<Order_By>
  codeChallenge?: InputMaybe<Order_By>
  codeChallengeMethod?: InputMaybe<Order_By>
  createdAt?: InputMaybe<Order_By>
  expiresAt?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  nonce?: InputMaybe<Order_By>
  redirectUri?: InputMaybe<Order_By>
  resource?: InputMaybe<Order_By>
  responseType?: InputMaybe<Order_By>
  scopes?: InputMaybe<Order_By>
  state?: InputMaybe<Order_By>
  userId?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type AuthOauth2AuthRequests_Min_Fields = {
  __typename?: 'authOauth2AuthRequests_min_fields'
  authTime?: Maybe<Scalars['timestamptz']['output']>
  clientId?: Maybe<Scalars['String']['output']>
  codeChallenge?: Maybe<Scalars['String']['output']>
  codeChallengeMethod?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['timestamptz']['output']>
  expiresAt?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['uuid']['output']>
  nonce?: Maybe<Scalars['String']['output']>
  redirectUri?: Maybe<Scalars['String']['output']>
  resource?: Maybe<Scalars['String']['output']>
  responseType?: Maybe<Scalars['String']['output']>
  scopes?: Maybe<Array<Scalars['String']['output']>>
  state?: Maybe<Scalars['String']['output']>
  userId?: Maybe<Scalars['uuid']['output']>
}

/** order by min() on columns of table "auth.oauth2_auth_requests" */
export type AuthOauth2AuthRequests_Min_Order_By = {
  authTime?: InputMaybe<Order_By>
  clientId?: InputMaybe<Order_By>
  codeChallenge?: InputMaybe<Order_By>
  codeChallengeMethod?: InputMaybe<Order_By>
  createdAt?: InputMaybe<Order_By>
  expiresAt?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  nonce?: InputMaybe<Order_By>
  redirectUri?: InputMaybe<Order_By>
  resource?: InputMaybe<Order_By>
  responseType?: InputMaybe<Order_By>
  scopes?: InputMaybe<Order_By>
  state?: InputMaybe<Order_By>
  userId?: InputMaybe<Order_By>
}

/** response of any mutation on the table "auth.oauth2_auth_requests" */
export type AuthOauth2AuthRequests_Mutation_Response = {
  __typename?: 'authOauth2AuthRequests_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<AuthOauth2AuthRequests>
}

/** input type for inserting object relation for remote table "auth.oauth2_auth_requests" */
export type AuthOauth2AuthRequests_Obj_Rel_Insert_Input = {
  data: AuthOauth2AuthRequests_Insert_Input
  /** upsert condition */
  on_conflict?: InputMaybe<AuthOauth2AuthRequests_On_Conflict>
}

/** on_conflict condition type for table "auth.oauth2_auth_requests" */
export type AuthOauth2AuthRequests_On_Conflict = {
  constraint: AuthOauth2AuthRequests_Constraint
  update_columns?: Array<AuthOauth2AuthRequests_Update_Column>
  where?: InputMaybe<AuthOauth2AuthRequests_Bool_Exp>
}

/** Ordering options when selecting data from "auth.oauth2_auth_requests". */
export type AuthOauth2AuthRequests_Order_By = {
  authTime?: InputMaybe<Order_By>
  authorizationCodes_aggregate?: InputMaybe<AuthOauth2AuthorizationCodes_Aggregate_Order_By>
  client?: InputMaybe<AuthOauth2Clients_Order_By>
  clientId?: InputMaybe<Order_By>
  codeChallenge?: InputMaybe<Order_By>
  codeChallengeMethod?: InputMaybe<Order_By>
  createdAt?: InputMaybe<Order_By>
  done?: InputMaybe<Order_By>
  expiresAt?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  nonce?: InputMaybe<Order_By>
  redirectUri?: InputMaybe<Order_By>
  refreshTokens_aggregate?: InputMaybe<AuthOauth2RefreshTokens_Aggregate_Order_By>
  resource?: InputMaybe<Order_By>
  responseType?: InputMaybe<Order_By>
  scopes?: InputMaybe<Order_By>
  state?: InputMaybe<Order_By>
  user?: InputMaybe<Users_Order_By>
  userId?: InputMaybe<Order_By>
}

/** primary key columns input for table: auth.oauth2_auth_requests */
export type AuthOauth2AuthRequests_Pk_Columns_Input = {
  id: Scalars['uuid']['input']
}

/** select columns of table "auth.oauth2_auth_requests" */
export enum AuthOauth2AuthRequests_Select_Column {
  /** column name */
  AuthTime = 'authTime',
  /** column name */
  ClientId = 'clientId',
  /** column name */
  CodeChallenge = 'codeChallenge',
  /** column name */
  CodeChallengeMethod = 'codeChallengeMethod',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Done = 'done',
  /** column name */
  ExpiresAt = 'expiresAt',
  /** column name */
  Id = 'id',
  /** column name */
  Nonce = 'nonce',
  /** column name */
  RedirectUri = 'redirectUri',
  /** column name */
  Resource = 'resource',
  /** column name */
  ResponseType = 'responseType',
  /** column name */
  Scopes = 'scopes',
  /** column name */
  State = 'state',
  /** column name */
  UserId = 'userId',
}

/** select "authOauth2AuthRequests_aggregate_bool_exp_bool_and_arguments_columns" columns of table "auth.oauth2_auth_requests" */
export enum AuthOauth2AuthRequests_Select_Column_AuthOauth2AuthRequests_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Done = 'done',
}

/** select "authOauth2AuthRequests_aggregate_bool_exp_bool_or_arguments_columns" columns of table "auth.oauth2_auth_requests" */
export enum AuthOauth2AuthRequests_Select_Column_AuthOauth2AuthRequests_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Done = 'done',
}

/** input type for updating data in table "auth.oauth2_auth_requests" */
export type AuthOauth2AuthRequests_Set_Input = {
  authTime?: InputMaybe<Scalars['timestamptz']['input']>
  clientId?: InputMaybe<Scalars['String']['input']>
  codeChallenge?: InputMaybe<Scalars['String']['input']>
  codeChallengeMethod?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>
  done?: InputMaybe<Scalars['Boolean']['input']>
  expiresAt?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  nonce?: InputMaybe<Scalars['String']['input']>
  redirectUri?: InputMaybe<Scalars['String']['input']>
  resource?: InputMaybe<Scalars['String']['input']>
  responseType?: InputMaybe<Scalars['String']['input']>
  scopes?: InputMaybe<Array<Scalars['String']['input']>>
  state?: InputMaybe<Scalars['String']['input']>
  userId?: InputMaybe<Scalars['uuid']['input']>
}

/** Streaming cursor of the table "authOauth2AuthRequests" */
export type AuthOauth2AuthRequests_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AuthOauth2AuthRequests_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type AuthOauth2AuthRequests_Stream_Cursor_Value_Input = {
  authTime?: InputMaybe<Scalars['timestamptz']['input']>
  clientId?: InputMaybe<Scalars['String']['input']>
  codeChallenge?: InputMaybe<Scalars['String']['input']>
  codeChallengeMethod?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>
  done?: InputMaybe<Scalars['Boolean']['input']>
  expiresAt?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  nonce?: InputMaybe<Scalars['String']['input']>
  redirectUri?: InputMaybe<Scalars['String']['input']>
  resource?: InputMaybe<Scalars['String']['input']>
  responseType?: InputMaybe<Scalars['String']['input']>
  scopes?: InputMaybe<Array<Scalars['String']['input']>>
  state?: InputMaybe<Scalars['String']['input']>
  userId?: InputMaybe<Scalars['uuid']['input']>
}

/** update columns of table "auth.oauth2_auth_requests" */
export enum AuthOauth2AuthRequests_Update_Column {
  /** column name */
  AuthTime = 'authTime',
  /** column name */
  ClientId = 'clientId',
  /** column name */
  CodeChallenge = 'codeChallenge',
  /** column name */
  CodeChallengeMethod = 'codeChallengeMethod',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Done = 'done',
  /** column name */
  ExpiresAt = 'expiresAt',
  /** column name */
  Id = 'id',
  /** column name */
  Nonce = 'nonce',
  /** column name */
  RedirectUri = 'redirectUri',
  /** column name */
  Resource = 'resource',
  /** column name */
  ResponseType = 'responseType',
  /** column name */
  Scopes = 'scopes',
  /** column name */
  State = 'state',
  /** column name */
  UserId = 'userId',
}

export type AuthOauth2AuthRequests_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuthOauth2AuthRequests_Set_Input>
  /** filter the rows which have to be updated */
  where: AuthOauth2AuthRequests_Bool_Exp
}

/** OAuth2 authorization codes pending exchange for tokens. */
export type AuthOauth2AuthorizationCodes = {
  __typename?: 'authOauth2AuthorizationCodes'
  /** An object relationship */
  authRequest: AuthOauth2AuthRequests
  authRequestId: Scalars['uuid']['output']
  codeHash: Scalars['String']['output']
  createdAt: Scalars['timestamptz']['output']
  expiresAt: Scalars['timestamptz']['output']
  id: Scalars['uuid']['output']
}

/** aggregated selection of "auth.oauth2_authorization_codes" */
export type AuthOauth2AuthorizationCodes_Aggregate = {
  __typename?: 'authOauth2AuthorizationCodes_aggregate'
  aggregate?: Maybe<AuthOauth2AuthorizationCodes_Aggregate_Fields>
  nodes: Array<AuthOauth2AuthorizationCodes>
}

export type AuthOauth2AuthorizationCodes_Aggregate_Bool_Exp = {
  count?: InputMaybe<AuthOauth2AuthorizationCodes_Aggregate_Bool_Exp_Count>
}

export type AuthOauth2AuthorizationCodes_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<AuthOauth2AuthorizationCodes_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<AuthOauth2AuthorizationCodes_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "auth.oauth2_authorization_codes" */
export type AuthOauth2AuthorizationCodes_Aggregate_Fields = {
  __typename?: 'authOauth2AuthorizationCodes_aggregate_fields'
  count: Scalars['Int']['output']
  max?: Maybe<AuthOauth2AuthorizationCodes_Max_Fields>
  min?: Maybe<AuthOauth2AuthorizationCodes_Min_Fields>
}

/** aggregate fields of "auth.oauth2_authorization_codes" */
export type AuthOauth2AuthorizationCodes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AuthOauth2AuthorizationCodes_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** order by aggregate values of table "auth.oauth2_authorization_codes" */
export type AuthOauth2AuthorizationCodes_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>
  max?: InputMaybe<AuthOauth2AuthorizationCodes_Max_Order_By>
  min?: InputMaybe<AuthOauth2AuthorizationCodes_Min_Order_By>
}

/** input type for inserting array relation for remote table "auth.oauth2_authorization_codes" */
export type AuthOauth2AuthorizationCodes_Arr_Rel_Insert_Input = {
  data: Array<AuthOauth2AuthorizationCodes_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<AuthOauth2AuthorizationCodes_On_Conflict>
}

/** Boolean expression to filter rows from the table "auth.oauth2_authorization_codes". All fields are combined with a logical 'AND'. */
export type AuthOauth2AuthorizationCodes_Bool_Exp = {
  _and?: InputMaybe<Array<AuthOauth2AuthorizationCodes_Bool_Exp>>
  _not?: InputMaybe<AuthOauth2AuthorizationCodes_Bool_Exp>
  _or?: InputMaybe<Array<AuthOauth2AuthorizationCodes_Bool_Exp>>
  authRequest?: InputMaybe<AuthOauth2AuthRequests_Bool_Exp>
  authRequestId?: InputMaybe<Uuid_Comparison_Exp>
  codeHash?: InputMaybe<String_Comparison_Exp>
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>
  expiresAt?: InputMaybe<Timestamptz_Comparison_Exp>
  id?: InputMaybe<Uuid_Comparison_Exp>
}

/** unique or primary key constraints on table "auth.oauth2_authorization_codes" */
export enum AuthOauth2AuthorizationCodes_Constraint {
  /** unique or primary key constraint on columns "code_hash" */
  Oauth2AuthorizationCodesCodeHashKey = 'oauth2_authorization_codes_code_hash_key',
  /** unique or primary key constraint on columns "id" */
  Oauth2AuthorizationCodesPkey = 'oauth2_authorization_codes_pkey',
}

/** input type for inserting data into table "auth.oauth2_authorization_codes" */
export type AuthOauth2AuthorizationCodes_Insert_Input = {
  authRequest?: InputMaybe<AuthOauth2AuthRequests_Obj_Rel_Insert_Input>
  authRequestId?: InputMaybe<Scalars['uuid']['input']>
  codeHash?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>
  expiresAt?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
}

/** aggregate max on columns */
export type AuthOauth2AuthorizationCodes_Max_Fields = {
  __typename?: 'authOauth2AuthorizationCodes_max_fields'
  authRequestId?: Maybe<Scalars['uuid']['output']>
  codeHash?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['timestamptz']['output']>
  expiresAt?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['uuid']['output']>
}

/** order by max() on columns of table "auth.oauth2_authorization_codes" */
export type AuthOauth2AuthorizationCodes_Max_Order_By = {
  authRequestId?: InputMaybe<Order_By>
  codeHash?: InputMaybe<Order_By>
  createdAt?: InputMaybe<Order_By>
  expiresAt?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type AuthOauth2AuthorizationCodes_Min_Fields = {
  __typename?: 'authOauth2AuthorizationCodes_min_fields'
  authRequestId?: Maybe<Scalars['uuid']['output']>
  codeHash?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['timestamptz']['output']>
  expiresAt?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['uuid']['output']>
}

/** order by min() on columns of table "auth.oauth2_authorization_codes" */
export type AuthOauth2AuthorizationCodes_Min_Order_By = {
  authRequestId?: InputMaybe<Order_By>
  codeHash?: InputMaybe<Order_By>
  createdAt?: InputMaybe<Order_By>
  expiresAt?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** response of any mutation on the table "auth.oauth2_authorization_codes" */
export type AuthOauth2AuthorizationCodes_Mutation_Response = {
  __typename?: 'authOauth2AuthorizationCodes_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<AuthOauth2AuthorizationCodes>
}

/** on_conflict condition type for table "auth.oauth2_authorization_codes" */
export type AuthOauth2AuthorizationCodes_On_Conflict = {
  constraint: AuthOauth2AuthorizationCodes_Constraint
  update_columns?: Array<AuthOauth2AuthorizationCodes_Update_Column>
  where?: InputMaybe<AuthOauth2AuthorizationCodes_Bool_Exp>
}

/** Ordering options when selecting data from "auth.oauth2_authorization_codes". */
export type AuthOauth2AuthorizationCodes_Order_By = {
  authRequest?: InputMaybe<AuthOauth2AuthRequests_Order_By>
  authRequestId?: InputMaybe<Order_By>
  codeHash?: InputMaybe<Order_By>
  createdAt?: InputMaybe<Order_By>
  expiresAt?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** primary key columns input for table: auth.oauth2_authorization_codes */
export type AuthOauth2AuthorizationCodes_Pk_Columns_Input = {
  id: Scalars['uuid']['input']
}

/** select columns of table "auth.oauth2_authorization_codes" */
export enum AuthOauth2AuthorizationCodes_Select_Column {
  /** column name */
  AuthRequestId = 'authRequestId',
  /** column name */
  CodeHash = 'codeHash',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ExpiresAt = 'expiresAt',
  /** column name */
  Id = 'id',
}

/** input type for updating data in table "auth.oauth2_authorization_codes" */
export type AuthOauth2AuthorizationCodes_Set_Input = {
  authRequestId?: InputMaybe<Scalars['uuid']['input']>
  codeHash?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>
  expiresAt?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
}

/** Streaming cursor of the table "authOauth2AuthorizationCodes" */
export type AuthOauth2AuthorizationCodes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AuthOauth2AuthorizationCodes_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type AuthOauth2AuthorizationCodes_Stream_Cursor_Value_Input = {
  authRequestId?: InputMaybe<Scalars['uuid']['input']>
  codeHash?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>
  expiresAt?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
}

/** update columns of table "auth.oauth2_authorization_codes" */
export enum AuthOauth2AuthorizationCodes_Update_Column {
  /** column name */
  AuthRequestId = 'authRequestId',
  /** column name */
  CodeHash = 'codeHash',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ExpiresAt = 'expiresAt',
  /** column name */
  Id = 'id',
}

export type AuthOauth2AuthorizationCodes_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuthOauth2AuthorizationCodes_Set_Input>
  /** filter the rows which have to be updated */
  where: AuthOauth2AuthorizationCodes_Bool_Exp
}

/** Registered OAuth2 client applications for the identity provider. */
export type AuthOauth2Clients = {
  __typename?: 'authOauth2Clients'
  /** An array relationship */
  authRequests: Array<AuthOauth2AuthRequests>
  /** An aggregate relationship */
  authRequests_aggregate: AuthOauth2AuthRequests_Aggregate
  clientId: Scalars['String']['output']
  clientSecretHash?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['timestamptz']['output']
  createdBy?: Maybe<Scalars['uuid']['output']>
  /** An object relationship */
  createdByUser?: Maybe<Users>
  metadata?: Maybe<Scalars['jsonb']['output']>
  metadataDocumentFetchedAt?: Maybe<Scalars['timestamptz']['output']>
  /** An array relationship */
  oauth2RefreshTokens: Array<AuthOauth2RefreshTokens>
  /** An aggregate relationship */
  oauth2RefreshTokens_aggregate: AuthOauth2RefreshTokens_Aggregate
  redirectUris: Array<Scalars['String']['output']>
  scopes: Array<Scalars['String']['output']>
  type: Scalars['String']['output']
  updatedAt: Scalars['timestamptz']['output']
}

/** Registered OAuth2 client applications for the identity provider. */
export type AuthOauth2ClientsAuthRequestsArgs = {
  distinct_on?: InputMaybe<Array<AuthOauth2AuthRequests_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<AuthOauth2AuthRequests_Order_By>>
  where?: InputMaybe<AuthOauth2AuthRequests_Bool_Exp>
}

/** Registered OAuth2 client applications for the identity provider. */
export type AuthOauth2ClientsAuthRequests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthOauth2AuthRequests_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<AuthOauth2AuthRequests_Order_By>>
  where?: InputMaybe<AuthOauth2AuthRequests_Bool_Exp>
}

/** Registered OAuth2 client applications for the identity provider. */
export type AuthOauth2ClientsMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>
}

/** Registered OAuth2 client applications for the identity provider. */
export type AuthOauth2ClientsOauth2RefreshTokensArgs = {
  distinct_on?: InputMaybe<Array<AuthOauth2RefreshTokens_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<AuthOauth2RefreshTokens_Order_By>>
  where?: InputMaybe<AuthOauth2RefreshTokens_Bool_Exp>
}

/** Registered OAuth2 client applications for the identity provider. */
export type AuthOauth2ClientsOauth2RefreshTokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthOauth2RefreshTokens_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<AuthOauth2RefreshTokens_Order_By>>
  where?: InputMaybe<AuthOauth2RefreshTokens_Bool_Exp>
}

/** aggregated selection of "auth.oauth2_clients" */
export type AuthOauth2Clients_Aggregate = {
  __typename?: 'authOauth2Clients_aggregate'
  aggregate?: Maybe<AuthOauth2Clients_Aggregate_Fields>
  nodes: Array<AuthOauth2Clients>
}

/** aggregate fields of "auth.oauth2_clients" */
export type AuthOauth2Clients_Aggregate_Fields = {
  __typename?: 'authOauth2Clients_aggregate_fields'
  count: Scalars['Int']['output']
  max?: Maybe<AuthOauth2Clients_Max_Fields>
  min?: Maybe<AuthOauth2Clients_Min_Fields>
}

/** aggregate fields of "auth.oauth2_clients" */
export type AuthOauth2Clients_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AuthOauth2Clients_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** append existing jsonb value of filtered columns with new jsonb value */
export type AuthOauth2Clients_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>
}

/** Boolean expression to filter rows from the table "auth.oauth2_clients". All fields are combined with a logical 'AND'. */
export type AuthOauth2Clients_Bool_Exp = {
  _and?: InputMaybe<Array<AuthOauth2Clients_Bool_Exp>>
  _not?: InputMaybe<AuthOauth2Clients_Bool_Exp>
  _or?: InputMaybe<Array<AuthOauth2Clients_Bool_Exp>>
  authRequests?: InputMaybe<AuthOauth2AuthRequests_Bool_Exp>
  authRequests_aggregate?: InputMaybe<AuthOauth2AuthRequests_Aggregate_Bool_Exp>
  clientId?: InputMaybe<String_Comparison_Exp>
  clientSecretHash?: InputMaybe<String_Comparison_Exp>
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>
  createdBy?: InputMaybe<Uuid_Comparison_Exp>
  createdByUser?: InputMaybe<Users_Bool_Exp>
  metadata?: InputMaybe<Jsonb_Comparison_Exp>
  metadataDocumentFetchedAt?: InputMaybe<Timestamptz_Comparison_Exp>
  oauth2RefreshTokens?: InputMaybe<AuthOauth2RefreshTokens_Bool_Exp>
  oauth2RefreshTokens_aggregate?: InputMaybe<AuthOauth2RefreshTokens_Aggregate_Bool_Exp>
  redirectUris?: InputMaybe<String_Array_Comparison_Exp>
  scopes?: InputMaybe<String_Array_Comparison_Exp>
  type?: InputMaybe<String_Comparison_Exp>
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>
}

/** unique or primary key constraints on table "auth.oauth2_clients" */
export enum AuthOauth2Clients_Constraint {
  /** unique or primary key constraint on columns "client_id" */
  Oauth2ClientsPkey = 'oauth2_clients_pkey',
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type AuthOauth2Clients_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']['input']>>
}

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type AuthOauth2Clients_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']['input']>
}

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type AuthOauth2Clients_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']['input']>
}

/** input type for inserting data into table "auth.oauth2_clients" */
export type AuthOauth2Clients_Insert_Input = {
  authRequests?: InputMaybe<AuthOauth2AuthRequests_Arr_Rel_Insert_Input>
  clientId?: InputMaybe<Scalars['String']['input']>
  clientSecretHash?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>
  createdBy?: InputMaybe<Scalars['uuid']['input']>
  createdByUser?: InputMaybe<Users_Obj_Rel_Insert_Input>
  metadata?: InputMaybe<Scalars['jsonb']['input']>
  metadataDocumentFetchedAt?: InputMaybe<Scalars['timestamptz']['input']>
  oauth2RefreshTokens?: InputMaybe<AuthOauth2RefreshTokens_Arr_Rel_Insert_Input>
  redirectUris?: InputMaybe<Array<Scalars['String']['input']>>
  scopes?: InputMaybe<Array<Scalars['String']['input']>>
  type?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate max on columns */
export type AuthOauth2Clients_Max_Fields = {
  __typename?: 'authOauth2Clients_max_fields'
  clientId?: Maybe<Scalars['String']['output']>
  clientSecretHash?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['timestamptz']['output']>
  createdBy?: Maybe<Scalars['uuid']['output']>
  metadataDocumentFetchedAt?: Maybe<Scalars['timestamptz']['output']>
  redirectUris?: Maybe<Array<Scalars['String']['output']>>
  scopes?: Maybe<Array<Scalars['String']['output']>>
  type?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['timestamptz']['output']>
}

/** aggregate min on columns */
export type AuthOauth2Clients_Min_Fields = {
  __typename?: 'authOauth2Clients_min_fields'
  clientId?: Maybe<Scalars['String']['output']>
  clientSecretHash?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['timestamptz']['output']>
  createdBy?: Maybe<Scalars['uuid']['output']>
  metadataDocumentFetchedAt?: Maybe<Scalars['timestamptz']['output']>
  redirectUris?: Maybe<Array<Scalars['String']['output']>>
  scopes?: Maybe<Array<Scalars['String']['output']>>
  type?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['timestamptz']['output']>
}

/** response of any mutation on the table "auth.oauth2_clients" */
export type AuthOauth2Clients_Mutation_Response = {
  __typename?: 'authOauth2Clients_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<AuthOauth2Clients>
}

/** input type for inserting object relation for remote table "auth.oauth2_clients" */
export type AuthOauth2Clients_Obj_Rel_Insert_Input = {
  data: AuthOauth2Clients_Insert_Input
  /** upsert condition */
  on_conflict?: InputMaybe<AuthOauth2Clients_On_Conflict>
}

/** on_conflict condition type for table "auth.oauth2_clients" */
export type AuthOauth2Clients_On_Conflict = {
  constraint: AuthOauth2Clients_Constraint
  update_columns?: Array<AuthOauth2Clients_Update_Column>
  where?: InputMaybe<AuthOauth2Clients_Bool_Exp>
}

/** Ordering options when selecting data from "auth.oauth2_clients". */
export type AuthOauth2Clients_Order_By = {
  authRequests_aggregate?: InputMaybe<AuthOauth2AuthRequests_Aggregate_Order_By>
  clientId?: InputMaybe<Order_By>
  clientSecretHash?: InputMaybe<Order_By>
  createdAt?: InputMaybe<Order_By>
  createdBy?: InputMaybe<Order_By>
  createdByUser?: InputMaybe<Users_Order_By>
  metadata?: InputMaybe<Order_By>
  metadataDocumentFetchedAt?: InputMaybe<Order_By>
  oauth2RefreshTokens_aggregate?: InputMaybe<AuthOauth2RefreshTokens_Aggregate_Order_By>
  redirectUris?: InputMaybe<Order_By>
  scopes?: InputMaybe<Order_By>
  type?: InputMaybe<Order_By>
  updatedAt?: InputMaybe<Order_By>
}

/** primary key columns input for table: auth.oauth2_clients */
export type AuthOauth2Clients_Pk_Columns_Input = {
  clientId: Scalars['String']['input']
}

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type AuthOauth2Clients_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>
}

/** select columns of table "auth.oauth2_clients" */
export enum AuthOauth2Clients_Select_Column {
  /** column name */
  ClientId = 'clientId',
  /** column name */
  ClientSecretHash = 'clientSecretHash',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  MetadataDocumentFetchedAt = 'metadataDocumentFetchedAt',
  /** column name */
  RedirectUris = 'redirectUris',
  /** column name */
  Scopes = 'scopes',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
}

/** input type for updating data in table "auth.oauth2_clients" */
export type AuthOauth2Clients_Set_Input = {
  clientId?: InputMaybe<Scalars['String']['input']>
  clientSecretHash?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>
  createdBy?: InputMaybe<Scalars['uuid']['input']>
  metadata?: InputMaybe<Scalars['jsonb']['input']>
  metadataDocumentFetchedAt?: InputMaybe<Scalars['timestamptz']['input']>
  redirectUris?: InputMaybe<Array<Scalars['String']['input']>>
  scopes?: InputMaybe<Array<Scalars['String']['input']>>
  type?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>
}

/** Streaming cursor of the table "authOauth2Clients" */
export type AuthOauth2Clients_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AuthOauth2Clients_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type AuthOauth2Clients_Stream_Cursor_Value_Input = {
  clientId?: InputMaybe<Scalars['String']['input']>
  clientSecretHash?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>
  createdBy?: InputMaybe<Scalars['uuid']['input']>
  metadata?: InputMaybe<Scalars['jsonb']['input']>
  metadataDocumentFetchedAt?: InputMaybe<Scalars['timestamptz']['input']>
  redirectUris?: InputMaybe<Array<Scalars['String']['input']>>
  scopes?: InputMaybe<Array<Scalars['String']['input']>>
  type?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>
}

/** update columns of table "auth.oauth2_clients" */
export enum AuthOauth2Clients_Update_Column {
  /** column name */
  ClientId = 'clientId',
  /** column name */
  ClientSecretHash = 'clientSecretHash',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  MetadataDocumentFetchedAt = 'metadataDocumentFetchedAt',
  /** column name */
  RedirectUris = 'redirectUris',
  /** column name */
  Scopes = 'scopes',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
}

export type AuthOauth2Clients_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<AuthOauth2Clients_Append_Input>
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<AuthOauth2Clients_Delete_At_Path_Input>
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<AuthOauth2Clients_Delete_Elem_Input>
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<AuthOauth2Clients_Delete_Key_Input>
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<AuthOauth2Clients_Prepend_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuthOauth2Clients_Set_Input>
  /** filter the rows which have to be updated */
  where: AuthOauth2Clients_Bool_Exp
}

/** OAuth2 refresh tokens with client and scope binding. */
export type AuthOauth2RefreshTokens = {
  __typename?: 'authOauth2RefreshTokens'
  /** An object relationship */
  authRequest?: Maybe<AuthOauth2AuthRequests>
  authRequestId?: Maybe<Scalars['uuid']['output']>
  /** An object relationship */
  client: AuthOauth2Clients
  clientId: Scalars['String']['output']
  createdAt: Scalars['timestamptz']['output']
  expiresAt: Scalars['timestamptz']['output']
  id: Scalars['uuid']['output']
  scopes: Array<Scalars['String']['output']>
  tokenHash: Scalars['String']['output']
  /** An object relationship */
  user: Users
  userId: Scalars['uuid']['output']
}

/** aggregated selection of "auth.oauth2_refresh_tokens" */
export type AuthOauth2RefreshTokens_Aggregate = {
  __typename?: 'authOauth2RefreshTokens_aggregate'
  aggregate?: Maybe<AuthOauth2RefreshTokens_Aggregate_Fields>
  nodes: Array<AuthOauth2RefreshTokens>
}

export type AuthOauth2RefreshTokens_Aggregate_Bool_Exp = {
  count?: InputMaybe<AuthOauth2RefreshTokens_Aggregate_Bool_Exp_Count>
}

export type AuthOauth2RefreshTokens_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<AuthOauth2RefreshTokens_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<AuthOauth2RefreshTokens_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "auth.oauth2_refresh_tokens" */
export type AuthOauth2RefreshTokens_Aggregate_Fields = {
  __typename?: 'authOauth2RefreshTokens_aggregate_fields'
  count: Scalars['Int']['output']
  max?: Maybe<AuthOauth2RefreshTokens_Max_Fields>
  min?: Maybe<AuthOauth2RefreshTokens_Min_Fields>
}

/** aggregate fields of "auth.oauth2_refresh_tokens" */
export type AuthOauth2RefreshTokens_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AuthOauth2RefreshTokens_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** order by aggregate values of table "auth.oauth2_refresh_tokens" */
export type AuthOauth2RefreshTokens_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>
  max?: InputMaybe<AuthOauth2RefreshTokens_Max_Order_By>
  min?: InputMaybe<AuthOauth2RefreshTokens_Min_Order_By>
}

/** input type for inserting array relation for remote table "auth.oauth2_refresh_tokens" */
export type AuthOauth2RefreshTokens_Arr_Rel_Insert_Input = {
  data: Array<AuthOauth2RefreshTokens_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<AuthOauth2RefreshTokens_On_Conflict>
}

/** Boolean expression to filter rows from the table "auth.oauth2_refresh_tokens". All fields are combined with a logical 'AND'. */
export type AuthOauth2RefreshTokens_Bool_Exp = {
  _and?: InputMaybe<Array<AuthOauth2RefreshTokens_Bool_Exp>>
  _not?: InputMaybe<AuthOauth2RefreshTokens_Bool_Exp>
  _or?: InputMaybe<Array<AuthOauth2RefreshTokens_Bool_Exp>>
  authRequest?: InputMaybe<AuthOauth2AuthRequests_Bool_Exp>
  authRequestId?: InputMaybe<Uuid_Comparison_Exp>
  client?: InputMaybe<AuthOauth2Clients_Bool_Exp>
  clientId?: InputMaybe<String_Comparison_Exp>
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>
  expiresAt?: InputMaybe<Timestamptz_Comparison_Exp>
  id?: InputMaybe<Uuid_Comparison_Exp>
  scopes?: InputMaybe<String_Array_Comparison_Exp>
  tokenHash?: InputMaybe<String_Comparison_Exp>
  user?: InputMaybe<Users_Bool_Exp>
  userId?: InputMaybe<Uuid_Comparison_Exp>
}

/** unique or primary key constraints on table "auth.oauth2_refresh_tokens" */
export enum AuthOauth2RefreshTokens_Constraint {
  /** unique or primary key constraint on columns "id" */
  Oauth2RefreshTokensPkey = 'oauth2_refresh_tokens_pkey',
  /** unique or primary key constraint on columns "token_hash" */
  Oauth2RefreshTokensTokenHashKey = 'oauth2_refresh_tokens_token_hash_key',
}

/** input type for inserting data into table "auth.oauth2_refresh_tokens" */
export type AuthOauth2RefreshTokens_Insert_Input = {
  authRequest?: InputMaybe<AuthOauth2AuthRequests_Obj_Rel_Insert_Input>
  authRequestId?: InputMaybe<Scalars['uuid']['input']>
  client?: InputMaybe<AuthOauth2Clients_Obj_Rel_Insert_Input>
  clientId?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>
  expiresAt?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  scopes?: InputMaybe<Array<Scalars['String']['input']>>
  tokenHash?: InputMaybe<Scalars['String']['input']>
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>
  userId?: InputMaybe<Scalars['uuid']['input']>
}

/** aggregate max on columns */
export type AuthOauth2RefreshTokens_Max_Fields = {
  __typename?: 'authOauth2RefreshTokens_max_fields'
  authRequestId?: Maybe<Scalars['uuid']['output']>
  clientId?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['timestamptz']['output']>
  expiresAt?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['uuid']['output']>
  scopes?: Maybe<Array<Scalars['String']['output']>>
  tokenHash?: Maybe<Scalars['String']['output']>
  userId?: Maybe<Scalars['uuid']['output']>
}

/** order by max() on columns of table "auth.oauth2_refresh_tokens" */
export type AuthOauth2RefreshTokens_Max_Order_By = {
  authRequestId?: InputMaybe<Order_By>
  clientId?: InputMaybe<Order_By>
  createdAt?: InputMaybe<Order_By>
  expiresAt?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  scopes?: InputMaybe<Order_By>
  tokenHash?: InputMaybe<Order_By>
  userId?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type AuthOauth2RefreshTokens_Min_Fields = {
  __typename?: 'authOauth2RefreshTokens_min_fields'
  authRequestId?: Maybe<Scalars['uuid']['output']>
  clientId?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['timestamptz']['output']>
  expiresAt?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['uuid']['output']>
  scopes?: Maybe<Array<Scalars['String']['output']>>
  tokenHash?: Maybe<Scalars['String']['output']>
  userId?: Maybe<Scalars['uuid']['output']>
}

/** order by min() on columns of table "auth.oauth2_refresh_tokens" */
export type AuthOauth2RefreshTokens_Min_Order_By = {
  authRequestId?: InputMaybe<Order_By>
  clientId?: InputMaybe<Order_By>
  createdAt?: InputMaybe<Order_By>
  expiresAt?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  scopes?: InputMaybe<Order_By>
  tokenHash?: InputMaybe<Order_By>
  userId?: InputMaybe<Order_By>
}

/** response of any mutation on the table "auth.oauth2_refresh_tokens" */
export type AuthOauth2RefreshTokens_Mutation_Response = {
  __typename?: 'authOauth2RefreshTokens_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<AuthOauth2RefreshTokens>
}

/** on_conflict condition type for table "auth.oauth2_refresh_tokens" */
export type AuthOauth2RefreshTokens_On_Conflict = {
  constraint: AuthOauth2RefreshTokens_Constraint
  update_columns?: Array<AuthOauth2RefreshTokens_Update_Column>
  where?: InputMaybe<AuthOauth2RefreshTokens_Bool_Exp>
}

/** Ordering options when selecting data from "auth.oauth2_refresh_tokens". */
export type AuthOauth2RefreshTokens_Order_By = {
  authRequest?: InputMaybe<AuthOauth2AuthRequests_Order_By>
  authRequestId?: InputMaybe<Order_By>
  client?: InputMaybe<AuthOauth2Clients_Order_By>
  clientId?: InputMaybe<Order_By>
  createdAt?: InputMaybe<Order_By>
  expiresAt?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  scopes?: InputMaybe<Order_By>
  tokenHash?: InputMaybe<Order_By>
  user?: InputMaybe<Users_Order_By>
  userId?: InputMaybe<Order_By>
}

/** primary key columns input for table: auth.oauth2_refresh_tokens */
export type AuthOauth2RefreshTokens_Pk_Columns_Input = {
  id: Scalars['uuid']['input']
}

/** select columns of table "auth.oauth2_refresh_tokens" */
export enum AuthOauth2RefreshTokens_Select_Column {
  /** column name */
  AuthRequestId = 'authRequestId',
  /** column name */
  ClientId = 'clientId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ExpiresAt = 'expiresAt',
  /** column name */
  Id = 'id',
  /** column name */
  Scopes = 'scopes',
  /** column name */
  TokenHash = 'tokenHash',
  /** column name */
  UserId = 'userId',
}

/** input type for updating data in table "auth.oauth2_refresh_tokens" */
export type AuthOauth2RefreshTokens_Set_Input = {
  authRequestId?: InputMaybe<Scalars['uuid']['input']>
  clientId?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>
  expiresAt?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  scopes?: InputMaybe<Array<Scalars['String']['input']>>
  tokenHash?: InputMaybe<Scalars['String']['input']>
  userId?: InputMaybe<Scalars['uuid']['input']>
}

/** Streaming cursor of the table "authOauth2RefreshTokens" */
export type AuthOauth2RefreshTokens_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AuthOauth2RefreshTokens_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type AuthOauth2RefreshTokens_Stream_Cursor_Value_Input = {
  authRequestId?: InputMaybe<Scalars['uuid']['input']>
  clientId?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>
  expiresAt?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  scopes?: InputMaybe<Array<Scalars['String']['input']>>
  tokenHash?: InputMaybe<Scalars['String']['input']>
  userId?: InputMaybe<Scalars['uuid']['input']>
}

/** update columns of table "auth.oauth2_refresh_tokens" */
export enum AuthOauth2RefreshTokens_Update_Column {
  /** column name */
  AuthRequestId = 'authRequestId',
  /** column name */
  ClientId = 'clientId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ExpiresAt = 'expiresAt',
  /** column name */
  Id = 'id',
  /** column name */
  Scopes = 'scopes',
  /** column name */
  TokenHash = 'tokenHash',
  /** column name */
  UserId = 'userId',
}

export type AuthOauth2RefreshTokens_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuthOauth2RefreshTokens_Set_Input>
  /** filter the rows which have to be updated */
  where: AuthOauth2RefreshTokens_Bool_Exp
}

/** Oauth requests, inserted before redirecting to the provider's site. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthProviderRequests = {
  __typename?: 'authProviderRequests'
  id: Scalars['uuid']['output']
  options?: Maybe<Scalars['jsonb']['output']>
}

/** Oauth requests, inserted before redirecting to the provider's site. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthProviderRequestsOptionsArgs = {
  path?: InputMaybe<Scalars['String']['input']>
}

/** aggregated selection of "auth.provider_requests" */
export type AuthProviderRequests_Aggregate = {
  __typename?: 'authProviderRequests_aggregate'
  aggregate?: Maybe<AuthProviderRequests_Aggregate_Fields>
  nodes: Array<AuthProviderRequests>
}

/** aggregate fields of "auth.provider_requests" */
export type AuthProviderRequests_Aggregate_Fields = {
  __typename?: 'authProviderRequests_aggregate_fields'
  count: Scalars['Int']['output']
  max?: Maybe<AuthProviderRequests_Max_Fields>
  min?: Maybe<AuthProviderRequests_Min_Fields>
}

/** aggregate fields of "auth.provider_requests" */
export type AuthProviderRequests_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AuthProviderRequests_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** append existing jsonb value of filtered columns with new jsonb value */
export type AuthProviderRequests_Append_Input = {
  options?: InputMaybe<Scalars['jsonb']['input']>
}

/** Boolean expression to filter rows from the table "auth.provider_requests". All fields are combined with a logical 'AND'. */
export type AuthProviderRequests_Bool_Exp = {
  _and?: InputMaybe<Array<AuthProviderRequests_Bool_Exp>>
  _not?: InputMaybe<AuthProviderRequests_Bool_Exp>
  _or?: InputMaybe<Array<AuthProviderRequests_Bool_Exp>>
  id?: InputMaybe<Uuid_Comparison_Exp>
  options?: InputMaybe<Jsonb_Comparison_Exp>
}

/** unique or primary key constraints on table "auth.provider_requests" */
export enum AuthProviderRequests_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProviderRequestsPkey = 'provider_requests_pkey',
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type AuthProviderRequests_Delete_At_Path_Input = {
  options?: InputMaybe<Array<Scalars['String']['input']>>
}

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type AuthProviderRequests_Delete_Elem_Input = {
  options?: InputMaybe<Scalars['Int']['input']>
}

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type AuthProviderRequests_Delete_Key_Input = {
  options?: InputMaybe<Scalars['String']['input']>
}

/** input type for inserting data into table "auth.provider_requests" */
export type AuthProviderRequests_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>
  options?: InputMaybe<Scalars['jsonb']['input']>
}

/** aggregate max on columns */
export type AuthProviderRequests_Max_Fields = {
  __typename?: 'authProviderRequests_max_fields'
  id?: Maybe<Scalars['uuid']['output']>
}

/** aggregate min on columns */
export type AuthProviderRequests_Min_Fields = {
  __typename?: 'authProviderRequests_min_fields'
  id?: Maybe<Scalars['uuid']['output']>
}

/** response of any mutation on the table "auth.provider_requests" */
export type AuthProviderRequests_Mutation_Response = {
  __typename?: 'authProviderRequests_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<AuthProviderRequests>
}

/** on_conflict condition type for table "auth.provider_requests" */
export type AuthProviderRequests_On_Conflict = {
  constraint: AuthProviderRequests_Constraint
  update_columns?: Array<AuthProviderRequests_Update_Column>
  where?: InputMaybe<AuthProviderRequests_Bool_Exp>
}

/** Ordering options when selecting data from "auth.provider_requests". */
export type AuthProviderRequests_Order_By = {
  id?: InputMaybe<Order_By>
  options?: InputMaybe<Order_By>
}

/** primary key columns input for table: auth.provider_requests */
export type AuthProviderRequests_Pk_Columns_Input = {
  id: Scalars['uuid']['input']
}

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type AuthProviderRequests_Prepend_Input = {
  options?: InputMaybe<Scalars['jsonb']['input']>
}

/** select columns of table "auth.provider_requests" */
export enum AuthProviderRequests_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Options = 'options',
}

/** input type for updating data in table "auth.provider_requests" */
export type AuthProviderRequests_Set_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>
  options?: InputMaybe<Scalars['jsonb']['input']>
}

/** Streaming cursor of the table "authProviderRequests" */
export type AuthProviderRequests_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AuthProviderRequests_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type AuthProviderRequests_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>
  options?: InputMaybe<Scalars['jsonb']['input']>
}

/** update columns of table "auth.provider_requests" */
export enum AuthProviderRequests_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Options = 'options',
}

export type AuthProviderRequests_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<AuthProviderRequests_Append_Input>
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<AuthProviderRequests_Delete_At_Path_Input>
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<AuthProviderRequests_Delete_Elem_Input>
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<AuthProviderRequests_Delete_Key_Input>
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<AuthProviderRequests_Prepend_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuthProviderRequests_Set_Input>
  /** filter the rows which have to be updated */
  where: AuthProviderRequests_Bool_Exp
}

/** List of available Oauth providers. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthProviders = {
  __typename?: 'authProviders'
  id: Scalars['String']['output']
  /** An array relationship */
  userProviders: Array<AuthUserProviders>
  /** An aggregate relationship */
  userProviders_aggregate: AuthUserProviders_Aggregate
}

/** List of available Oauth providers. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthProvidersUserProvidersArgs = {
  distinct_on?: InputMaybe<Array<AuthUserProviders_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<AuthUserProviders_Order_By>>
  where?: InputMaybe<AuthUserProviders_Bool_Exp>
}

/** List of available Oauth providers. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthProvidersUserProviders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthUserProviders_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<AuthUserProviders_Order_By>>
  where?: InputMaybe<AuthUserProviders_Bool_Exp>
}

/** aggregated selection of "auth.providers" */
export type AuthProviders_Aggregate = {
  __typename?: 'authProviders_aggregate'
  aggregate?: Maybe<AuthProviders_Aggregate_Fields>
  nodes: Array<AuthProviders>
}

/** aggregate fields of "auth.providers" */
export type AuthProviders_Aggregate_Fields = {
  __typename?: 'authProviders_aggregate_fields'
  count: Scalars['Int']['output']
  max?: Maybe<AuthProviders_Max_Fields>
  min?: Maybe<AuthProviders_Min_Fields>
}

/** aggregate fields of "auth.providers" */
export type AuthProviders_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AuthProviders_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** Boolean expression to filter rows from the table "auth.providers". All fields are combined with a logical 'AND'. */
export type AuthProviders_Bool_Exp = {
  _and?: InputMaybe<Array<AuthProviders_Bool_Exp>>
  _not?: InputMaybe<AuthProviders_Bool_Exp>
  _or?: InputMaybe<Array<AuthProviders_Bool_Exp>>
  id?: InputMaybe<String_Comparison_Exp>
  userProviders?: InputMaybe<AuthUserProviders_Bool_Exp>
  userProviders_aggregate?: InputMaybe<AuthUserProviders_Aggregate_Bool_Exp>
}

/** unique or primary key constraints on table "auth.providers" */
export enum AuthProviders_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProvidersPkey = 'providers_pkey',
}

/** input type for inserting data into table "auth.providers" */
export type AuthProviders_Insert_Input = {
  id?: InputMaybe<Scalars['String']['input']>
  userProviders?: InputMaybe<AuthUserProviders_Arr_Rel_Insert_Input>
}

/** aggregate max on columns */
export type AuthProviders_Max_Fields = {
  __typename?: 'authProviders_max_fields'
  id?: Maybe<Scalars['String']['output']>
}

/** aggregate min on columns */
export type AuthProviders_Min_Fields = {
  __typename?: 'authProviders_min_fields'
  id?: Maybe<Scalars['String']['output']>
}

/** response of any mutation on the table "auth.providers" */
export type AuthProviders_Mutation_Response = {
  __typename?: 'authProviders_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<AuthProviders>
}

/** input type for inserting object relation for remote table "auth.providers" */
export type AuthProviders_Obj_Rel_Insert_Input = {
  data: AuthProviders_Insert_Input
  /** upsert condition */
  on_conflict?: InputMaybe<AuthProviders_On_Conflict>
}

/** on_conflict condition type for table "auth.providers" */
export type AuthProviders_On_Conflict = {
  constraint: AuthProviders_Constraint
  update_columns?: Array<AuthProviders_Update_Column>
  where?: InputMaybe<AuthProviders_Bool_Exp>
}

/** Ordering options when selecting data from "auth.providers". */
export type AuthProviders_Order_By = {
  id?: InputMaybe<Order_By>
  userProviders_aggregate?: InputMaybe<AuthUserProviders_Aggregate_Order_By>
}

/** primary key columns input for table: auth.providers */
export type AuthProviders_Pk_Columns_Input = {
  id: Scalars['String']['input']
}

/** select columns of table "auth.providers" */
export enum AuthProviders_Select_Column {
  /** column name */
  Id = 'id',
}

/** input type for updating data in table "auth.providers" */
export type AuthProviders_Set_Input = {
  id?: InputMaybe<Scalars['String']['input']>
}

/** Streaming cursor of the table "authProviders" */
export type AuthProviders_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AuthProviders_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type AuthProviders_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['String']['input']>
}

/** update columns of table "auth.providers" */
export enum AuthProviders_Update_Column {
  /** column name */
  Id = 'id',
}

export type AuthProviders_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuthProviders_Set_Input>
  /** filter the rows which have to be updated */
  where: AuthProviders_Bool_Exp
}

/** columns and relationships of "auth.refresh_token_types" */
export type AuthRefreshTokenTypes = {
  __typename?: 'authRefreshTokenTypes'
  comment?: Maybe<Scalars['String']['output']>
  /** An array relationship */
  refreshTokens: Array<AuthRefreshTokens>
  /** An aggregate relationship */
  refreshTokens_aggregate: AuthRefreshTokens_Aggregate
  value: Scalars['String']['output']
}

/** columns and relationships of "auth.refresh_token_types" */
export type AuthRefreshTokenTypesRefreshTokensArgs = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokens_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<AuthRefreshTokens_Order_By>>
  where?: InputMaybe<AuthRefreshTokens_Bool_Exp>
}

/** columns and relationships of "auth.refresh_token_types" */
export type AuthRefreshTokenTypesRefreshTokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokens_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<AuthRefreshTokens_Order_By>>
  where?: InputMaybe<AuthRefreshTokens_Bool_Exp>
}

/** aggregated selection of "auth.refresh_token_types" */
export type AuthRefreshTokenTypes_Aggregate = {
  __typename?: 'authRefreshTokenTypes_aggregate'
  aggregate?: Maybe<AuthRefreshTokenTypes_Aggregate_Fields>
  nodes: Array<AuthRefreshTokenTypes>
}

/** aggregate fields of "auth.refresh_token_types" */
export type AuthRefreshTokenTypes_Aggregate_Fields = {
  __typename?: 'authRefreshTokenTypes_aggregate_fields'
  count: Scalars['Int']['output']
  max?: Maybe<AuthRefreshTokenTypes_Max_Fields>
  min?: Maybe<AuthRefreshTokenTypes_Min_Fields>
}

/** aggregate fields of "auth.refresh_token_types" */
export type AuthRefreshTokenTypes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AuthRefreshTokenTypes_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** Boolean expression to filter rows from the table "auth.refresh_token_types". All fields are combined with a logical 'AND'. */
export type AuthRefreshTokenTypes_Bool_Exp = {
  _and?: InputMaybe<Array<AuthRefreshTokenTypes_Bool_Exp>>
  _not?: InputMaybe<AuthRefreshTokenTypes_Bool_Exp>
  _or?: InputMaybe<Array<AuthRefreshTokenTypes_Bool_Exp>>
  comment?: InputMaybe<String_Comparison_Exp>
  refreshTokens?: InputMaybe<AuthRefreshTokens_Bool_Exp>
  refreshTokens_aggregate?: InputMaybe<AuthRefreshTokens_Aggregate_Bool_Exp>
  value?: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "auth.refresh_token_types" */
export enum AuthRefreshTokenTypes_Constraint {
  /** unique or primary key constraint on columns "value" */
  RefreshTokenTypesPkey = 'refresh_token_types_pkey',
}

export enum AuthRefreshTokenTypes_Enum {
  /** Personal access token */
  Pat = 'pat',
  /** Regular refresh token */
  Regular = 'regular',
}

/** Boolean expression to compare columns of type "authRefreshTokenTypes_enum". All fields are combined with logical 'AND'. */
export type AuthRefreshTokenTypes_Enum_Comparison_Exp = {
  _eq?: InputMaybe<AuthRefreshTokenTypes_Enum>
  _in?: InputMaybe<Array<AuthRefreshTokenTypes_Enum>>
  _is_null?: InputMaybe<Scalars['Boolean']['input']>
  _neq?: InputMaybe<AuthRefreshTokenTypes_Enum>
  _nin?: InputMaybe<Array<AuthRefreshTokenTypes_Enum>>
}

/** input type for inserting data into table "auth.refresh_token_types" */
export type AuthRefreshTokenTypes_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>
  refreshTokens?: InputMaybe<AuthRefreshTokens_Arr_Rel_Insert_Input>
  value?: InputMaybe<Scalars['String']['input']>
}

/** aggregate max on columns */
export type AuthRefreshTokenTypes_Max_Fields = {
  __typename?: 'authRefreshTokenTypes_max_fields'
  comment?: Maybe<Scalars['String']['output']>
  value?: Maybe<Scalars['String']['output']>
}

/** aggregate min on columns */
export type AuthRefreshTokenTypes_Min_Fields = {
  __typename?: 'authRefreshTokenTypes_min_fields'
  comment?: Maybe<Scalars['String']['output']>
  value?: Maybe<Scalars['String']['output']>
}

/** response of any mutation on the table "auth.refresh_token_types" */
export type AuthRefreshTokenTypes_Mutation_Response = {
  __typename?: 'authRefreshTokenTypes_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<AuthRefreshTokenTypes>
}

/** on_conflict condition type for table "auth.refresh_token_types" */
export type AuthRefreshTokenTypes_On_Conflict = {
  constraint: AuthRefreshTokenTypes_Constraint
  update_columns?: Array<AuthRefreshTokenTypes_Update_Column>
  where?: InputMaybe<AuthRefreshTokenTypes_Bool_Exp>
}

/** Ordering options when selecting data from "auth.refresh_token_types". */
export type AuthRefreshTokenTypes_Order_By = {
  comment?: InputMaybe<Order_By>
  refreshTokens_aggregate?: InputMaybe<AuthRefreshTokens_Aggregate_Order_By>
  value?: InputMaybe<Order_By>
}

/** primary key columns input for table: auth.refresh_token_types */
export type AuthRefreshTokenTypes_Pk_Columns_Input = {
  value: Scalars['String']['input']
}

/** select columns of table "auth.refresh_token_types" */
export enum AuthRefreshTokenTypes_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value',
}

/** input type for updating data in table "auth.refresh_token_types" */
export type AuthRefreshTokenTypes_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>
  value?: InputMaybe<Scalars['String']['input']>
}

/** Streaming cursor of the table "authRefreshTokenTypes" */
export type AuthRefreshTokenTypes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AuthRefreshTokenTypes_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type AuthRefreshTokenTypes_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>
  value?: InputMaybe<Scalars['String']['input']>
}

/** update columns of table "auth.refresh_token_types" */
export enum AuthRefreshTokenTypes_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value',
}

export type AuthRefreshTokenTypes_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuthRefreshTokenTypes_Set_Input>
  /** filter the rows which have to be updated */
  where: AuthRefreshTokenTypes_Bool_Exp
}

/** User refresh tokens. Hasura auth uses them to rotate new access tokens as long as the refresh token is not expired. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthRefreshTokens = {
  __typename?: 'authRefreshTokens'
  createdAt: Scalars['timestamptz']['output']
  expiresAt: Scalars['timestamptz']['output']
  id: Scalars['uuid']['output']
  metadata?: Maybe<Scalars['jsonb']['output']>
  refreshTokenHash?: Maybe<Scalars['String']['output']>
  type: AuthRefreshTokenTypes_Enum
  /** An object relationship */
  user: Users
  userId: Scalars['uuid']['output']
}

/** User refresh tokens. Hasura auth uses them to rotate new access tokens as long as the refresh token is not expired. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthRefreshTokensMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>
}

/** aggregated selection of "auth.refresh_tokens" */
export type AuthRefreshTokens_Aggregate = {
  __typename?: 'authRefreshTokens_aggregate'
  aggregate?: Maybe<AuthRefreshTokens_Aggregate_Fields>
  nodes: Array<AuthRefreshTokens>
}

export type AuthRefreshTokens_Aggregate_Bool_Exp = {
  count?: InputMaybe<AuthRefreshTokens_Aggregate_Bool_Exp_Count>
}

export type AuthRefreshTokens_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<AuthRefreshTokens_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<AuthRefreshTokens_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "auth.refresh_tokens" */
export type AuthRefreshTokens_Aggregate_Fields = {
  __typename?: 'authRefreshTokens_aggregate_fields'
  count: Scalars['Int']['output']
  max?: Maybe<AuthRefreshTokens_Max_Fields>
  min?: Maybe<AuthRefreshTokens_Min_Fields>
}

/** aggregate fields of "auth.refresh_tokens" */
export type AuthRefreshTokens_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AuthRefreshTokens_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** order by aggregate values of table "auth.refresh_tokens" */
export type AuthRefreshTokens_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>
  max?: InputMaybe<AuthRefreshTokens_Max_Order_By>
  min?: InputMaybe<AuthRefreshTokens_Min_Order_By>
}

/** append existing jsonb value of filtered columns with new jsonb value */
export type AuthRefreshTokens_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>
}

/** input type for inserting array relation for remote table "auth.refresh_tokens" */
export type AuthRefreshTokens_Arr_Rel_Insert_Input = {
  data: Array<AuthRefreshTokens_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<AuthRefreshTokens_On_Conflict>
}

/** Boolean expression to filter rows from the table "auth.refresh_tokens". All fields are combined with a logical 'AND'. */
export type AuthRefreshTokens_Bool_Exp = {
  _and?: InputMaybe<Array<AuthRefreshTokens_Bool_Exp>>
  _not?: InputMaybe<AuthRefreshTokens_Bool_Exp>
  _or?: InputMaybe<Array<AuthRefreshTokens_Bool_Exp>>
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>
  expiresAt?: InputMaybe<Timestamptz_Comparison_Exp>
  id?: InputMaybe<Uuid_Comparison_Exp>
  metadata?: InputMaybe<Jsonb_Comparison_Exp>
  refreshTokenHash?: InputMaybe<String_Comparison_Exp>
  type?: InputMaybe<AuthRefreshTokenTypes_Enum_Comparison_Exp>
  user?: InputMaybe<Users_Bool_Exp>
  userId?: InputMaybe<Uuid_Comparison_Exp>
}

/** unique or primary key constraints on table "auth.refresh_tokens" */
export enum AuthRefreshTokens_Constraint {
  /** unique or primary key constraint on columns "id" */
  RefreshTokensPkey = 'refresh_tokens_pkey',
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type AuthRefreshTokens_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']['input']>>
}

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type AuthRefreshTokens_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']['input']>
}

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type AuthRefreshTokens_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']['input']>
}

/** input type for inserting data into table "auth.refresh_tokens" */
export type AuthRefreshTokens_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>
  expiresAt?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  metadata?: InputMaybe<Scalars['jsonb']['input']>
  refreshTokenHash?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<AuthRefreshTokenTypes_Enum>
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>
  userId?: InputMaybe<Scalars['uuid']['input']>
}

/** aggregate max on columns */
export type AuthRefreshTokens_Max_Fields = {
  __typename?: 'authRefreshTokens_max_fields'
  createdAt?: Maybe<Scalars['timestamptz']['output']>
  expiresAt?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['uuid']['output']>
  refreshTokenHash?: Maybe<Scalars['String']['output']>
  userId?: Maybe<Scalars['uuid']['output']>
}

/** order by max() on columns of table "auth.refresh_tokens" */
export type AuthRefreshTokens_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>
  expiresAt?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  refreshTokenHash?: InputMaybe<Order_By>
  userId?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type AuthRefreshTokens_Min_Fields = {
  __typename?: 'authRefreshTokens_min_fields'
  createdAt?: Maybe<Scalars['timestamptz']['output']>
  expiresAt?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['uuid']['output']>
  refreshTokenHash?: Maybe<Scalars['String']['output']>
  userId?: Maybe<Scalars['uuid']['output']>
}

/** order by min() on columns of table "auth.refresh_tokens" */
export type AuthRefreshTokens_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>
  expiresAt?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  refreshTokenHash?: InputMaybe<Order_By>
  userId?: InputMaybe<Order_By>
}

/** response of any mutation on the table "auth.refresh_tokens" */
export type AuthRefreshTokens_Mutation_Response = {
  __typename?: 'authRefreshTokens_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<AuthRefreshTokens>
}

/** on_conflict condition type for table "auth.refresh_tokens" */
export type AuthRefreshTokens_On_Conflict = {
  constraint: AuthRefreshTokens_Constraint
  update_columns?: Array<AuthRefreshTokens_Update_Column>
  where?: InputMaybe<AuthRefreshTokens_Bool_Exp>
}

/** Ordering options when selecting data from "auth.refresh_tokens". */
export type AuthRefreshTokens_Order_By = {
  createdAt?: InputMaybe<Order_By>
  expiresAt?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  metadata?: InputMaybe<Order_By>
  refreshTokenHash?: InputMaybe<Order_By>
  type?: InputMaybe<Order_By>
  user?: InputMaybe<Users_Order_By>
  userId?: InputMaybe<Order_By>
}

/** primary key columns input for table: auth.refresh_tokens */
export type AuthRefreshTokens_Pk_Columns_Input = {
  id: Scalars['uuid']['input']
}

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type AuthRefreshTokens_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>
}

/** select columns of table "auth.refresh_tokens" */
export enum AuthRefreshTokens_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ExpiresAt = 'expiresAt',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  RefreshTokenHash = 'refreshTokenHash',
  /** column name */
  Type = 'type',
  /** column name */
  UserId = 'userId',
}

/** input type for updating data in table "auth.refresh_tokens" */
export type AuthRefreshTokens_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>
  expiresAt?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  metadata?: InputMaybe<Scalars['jsonb']['input']>
  refreshTokenHash?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<AuthRefreshTokenTypes_Enum>
  userId?: InputMaybe<Scalars['uuid']['input']>
}

/** Streaming cursor of the table "authRefreshTokens" */
export type AuthRefreshTokens_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AuthRefreshTokens_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type AuthRefreshTokens_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>
  expiresAt?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  metadata?: InputMaybe<Scalars['jsonb']['input']>
  refreshTokenHash?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<AuthRefreshTokenTypes_Enum>
  userId?: InputMaybe<Scalars['uuid']['input']>
}

/** update columns of table "auth.refresh_tokens" */
export enum AuthRefreshTokens_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ExpiresAt = 'expiresAt',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  RefreshTokenHash = 'refreshTokenHash',
  /** column name */
  Type = 'type',
  /** column name */
  UserId = 'userId',
}

export type AuthRefreshTokens_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<AuthRefreshTokens_Append_Input>
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<AuthRefreshTokens_Delete_At_Path_Input>
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<AuthRefreshTokens_Delete_Elem_Input>
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<AuthRefreshTokens_Delete_Key_Input>
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<AuthRefreshTokens_Prepend_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuthRefreshTokens_Set_Input>
  /** filter the rows which have to be updated */
  where: AuthRefreshTokens_Bool_Exp
}

/** Persistent Hasura roles for users. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthRoles = {
  __typename?: 'authRoles'
  role: Scalars['String']['output']
  /** An array relationship */
  userRoles: Array<AuthUserRoles>
  /** An aggregate relationship */
  userRoles_aggregate: AuthUserRoles_Aggregate
  /** An array relationship */
  usersByDefaultRole: Array<Users>
  /** An aggregate relationship */
  usersByDefaultRole_aggregate: Users_Aggregate
}

/** Persistent Hasura roles for users. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthRolesUserRolesArgs = {
  distinct_on?: InputMaybe<Array<AuthUserRoles_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<AuthUserRoles_Order_By>>
  where?: InputMaybe<AuthUserRoles_Bool_Exp>
}

/** Persistent Hasura roles for users. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthRolesUserRoles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthUserRoles_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<AuthUserRoles_Order_By>>
  where?: InputMaybe<AuthUserRoles_Bool_Exp>
}

/** Persistent Hasura roles for users. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthRolesUsersByDefaultRoleArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Users_Order_By>>
  where?: InputMaybe<Users_Bool_Exp>
}

/** Persistent Hasura roles for users. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthRolesUsersByDefaultRole_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Users_Order_By>>
  where?: InputMaybe<Users_Bool_Exp>
}

/** aggregated selection of "auth.roles" */
export type AuthRoles_Aggregate = {
  __typename?: 'authRoles_aggregate'
  aggregate?: Maybe<AuthRoles_Aggregate_Fields>
  nodes: Array<AuthRoles>
}

/** aggregate fields of "auth.roles" */
export type AuthRoles_Aggregate_Fields = {
  __typename?: 'authRoles_aggregate_fields'
  count: Scalars['Int']['output']
  max?: Maybe<AuthRoles_Max_Fields>
  min?: Maybe<AuthRoles_Min_Fields>
}

/** aggregate fields of "auth.roles" */
export type AuthRoles_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AuthRoles_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** Boolean expression to filter rows from the table "auth.roles". All fields are combined with a logical 'AND'. */
export type AuthRoles_Bool_Exp = {
  _and?: InputMaybe<Array<AuthRoles_Bool_Exp>>
  _not?: InputMaybe<AuthRoles_Bool_Exp>
  _or?: InputMaybe<Array<AuthRoles_Bool_Exp>>
  role?: InputMaybe<String_Comparison_Exp>
  userRoles?: InputMaybe<AuthUserRoles_Bool_Exp>
  userRoles_aggregate?: InputMaybe<AuthUserRoles_Aggregate_Bool_Exp>
  usersByDefaultRole?: InputMaybe<Users_Bool_Exp>
  usersByDefaultRole_aggregate?: InputMaybe<Users_Aggregate_Bool_Exp>
}

/** unique or primary key constraints on table "auth.roles" */
export enum AuthRoles_Constraint {
  /** unique or primary key constraint on columns "role" */
  RolesPkey = 'roles_pkey',
}

/** input type for inserting data into table "auth.roles" */
export type AuthRoles_Insert_Input = {
  role?: InputMaybe<Scalars['String']['input']>
  userRoles?: InputMaybe<AuthUserRoles_Arr_Rel_Insert_Input>
  usersByDefaultRole?: InputMaybe<Users_Arr_Rel_Insert_Input>
}

/** aggregate max on columns */
export type AuthRoles_Max_Fields = {
  __typename?: 'authRoles_max_fields'
  role?: Maybe<Scalars['String']['output']>
}

/** aggregate min on columns */
export type AuthRoles_Min_Fields = {
  __typename?: 'authRoles_min_fields'
  role?: Maybe<Scalars['String']['output']>
}

/** response of any mutation on the table "auth.roles" */
export type AuthRoles_Mutation_Response = {
  __typename?: 'authRoles_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<AuthRoles>
}

/** input type for inserting object relation for remote table "auth.roles" */
export type AuthRoles_Obj_Rel_Insert_Input = {
  data: AuthRoles_Insert_Input
  /** upsert condition */
  on_conflict?: InputMaybe<AuthRoles_On_Conflict>
}

/** on_conflict condition type for table "auth.roles" */
export type AuthRoles_On_Conflict = {
  constraint: AuthRoles_Constraint
  update_columns?: Array<AuthRoles_Update_Column>
  where?: InputMaybe<AuthRoles_Bool_Exp>
}

/** Ordering options when selecting data from "auth.roles". */
export type AuthRoles_Order_By = {
  role?: InputMaybe<Order_By>
  userRoles_aggregate?: InputMaybe<AuthUserRoles_Aggregate_Order_By>
  usersByDefaultRole_aggregate?: InputMaybe<Users_Aggregate_Order_By>
}

/** primary key columns input for table: auth.roles */
export type AuthRoles_Pk_Columns_Input = {
  role: Scalars['String']['input']
}

/** select columns of table "auth.roles" */
export enum AuthRoles_Select_Column {
  /** column name */
  Role = 'role',
}

/** input type for updating data in table "auth.roles" */
export type AuthRoles_Set_Input = {
  role?: InputMaybe<Scalars['String']['input']>
}

/** Streaming cursor of the table "authRoles" */
export type AuthRoles_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AuthRoles_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type AuthRoles_Stream_Cursor_Value_Input = {
  role?: InputMaybe<Scalars['String']['input']>
}

/** update columns of table "auth.roles" */
export enum AuthRoles_Update_Column {
  /** column name */
  Role = 'role',
}

export type AuthRoles_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuthRoles_Set_Input>
  /** filter the rows which have to be updated */
  where: AuthRoles_Bool_Exp
}

/** Active providers for a given user. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthUserProviders = {
  __typename?: 'authUserProviders'
  accessToken: Scalars['String']['output']
  createdAt: Scalars['timestamptz']['output']
  id: Scalars['uuid']['output']
  /** An object relationship */
  provider: AuthProviders
  providerId: Scalars['String']['output']
  providerUserId: Scalars['String']['output']
  refreshToken?: Maybe<Scalars['String']['output']>
  updatedAt: Scalars['timestamptz']['output']
  /** An object relationship */
  user: Users
  userId: Scalars['uuid']['output']
}

/** aggregated selection of "auth.user_providers" */
export type AuthUserProviders_Aggregate = {
  __typename?: 'authUserProviders_aggregate'
  aggregate?: Maybe<AuthUserProviders_Aggregate_Fields>
  nodes: Array<AuthUserProviders>
}

export type AuthUserProviders_Aggregate_Bool_Exp = {
  count?: InputMaybe<AuthUserProviders_Aggregate_Bool_Exp_Count>
}

export type AuthUserProviders_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<AuthUserProviders_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<AuthUserProviders_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "auth.user_providers" */
export type AuthUserProviders_Aggregate_Fields = {
  __typename?: 'authUserProviders_aggregate_fields'
  count: Scalars['Int']['output']
  max?: Maybe<AuthUserProviders_Max_Fields>
  min?: Maybe<AuthUserProviders_Min_Fields>
}

/** aggregate fields of "auth.user_providers" */
export type AuthUserProviders_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AuthUserProviders_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** order by aggregate values of table "auth.user_providers" */
export type AuthUserProviders_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>
  max?: InputMaybe<AuthUserProviders_Max_Order_By>
  min?: InputMaybe<AuthUserProviders_Min_Order_By>
}

/** input type for inserting array relation for remote table "auth.user_providers" */
export type AuthUserProviders_Arr_Rel_Insert_Input = {
  data: Array<AuthUserProviders_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<AuthUserProviders_On_Conflict>
}

/** Boolean expression to filter rows from the table "auth.user_providers". All fields are combined with a logical 'AND'. */
export type AuthUserProviders_Bool_Exp = {
  _and?: InputMaybe<Array<AuthUserProviders_Bool_Exp>>
  _not?: InputMaybe<AuthUserProviders_Bool_Exp>
  _or?: InputMaybe<Array<AuthUserProviders_Bool_Exp>>
  accessToken?: InputMaybe<String_Comparison_Exp>
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>
  id?: InputMaybe<Uuid_Comparison_Exp>
  provider?: InputMaybe<AuthProviders_Bool_Exp>
  providerId?: InputMaybe<String_Comparison_Exp>
  providerUserId?: InputMaybe<String_Comparison_Exp>
  refreshToken?: InputMaybe<String_Comparison_Exp>
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>
  user?: InputMaybe<Users_Bool_Exp>
  userId?: InputMaybe<Uuid_Comparison_Exp>
}

/** unique or primary key constraints on table "auth.user_providers" */
export enum AuthUserProviders_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserProvidersPkey = 'user_providers_pkey',
  /** unique or primary key constraint on columns "provider_user_id", "provider_id" */
  UserProvidersProviderIdProviderUserIdKey = 'user_providers_provider_id_provider_user_id_key',
}

/** input type for inserting data into table "auth.user_providers" */
export type AuthUserProviders_Insert_Input = {
  accessToken?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  provider?: InputMaybe<AuthProviders_Obj_Rel_Insert_Input>
  providerId?: InputMaybe<Scalars['String']['input']>
  providerUserId?: InputMaybe<Scalars['String']['input']>
  refreshToken?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>
  userId?: InputMaybe<Scalars['uuid']['input']>
}

/** aggregate max on columns */
export type AuthUserProviders_Max_Fields = {
  __typename?: 'authUserProviders_max_fields'
  accessToken?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['uuid']['output']>
  providerId?: Maybe<Scalars['String']['output']>
  providerUserId?: Maybe<Scalars['String']['output']>
  refreshToken?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['timestamptz']['output']>
  userId?: Maybe<Scalars['uuid']['output']>
}

/** order by max() on columns of table "auth.user_providers" */
export type AuthUserProviders_Max_Order_By = {
  accessToken?: InputMaybe<Order_By>
  createdAt?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  providerId?: InputMaybe<Order_By>
  providerUserId?: InputMaybe<Order_By>
  refreshToken?: InputMaybe<Order_By>
  updatedAt?: InputMaybe<Order_By>
  userId?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type AuthUserProviders_Min_Fields = {
  __typename?: 'authUserProviders_min_fields'
  accessToken?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['uuid']['output']>
  providerId?: Maybe<Scalars['String']['output']>
  providerUserId?: Maybe<Scalars['String']['output']>
  refreshToken?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['timestamptz']['output']>
  userId?: Maybe<Scalars['uuid']['output']>
}

/** order by min() on columns of table "auth.user_providers" */
export type AuthUserProviders_Min_Order_By = {
  accessToken?: InputMaybe<Order_By>
  createdAt?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  providerId?: InputMaybe<Order_By>
  providerUserId?: InputMaybe<Order_By>
  refreshToken?: InputMaybe<Order_By>
  updatedAt?: InputMaybe<Order_By>
  userId?: InputMaybe<Order_By>
}

/** response of any mutation on the table "auth.user_providers" */
export type AuthUserProviders_Mutation_Response = {
  __typename?: 'authUserProviders_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<AuthUserProviders>
}

/** on_conflict condition type for table "auth.user_providers" */
export type AuthUserProviders_On_Conflict = {
  constraint: AuthUserProviders_Constraint
  update_columns?: Array<AuthUserProviders_Update_Column>
  where?: InputMaybe<AuthUserProviders_Bool_Exp>
}

/** Ordering options when selecting data from "auth.user_providers". */
export type AuthUserProviders_Order_By = {
  accessToken?: InputMaybe<Order_By>
  createdAt?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  provider?: InputMaybe<AuthProviders_Order_By>
  providerId?: InputMaybe<Order_By>
  providerUserId?: InputMaybe<Order_By>
  refreshToken?: InputMaybe<Order_By>
  updatedAt?: InputMaybe<Order_By>
  user?: InputMaybe<Users_Order_By>
  userId?: InputMaybe<Order_By>
}

/** primary key columns input for table: auth.user_providers */
export type AuthUserProviders_Pk_Columns_Input = {
  id: Scalars['uuid']['input']
}

/** select columns of table "auth.user_providers" */
export enum AuthUserProviders_Select_Column {
  /** column name */
  AccessToken = 'accessToken',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  ProviderId = 'providerId',
  /** column name */
  ProviderUserId = 'providerUserId',
  /** column name */
  RefreshToken = 'refreshToken',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId',
}

/** input type for updating data in table "auth.user_providers" */
export type AuthUserProviders_Set_Input = {
  accessToken?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  providerId?: InputMaybe<Scalars['String']['input']>
  providerUserId?: InputMaybe<Scalars['String']['input']>
  refreshToken?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>
  userId?: InputMaybe<Scalars['uuid']['input']>
}

/** Streaming cursor of the table "authUserProviders" */
export type AuthUserProviders_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AuthUserProviders_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type AuthUserProviders_Stream_Cursor_Value_Input = {
  accessToken?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  providerId?: InputMaybe<Scalars['String']['input']>
  providerUserId?: InputMaybe<Scalars['String']['input']>
  refreshToken?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>
  userId?: InputMaybe<Scalars['uuid']['input']>
}

/** update columns of table "auth.user_providers" */
export enum AuthUserProviders_Update_Column {
  /** column name */
  AccessToken = 'accessToken',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  ProviderId = 'providerId',
  /** column name */
  ProviderUserId = 'providerUserId',
  /** column name */
  RefreshToken = 'refreshToken',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId',
}

export type AuthUserProviders_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuthUserProviders_Set_Input>
  /** filter the rows which have to be updated */
  where: AuthUserProviders_Bool_Exp
}

/** Roles of users. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthUserRoles = {
  __typename?: 'authUserRoles'
  createdAt: Scalars['timestamptz']['output']
  id: Scalars['uuid']['output']
  role: Scalars['String']['output']
  /** An object relationship */
  roleByRole: AuthRoles
  /** An object relationship */
  user: Users
  userId: Scalars['uuid']['output']
}

/** aggregated selection of "auth.user_roles" */
export type AuthUserRoles_Aggregate = {
  __typename?: 'authUserRoles_aggregate'
  aggregate?: Maybe<AuthUserRoles_Aggregate_Fields>
  nodes: Array<AuthUserRoles>
}

export type AuthUserRoles_Aggregate_Bool_Exp = {
  count?: InputMaybe<AuthUserRoles_Aggregate_Bool_Exp_Count>
}

export type AuthUserRoles_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<AuthUserRoles_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<AuthUserRoles_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "auth.user_roles" */
export type AuthUserRoles_Aggregate_Fields = {
  __typename?: 'authUserRoles_aggregate_fields'
  count: Scalars['Int']['output']
  max?: Maybe<AuthUserRoles_Max_Fields>
  min?: Maybe<AuthUserRoles_Min_Fields>
}

/** aggregate fields of "auth.user_roles" */
export type AuthUserRoles_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AuthUserRoles_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** order by aggregate values of table "auth.user_roles" */
export type AuthUserRoles_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>
  max?: InputMaybe<AuthUserRoles_Max_Order_By>
  min?: InputMaybe<AuthUserRoles_Min_Order_By>
}

/** input type for inserting array relation for remote table "auth.user_roles" */
export type AuthUserRoles_Arr_Rel_Insert_Input = {
  data: Array<AuthUserRoles_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<AuthUserRoles_On_Conflict>
}

/** Boolean expression to filter rows from the table "auth.user_roles". All fields are combined with a logical 'AND'. */
export type AuthUserRoles_Bool_Exp = {
  _and?: InputMaybe<Array<AuthUserRoles_Bool_Exp>>
  _not?: InputMaybe<AuthUserRoles_Bool_Exp>
  _or?: InputMaybe<Array<AuthUserRoles_Bool_Exp>>
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>
  id?: InputMaybe<Uuid_Comparison_Exp>
  role?: InputMaybe<String_Comparison_Exp>
  roleByRole?: InputMaybe<AuthRoles_Bool_Exp>
  user?: InputMaybe<Users_Bool_Exp>
  userId?: InputMaybe<Uuid_Comparison_Exp>
}

/** unique or primary key constraints on table "auth.user_roles" */
export enum AuthUserRoles_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserRolesPkey = 'user_roles_pkey',
  /** unique or primary key constraint on columns "user_id", "role" */
  UserRolesUserIdRoleKey = 'user_roles_user_id_role_key',
}

/** input type for inserting data into table "auth.user_roles" */
export type AuthUserRoles_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  role?: InputMaybe<Scalars['String']['input']>
  roleByRole?: InputMaybe<AuthRoles_Obj_Rel_Insert_Input>
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>
  userId?: InputMaybe<Scalars['uuid']['input']>
}

/** aggregate max on columns */
export type AuthUserRoles_Max_Fields = {
  __typename?: 'authUserRoles_max_fields'
  createdAt?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['uuid']['output']>
  role?: Maybe<Scalars['String']['output']>
  userId?: Maybe<Scalars['uuid']['output']>
}

/** order by max() on columns of table "auth.user_roles" */
export type AuthUserRoles_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  role?: InputMaybe<Order_By>
  userId?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type AuthUserRoles_Min_Fields = {
  __typename?: 'authUserRoles_min_fields'
  createdAt?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['uuid']['output']>
  role?: Maybe<Scalars['String']['output']>
  userId?: Maybe<Scalars['uuid']['output']>
}

/** order by min() on columns of table "auth.user_roles" */
export type AuthUserRoles_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  role?: InputMaybe<Order_By>
  userId?: InputMaybe<Order_By>
}

/** response of any mutation on the table "auth.user_roles" */
export type AuthUserRoles_Mutation_Response = {
  __typename?: 'authUserRoles_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<AuthUserRoles>
}

/** on_conflict condition type for table "auth.user_roles" */
export type AuthUserRoles_On_Conflict = {
  constraint: AuthUserRoles_Constraint
  update_columns?: Array<AuthUserRoles_Update_Column>
  where?: InputMaybe<AuthUserRoles_Bool_Exp>
}

/** Ordering options when selecting data from "auth.user_roles". */
export type AuthUserRoles_Order_By = {
  createdAt?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  role?: InputMaybe<Order_By>
  roleByRole?: InputMaybe<AuthRoles_Order_By>
  user?: InputMaybe<Users_Order_By>
  userId?: InputMaybe<Order_By>
}

/** primary key columns input for table: auth.user_roles */
export type AuthUserRoles_Pk_Columns_Input = {
  id: Scalars['uuid']['input']
}

/** select columns of table "auth.user_roles" */
export enum AuthUserRoles_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Role = 'role',
  /** column name */
  UserId = 'userId',
}

/** input type for updating data in table "auth.user_roles" */
export type AuthUserRoles_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  role?: InputMaybe<Scalars['String']['input']>
  userId?: InputMaybe<Scalars['uuid']['input']>
}

/** Streaming cursor of the table "authUserRoles" */
export type AuthUserRoles_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AuthUserRoles_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type AuthUserRoles_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  role?: InputMaybe<Scalars['String']['input']>
  userId?: InputMaybe<Scalars['uuid']['input']>
}

/** update columns of table "auth.user_roles" */
export enum AuthUserRoles_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Role = 'role',
  /** column name */
  UserId = 'userId',
}

export type AuthUserRoles_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuthUserRoles_Set_Input>
  /** filter the rows which have to be updated */
  where: AuthUserRoles_Bool_Exp
}

/** User webauthn security keys. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthUserSecurityKeys = {
  __typename?: 'authUserSecurityKeys'
  counter: Scalars['bigint']['output']
  credentialId: Scalars['String']['output']
  credentialPublicKey?: Maybe<Scalars['bytea']['output']>
  id: Scalars['uuid']['output']
  nickname?: Maybe<Scalars['String']['output']>
  transports: Scalars['String']['output']
  /** An object relationship */
  user: Users
  userId: Scalars['uuid']['output']
}

/** aggregated selection of "auth.user_security_keys" */
export type AuthUserSecurityKeys_Aggregate = {
  __typename?: 'authUserSecurityKeys_aggregate'
  aggregate?: Maybe<AuthUserSecurityKeys_Aggregate_Fields>
  nodes: Array<AuthUserSecurityKeys>
}

export type AuthUserSecurityKeys_Aggregate_Bool_Exp = {
  count?: InputMaybe<AuthUserSecurityKeys_Aggregate_Bool_Exp_Count>
}

export type AuthUserSecurityKeys_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<AuthUserSecurityKeys_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<AuthUserSecurityKeys_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "auth.user_security_keys" */
export type AuthUserSecurityKeys_Aggregate_Fields = {
  __typename?: 'authUserSecurityKeys_aggregate_fields'
  avg?: Maybe<AuthUserSecurityKeys_Avg_Fields>
  count: Scalars['Int']['output']
  max?: Maybe<AuthUserSecurityKeys_Max_Fields>
  min?: Maybe<AuthUserSecurityKeys_Min_Fields>
  stddev?: Maybe<AuthUserSecurityKeys_Stddev_Fields>
  stddev_pop?: Maybe<AuthUserSecurityKeys_Stddev_Pop_Fields>
  stddev_samp?: Maybe<AuthUserSecurityKeys_Stddev_Samp_Fields>
  sum?: Maybe<AuthUserSecurityKeys_Sum_Fields>
  var_pop?: Maybe<AuthUserSecurityKeys_Var_Pop_Fields>
  var_samp?: Maybe<AuthUserSecurityKeys_Var_Samp_Fields>
  variance?: Maybe<AuthUserSecurityKeys_Variance_Fields>
}

/** aggregate fields of "auth.user_security_keys" */
export type AuthUserSecurityKeys_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AuthUserSecurityKeys_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** order by aggregate values of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Aggregate_Order_By = {
  avg?: InputMaybe<AuthUserSecurityKeys_Avg_Order_By>
  count?: InputMaybe<Order_By>
  max?: InputMaybe<AuthUserSecurityKeys_Max_Order_By>
  min?: InputMaybe<AuthUserSecurityKeys_Min_Order_By>
  stddev?: InputMaybe<AuthUserSecurityKeys_Stddev_Order_By>
  stddev_pop?: InputMaybe<AuthUserSecurityKeys_Stddev_Pop_Order_By>
  stddev_samp?: InputMaybe<AuthUserSecurityKeys_Stddev_Samp_Order_By>
  sum?: InputMaybe<AuthUserSecurityKeys_Sum_Order_By>
  var_pop?: InputMaybe<AuthUserSecurityKeys_Var_Pop_Order_By>
  var_samp?: InputMaybe<AuthUserSecurityKeys_Var_Samp_Order_By>
  variance?: InputMaybe<AuthUserSecurityKeys_Variance_Order_By>
}

/** input type for inserting array relation for remote table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Arr_Rel_Insert_Input = {
  data: Array<AuthUserSecurityKeys_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<AuthUserSecurityKeys_On_Conflict>
}

/** aggregate avg on columns */
export type AuthUserSecurityKeys_Avg_Fields = {
  __typename?: 'authUserSecurityKeys_avg_fields'
  counter?: Maybe<Scalars['Float']['output']>
}

/** order by avg() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Avg_Order_By = {
  counter?: InputMaybe<Order_By>
}

/** Boolean expression to filter rows from the table "auth.user_security_keys". All fields are combined with a logical 'AND'. */
export type AuthUserSecurityKeys_Bool_Exp = {
  _and?: InputMaybe<Array<AuthUserSecurityKeys_Bool_Exp>>
  _not?: InputMaybe<AuthUserSecurityKeys_Bool_Exp>
  _or?: InputMaybe<Array<AuthUserSecurityKeys_Bool_Exp>>
  counter?: InputMaybe<Bigint_Comparison_Exp>
  credentialId?: InputMaybe<String_Comparison_Exp>
  credentialPublicKey?: InputMaybe<Bytea_Comparison_Exp>
  id?: InputMaybe<Uuid_Comparison_Exp>
  nickname?: InputMaybe<String_Comparison_Exp>
  transports?: InputMaybe<String_Comparison_Exp>
  user?: InputMaybe<Users_Bool_Exp>
  userId?: InputMaybe<Uuid_Comparison_Exp>
}

/** unique or primary key constraints on table "auth.user_security_keys" */
export enum AuthUserSecurityKeys_Constraint {
  /** unique or primary key constraint on columns "credential_id" */
  UserSecurityKeyCredentialIdKey = 'user_security_key_credential_id_key',
  /** unique or primary key constraint on columns "id" */
  UserSecurityKeysPkey = 'user_security_keys_pkey',
}

/** input type for incrementing numeric columns in table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Inc_Input = {
  counter?: InputMaybe<Scalars['bigint']['input']>
}

/** input type for inserting data into table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Insert_Input = {
  counter?: InputMaybe<Scalars['bigint']['input']>
  credentialId?: InputMaybe<Scalars['String']['input']>
  credentialPublicKey?: InputMaybe<Scalars['bytea']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  nickname?: InputMaybe<Scalars['String']['input']>
  transports?: InputMaybe<Scalars['String']['input']>
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>
  userId?: InputMaybe<Scalars['uuid']['input']>
}

/** aggregate max on columns */
export type AuthUserSecurityKeys_Max_Fields = {
  __typename?: 'authUserSecurityKeys_max_fields'
  counter?: Maybe<Scalars['bigint']['output']>
  credentialId?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['uuid']['output']>
  nickname?: Maybe<Scalars['String']['output']>
  transports?: Maybe<Scalars['String']['output']>
  userId?: Maybe<Scalars['uuid']['output']>
}

/** order by max() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Max_Order_By = {
  counter?: InputMaybe<Order_By>
  credentialId?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  nickname?: InputMaybe<Order_By>
  transports?: InputMaybe<Order_By>
  userId?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type AuthUserSecurityKeys_Min_Fields = {
  __typename?: 'authUserSecurityKeys_min_fields'
  counter?: Maybe<Scalars['bigint']['output']>
  credentialId?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['uuid']['output']>
  nickname?: Maybe<Scalars['String']['output']>
  transports?: Maybe<Scalars['String']['output']>
  userId?: Maybe<Scalars['uuid']['output']>
}

/** order by min() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Min_Order_By = {
  counter?: InputMaybe<Order_By>
  credentialId?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  nickname?: InputMaybe<Order_By>
  transports?: InputMaybe<Order_By>
  userId?: InputMaybe<Order_By>
}

/** response of any mutation on the table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Mutation_Response = {
  __typename?: 'authUserSecurityKeys_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<AuthUserSecurityKeys>
}

/** on_conflict condition type for table "auth.user_security_keys" */
export type AuthUserSecurityKeys_On_Conflict = {
  constraint: AuthUserSecurityKeys_Constraint
  update_columns?: Array<AuthUserSecurityKeys_Update_Column>
  where?: InputMaybe<AuthUserSecurityKeys_Bool_Exp>
}

/** Ordering options when selecting data from "auth.user_security_keys". */
export type AuthUserSecurityKeys_Order_By = {
  counter?: InputMaybe<Order_By>
  credentialId?: InputMaybe<Order_By>
  credentialPublicKey?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  nickname?: InputMaybe<Order_By>
  transports?: InputMaybe<Order_By>
  user?: InputMaybe<Users_Order_By>
  userId?: InputMaybe<Order_By>
}

/** primary key columns input for table: auth.user_security_keys */
export type AuthUserSecurityKeys_Pk_Columns_Input = {
  id: Scalars['uuid']['input']
}

/** select columns of table "auth.user_security_keys" */
export enum AuthUserSecurityKeys_Select_Column {
  /** column name */
  Counter = 'counter',
  /** column name */
  CredentialId = 'credentialId',
  /** column name */
  CredentialPublicKey = 'credentialPublicKey',
  /** column name */
  Id = 'id',
  /** column name */
  Nickname = 'nickname',
  /** column name */
  Transports = 'transports',
  /** column name */
  UserId = 'userId',
}

/** input type for updating data in table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Set_Input = {
  counter?: InputMaybe<Scalars['bigint']['input']>
  credentialId?: InputMaybe<Scalars['String']['input']>
  credentialPublicKey?: InputMaybe<Scalars['bytea']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  nickname?: InputMaybe<Scalars['String']['input']>
  transports?: InputMaybe<Scalars['String']['input']>
  userId?: InputMaybe<Scalars['uuid']['input']>
}

/** aggregate stddev on columns */
export type AuthUserSecurityKeys_Stddev_Fields = {
  __typename?: 'authUserSecurityKeys_stddev_fields'
  counter?: Maybe<Scalars['Float']['output']>
}

/** order by stddev() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Stddev_Order_By = {
  counter?: InputMaybe<Order_By>
}

/** aggregate stddev_pop on columns */
export type AuthUserSecurityKeys_Stddev_Pop_Fields = {
  __typename?: 'authUserSecurityKeys_stddev_pop_fields'
  counter?: Maybe<Scalars['Float']['output']>
}

/** order by stddev_pop() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Stddev_Pop_Order_By = {
  counter?: InputMaybe<Order_By>
}

/** aggregate stddev_samp on columns */
export type AuthUserSecurityKeys_Stddev_Samp_Fields = {
  __typename?: 'authUserSecurityKeys_stddev_samp_fields'
  counter?: Maybe<Scalars['Float']['output']>
}

/** order by stddev_samp() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Stddev_Samp_Order_By = {
  counter?: InputMaybe<Order_By>
}

/** Streaming cursor of the table "authUserSecurityKeys" */
export type AuthUserSecurityKeys_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AuthUserSecurityKeys_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type AuthUserSecurityKeys_Stream_Cursor_Value_Input = {
  counter?: InputMaybe<Scalars['bigint']['input']>
  credentialId?: InputMaybe<Scalars['String']['input']>
  credentialPublicKey?: InputMaybe<Scalars['bytea']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  nickname?: InputMaybe<Scalars['String']['input']>
  transports?: InputMaybe<Scalars['String']['input']>
  userId?: InputMaybe<Scalars['uuid']['input']>
}

/** aggregate sum on columns */
export type AuthUserSecurityKeys_Sum_Fields = {
  __typename?: 'authUserSecurityKeys_sum_fields'
  counter?: Maybe<Scalars['bigint']['output']>
}

/** order by sum() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Sum_Order_By = {
  counter?: InputMaybe<Order_By>
}

/** update columns of table "auth.user_security_keys" */
export enum AuthUserSecurityKeys_Update_Column {
  /** column name */
  Counter = 'counter',
  /** column name */
  CredentialId = 'credentialId',
  /** column name */
  CredentialPublicKey = 'credentialPublicKey',
  /** column name */
  Id = 'id',
  /** column name */
  Nickname = 'nickname',
  /** column name */
  Transports = 'transports',
  /** column name */
  UserId = 'userId',
}

export type AuthUserSecurityKeys_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AuthUserSecurityKeys_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuthUserSecurityKeys_Set_Input>
  /** filter the rows which have to be updated */
  where: AuthUserSecurityKeys_Bool_Exp
}

/** aggregate var_pop on columns */
export type AuthUserSecurityKeys_Var_Pop_Fields = {
  __typename?: 'authUserSecurityKeys_var_pop_fields'
  counter?: Maybe<Scalars['Float']['output']>
}

/** order by var_pop() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Var_Pop_Order_By = {
  counter?: InputMaybe<Order_By>
}

/** aggregate var_samp on columns */
export type AuthUserSecurityKeys_Var_Samp_Fields = {
  __typename?: 'authUserSecurityKeys_var_samp_fields'
  counter?: Maybe<Scalars['Float']['output']>
}

/** order by var_samp() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Var_Samp_Order_By = {
  counter?: InputMaybe<Order_By>
}

/** aggregate variance on columns */
export type AuthUserSecurityKeys_Variance_Fields = {
  __typename?: 'authUserSecurityKeys_variance_fields'
  counter?: Maybe<Scalars['Float']['output']>
}

/** order by variance() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Variance_Order_By = {
  counter?: InputMaybe<Order_By>
}

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bigint']['input']>
  _gt?: InputMaybe<Scalars['bigint']['input']>
  _gte?: InputMaybe<Scalars['bigint']['input']>
  _in?: InputMaybe<Array<Scalars['bigint']['input']>>
  _is_null?: InputMaybe<Scalars['Boolean']['input']>
  _lt?: InputMaybe<Scalars['bigint']['input']>
  _lte?: InputMaybe<Scalars['bigint']['input']>
  _neq?: InputMaybe<Scalars['bigint']['input']>
  _nin?: InputMaybe<Array<Scalars['bigint']['input']>>
}

/** columns and relationships of "storage.buckets" */
export type Buckets = {
  __typename?: 'buckets'
  cacheControl?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['timestamptz']['output']
  downloadExpiration: Scalars['Int']['output']
  /** An array relationship */
  files: Array<Files>
  /** An aggregate relationship */
  files_aggregate: Files_Aggregate
  id: Scalars['String']['output']
  maxUploadFileSize: Scalars['Int']['output']
  minUploadFileSize: Scalars['Int']['output']
  presignedUrlsEnabled: Scalars['Boolean']['output']
  updatedAt: Scalars['timestamptz']['output']
}

/** columns and relationships of "storage.buckets" */
export type BucketsFilesArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Files_Order_By>>
  where?: InputMaybe<Files_Bool_Exp>
}

/** columns and relationships of "storage.buckets" */
export type BucketsFiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Files_Order_By>>
  where?: InputMaybe<Files_Bool_Exp>
}

/** aggregated selection of "storage.buckets" */
export type Buckets_Aggregate = {
  __typename?: 'buckets_aggregate'
  aggregate?: Maybe<Buckets_Aggregate_Fields>
  nodes: Array<Buckets>
}

/** aggregate fields of "storage.buckets" */
export type Buckets_Aggregate_Fields = {
  __typename?: 'buckets_aggregate_fields'
  avg?: Maybe<Buckets_Avg_Fields>
  count: Scalars['Int']['output']
  max?: Maybe<Buckets_Max_Fields>
  min?: Maybe<Buckets_Min_Fields>
  stddev?: Maybe<Buckets_Stddev_Fields>
  stddev_pop?: Maybe<Buckets_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Buckets_Stddev_Samp_Fields>
  sum?: Maybe<Buckets_Sum_Fields>
  var_pop?: Maybe<Buckets_Var_Pop_Fields>
  var_samp?: Maybe<Buckets_Var_Samp_Fields>
  variance?: Maybe<Buckets_Variance_Fields>
}

/** aggregate fields of "storage.buckets" */
export type Buckets_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Buckets_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** aggregate avg on columns */
export type Buckets_Avg_Fields = {
  __typename?: 'buckets_avg_fields'
  downloadExpiration?: Maybe<Scalars['Float']['output']>
  maxUploadFileSize?: Maybe<Scalars['Float']['output']>
  minUploadFileSize?: Maybe<Scalars['Float']['output']>
}

/** Boolean expression to filter rows from the table "storage.buckets". All fields are combined with a logical 'AND'. */
export type Buckets_Bool_Exp = {
  _and?: InputMaybe<Array<Buckets_Bool_Exp>>
  _not?: InputMaybe<Buckets_Bool_Exp>
  _or?: InputMaybe<Array<Buckets_Bool_Exp>>
  cacheControl?: InputMaybe<String_Comparison_Exp>
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>
  downloadExpiration?: InputMaybe<Int_Comparison_Exp>
  files?: InputMaybe<Files_Bool_Exp>
  files_aggregate?: InputMaybe<Files_Aggregate_Bool_Exp>
  id?: InputMaybe<String_Comparison_Exp>
  maxUploadFileSize?: InputMaybe<Int_Comparison_Exp>
  minUploadFileSize?: InputMaybe<Int_Comparison_Exp>
  presignedUrlsEnabled?: InputMaybe<Boolean_Comparison_Exp>
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>
}

/** unique or primary key constraints on table "storage.buckets" */
export enum Buckets_Constraint {
  /** unique or primary key constraint on columns "id" */
  BucketsPkey = 'buckets_pkey',
}

/** input type for incrementing numeric columns in table "storage.buckets" */
export type Buckets_Inc_Input = {
  downloadExpiration?: InputMaybe<Scalars['Int']['input']>
  maxUploadFileSize?: InputMaybe<Scalars['Int']['input']>
  minUploadFileSize?: InputMaybe<Scalars['Int']['input']>
}

/** input type for inserting data into table "storage.buckets" */
export type Buckets_Insert_Input = {
  cacheControl?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>
  downloadExpiration?: InputMaybe<Scalars['Int']['input']>
  files?: InputMaybe<Files_Arr_Rel_Insert_Input>
  id?: InputMaybe<Scalars['String']['input']>
  maxUploadFileSize?: InputMaybe<Scalars['Int']['input']>
  minUploadFileSize?: InputMaybe<Scalars['Int']['input']>
  presignedUrlsEnabled?: InputMaybe<Scalars['Boolean']['input']>
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate max on columns */
export type Buckets_Max_Fields = {
  __typename?: 'buckets_max_fields'
  cacheControl?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['timestamptz']['output']>
  downloadExpiration?: Maybe<Scalars['Int']['output']>
  id?: Maybe<Scalars['String']['output']>
  maxUploadFileSize?: Maybe<Scalars['Int']['output']>
  minUploadFileSize?: Maybe<Scalars['Int']['output']>
  updatedAt?: Maybe<Scalars['timestamptz']['output']>
}

/** aggregate min on columns */
export type Buckets_Min_Fields = {
  __typename?: 'buckets_min_fields'
  cacheControl?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['timestamptz']['output']>
  downloadExpiration?: Maybe<Scalars['Int']['output']>
  id?: Maybe<Scalars['String']['output']>
  maxUploadFileSize?: Maybe<Scalars['Int']['output']>
  minUploadFileSize?: Maybe<Scalars['Int']['output']>
  updatedAt?: Maybe<Scalars['timestamptz']['output']>
}

/** response of any mutation on the table "storage.buckets" */
export type Buckets_Mutation_Response = {
  __typename?: 'buckets_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Buckets>
}

/** input type for inserting object relation for remote table "storage.buckets" */
export type Buckets_Obj_Rel_Insert_Input = {
  data: Buckets_Insert_Input
  /** upsert condition */
  on_conflict?: InputMaybe<Buckets_On_Conflict>
}

/** on_conflict condition type for table "storage.buckets" */
export type Buckets_On_Conflict = {
  constraint: Buckets_Constraint
  update_columns?: Array<Buckets_Update_Column>
  where?: InputMaybe<Buckets_Bool_Exp>
}

/** Ordering options when selecting data from "storage.buckets". */
export type Buckets_Order_By = {
  cacheControl?: InputMaybe<Order_By>
  createdAt?: InputMaybe<Order_By>
  downloadExpiration?: InputMaybe<Order_By>
  files_aggregate?: InputMaybe<Files_Aggregate_Order_By>
  id?: InputMaybe<Order_By>
  maxUploadFileSize?: InputMaybe<Order_By>
  minUploadFileSize?: InputMaybe<Order_By>
  presignedUrlsEnabled?: InputMaybe<Order_By>
  updatedAt?: InputMaybe<Order_By>
}

/** primary key columns input for table: storage.buckets */
export type Buckets_Pk_Columns_Input = {
  id: Scalars['String']['input']
}

/** select columns of table "storage.buckets" */
export enum Buckets_Select_Column {
  /** column name */
  CacheControl = 'cacheControl',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DownloadExpiration = 'downloadExpiration',
  /** column name */
  Id = 'id',
  /** column name */
  MaxUploadFileSize = 'maxUploadFileSize',
  /** column name */
  MinUploadFileSize = 'minUploadFileSize',
  /** column name */
  PresignedUrlsEnabled = 'presignedUrlsEnabled',
  /** column name */
  UpdatedAt = 'updatedAt',
}

/** input type for updating data in table "storage.buckets" */
export type Buckets_Set_Input = {
  cacheControl?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>
  downloadExpiration?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  maxUploadFileSize?: InputMaybe<Scalars['Int']['input']>
  minUploadFileSize?: InputMaybe<Scalars['Int']['input']>
  presignedUrlsEnabled?: InputMaybe<Scalars['Boolean']['input']>
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate stddev on columns */
export type Buckets_Stddev_Fields = {
  __typename?: 'buckets_stddev_fields'
  downloadExpiration?: Maybe<Scalars['Float']['output']>
  maxUploadFileSize?: Maybe<Scalars['Float']['output']>
  minUploadFileSize?: Maybe<Scalars['Float']['output']>
}

/** aggregate stddev_pop on columns */
export type Buckets_Stddev_Pop_Fields = {
  __typename?: 'buckets_stddev_pop_fields'
  downloadExpiration?: Maybe<Scalars['Float']['output']>
  maxUploadFileSize?: Maybe<Scalars['Float']['output']>
  minUploadFileSize?: Maybe<Scalars['Float']['output']>
}

/** aggregate stddev_samp on columns */
export type Buckets_Stddev_Samp_Fields = {
  __typename?: 'buckets_stddev_samp_fields'
  downloadExpiration?: Maybe<Scalars['Float']['output']>
  maxUploadFileSize?: Maybe<Scalars['Float']['output']>
  minUploadFileSize?: Maybe<Scalars['Float']['output']>
}

/** Streaming cursor of the table "buckets" */
export type Buckets_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Buckets_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Buckets_Stream_Cursor_Value_Input = {
  cacheControl?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>
  downloadExpiration?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  maxUploadFileSize?: InputMaybe<Scalars['Int']['input']>
  minUploadFileSize?: InputMaybe<Scalars['Int']['input']>
  presignedUrlsEnabled?: InputMaybe<Scalars['Boolean']['input']>
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>
}

/** aggregate sum on columns */
export type Buckets_Sum_Fields = {
  __typename?: 'buckets_sum_fields'
  downloadExpiration?: Maybe<Scalars['Int']['output']>
  maxUploadFileSize?: Maybe<Scalars['Int']['output']>
  minUploadFileSize?: Maybe<Scalars['Int']['output']>
}

/** update columns of table "storage.buckets" */
export enum Buckets_Update_Column {
  /** column name */
  CacheControl = 'cacheControl',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DownloadExpiration = 'downloadExpiration',
  /** column name */
  Id = 'id',
  /** column name */
  MaxUploadFileSize = 'maxUploadFileSize',
  /** column name */
  MinUploadFileSize = 'minUploadFileSize',
  /** column name */
  PresignedUrlsEnabled = 'presignedUrlsEnabled',
  /** column name */
  UpdatedAt = 'updatedAt',
}

export type Buckets_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Buckets_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Buckets_Set_Input>
  /** filter the rows which have to be updated */
  where: Buckets_Bool_Exp
}

/** aggregate var_pop on columns */
export type Buckets_Var_Pop_Fields = {
  __typename?: 'buckets_var_pop_fields'
  downloadExpiration?: Maybe<Scalars['Float']['output']>
  maxUploadFileSize?: Maybe<Scalars['Float']['output']>
  minUploadFileSize?: Maybe<Scalars['Float']['output']>
}

/** aggregate var_samp on columns */
export type Buckets_Var_Samp_Fields = {
  __typename?: 'buckets_var_samp_fields'
  downloadExpiration?: Maybe<Scalars['Float']['output']>
  maxUploadFileSize?: Maybe<Scalars['Float']['output']>
  minUploadFileSize?: Maybe<Scalars['Float']['output']>
}

/** aggregate variance on columns */
export type Buckets_Variance_Fields = {
  __typename?: 'buckets_variance_fields'
  downloadExpiration?: Maybe<Scalars['Float']['output']>
  maxUploadFileSize?: Maybe<Scalars['Float']['output']>
  minUploadFileSize?: Maybe<Scalars['Float']['output']>
}

/** Boolean expression to compare columns of type "bytea". All fields are combined with logical 'AND'. */
export type Bytea_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bytea']['input']>
  _gt?: InputMaybe<Scalars['bytea']['input']>
  _gte?: InputMaybe<Scalars['bytea']['input']>
  _in?: InputMaybe<Array<Scalars['bytea']['input']>>
  _is_null?: InputMaybe<Scalars['Boolean']['input']>
  _lt?: InputMaybe<Scalars['bytea']['input']>
  _lte?: InputMaybe<Scalars['bytea']['input']>
  _neq?: InputMaybe<Scalars['bytea']['input']>
  _nin?: InputMaybe<Array<Scalars['bytea']['input']>>
}

/** columns and relationships of "categories" */
export type Categories = {
  __typename?: 'categories'
  created_at?: Maybe<Scalars['timestamptz']['output']>
  position?: Maybe<Scalars['Int']['output']>
  slug: Scalars['String']['output']
  title: Scalars['String']['output']
}

/** aggregated selection of "categories" */
export type Categories_Aggregate = {
  __typename?: 'categories_aggregate'
  aggregate?: Maybe<Categories_Aggregate_Fields>
  nodes: Array<Categories>
}

/** aggregate fields of "categories" */
export type Categories_Aggregate_Fields = {
  __typename?: 'categories_aggregate_fields'
  avg?: Maybe<Categories_Avg_Fields>
  count: Scalars['Int']['output']
  max?: Maybe<Categories_Max_Fields>
  min?: Maybe<Categories_Min_Fields>
  stddev?: Maybe<Categories_Stddev_Fields>
  stddev_pop?: Maybe<Categories_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Categories_Stddev_Samp_Fields>
  sum?: Maybe<Categories_Sum_Fields>
  var_pop?: Maybe<Categories_Var_Pop_Fields>
  var_samp?: Maybe<Categories_Var_Samp_Fields>
  variance?: Maybe<Categories_Variance_Fields>
}

/** aggregate fields of "categories" */
export type Categories_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Categories_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** aggregate avg on columns */
export type Categories_Avg_Fields = {
  __typename?: 'categories_avg_fields'
  position?: Maybe<Scalars['Float']['output']>
}

/** Boolean expression to filter rows from the table "categories". All fields are combined with a logical 'AND'. */
export type Categories_Bool_Exp = {
  _and?: InputMaybe<Array<Categories_Bool_Exp>>
  _not?: InputMaybe<Categories_Bool_Exp>
  _or?: InputMaybe<Array<Categories_Bool_Exp>>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  position?: InputMaybe<Int_Comparison_Exp>
  slug?: InputMaybe<String_Comparison_Exp>
  title?: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "categories" */
export enum Categories_Constraint {
  /** unique or primary key constraint on columns "slug" */
  CategoriesPkey = 'categories_pkey',
}

/** input type for incrementing numeric columns in table "categories" */
export type Categories_Inc_Input = {
  position?: InputMaybe<Scalars['Int']['input']>
}

/** input type for inserting data into table "categories" */
export type Categories_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  position?: InputMaybe<Scalars['Int']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

/** aggregate max on columns */
export type Categories_Max_Fields = {
  __typename?: 'categories_max_fields'
  created_at?: Maybe<Scalars['timestamptz']['output']>
  position?: Maybe<Scalars['Int']['output']>
  slug?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
}

/** aggregate min on columns */
export type Categories_Min_Fields = {
  __typename?: 'categories_min_fields'
  created_at?: Maybe<Scalars['timestamptz']['output']>
  position?: Maybe<Scalars['Int']['output']>
  slug?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
}

/** response of any mutation on the table "categories" */
export type Categories_Mutation_Response = {
  __typename?: 'categories_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Categories>
}

/** on_conflict condition type for table "categories" */
export type Categories_On_Conflict = {
  constraint: Categories_Constraint
  update_columns?: Array<Categories_Update_Column>
  where?: InputMaybe<Categories_Bool_Exp>
}

/** Ordering options when selecting data from "categories". */
export type Categories_Order_By = {
  created_at?: InputMaybe<Order_By>
  position?: InputMaybe<Order_By>
  slug?: InputMaybe<Order_By>
  title?: InputMaybe<Order_By>
}

/** primary key columns input for table: categories */
export type Categories_Pk_Columns_Input = {
  slug: Scalars['String']['input']
}

/** select columns of table "categories" */
export enum Categories_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Position = 'position',
  /** column name */
  Slug = 'slug',
  /** column name */
  Title = 'title',
}

/** input type for updating data in table "categories" */
export type Categories_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  position?: InputMaybe<Scalars['Int']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

/** aggregate stddev on columns */
export type Categories_Stddev_Fields = {
  __typename?: 'categories_stddev_fields'
  position?: Maybe<Scalars['Float']['output']>
}

/** aggregate stddev_pop on columns */
export type Categories_Stddev_Pop_Fields = {
  __typename?: 'categories_stddev_pop_fields'
  position?: Maybe<Scalars['Float']['output']>
}

/** aggregate stddev_samp on columns */
export type Categories_Stddev_Samp_Fields = {
  __typename?: 'categories_stddev_samp_fields'
  position?: Maybe<Scalars['Float']['output']>
}

/** Streaming cursor of the table "categories" */
export type Categories_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Categories_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Categories_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  position?: InputMaybe<Scalars['Int']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

/** aggregate sum on columns */
export type Categories_Sum_Fields = {
  __typename?: 'categories_sum_fields'
  position?: Maybe<Scalars['Int']['output']>
}

/** update columns of table "categories" */
export enum Categories_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Position = 'position',
  /** column name */
  Slug = 'slug',
  /** column name */
  Title = 'title',
}

export type Categories_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Categories_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Categories_Set_Input>
  /** filter the rows which have to be updated */
  where: Categories_Bool_Exp
}

/** aggregate var_pop on columns */
export type Categories_Var_Pop_Fields = {
  __typename?: 'categories_var_pop_fields'
  position?: Maybe<Scalars['Float']['output']>
}

/** aggregate var_samp on columns */
export type Categories_Var_Samp_Fields = {
  __typename?: 'categories_var_samp_fields'
  position?: Maybe<Scalars['Float']['output']>
}

/** aggregate variance on columns */
export type Categories_Variance_Fields = {
  __typename?: 'categories_variance_fields'
  position?: Maybe<Scalars['Float']['output']>
}

/** columns and relationships of "chapters" */
export type Chapters = {
  __typename?: 'chapters'
  /** An array relationship */
  articles: Array<Articles>
  /** An aggregate relationship */
  articles_aggregate: Articles_Aggregate
  baby_age_max_weeks?: Maybe<Scalars['Int']['output']>
  baby_age_min_weeks?: Maybe<Scalars['Int']['output']>
  category_slug?: Maybe<Scalars['String']['output']>
  chapter_position?: Maybe<Scalars['Int']['output']>
  content_type?: Maybe<Scalars['String']['output']>
  created_at: Scalars['timestamptz']['output']
  duration?: Maybe<Scalars['Int']['output']>
  hook?: Maybe<Scalars['String']['output']>
  id: Scalars['uuid']['output']
  merken: Scalars['Boolean']['output']
  merken_at?: Maybe<Scalars['timestamptz']['output']>
  selection_class: Scalars['jsonb']['output']
  selection_criterion: Scalars['jsonb']['output']
  slider?: Maybe<Scalars['String']['output']>
  slug?: Maybe<Scalars['String']['output']>
  subtitle?: Maybe<Scalars['String']['output']>
  summary: Scalars['String']['output']
  takeaway?: Maybe<Scalars['String']['output']>
  title: Scalars['String']['output']
}

/** columns and relationships of "chapters" */
export type ChaptersArticlesArgs = {
  distinct_on?: InputMaybe<Array<Articles_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Articles_Order_By>>
  where?: InputMaybe<Articles_Bool_Exp>
}

/** columns and relationships of "chapters" */
export type ChaptersArticles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Articles_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Articles_Order_By>>
  where?: InputMaybe<Articles_Bool_Exp>
}

/** columns and relationships of "chapters" */
export type ChaptersSelection_ClassArgs = {
  path?: InputMaybe<Scalars['String']['input']>
}

/** columns and relationships of "chapters" */
export type ChaptersSelection_CriterionArgs = {
  path?: InputMaybe<Scalars['String']['input']>
}

/** aggregated selection of "chapters" */
export type Chapters_Aggregate = {
  __typename?: 'chapters_aggregate'
  aggregate?: Maybe<Chapters_Aggregate_Fields>
  nodes: Array<Chapters>
}

/** aggregate fields of "chapters" */
export type Chapters_Aggregate_Fields = {
  __typename?: 'chapters_aggregate_fields'
  avg?: Maybe<Chapters_Avg_Fields>
  count: Scalars['Int']['output']
  max?: Maybe<Chapters_Max_Fields>
  min?: Maybe<Chapters_Min_Fields>
  stddev?: Maybe<Chapters_Stddev_Fields>
  stddev_pop?: Maybe<Chapters_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Chapters_Stddev_Samp_Fields>
  sum?: Maybe<Chapters_Sum_Fields>
  var_pop?: Maybe<Chapters_Var_Pop_Fields>
  var_samp?: Maybe<Chapters_Var_Samp_Fields>
  variance?: Maybe<Chapters_Variance_Fields>
}

/** aggregate fields of "chapters" */
export type Chapters_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Chapters_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** append existing jsonb value of filtered columns with new jsonb value */
export type Chapters_Append_Input = {
  selection_class?: InputMaybe<Scalars['jsonb']['input']>
  selection_criterion?: InputMaybe<Scalars['jsonb']['input']>
}

/** aggregate avg on columns */
export type Chapters_Avg_Fields = {
  __typename?: 'chapters_avg_fields'
  baby_age_max_weeks?: Maybe<Scalars['Float']['output']>
  baby_age_min_weeks?: Maybe<Scalars['Float']['output']>
  chapter_position?: Maybe<Scalars['Float']['output']>
  duration?: Maybe<Scalars['Float']['output']>
}

/** Boolean expression to filter rows from the table "chapters". All fields are combined with a logical 'AND'. */
export type Chapters_Bool_Exp = {
  _and?: InputMaybe<Array<Chapters_Bool_Exp>>
  _not?: InputMaybe<Chapters_Bool_Exp>
  _or?: InputMaybe<Array<Chapters_Bool_Exp>>
  articles?: InputMaybe<Articles_Bool_Exp>
  articles_aggregate?: InputMaybe<Articles_Aggregate_Bool_Exp>
  baby_age_max_weeks?: InputMaybe<Int_Comparison_Exp>
  baby_age_min_weeks?: InputMaybe<Int_Comparison_Exp>
  category_slug?: InputMaybe<String_Comparison_Exp>
  chapter_position?: InputMaybe<Int_Comparison_Exp>
  content_type?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  duration?: InputMaybe<Int_Comparison_Exp>
  hook?: InputMaybe<String_Comparison_Exp>
  id?: InputMaybe<Uuid_Comparison_Exp>
  merken?: InputMaybe<Boolean_Comparison_Exp>
  merken_at?: InputMaybe<Timestamptz_Comparison_Exp>
  selection_class?: InputMaybe<Jsonb_Comparison_Exp>
  selection_criterion?: InputMaybe<Jsonb_Comparison_Exp>
  slider?: InputMaybe<String_Comparison_Exp>
  slug?: InputMaybe<String_Comparison_Exp>
  subtitle?: InputMaybe<String_Comparison_Exp>
  summary?: InputMaybe<String_Comparison_Exp>
  takeaway?: InputMaybe<String_Comparison_Exp>
  title?: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "chapters" */
export enum Chapters_Constraint {
  /** unique or primary key constraint on columns "id" */
  ChaptersIdKey = 'chapters_id_key',
  /** unique or primary key constraint on columns "slug" */
  ChaptersSlugKey = 'chapters_slug_key',
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Chapters_Delete_At_Path_Input = {
  selection_class?: InputMaybe<Array<Scalars['String']['input']>>
  selection_criterion?: InputMaybe<Array<Scalars['String']['input']>>
}

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Chapters_Delete_Elem_Input = {
  selection_class?: InputMaybe<Scalars['Int']['input']>
  selection_criterion?: InputMaybe<Scalars['Int']['input']>
}

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Chapters_Delete_Key_Input = {
  selection_class?: InputMaybe<Scalars['String']['input']>
  selection_criterion?: InputMaybe<Scalars['String']['input']>
}

/** input type for incrementing numeric columns in table "chapters" */
export type Chapters_Inc_Input = {
  baby_age_max_weeks?: InputMaybe<Scalars['Int']['input']>
  baby_age_min_weeks?: InputMaybe<Scalars['Int']['input']>
  chapter_position?: InputMaybe<Scalars['Int']['input']>
  duration?: InputMaybe<Scalars['Int']['input']>
}

/** input type for inserting data into table "chapters" */
export type Chapters_Insert_Input = {
  articles?: InputMaybe<Articles_Arr_Rel_Insert_Input>
  baby_age_max_weeks?: InputMaybe<Scalars['Int']['input']>
  baby_age_min_weeks?: InputMaybe<Scalars['Int']['input']>
  category_slug?: InputMaybe<Scalars['String']['input']>
  chapter_position?: InputMaybe<Scalars['Int']['input']>
  content_type?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  duration?: InputMaybe<Scalars['Int']['input']>
  hook?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  merken?: InputMaybe<Scalars['Boolean']['input']>
  merken_at?: InputMaybe<Scalars['timestamptz']['input']>
  selection_class?: InputMaybe<Scalars['jsonb']['input']>
  selection_criterion?: InputMaybe<Scalars['jsonb']['input']>
  slider?: InputMaybe<Scalars['String']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  subtitle?: InputMaybe<Scalars['String']['input']>
  summary?: InputMaybe<Scalars['String']['input']>
  takeaway?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

/** aggregate max on columns */
export type Chapters_Max_Fields = {
  __typename?: 'chapters_max_fields'
  baby_age_max_weeks?: Maybe<Scalars['Int']['output']>
  baby_age_min_weeks?: Maybe<Scalars['Int']['output']>
  category_slug?: Maybe<Scalars['String']['output']>
  chapter_position?: Maybe<Scalars['Int']['output']>
  content_type?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  duration?: Maybe<Scalars['Int']['output']>
  hook?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['uuid']['output']>
  merken_at?: Maybe<Scalars['timestamptz']['output']>
  slider?: Maybe<Scalars['String']['output']>
  slug?: Maybe<Scalars['String']['output']>
  subtitle?: Maybe<Scalars['String']['output']>
  summary?: Maybe<Scalars['String']['output']>
  takeaway?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
}

/** aggregate min on columns */
export type Chapters_Min_Fields = {
  __typename?: 'chapters_min_fields'
  baby_age_max_weeks?: Maybe<Scalars['Int']['output']>
  baby_age_min_weeks?: Maybe<Scalars['Int']['output']>
  category_slug?: Maybe<Scalars['String']['output']>
  chapter_position?: Maybe<Scalars['Int']['output']>
  content_type?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  duration?: Maybe<Scalars['Int']['output']>
  hook?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['uuid']['output']>
  merken_at?: Maybe<Scalars['timestamptz']['output']>
  slider?: Maybe<Scalars['String']['output']>
  slug?: Maybe<Scalars['String']['output']>
  subtitle?: Maybe<Scalars['String']['output']>
  summary?: Maybe<Scalars['String']['output']>
  takeaway?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
}

/** response of any mutation on the table "chapters" */
export type Chapters_Mutation_Response = {
  __typename?: 'chapters_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Chapters>
}

/** input type for inserting object relation for remote table "chapters" */
export type Chapters_Obj_Rel_Insert_Input = {
  data: Chapters_Insert_Input
  /** upsert condition */
  on_conflict?: InputMaybe<Chapters_On_Conflict>
}

/** on_conflict condition type for table "chapters" */
export type Chapters_On_Conflict = {
  constraint: Chapters_Constraint
  update_columns?: Array<Chapters_Update_Column>
  where?: InputMaybe<Chapters_Bool_Exp>
}

/** Ordering options when selecting data from "chapters". */
export type Chapters_Order_By = {
  articles_aggregate?: InputMaybe<Articles_Aggregate_Order_By>
  baby_age_max_weeks?: InputMaybe<Order_By>
  baby_age_min_weeks?: InputMaybe<Order_By>
  category_slug?: InputMaybe<Order_By>
  chapter_position?: InputMaybe<Order_By>
  content_type?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  duration?: InputMaybe<Order_By>
  hook?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  merken?: InputMaybe<Order_By>
  merken_at?: InputMaybe<Order_By>
  selection_class?: InputMaybe<Order_By>
  selection_criterion?: InputMaybe<Order_By>
  slider?: InputMaybe<Order_By>
  slug?: InputMaybe<Order_By>
  subtitle?: InputMaybe<Order_By>
  summary?: InputMaybe<Order_By>
  takeaway?: InputMaybe<Order_By>
  title?: InputMaybe<Order_By>
}

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Chapters_Prepend_Input = {
  selection_class?: InputMaybe<Scalars['jsonb']['input']>
  selection_criterion?: InputMaybe<Scalars['jsonb']['input']>
}

/** select columns of table "chapters" */
export enum Chapters_Select_Column {
  /** column name */
  BabyAgeMaxWeeks = 'baby_age_max_weeks',
  /** column name */
  BabyAgeMinWeeks = 'baby_age_min_weeks',
  /** column name */
  CategorySlug = 'category_slug',
  /** column name */
  ChapterPosition = 'chapter_position',
  /** column name */
  ContentType = 'content_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Duration = 'duration',
  /** column name */
  Hook = 'hook',
  /** column name */
  Id = 'id',
  /** column name */
  Merken = 'merken',
  /** column name */
  MerkenAt = 'merken_at',
  /** column name */
  SelectionClass = 'selection_class',
  /** column name */
  SelectionCriterion = 'selection_criterion',
  /** column name */
  Slider = 'slider',
  /** column name */
  Slug = 'slug',
  /** column name */
  Subtitle = 'subtitle',
  /** column name */
  Summary = 'summary',
  /** column name */
  Takeaway = 'takeaway',
  /** column name */
  Title = 'title',
}

/** input type for updating data in table "chapters" */
export type Chapters_Set_Input = {
  baby_age_max_weeks?: InputMaybe<Scalars['Int']['input']>
  baby_age_min_weeks?: InputMaybe<Scalars['Int']['input']>
  category_slug?: InputMaybe<Scalars['String']['input']>
  chapter_position?: InputMaybe<Scalars['Int']['input']>
  content_type?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  duration?: InputMaybe<Scalars['Int']['input']>
  hook?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  merken?: InputMaybe<Scalars['Boolean']['input']>
  merken_at?: InputMaybe<Scalars['timestamptz']['input']>
  selection_class?: InputMaybe<Scalars['jsonb']['input']>
  selection_criterion?: InputMaybe<Scalars['jsonb']['input']>
  slider?: InputMaybe<Scalars['String']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  subtitle?: InputMaybe<Scalars['String']['input']>
  summary?: InputMaybe<Scalars['String']['input']>
  takeaway?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

/** aggregate stddev on columns */
export type Chapters_Stddev_Fields = {
  __typename?: 'chapters_stddev_fields'
  baby_age_max_weeks?: Maybe<Scalars['Float']['output']>
  baby_age_min_weeks?: Maybe<Scalars['Float']['output']>
  chapter_position?: Maybe<Scalars['Float']['output']>
  duration?: Maybe<Scalars['Float']['output']>
}

/** aggregate stddev_pop on columns */
export type Chapters_Stddev_Pop_Fields = {
  __typename?: 'chapters_stddev_pop_fields'
  baby_age_max_weeks?: Maybe<Scalars['Float']['output']>
  baby_age_min_weeks?: Maybe<Scalars['Float']['output']>
  chapter_position?: Maybe<Scalars['Float']['output']>
  duration?: Maybe<Scalars['Float']['output']>
}

/** aggregate stddev_samp on columns */
export type Chapters_Stddev_Samp_Fields = {
  __typename?: 'chapters_stddev_samp_fields'
  baby_age_max_weeks?: Maybe<Scalars['Float']['output']>
  baby_age_min_weeks?: Maybe<Scalars['Float']['output']>
  chapter_position?: Maybe<Scalars['Float']['output']>
  duration?: Maybe<Scalars['Float']['output']>
}

/** Streaming cursor of the table "chapters" */
export type Chapters_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Chapters_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Chapters_Stream_Cursor_Value_Input = {
  baby_age_max_weeks?: InputMaybe<Scalars['Int']['input']>
  baby_age_min_weeks?: InputMaybe<Scalars['Int']['input']>
  category_slug?: InputMaybe<Scalars['String']['input']>
  chapter_position?: InputMaybe<Scalars['Int']['input']>
  content_type?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  duration?: InputMaybe<Scalars['Int']['input']>
  hook?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  merken?: InputMaybe<Scalars['Boolean']['input']>
  merken_at?: InputMaybe<Scalars['timestamptz']['input']>
  selection_class?: InputMaybe<Scalars['jsonb']['input']>
  selection_criterion?: InputMaybe<Scalars['jsonb']['input']>
  slider?: InputMaybe<Scalars['String']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  subtitle?: InputMaybe<Scalars['String']['input']>
  summary?: InputMaybe<Scalars['String']['input']>
  takeaway?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

/** aggregate sum on columns */
export type Chapters_Sum_Fields = {
  __typename?: 'chapters_sum_fields'
  baby_age_max_weeks?: Maybe<Scalars['Int']['output']>
  baby_age_min_weeks?: Maybe<Scalars['Int']['output']>
  chapter_position?: Maybe<Scalars['Int']['output']>
  duration?: Maybe<Scalars['Int']['output']>
}

/** update columns of table "chapters" */
export enum Chapters_Update_Column {
  /** column name */
  BabyAgeMaxWeeks = 'baby_age_max_weeks',
  /** column name */
  BabyAgeMinWeeks = 'baby_age_min_weeks',
  /** column name */
  CategorySlug = 'category_slug',
  /** column name */
  ChapterPosition = 'chapter_position',
  /** column name */
  ContentType = 'content_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Duration = 'duration',
  /** column name */
  Hook = 'hook',
  /** column name */
  Id = 'id',
  /** column name */
  Merken = 'merken',
  /** column name */
  MerkenAt = 'merken_at',
  /** column name */
  SelectionClass = 'selection_class',
  /** column name */
  SelectionCriterion = 'selection_criterion',
  /** column name */
  Slider = 'slider',
  /** column name */
  Slug = 'slug',
  /** column name */
  Subtitle = 'subtitle',
  /** column name */
  Summary = 'summary',
  /** column name */
  Takeaway = 'takeaway',
  /** column name */
  Title = 'title',
}

export type Chapters_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Chapters_Append_Input>
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Chapters_Delete_At_Path_Input>
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Chapters_Delete_Elem_Input>
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Chapters_Delete_Key_Input>
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Chapters_Inc_Input>
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Chapters_Prepend_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Chapters_Set_Input>
  /** filter the rows which have to be updated */
  where: Chapters_Bool_Exp
}

/** aggregate var_pop on columns */
export type Chapters_Var_Pop_Fields = {
  __typename?: 'chapters_var_pop_fields'
  baby_age_max_weeks?: Maybe<Scalars['Float']['output']>
  baby_age_min_weeks?: Maybe<Scalars['Float']['output']>
  chapter_position?: Maybe<Scalars['Float']['output']>
  duration?: Maybe<Scalars['Float']['output']>
}

/** aggregate var_samp on columns */
export type Chapters_Var_Samp_Fields = {
  __typename?: 'chapters_var_samp_fields'
  baby_age_max_weeks?: Maybe<Scalars['Float']['output']>
  baby_age_min_weeks?: Maybe<Scalars['Float']['output']>
  chapter_position?: Maybe<Scalars['Float']['output']>
  duration?: Maybe<Scalars['Float']['output']>
}

/** aggregate variance on columns */
export type Chapters_Variance_Fields = {
  __typename?: 'chapters_variance_fields'
  baby_age_max_weeks?: Maybe<Scalars['Float']['output']>
  baby_age_min_weeks?: Maybe<Scalars['Float']['output']>
  chapter_position?: Maybe<Scalars['Float']['output']>
  duration?: Maybe<Scalars['Float']['output']>
}

/** columns and relationships of "chat_messages" */
export type Chat_Messages = {
  __typename?: 'chat_messages'
  body: Scalars['String']['output']
  created_at: Scalars['timestamptz']['output']
  id: Scalars['uuid']['output']
  midwife_user_id: Scalars['uuid']['output']
  patient_user_id: Scalars['uuid']['output']
  read_at?: Maybe<Scalars['timestamptz']['output']>
  sender_user_id: Scalars['uuid']['output']
}

/** aggregated selection of "chat_messages" */
export type Chat_Messages_Aggregate = {
  __typename?: 'chat_messages_aggregate'
  aggregate?: Maybe<Chat_Messages_Aggregate_Fields>
  nodes: Array<Chat_Messages>
}

/** aggregate fields of "chat_messages" */
export type Chat_Messages_Aggregate_Fields = {
  __typename?: 'chat_messages_aggregate_fields'
  count: Scalars['Int']['output']
  max?: Maybe<Chat_Messages_Max_Fields>
  min?: Maybe<Chat_Messages_Min_Fields>
}

/** aggregate fields of "chat_messages" */
export type Chat_Messages_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Chat_Messages_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** Boolean expression to filter rows from the table "chat_messages". All fields are combined with a logical 'AND'. */
export type Chat_Messages_Bool_Exp = {
  _and?: InputMaybe<Array<Chat_Messages_Bool_Exp>>
  _not?: InputMaybe<Chat_Messages_Bool_Exp>
  _or?: InputMaybe<Array<Chat_Messages_Bool_Exp>>
  body?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  id?: InputMaybe<Uuid_Comparison_Exp>
  midwife_user_id?: InputMaybe<Uuid_Comparison_Exp>
  patient_user_id?: InputMaybe<Uuid_Comparison_Exp>
  read_at?: InputMaybe<Timestamptz_Comparison_Exp>
  sender_user_id?: InputMaybe<Uuid_Comparison_Exp>
}

/** unique or primary key constraints on table "chat_messages" */
export enum Chat_Messages_Constraint {
  /** unique or primary key constraint on columns "id" */
  ChatMessagesPkey = 'chat_messages_pkey',
}

/** input type for inserting data into table "chat_messages" */
export type Chat_Messages_Insert_Input = {
  body?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  midwife_user_id?: InputMaybe<Scalars['uuid']['input']>
  patient_user_id?: InputMaybe<Scalars['uuid']['input']>
  read_at?: InputMaybe<Scalars['timestamptz']['input']>
  sender_user_id?: InputMaybe<Scalars['uuid']['input']>
}

/** aggregate max on columns */
export type Chat_Messages_Max_Fields = {
  __typename?: 'chat_messages_max_fields'
  body?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['uuid']['output']>
  midwife_user_id?: Maybe<Scalars['uuid']['output']>
  patient_user_id?: Maybe<Scalars['uuid']['output']>
  read_at?: Maybe<Scalars['timestamptz']['output']>
  sender_user_id?: Maybe<Scalars['uuid']['output']>
}

/** aggregate min on columns */
export type Chat_Messages_Min_Fields = {
  __typename?: 'chat_messages_min_fields'
  body?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['uuid']['output']>
  midwife_user_id?: Maybe<Scalars['uuid']['output']>
  patient_user_id?: Maybe<Scalars['uuid']['output']>
  read_at?: Maybe<Scalars['timestamptz']['output']>
  sender_user_id?: Maybe<Scalars['uuid']['output']>
}

/** response of any mutation on the table "chat_messages" */
export type Chat_Messages_Mutation_Response = {
  __typename?: 'chat_messages_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Chat_Messages>
}

/** on_conflict condition type for table "chat_messages" */
export type Chat_Messages_On_Conflict = {
  constraint: Chat_Messages_Constraint
  update_columns?: Array<Chat_Messages_Update_Column>
  where?: InputMaybe<Chat_Messages_Bool_Exp>
}

/** Ordering options when selecting data from "chat_messages". */
export type Chat_Messages_Order_By = {
  body?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  midwife_user_id?: InputMaybe<Order_By>
  patient_user_id?: InputMaybe<Order_By>
  read_at?: InputMaybe<Order_By>
  sender_user_id?: InputMaybe<Order_By>
}

/** primary key columns input for table: chat_messages */
export type Chat_Messages_Pk_Columns_Input = {
  id: Scalars['uuid']['input']
}

/** select columns of table "chat_messages" */
export enum Chat_Messages_Select_Column {
  /** column name */
  Body = 'body',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  MidwifeUserId = 'midwife_user_id',
  /** column name */
  PatientUserId = 'patient_user_id',
  /** column name */
  ReadAt = 'read_at',
  /** column name */
  SenderUserId = 'sender_user_id',
}

/** input type for updating data in table "chat_messages" */
export type Chat_Messages_Set_Input = {
  body?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  midwife_user_id?: InputMaybe<Scalars['uuid']['input']>
  patient_user_id?: InputMaybe<Scalars['uuid']['input']>
  read_at?: InputMaybe<Scalars['timestamptz']['input']>
  sender_user_id?: InputMaybe<Scalars['uuid']['input']>
}

/** Streaming cursor of the table "chat_messages" */
export type Chat_Messages_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Chat_Messages_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Chat_Messages_Stream_Cursor_Value_Input = {
  body?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  midwife_user_id?: InputMaybe<Scalars['uuid']['input']>
  patient_user_id?: InputMaybe<Scalars['uuid']['input']>
  read_at?: InputMaybe<Scalars['timestamptz']['input']>
  sender_user_id?: InputMaybe<Scalars['uuid']['input']>
}

/** update columns of table "chat_messages" */
export enum Chat_Messages_Update_Column {
  /** column name */
  Body = 'body',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  MidwifeUserId = 'midwife_user_id',
  /** column name */
  PatientUserId = 'patient_user_id',
  /** column name */
  ReadAt = 'read_at',
  /** column name */
  SenderUserId = 'sender_user_id',
}

export type Chat_Messages_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Chat_Messages_Set_Input>
  /** filter the rows which have to be updated */
  where: Chat_Messages_Bool_Exp
}

/** Boolean expression to compare columns of type "citext". All fields are combined with logical 'AND'. */
export type Citext_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['citext']['input']>
  _gt?: InputMaybe<Scalars['citext']['input']>
  _gte?: InputMaybe<Scalars['citext']['input']>
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['citext']['input']>
  _in?: InputMaybe<Array<Scalars['citext']['input']>>
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['citext']['input']>
  _is_null?: InputMaybe<Scalars['Boolean']['input']>
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['citext']['input']>
  _lt?: InputMaybe<Scalars['citext']['input']>
  _lte?: InputMaybe<Scalars['citext']['input']>
  _neq?: InputMaybe<Scalars['citext']['input']>
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['citext']['input']>
  _nin?: InputMaybe<Array<Scalars['citext']['input']>>
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['citext']['input']>
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['citext']['input']>
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['citext']['input']>
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['citext']['input']>
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['citext']['input']>
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['citext']['input']>
}

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC',
}

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['date']['input']>
  _gt?: InputMaybe<Scalars['date']['input']>
  _gte?: InputMaybe<Scalars['date']['input']>
  _in?: InputMaybe<Array<Scalars['date']['input']>>
  _is_null?: InputMaybe<Scalars['Boolean']['input']>
  _lt?: InputMaybe<Scalars['date']['input']>
  _lte?: InputMaybe<Scalars['date']['input']>
  _neq?: InputMaybe<Scalars['date']['input']>
  _nin?: InputMaybe<Array<Scalars['date']['input']>>
}

/** columns and relationships of "feedback_messages" */
export type Feedback_Messages = {
  __typename?: 'feedback_messages'
  body: Scalars['String']['output']
  created_at: Scalars['timestamptz']['output']
  id: Scalars['uuid']['output']
  is_from_member: Scalars['Boolean']['output']
  member_user_id: Scalars['uuid']['output']
  read_at?: Maybe<Scalars['timestamptz']['output']>
  sender_user_id?: Maybe<Scalars['uuid']['output']>
}

/** aggregated selection of "feedback_messages" */
export type Feedback_Messages_Aggregate = {
  __typename?: 'feedback_messages_aggregate'
  aggregate?: Maybe<Feedback_Messages_Aggregate_Fields>
  nodes: Array<Feedback_Messages>
}

/** aggregate fields of "feedback_messages" */
export type Feedback_Messages_Aggregate_Fields = {
  __typename?: 'feedback_messages_aggregate_fields'
  count: Scalars['Int']['output']
  max?: Maybe<Feedback_Messages_Max_Fields>
  min?: Maybe<Feedback_Messages_Min_Fields>
}

/** aggregate fields of "feedback_messages" */
export type Feedback_Messages_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Feedback_Messages_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** Boolean expression to filter rows from the table "feedback_messages". All fields are combined with a logical 'AND'. */
export type Feedback_Messages_Bool_Exp = {
  _and?: InputMaybe<Array<Feedback_Messages_Bool_Exp>>
  _not?: InputMaybe<Feedback_Messages_Bool_Exp>
  _or?: InputMaybe<Array<Feedback_Messages_Bool_Exp>>
  body?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  id?: InputMaybe<Uuid_Comparison_Exp>
  is_from_member?: InputMaybe<Boolean_Comparison_Exp>
  member_user_id?: InputMaybe<Uuid_Comparison_Exp>
  read_at?: InputMaybe<Timestamptz_Comparison_Exp>
  sender_user_id?: InputMaybe<Uuid_Comparison_Exp>
}

/** unique or primary key constraints on table "feedback_messages" */
export enum Feedback_Messages_Constraint {
  /** unique or primary key constraint on columns "id" */
  FeedbackMessagesPkey = 'feedback_messages_pkey',
}

/** input type for inserting data into table "feedback_messages" */
export type Feedback_Messages_Insert_Input = {
  body?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  is_from_member?: InputMaybe<Scalars['Boolean']['input']>
  member_user_id?: InputMaybe<Scalars['uuid']['input']>
  read_at?: InputMaybe<Scalars['timestamptz']['input']>
  sender_user_id?: InputMaybe<Scalars['uuid']['input']>
}

/** aggregate max on columns */
export type Feedback_Messages_Max_Fields = {
  __typename?: 'feedback_messages_max_fields'
  body?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['uuid']['output']>
  member_user_id?: Maybe<Scalars['uuid']['output']>
  read_at?: Maybe<Scalars['timestamptz']['output']>
  sender_user_id?: Maybe<Scalars['uuid']['output']>
}

/** aggregate min on columns */
export type Feedback_Messages_Min_Fields = {
  __typename?: 'feedback_messages_min_fields'
  body?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['uuid']['output']>
  member_user_id?: Maybe<Scalars['uuid']['output']>
  read_at?: Maybe<Scalars['timestamptz']['output']>
  sender_user_id?: Maybe<Scalars['uuid']['output']>
}

/** response of any mutation on the table "feedback_messages" */
export type Feedback_Messages_Mutation_Response = {
  __typename?: 'feedback_messages_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Feedback_Messages>
}

/** on_conflict condition type for table "feedback_messages" */
export type Feedback_Messages_On_Conflict = {
  constraint: Feedback_Messages_Constraint
  update_columns?: Array<Feedback_Messages_Update_Column>
  where?: InputMaybe<Feedback_Messages_Bool_Exp>
}

/** Ordering options when selecting data from "feedback_messages". */
export type Feedback_Messages_Order_By = {
  body?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  is_from_member?: InputMaybe<Order_By>
  member_user_id?: InputMaybe<Order_By>
  read_at?: InputMaybe<Order_By>
  sender_user_id?: InputMaybe<Order_By>
}

/** primary key columns input for table: feedback_messages */
export type Feedback_Messages_Pk_Columns_Input = {
  id: Scalars['uuid']['input']
}

/** select columns of table "feedback_messages" */
export enum Feedback_Messages_Select_Column {
  /** column name */
  Body = 'body',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsFromMember = 'is_from_member',
  /** column name */
  MemberUserId = 'member_user_id',
  /** column name */
  ReadAt = 'read_at',
  /** column name */
  SenderUserId = 'sender_user_id',
}

/** input type for updating data in table "feedback_messages" */
export type Feedback_Messages_Set_Input = {
  body?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  is_from_member?: InputMaybe<Scalars['Boolean']['input']>
  member_user_id?: InputMaybe<Scalars['uuid']['input']>
  read_at?: InputMaybe<Scalars['timestamptz']['input']>
  sender_user_id?: InputMaybe<Scalars['uuid']['input']>
}

/** Streaming cursor of the table "feedback_messages" */
export type Feedback_Messages_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Feedback_Messages_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Feedback_Messages_Stream_Cursor_Value_Input = {
  body?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  is_from_member?: InputMaybe<Scalars['Boolean']['input']>
  member_user_id?: InputMaybe<Scalars['uuid']['input']>
  read_at?: InputMaybe<Scalars['timestamptz']['input']>
  sender_user_id?: InputMaybe<Scalars['uuid']['input']>
}

/** update columns of table "feedback_messages" */
export enum Feedback_Messages_Update_Column {
  /** column name */
  Body = 'body',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsFromMember = 'is_from_member',
  /** column name */
  MemberUserId = 'member_user_id',
  /** column name */
  ReadAt = 'read_at',
  /** column name */
  SenderUserId = 'sender_user_id',
}

export type Feedback_Messages_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Feedback_Messages_Set_Input>
  /** filter the rows which have to be updated */
  where: Feedback_Messages_Bool_Exp
}

/** columns and relationships of "storage.files" */
export type Files = {
  __typename?: 'files'
  /** An object relationship */
  bucket: Buckets
  bucketId: Scalars['String']['output']
  createdAt: Scalars['timestamptz']['output']
  etag?: Maybe<Scalars['String']['output']>
  id: Scalars['uuid']['output']
  isUploaded?: Maybe<Scalars['Boolean']['output']>
  metadata?: Maybe<Scalars['jsonb']['output']>
  mimeType?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  size?: Maybe<Scalars['Int']['output']>
  updatedAt: Scalars['timestamptz']['output']
  uploadedByUserId?: Maybe<Scalars['uuid']['output']>
}

/** columns and relationships of "storage.files" */
export type FilesMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>
}

/** aggregated selection of "storage.files" */
export type Files_Aggregate = {
  __typename?: 'files_aggregate'
  aggregate?: Maybe<Files_Aggregate_Fields>
  nodes: Array<Files>
}

export type Files_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Files_Aggregate_Bool_Exp_Bool_And>
  bool_or?: InputMaybe<Files_Aggregate_Bool_Exp_Bool_Or>
  count?: InputMaybe<Files_Aggregate_Bool_Exp_Count>
}

export type Files_Aggregate_Bool_Exp_Bool_And = {
  arguments: Files_Select_Column_Files_Aggregate_Bool_Exp_Bool_And_Arguments_Columns
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Files_Bool_Exp>
  predicate: Boolean_Comparison_Exp
}

export type Files_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Files_Select_Column_Files_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Files_Bool_Exp>
  predicate: Boolean_Comparison_Exp
}

export type Files_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Files_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Files_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "storage.files" */
export type Files_Aggregate_Fields = {
  __typename?: 'files_aggregate_fields'
  avg?: Maybe<Files_Avg_Fields>
  count: Scalars['Int']['output']
  max?: Maybe<Files_Max_Fields>
  min?: Maybe<Files_Min_Fields>
  stddev?: Maybe<Files_Stddev_Fields>
  stddev_pop?: Maybe<Files_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Files_Stddev_Samp_Fields>
  sum?: Maybe<Files_Sum_Fields>
  var_pop?: Maybe<Files_Var_Pop_Fields>
  var_samp?: Maybe<Files_Var_Samp_Fields>
  variance?: Maybe<Files_Variance_Fields>
}

/** aggregate fields of "storage.files" */
export type Files_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Files_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** order by aggregate values of table "storage.files" */
export type Files_Aggregate_Order_By = {
  avg?: InputMaybe<Files_Avg_Order_By>
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Files_Max_Order_By>
  min?: InputMaybe<Files_Min_Order_By>
  stddev?: InputMaybe<Files_Stddev_Order_By>
  stddev_pop?: InputMaybe<Files_Stddev_Pop_Order_By>
  stddev_samp?: InputMaybe<Files_Stddev_Samp_Order_By>
  sum?: InputMaybe<Files_Sum_Order_By>
  var_pop?: InputMaybe<Files_Var_Pop_Order_By>
  var_samp?: InputMaybe<Files_Var_Samp_Order_By>
  variance?: InputMaybe<Files_Variance_Order_By>
}

/** append existing jsonb value of filtered columns with new jsonb value */
export type Files_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>
}

/** input type for inserting array relation for remote table "storage.files" */
export type Files_Arr_Rel_Insert_Input = {
  data: Array<Files_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Files_On_Conflict>
}

/** aggregate avg on columns */
export type Files_Avg_Fields = {
  __typename?: 'files_avg_fields'
  size?: Maybe<Scalars['Float']['output']>
}

/** order by avg() on columns of table "storage.files" */
export type Files_Avg_Order_By = {
  size?: InputMaybe<Order_By>
}

/** Boolean expression to filter rows from the table "storage.files". All fields are combined with a logical 'AND'. */
export type Files_Bool_Exp = {
  _and?: InputMaybe<Array<Files_Bool_Exp>>
  _not?: InputMaybe<Files_Bool_Exp>
  _or?: InputMaybe<Array<Files_Bool_Exp>>
  bucket?: InputMaybe<Buckets_Bool_Exp>
  bucketId?: InputMaybe<String_Comparison_Exp>
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>
  etag?: InputMaybe<String_Comparison_Exp>
  id?: InputMaybe<Uuid_Comparison_Exp>
  isUploaded?: InputMaybe<Boolean_Comparison_Exp>
  metadata?: InputMaybe<Jsonb_Comparison_Exp>
  mimeType?: InputMaybe<String_Comparison_Exp>
  name?: InputMaybe<String_Comparison_Exp>
  size?: InputMaybe<Int_Comparison_Exp>
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>
  uploadedByUserId?: InputMaybe<Uuid_Comparison_Exp>
}

/** unique or primary key constraints on table "storage.files" */
export enum Files_Constraint {
  /** unique or primary key constraint on columns "id" */
  FilesPkey = 'files_pkey',
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Files_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']['input']>>
}

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Files_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']['input']>
}

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Files_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']['input']>
}

/** input type for incrementing numeric columns in table "storage.files" */
export type Files_Inc_Input = {
  size?: InputMaybe<Scalars['Int']['input']>
}

/** input type for inserting data into table "storage.files" */
export type Files_Insert_Input = {
  bucket?: InputMaybe<Buckets_Obj_Rel_Insert_Input>
  bucketId?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>
  etag?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  isUploaded?: InputMaybe<Scalars['Boolean']['input']>
  metadata?: InputMaybe<Scalars['jsonb']['input']>
  mimeType?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  size?: InputMaybe<Scalars['Int']['input']>
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>
  uploadedByUserId?: InputMaybe<Scalars['uuid']['input']>
}

/** aggregate max on columns */
export type Files_Max_Fields = {
  __typename?: 'files_max_fields'
  bucketId?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['timestamptz']['output']>
  etag?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['uuid']['output']>
  mimeType?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  size?: Maybe<Scalars['Int']['output']>
  updatedAt?: Maybe<Scalars['timestamptz']['output']>
  uploadedByUserId?: Maybe<Scalars['uuid']['output']>
}

/** order by max() on columns of table "storage.files" */
export type Files_Max_Order_By = {
  bucketId?: InputMaybe<Order_By>
  createdAt?: InputMaybe<Order_By>
  etag?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  mimeType?: InputMaybe<Order_By>
  name?: InputMaybe<Order_By>
  size?: InputMaybe<Order_By>
  updatedAt?: InputMaybe<Order_By>
  uploadedByUserId?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Files_Min_Fields = {
  __typename?: 'files_min_fields'
  bucketId?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['timestamptz']['output']>
  etag?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['uuid']['output']>
  mimeType?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  size?: Maybe<Scalars['Int']['output']>
  updatedAt?: Maybe<Scalars['timestamptz']['output']>
  uploadedByUserId?: Maybe<Scalars['uuid']['output']>
}

/** order by min() on columns of table "storage.files" */
export type Files_Min_Order_By = {
  bucketId?: InputMaybe<Order_By>
  createdAt?: InputMaybe<Order_By>
  etag?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  mimeType?: InputMaybe<Order_By>
  name?: InputMaybe<Order_By>
  size?: InputMaybe<Order_By>
  updatedAt?: InputMaybe<Order_By>
  uploadedByUserId?: InputMaybe<Order_By>
}

/** response of any mutation on the table "storage.files" */
export type Files_Mutation_Response = {
  __typename?: 'files_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Files>
}

/** input type for inserting object relation for remote table "storage.files" */
export type Files_Obj_Rel_Insert_Input = {
  data: Files_Insert_Input
  /** upsert condition */
  on_conflict?: InputMaybe<Files_On_Conflict>
}

/** on_conflict condition type for table "storage.files" */
export type Files_On_Conflict = {
  constraint: Files_Constraint
  update_columns?: Array<Files_Update_Column>
  where?: InputMaybe<Files_Bool_Exp>
}

/** Ordering options when selecting data from "storage.files". */
export type Files_Order_By = {
  bucket?: InputMaybe<Buckets_Order_By>
  bucketId?: InputMaybe<Order_By>
  createdAt?: InputMaybe<Order_By>
  etag?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  isUploaded?: InputMaybe<Order_By>
  metadata?: InputMaybe<Order_By>
  mimeType?: InputMaybe<Order_By>
  name?: InputMaybe<Order_By>
  size?: InputMaybe<Order_By>
  updatedAt?: InputMaybe<Order_By>
  uploadedByUserId?: InputMaybe<Order_By>
}

/** primary key columns input for table: storage.files */
export type Files_Pk_Columns_Input = {
  id: Scalars['uuid']['input']
}

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Files_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>
}

/** select columns of table "storage.files" */
export enum Files_Select_Column {
  /** column name */
  BucketId = 'bucketId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Etag = 'etag',
  /** column name */
  Id = 'id',
  /** column name */
  IsUploaded = 'isUploaded',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  MimeType = 'mimeType',
  /** column name */
  Name = 'name',
  /** column name */
  Size = 'size',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UploadedByUserId = 'uploadedByUserId',
}

/** select "files_aggregate_bool_exp_bool_and_arguments_columns" columns of table "storage.files" */
export enum Files_Select_Column_Files_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsUploaded = 'isUploaded',
}

/** select "files_aggregate_bool_exp_bool_or_arguments_columns" columns of table "storage.files" */
export enum Files_Select_Column_Files_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsUploaded = 'isUploaded',
}

/** input type for updating data in table "storage.files" */
export type Files_Set_Input = {
  bucketId?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>
  etag?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  isUploaded?: InputMaybe<Scalars['Boolean']['input']>
  metadata?: InputMaybe<Scalars['jsonb']['input']>
  mimeType?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  size?: InputMaybe<Scalars['Int']['input']>
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>
  uploadedByUserId?: InputMaybe<Scalars['uuid']['input']>
}

/** aggregate stddev on columns */
export type Files_Stddev_Fields = {
  __typename?: 'files_stddev_fields'
  size?: Maybe<Scalars['Float']['output']>
}

/** order by stddev() on columns of table "storage.files" */
export type Files_Stddev_Order_By = {
  size?: InputMaybe<Order_By>
}

/** aggregate stddev_pop on columns */
export type Files_Stddev_Pop_Fields = {
  __typename?: 'files_stddev_pop_fields'
  size?: Maybe<Scalars['Float']['output']>
}

/** order by stddev_pop() on columns of table "storage.files" */
export type Files_Stddev_Pop_Order_By = {
  size?: InputMaybe<Order_By>
}

/** aggregate stddev_samp on columns */
export type Files_Stddev_Samp_Fields = {
  __typename?: 'files_stddev_samp_fields'
  size?: Maybe<Scalars['Float']['output']>
}

/** order by stddev_samp() on columns of table "storage.files" */
export type Files_Stddev_Samp_Order_By = {
  size?: InputMaybe<Order_By>
}

/** Streaming cursor of the table "files" */
export type Files_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Files_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Files_Stream_Cursor_Value_Input = {
  bucketId?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>
  etag?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  isUploaded?: InputMaybe<Scalars['Boolean']['input']>
  metadata?: InputMaybe<Scalars['jsonb']['input']>
  mimeType?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  size?: InputMaybe<Scalars['Int']['input']>
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>
  uploadedByUserId?: InputMaybe<Scalars['uuid']['input']>
}

/** aggregate sum on columns */
export type Files_Sum_Fields = {
  __typename?: 'files_sum_fields'
  size?: Maybe<Scalars['Int']['output']>
}

/** order by sum() on columns of table "storage.files" */
export type Files_Sum_Order_By = {
  size?: InputMaybe<Order_By>
}

/** update columns of table "storage.files" */
export enum Files_Update_Column {
  /** column name */
  BucketId = 'bucketId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Etag = 'etag',
  /** column name */
  Id = 'id',
  /** column name */
  IsUploaded = 'isUploaded',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  MimeType = 'mimeType',
  /** column name */
  Name = 'name',
  /** column name */
  Size = 'size',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UploadedByUserId = 'uploadedByUserId',
}

export type Files_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Files_Append_Input>
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Files_Delete_At_Path_Input>
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Files_Delete_Elem_Input>
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Files_Delete_Key_Input>
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Files_Inc_Input>
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Files_Prepend_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Files_Set_Input>
  /** filter the rows which have to be updated */
  where: Files_Bool_Exp
}

/** aggregate var_pop on columns */
export type Files_Var_Pop_Fields = {
  __typename?: 'files_var_pop_fields'
  size?: Maybe<Scalars['Float']['output']>
}

/** order by var_pop() on columns of table "storage.files" */
export type Files_Var_Pop_Order_By = {
  size?: InputMaybe<Order_By>
}

/** aggregate var_samp on columns */
export type Files_Var_Samp_Fields = {
  __typename?: 'files_var_samp_fields'
  size?: Maybe<Scalars['Float']['output']>
}

/** order by var_samp() on columns of table "storage.files" */
export type Files_Var_Samp_Order_By = {
  size?: InputMaybe<Order_By>
}

/** aggregate variance on columns */
export type Files_Variance_Fields = {
  __typename?: 'files_variance_fields'
  size?: Maybe<Scalars['Float']['output']>
}

/** order by variance() on columns of table "storage.files" */
export type Files_Variance_Order_By = {
  size?: InputMaybe<Order_By>
}

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>
}

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']['input']>
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']['input']>
  _eq?: InputMaybe<Scalars['jsonb']['input']>
  _gt?: InputMaybe<Scalars['jsonb']['input']>
  _gte?: InputMaybe<Scalars['jsonb']['input']>
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']['input']>
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']['input']>>
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']['input']>>
  _in?: InputMaybe<Array<Scalars['jsonb']['input']>>
  _is_null?: InputMaybe<Scalars['Boolean']['input']>
  _lt?: InputMaybe<Scalars['jsonb']['input']>
  _lte?: InputMaybe<Scalars['jsonb']['input']>
  _neq?: InputMaybe<Scalars['jsonb']['input']>
  _nin?: InputMaybe<Array<Scalars['jsonb']['input']>>
}

/** columns and relationships of "matching_question_with_chapter" */
export type Matching_Question_With_Chapter = {
  __typename?: 'matching_question_with_chapter'
  answer_key: Scalars['String']['output']
  article_slugs?: Maybe<Scalars['jsonb']['output']>
  created_at: Scalars['timestamptz']['output']
  criterion?: Maybe<Scalars['jsonb']['output']>
  exclusive: Scalars['Boolean']['output']
}

/** columns and relationships of "matching_question_with_chapter" */
export type Matching_Question_With_ChapterArticle_SlugsArgs = {
  path?: InputMaybe<Scalars['String']['input']>
}

/** columns and relationships of "matching_question_with_chapter" */
export type Matching_Question_With_ChapterCriterionArgs = {
  path?: InputMaybe<Scalars['String']['input']>
}

/** aggregated selection of "matching_question_with_chapter" */
export type Matching_Question_With_Chapter_Aggregate = {
  __typename?: 'matching_question_with_chapter_aggregate'
  aggregate?: Maybe<Matching_Question_With_Chapter_Aggregate_Fields>
  nodes: Array<Matching_Question_With_Chapter>
}

/** aggregate fields of "matching_question_with_chapter" */
export type Matching_Question_With_Chapter_Aggregate_Fields = {
  __typename?: 'matching_question_with_chapter_aggregate_fields'
  count: Scalars['Int']['output']
  max?: Maybe<Matching_Question_With_Chapter_Max_Fields>
  min?: Maybe<Matching_Question_With_Chapter_Min_Fields>
}

/** aggregate fields of "matching_question_with_chapter" */
export type Matching_Question_With_Chapter_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Matching_Question_With_Chapter_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** append existing jsonb value of filtered columns with new jsonb value */
export type Matching_Question_With_Chapter_Append_Input = {
  article_slugs?: InputMaybe<Scalars['jsonb']['input']>
  criterion?: InputMaybe<Scalars['jsonb']['input']>
}

/** Boolean expression to filter rows from the table "matching_question_with_chapter". All fields are combined with a logical 'AND'. */
export type Matching_Question_With_Chapter_Bool_Exp = {
  _and?: InputMaybe<Array<Matching_Question_With_Chapter_Bool_Exp>>
  _not?: InputMaybe<Matching_Question_With_Chapter_Bool_Exp>
  _or?: InputMaybe<Array<Matching_Question_With_Chapter_Bool_Exp>>
  answer_key?: InputMaybe<String_Comparison_Exp>
  article_slugs?: InputMaybe<Jsonb_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  criterion?: InputMaybe<Jsonb_Comparison_Exp>
  exclusive?: InputMaybe<Boolean_Comparison_Exp>
}

/** unique or primary key constraints on table "matching_question_with_chapter" */
export enum Matching_Question_With_Chapter_Constraint {
  /** unique or primary key constraint on columns "answer_key" */
  MatchingQuestionWithChapterPkey = 'matching_question_with_chapter_pkey',
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Matching_Question_With_Chapter_Delete_At_Path_Input = {
  article_slugs?: InputMaybe<Array<Scalars['String']['input']>>
  criterion?: InputMaybe<Array<Scalars['String']['input']>>
}

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Matching_Question_With_Chapter_Delete_Elem_Input = {
  article_slugs?: InputMaybe<Scalars['Int']['input']>
  criterion?: InputMaybe<Scalars['Int']['input']>
}

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Matching_Question_With_Chapter_Delete_Key_Input = {
  article_slugs?: InputMaybe<Scalars['String']['input']>
  criterion?: InputMaybe<Scalars['String']['input']>
}

/** input type for inserting data into table "matching_question_with_chapter" */
export type Matching_Question_With_Chapter_Insert_Input = {
  answer_key?: InputMaybe<Scalars['String']['input']>
  article_slugs?: InputMaybe<Scalars['jsonb']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  criterion?: InputMaybe<Scalars['jsonb']['input']>
  exclusive?: InputMaybe<Scalars['Boolean']['input']>
}

/** aggregate max on columns */
export type Matching_Question_With_Chapter_Max_Fields = {
  __typename?: 'matching_question_with_chapter_max_fields'
  answer_key?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
}

/** aggregate min on columns */
export type Matching_Question_With_Chapter_Min_Fields = {
  __typename?: 'matching_question_with_chapter_min_fields'
  answer_key?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
}

/** response of any mutation on the table "matching_question_with_chapter" */
export type Matching_Question_With_Chapter_Mutation_Response = {
  __typename?: 'matching_question_with_chapter_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Matching_Question_With_Chapter>
}

/** on_conflict condition type for table "matching_question_with_chapter" */
export type Matching_Question_With_Chapter_On_Conflict = {
  constraint: Matching_Question_With_Chapter_Constraint
  update_columns?: Array<Matching_Question_With_Chapter_Update_Column>
  where?: InputMaybe<Matching_Question_With_Chapter_Bool_Exp>
}

/** Ordering options when selecting data from "matching_question_with_chapter". */
export type Matching_Question_With_Chapter_Order_By = {
  answer_key?: InputMaybe<Order_By>
  article_slugs?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  criterion?: InputMaybe<Order_By>
  exclusive?: InputMaybe<Order_By>
}

/** primary key columns input for table: matching_question_with_chapter */
export type Matching_Question_With_Chapter_Pk_Columns_Input = {
  answer_key: Scalars['String']['input']
}

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Matching_Question_With_Chapter_Prepend_Input = {
  article_slugs?: InputMaybe<Scalars['jsonb']['input']>
  criterion?: InputMaybe<Scalars['jsonb']['input']>
}

/** select columns of table "matching_question_with_chapter" */
export enum Matching_Question_With_Chapter_Select_Column {
  /** column name */
  AnswerKey = 'answer_key',
  /** column name */
  ArticleSlugs = 'article_slugs',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Criterion = 'criterion',
  /** column name */
  Exclusive = 'exclusive',
}

/** input type for updating data in table "matching_question_with_chapter" */
export type Matching_Question_With_Chapter_Set_Input = {
  answer_key?: InputMaybe<Scalars['String']['input']>
  article_slugs?: InputMaybe<Scalars['jsonb']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  criterion?: InputMaybe<Scalars['jsonb']['input']>
  exclusive?: InputMaybe<Scalars['Boolean']['input']>
}

/** Streaming cursor of the table "matching_question_with_chapter" */
export type Matching_Question_With_Chapter_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Matching_Question_With_Chapter_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Matching_Question_With_Chapter_Stream_Cursor_Value_Input = {
  answer_key?: InputMaybe<Scalars['String']['input']>
  article_slugs?: InputMaybe<Scalars['jsonb']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  criterion?: InputMaybe<Scalars['jsonb']['input']>
  exclusive?: InputMaybe<Scalars['Boolean']['input']>
}

/** update columns of table "matching_question_with_chapter" */
export enum Matching_Question_With_Chapter_Update_Column {
  /** column name */
  AnswerKey = 'answer_key',
  /** column name */
  ArticleSlugs = 'article_slugs',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Criterion = 'criterion',
  /** column name */
  Exclusive = 'exclusive',
}

export type Matching_Question_With_Chapter_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Matching_Question_With_Chapter_Append_Input>
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Matching_Question_With_Chapter_Delete_At_Path_Input>
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Matching_Question_With_Chapter_Delete_Elem_Input>
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Matching_Question_With_Chapter_Delete_Key_Input>
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Matching_Question_With_Chapter_Prepend_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Matching_Question_With_Chapter_Set_Input>
  /** filter the rows which have to be updated */
  where: Matching_Question_With_Chapter_Bool_Exp
}

/** columns and relationships of "midwife_profiles" */
export type Midwife_Profiles = {
  __typename?: 'midwife_profiles'
  business_name?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  id: Scalars['uuid']['output']
  midwife_code?: Maybe<Scalars['String']['output']>
  phone?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
  /** An object relationship */
  user?: Maybe<Users>
  user_id: Scalars['uuid']['output']
  /** An object relationship */
  voucher_codes?: Maybe<Voucher_Codes>
}

/** aggregated selection of "midwife_profiles" */
export type Midwife_Profiles_Aggregate = {
  __typename?: 'midwife_profiles_aggregate'
  aggregate?: Maybe<Midwife_Profiles_Aggregate_Fields>
  nodes: Array<Midwife_Profiles>
}

/** aggregate fields of "midwife_profiles" */
export type Midwife_Profiles_Aggregate_Fields = {
  __typename?: 'midwife_profiles_aggregate_fields'
  count: Scalars['Int']['output']
  max?: Maybe<Midwife_Profiles_Max_Fields>
  min?: Maybe<Midwife_Profiles_Min_Fields>
}

/** aggregate fields of "midwife_profiles" */
export type Midwife_Profiles_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Midwife_Profiles_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** Boolean expression to filter rows from the table "midwife_profiles". All fields are combined with a logical 'AND'. */
export type Midwife_Profiles_Bool_Exp = {
  _and?: InputMaybe<Array<Midwife_Profiles_Bool_Exp>>
  _not?: InputMaybe<Midwife_Profiles_Bool_Exp>
  _or?: InputMaybe<Array<Midwife_Profiles_Bool_Exp>>
  business_name?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  id?: InputMaybe<Uuid_Comparison_Exp>
  midwife_code?: InputMaybe<String_Comparison_Exp>
  phone?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>
  user?: InputMaybe<Users_Bool_Exp>
  user_id?: InputMaybe<Uuid_Comparison_Exp>
  voucher_codes?: InputMaybe<Voucher_Codes_Bool_Exp>
}

/** unique or primary key constraints on table "midwife_profiles" */
export enum Midwife_Profiles_Constraint {
  /** unique or primary key constraint on columns "midwife_code" */
  MidwifeProfilesMidwifeCodeKey = 'midwife_profiles_midwife_code_key',
  /** unique or primary key constraint on columns "id" */
  MidwifeProfilesPkey = 'midwife_profiles_pkey',
  /** unique or primary key constraint on columns "user_id" */
  MidwifeProfilesUserIdKey = 'midwife_profiles_user_id_key',
}

/** input type for inserting data into table "midwife_profiles" */
export type Midwife_Profiles_Insert_Input = {
  business_name?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  midwife_code?: InputMaybe<Scalars['String']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>
  user_id?: InputMaybe<Scalars['uuid']['input']>
  voucher_codes?: InputMaybe<Voucher_Codes_Obj_Rel_Insert_Input>
}

/** aggregate max on columns */
export type Midwife_Profiles_Max_Fields = {
  __typename?: 'midwife_profiles_max_fields'
  business_name?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['uuid']['output']>
  midwife_code?: Maybe<Scalars['String']['output']>
  phone?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
  user_id?: Maybe<Scalars['uuid']['output']>
}

/** aggregate min on columns */
export type Midwife_Profiles_Min_Fields = {
  __typename?: 'midwife_profiles_min_fields'
  business_name?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['uuid']['output']>
  midwife_code?: Maybe<Scalars['String']['output']>
  phone?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
  user_id?: Maybe<Scalars['uuid']['output']>
}

/** response of any mutation on the table "midwife_profiles" */
export type Midwife_Profiles_Mutation_Response = {
  __typename?: 'midwife_profiles_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Midwife_Profiles>
}

/** input type for inserting object relation for remote table "midwife_profiles" */
export type Midwife_Profiles_Obj_Rel_Insert_Input = {
  data: Midwife_Profiles_Insert_Input
  /** upsert condition */
  on_conflict?: InputMaybe<Midwife_Profiles_On_Conflict>
}

/** on_conflict condition type for table "midwife_profiles" */
export type Midwife_Profiles_On_Conflict = {
  constraint: Midwife_Profiles_Constraint
  update_columns?: Array<Midwife_Profiles_Update_Column>
  where?: InputMaybe<Midwife_Profiles_Bool_Exp>
}

/** Ordering options when selecting data from "midwife_profiles". */
export type Midwife_Profiles_Order_By = {
  business_name?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  midwife_code?: InputMaybe<Order_By>
  phone?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  user?: InputMaybe<Users_Order_By>
  user_id?: InputMaybe<Order_By>
  voucher_codes?: InputMaybe<Voucher_Codes_Order_By>
}

/** primary key columns input for table: midwife_profiles */
export type Midwife_Profiles_Pk_Columns_Input = {
  id: Scalars['uuid']['input']
}

/** select columns of table "midwife_profiles" */
export enum Midwife_Profiles_Select_Column {
  /** column name */
  BusinessName = 'business_name',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  MidwifeCode = 'midwife_code',
  /** column name */
  Phone = 'phone',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
}

/** input type for updating data in table "midwife_profiles" */
export type Midwife_Profiles_Set_Input = {
  business_name?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  midwife_code?: InputMaybe<Scalars['String']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  user_id?: InputMaybe<Scalars['uuid']['input']>
}

/** Streaming cursor of the table "midwife_profiles" */
export type Midwife_Profiles_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Midwife_Profiles_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Midwife_Profiles_Stream_Cursor_Value_Input = {
  business_name?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  midwife_code?: InputMaybe<Scalars['String']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  user_id?: InputMaybe<Scalars['uuid']['input']>
}

/** update columns of table "midwife_profiles" */
export enum Midwife_Profiles_Update_Column {
  /** column name */
  BusinessName = 'business_name',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  MidwifeCode = 'midwife_code',
  /** column name */
  Phone = 'phone',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
}

export type Midwife_Profiles_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Midwife_Profiles_Set_Input>
  /** filter the rows which have to be updated */
  where: Midwife_Profiles_Bool_Exp
}

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root'
  /** delete single row from the table: "auth.oauth2_auth_requests" */
  deleteAuthOauth2AuthRequest?: Maybe<AuthOauth2AuthRequests>
  /** delete data from the table: "auth.oauth2_auth_requests" */
  deleteAuthOauth2AuthRequests?: Maybe<AuthOauth2AuthRequests_Mutation_Response>
  /** delete single row from the table: "auth.oauth2_authorization_codes" */
  deleteAuthOauth2AuthorizationCode?: Maybe<AuthOauth2AuthorizationCodes>
  /** delete data from the table: "auth.oauth2_authorization_codes" */
  deleteAuthOauth2AuthorizationCodes?: Maybe<AuthOauth2AuthorizationCodes_Mutation_Response>
  /** delete single row from the table: "auth.oauth2_clients" */
  deleteAuthOauth2Client?: Maybe<AuthOauth2Clients>
  /** delete data from the table: "auth.oauth2_clients" */
  deleteAuthOauth2Clients?: Maybe<AuthOauth2Clients_Mutation_Response>
  /** delete single row from the table: "auth.oauth2_refresh_tokens" */
  deleteAuthOauth2RefreshToken?: Maybe<AuthOauth2RefreshTokens>
  /** delete data from the table: "auth.oauth2_refresh_tokens" */
  deleteAuthOauth2RefreshTokens?: Maybe<AuthOauth2RefreshTokens_Mutation_Response>
  /** delete single row from the table: "auth.providers" */
  deleteAuthProvider?: Maybe<AuthProviders>
  /** delete single row from the table: "auth.provider_requests" */
  deleteAuthProviderRequest?: Maybe<AuthProviderRequests>
  /** delete data from the table: "auth.provider_requests" */
  deleteAuthProviderRequests?: Maybe<AuthProviderRequests_Mutation_Response>
  /** delete data from the table: "auth.providers" */
  deleteAuthProviders?: Maybe<AuthProviders_Mutation_Response>
  /** delete single row from the table: "auth.refresh_tokens" */
  deleteAuthRefreshToken?: Maybe<AuthRefreshTokens>
  /** delete single row from the table: "auth.refresh_token_types" */
  deleteAuthRefreshTokenType?: Maybe<AuthRefreshTokenTypes>
  /** delete data from the table: "auth.refresh_token_types" */
  deleteAuthRefreshTokenTypes?: Maybe<AuthRefreshTokenTypes_Mutation_Response>
  /** delete data from the table: "auth.refresh_tokens" */
  deleteAuthRefreshTokens?: Maybe<AuthRefreshTokens_Mutation_Response>
  /** delete single row from the table: "auth.roles" */
  deleteAuthRole?: Maybe<AuthRoles>
  /** delete data from the table: "auth.roles" */
  deleteAuthRoles?: Maybe<AuthRoles_Mutation_Response>
  /** delete single row from the table: "auth.user_providers" */
  deleteAuthUserProvider?: Maybe<AuthUserProviders>
  /** delete data from the table: "auth.user_providers" */
  deleteAuthUserProviders?: Maybe<AuthUserProviders_Mutation_Response>
  /** delete single row from the table: "auth.user_roles" */
  deleteAuthUserRole?: Maybe<AuthUserRoles>
  /** delete data from the table: "auth.user_roles" */
  deleteAuthUserRoles?: Maybe<AuthUserRoles_Mutation_Response>
  /** delete single row from the table: "auth.user_security_keys" */
  deleteAuthUserSecurityKey?: Maybe<AuthUserSecurityKeys>
  /** delete data from the table: "auth.user_security_keys" */
  deleteAuthUserSecurityKeys?: Maybe<AuthUserSecurityKeys_Mutation_Response>
  /** delete single row from the table: "storage.buckets" */
  deleteBucket?: Maybe<Buckets>
  /** delete data from the table: "storage.buckets" */
  deleteBuckets?: Maybe<Buckets_Mutation_Response>
  /** delete single row from the table: "storage.files" */
  deleteFile?: Maybe<Files>
  /** delete data from the table: "storage.files" */
  deleteFiles?: Maybe<Files_Mutation_Response>
  /** delete single row from the table: "auth.users" */
  deleteUser?: Maybe<Users>
  /** delete data from the table: "auth.users" */
  deleteUsers?: Maybe<Users_Mutation_Response>
  /** delete single row from the table: "storage.virus" */
  deleteVirus?: Maybe<Virus>
  /** delete data from the table: "storage.virus" */
  deleteViruses?: Maybe<Virus_Mutation_Response>
  /** delete data from the table: "appointments" */
  delete_appointments?: Maybe<Appointments_Mutation_Response>
  /** delete single row from the table: "appointments" */
  delete_appointments_by_pk?: Maybe<Appointments>
  /** delete data from the table: "article_progress" */
  delete_article_progress?: Maybe<Article_Progress_Mutation_Response>
  /** delete single row from the table: "article_progress" */
  delete_article_progress_by_pk?: Maybe<Article_Progress>
  /** delete data from the table: "article_sections" */
  delete_article_sections?: Maybe<Article_Sections_Mutation_Response>
  /** delete single row from the table: "article_sections" */
  delete_article_sections_by_pk?: Maybe<Article_Sections>
  /** delete data from the table: "articles" */
  delete_articles?: Maybe<Articles_Mutation_Response>
  /** delete single row from the table: "articles" */
  delete_articles_by_pk?: Maybe<Articles>
  /** delete data from the table: "categories" */
  delete_categories?: Maybe<Categories_Mutation_Response>
  /** delete single row from the table: "categories" */
  delete_categories_by_pk?: Maybe<Categories>
  /** delete data from the table: "chapters" */
  delete_chapters?: Maybe<Chapters_Mutation_Response>
  /** delete data from the table: "chat_messages" */
  delete_chat_messages?: Maybe<Chat_Messages_Mutation_Response>
  /** delete single row from the table: "chat_messages" */
  delete_chat_messages_by_pk?: Maybe<Chat_Messages>
  /** delete data from the table: "feedback_messages" */
  delete_feedback_messages?: Maybe<Feedback_Messages_Mutation_Response>
  /** delete single row from the table: "feedback_messages" */
  delete_feedback_messages_by_pk?: Maybe<Feedback_Messages>
  /** delete data from the table: "matching_question_with_chapter" */
  delete_matching_question_with_chapter?: Maybe<Matching_Question_With_Chapter_Mutation_Response>
  /** delete single row from the table: "matching_question_with_chapter" */
  delete_matching_question_with_chapter_by_pk?: Maybe<Matching_Question_With_Chapter>
  /** delete data from the table: "midwife_profiles" */
  delete_midwife_profiles?: Maybe<Midwife_Profiles_Mutation_Response>
  /** delete single row from the table: "midwife_profiles" */
  delete_midwife_profiles_by_pk?: Maybe<Midwife_Profiles>
  /** delete data from the table: "preparation" */
  delete_preparation?: Maybe<Preparation_Mutation_Response>
  /** delete single row from the table: "preparation" */
  delete_preparation_by_pk?: Maybe<Preparation>
  /** delete data from the table: "qm_entries" */
  delete_qm_entries?: Maybe<Qm_Entries_Mutation_Response>
  /** delete single row from the table: "qm_entries" */
  delete_qm_entries_by_pk?: Maybe<Qm_Entries>
  /** delete data from the table: "tracking_birth" */
  delete_tracking_birth?: Maybe<Tracking_Birth_Mutation_Response>
  /** delete single row from the table: "tracking_birth" */
  delete_tracking_birth_by_pk?: Maybe<Tracking_Birth>
  /** delete data from the table: "tracking_bottle" */
  delete_tracking_bottle?: Maybe<Tracking_Bottle_Mutation_Response>
  /** delete single row from the table: "tracking_bottle" */
  delete_tracking_bottle_by_pk?: Maybe<Tracking_Bottle>
  /** delete data from the table: "tracking_breast" */
  delete_tracking_breast?: Maybe<Tracking_Breast_Mutation_Response>
  /** delete single row from the table: "tracking_breast" */
  delete_tracking_breast_by_pk?: Maybe<Tracking_Breast>
  /** delete data from the table: "tracking_diaper" */
  delete_tracking_diaper?: Maybe<Tracking_Diaper_Mutation_Response>
  /** delete single row from the table: "tracking_diaper" */
  delete_tracking_diaper_by_pk?: Maybe<Tracking_Diaper>
  /** delete data from the table: "tracking_mental_health" */
  delete_tracking_mental_health?: Maybe<Tracking_Mental_Health_Mutation_Response>
  /** delete single row from the table: "tracking_mental_health" */
  delete_tracking_mental_health_by_pk?: Maybe<Tracking_Mental_Health>
  /** delete data from the table: "tracking_nursing" */
  delete_tracking_nursing?: Maybe<Tracking_Nursing_Mutation_Response>
  /** delete single row from the table: "tracking_nursing" */
  delete_tracking_nursing_by_pk?: Maybe<Tracking_Nursing>
  /** delete data from the table: "tracking_substance" */
  delete_tracking_substance?: Maybe<Tracking_Substance_Mutation_Response>
  /** delete single row from the table: "tracking_substance" */
  delete_tracking_substance_by_pk?: Maybe<Tracking_Substance>
  /** delete data from the table: "tracking_tonguetie" */
  delete_tracking_tonguetie?: Maybe<Tracking_Tonguetie_Mutation_Response>
  /** delete single row from the table: "tracking_tonguetie" */
  delete_tracking_tonguetie_by_pk?: Maybe<Tracking_Tonguetie>
  /** delete data from the table: "tracking_weight" */
  delete_tracking_weight?: Maybe<Tracking_Weight_Mutation_Response>
  /** delete single row from the table: "tracking_weight" */
  delete_tracking_weight_by_pk?: Maybe<Tracking_Weight>
  /** delete data from the table: "user_profiles" */
  delete_user_profiles?: Maybe<User_Profiles_Mutation_Response>
  /** delete single row from the table: "user_profiles" */
  delete_user_profiles_by_pk?: Maybe<User_Profiles>
  /** delete data from the table: "voucher_codes" */
  delete_voucher_codes?: Maybe<Voucher_Codes_Mutation_Response>
  /** delete single row from the table: "voucher_codes" */
  delete_voucher_codes_by_pk?: Maybe<Voucher_Codes>
  /** insert a single row into the table: "auth.oauth2_auth_requests" */
  insertAuthOauth2AuthRequest?: Maybe<AuthOauth2AuthRequests>
  /** insert data into the table: "auth.oauth2_auth_requests" */
  insertAuthOauth2AuthRequests?: Maybe<AuthOauth2AuthRequests_Mutation_Response>
  /** insert a single row into the table: "auth.oauth2_authorization_codes" */
  insertAuthOauth2AuthorizationCode?: Maybe<AuthOauth2AuthorizationCodes>
  /** insert data into the table: "auth.oauth2_authorization_codes" */
  insertAuthOauth2AuthorizationCodes?: Maybe<AuthOauth2AuthorizationCodes_Mutation_Response>
  /** insert a single row into the table: "auth.oauth2_clients" */
  insertAuthOauth2Client?: Maybe<AuthOauth2Clients>
  /** insert data into the table: "auth.oauth2_clients" */
  insertAuthOauth2Clients?: Maybe<AuthOauth2Clients_Mutation_Response>
  /** insert a single row into the table: "auth.oauth2_refresh_tokens" */
  insertAuthOauth2RefreshToken?: Maybe<AuthOauth2RefreshTokens>
  /** insert data into the table: "auth.oauth2_refresh_tokens" */
  insertAuthOauth2RefreshTokens?: Maybe<AuthOauth2RefreshTokens_Mutation_Response>
  /** insert a single row into the table: "auth.providers" */
  insertAuthProvider?: Maybe<AuthProviders>
  /** insert a single row into the table: "auth.provider_requests" */
  insertAuthProviderRequest?: Maybe<AuthProviderRequests>
  /** insert data into the table: "auth.provider_requests" */
  insertAuthProviderRequests?: Maybe<AuthProviderRequests_Mutation_Response>
  /** insert data into the table: "auth.providers" */
  insertAuthProviders?: Maybe<AuthProviders_Mutation_Response>
  /** insert a single row into the table: "auth.refresh_tokens" */
  insertAuthRefreshToken?: Maybe<AuthRefreshTokens>
  /** insert a single row into the table: "auth.refresh_token_types" */
  insertAuthRefreshTokenType?: Maybe<AuthRefreshTokenTypes>
  /** insert data into the table: "auth.refresh_token_types" */
  insertAuthRefreshTokenTypes?: Maybe<AuthRefreshTokenTypes_Mutation_Response>
  /** insert data into the table: "auth.refresh_tokens" */
  insertAuthRefreshTokens?: Maybe<AuthRefreshTokens_Mutation_Response>
  /** insert a single row into the table: "auth.roles" */
  insertAuthRole?: Maybe<AuthRoles>
  /** insert data into the table: "auth.roles" */
  insertAuthRoles?: Maybe<AuthRoles_Mutation_Response>
  /** insert a single row into the table: "auth.user_providers" */
  insertAuthUserProvider?: Maybe<AuthUserProviders>
  /** insert data into the table: "auth.user_providers" */
  insertAuthUserProviders?: Maybe<AuthUserProviders_Mutation_Response>
  /** insert a single row into the table: "auth.user_roles" */
  insertAuthUserRole?: Maybe<AuthUserRoles>
  /** insert data into the table: "auth.user_roles" */
  insertAuthUserRoles?: Maybe<AuthUserRoles_Mutation_Response>
  /** insert a single row into the table: "auth.user_security_keys" */
  insertAuthUserSecurityKey?: Maybe<AuthUserSecurityKeys>
  /** insert data into the table: "auth.user_security_keys" */
  insertAuthUserSecurityKeys?: Maybe<AuthUserSecurityKeys_Mutation_Response>
  /** insert a single row into the table: "storage.buckets" */
  insertBucket?: Maybe<Buckets>
  /** insert data into the table: "storage.buckets" */
  insertBuckets?: Maybe<Buckets_Mutation_Response>
  /** insert a single row into the table: "storage.files" */
  insertFile?: Maybe<Files>
  /** insert data into the table: "storage.files" */
  insertFiles?: Maybe<Files_Mutation_Response>
  /** insert a single row into the table: "auth.users" */
  insertUser?: Maybe<Users>
  /** insert data into the table: "auth.users" */
  insertUsers?: Maybe<Users_Mutation_Response>
  /** insert a single row into the table: "storage.virus" */
  insertVirus?: Maybe<Virus>
  /** insert data into the table: "storage.virus" */
  insertViruses?: Maybe<Virus_Mutation_Response>
  /** insert data into the table: "appointments" */
  insert_appointments?: Maybe<Appointments_Mutation_Response>
  /** insert a single row into the table: "appointments" */
  insert_appointments_one?: Maybe<Appointments>
  /** insert data into the table: "article_progress" */
  insert_article_progress?: Maybe<Article_Progress_Mutation_Response>
  /** insert a single row into the table: "article_progress" */
  insert_article_progress_one?: Maybe<Article_Progress>
  /** insert data into the table: "article_sections" */
  insert_article_sections?: Maybe<Article_Sections_Mutation_Response>
  /** insert a single row into the table: "article_sections" */
  insert_article_sections_one?: Maybe<Article_Sections>
  /** insert data into the table: "articles" */
  insert_articles?: Maybe<Articles_Mutation_Response>
  /** insert a single row into the table: "articles" */
  insert_articles_one?: Maybe<Articles>
  /** insert data into the table: "categories" */
  insert_categories?: Maybe<Categories_Mutation_Response>
  /** insert a single row into the table: "categories" */
  insert_categories_one?: Maybe<Categories>
  /** insert data into the table: "chapters" */
  insert_chapters?: Maybe<Chapters_Mutation_Response>
  /** insert a single row into the table: "chapters" */
  insert_chapters_one?: Maybe<Chapters>
  /** insert data into the table: "chat_messages" */
  insert_chat_messages?: Maybe<Chat_Messages_Mutation_Response>
  /** insert a single row into the table: "chat_messages" */
  insert_chat_messages_one?: Maybe<Chat_Messages>
  /** insert data into the table: "feedback_messages" */
  insert_feedback_messages?: Maybe<Feedback_Messages_Mutation_Response>
  /** insert a single row into the table: "feedback_messages" */
  insert_feedback_messages_one?: Maybe<Feedback_Messages>
  /** insert data into the table: "matching_question_with_chapter" */
  insert_matching_question_with_chapter?: Maybe<Matching_Question_With_Chapter_Mutation_Response>
  /** insert a single row into the table: "matching_question_with_chapter" */
  insert_matching_question_with_chapter_one?: Maybe<Matching_Question_With_Chapter>
  /** insert data into the table: "midwife_profiles" */
  insert_midwife_profiles?: Maybe<Midwife_Profiles_Mutation_Response>
  /** insert a single row into the table: "midwife_profiles" */
  insert_midwife_profiles_one?: Maybe<Midwife_Profiles>
  /** insert data into the table: "preparation" */
  insert_preparation?: Maybe<Preparation_Mutation_Response>
  /** insert a single row into the table: "preparation" */
  insert_preparation_one?: Maybe<Preparation>
  /** insert data into the table: "qm_entries" */
  insert_qm_entries?: Maybe<Qm_Entries_Mutation_Response>
  /** insert a single row into the table: "qm_entries" */
  insert_qm_entries_one?: Maybe<Qm_Entries>
  /** insert data into the table: "tracking_birth" */
  insert_tracking_birth?: Maybe<Tracking_Birth_Mutation_Response>
  /** insert a single row into the table: "tracking_birth" */
  insert_tracking_birth_one?: Maybe<Tracking_Birth>
  /** insert data into the table: "tracking_bottle" */
  insert_tracking_bottle?: Maybe<Tracking_Bottle_Mutation_Response>
  /** insert a single row into the table: "tracking_bottle" */
  insert_tracking_bottle_one?: Maybe<Tracking_Bottle>
  /** insert data into the table: "tracking_breast" */
  insert_tracking_breast?: Maybe<Tracking_Breast_Mutation_Response>
  /** insert a single row into the table: "tracking_breast" */
  insert_tracking_breast_one?: Maybe<Tracking_Breast>
  /** insert data into the table: "tracking_diaper" */
  insert_tracking_diaper?: Maybe<Tracking_Diaper_Mutation_Response>
  /** insert a single row into the table: "tracking_diaper" */
  insert_tracking_diaper_one?: Maybe<Tracking_Diaper>
  /** insert data into the table: "tracking_mental_health" */
  insert_tracking_mental_health?: Maybe<Tracking_Mental_Health_Mutation_Response>
  /** insert a single row into the table: "tracking_mental_health" */
  insert_tracking_mental_health_one?: Maybe<Tracking_Mental_Health>
  /** insert data into the table: "tracking_nursing" */
  insert_tracking_nursing?: Maybe<Tracking_Nursing_Mutation_Response>
  /** insert a single row into the table: "tracking_nursing" */
  insert_tracking_nursing_one?: Maybe<Tracking_Nursing>
  /** insert data into the table: "tracking_substance" */
  insert_tracking_substance?: Maybe<Tracking_Substance_Mutation_Response>
  /** insert a single row into the table: "tracking_substance" */
  insert_tracking_substance_one?: Maybe<Tracking_Substance>
  /** insert data into the table: "tracking_tonguetie" */
  insert_tracking_tonguetie?: Maybe<Tracking_Tonguetie_Mutation_Response>
  /** insert a single row into the table: "tracking_tonguetie" */
  insert_tracking_tonguetie_one?: Maybe<Tracking_Tonguetie>
  /** insert data into the table: "tracking_weight" */
  insert_tracking_weight?: Maybe<Tracking_Weight_Mutation_Response>
  /** insert a single row into the table: "tracking_weight" */
  insert_tracking_weight_one?: Maybe<Tracking_Weight>
  /** insert data into the table: "user_profiles" */
  insert_user_profiles?: Maybe<User_Profiles_Mutation_Response>
  /** insert a single row into the table: "user_profiles" */
  insert_user_profiles_one?: Maybe<User_Profiles>
  /** insert data into the table: "voucher_codes" */
  insert_voucher_codes?: Maybe<Voucher_Codes_Mutation_Response>
  /** insert a single row into the table: "voucher_codes" */
  insert_voucher_codes_one?: Maybe<Voucher_Codes>
  /** update single row of the table: "auth.oauth2_auth_requests" */
  updateAuthOauth2AuthRequest?: Maybe<AuthOauth2AuthRequests>
  /** update data of the table: "auth.oauth2_auth_requests" */
  updateAuthOauth2AuthRequests?: Maybe<AuthOauth2AuthRequests_Mutation_Response>
  /** update single row of the table: "auth.oauth2_authorization_codes" */
  updateAuthOauth2AuthorizationCode?: Maybe<AuthOauth2AuthorizationCodes>
  /** update data of the table: "auth.oauth2_authorization_codes" */
  updateAuthOauth2AuthorizationCodes?: Maybe<AuthOauth2AuthorizationCodes_Mutation_Response>
  /** update single row of the table: "auth.oauth2_clients" */
  updateAuthOauth2Client?: Maybe<AuthOauth2Clients>
  /** update data of the table: "auth.oauth2_clients" */
  updateAuthOauth2Clients?: Maybe<AuthOauth2Clients_Mutation_Response>
  /** update single row of the table: "auth.oauth2_refresh_tokens" */
  updateAuthOauth2RefreshToken?: Maybe<AuthOauth2RefreshTokens>
  /** update data of the table: "auth.oauth2_refresh_tokens" */
  updateAuthOauth2RefreshTokens?: Maybe<AuthOauth2RefreshTokens_Mutation_Response>
  /** update single row of the table: "auth.providers" */
  updateAuthProvider?: Maybe<AuthProviders>
  /** update single row of the table: "auth.provider_requests" */
  updateAuthProviderRequest?: Maybe<AuthProviderRequests>
  /** update data of the table: "auth.provider_requests" */
  updateAuthProviderRequests?: Maybe<AuthProviderRequests_Mutation_Response>
  /** update data of the table: "auth.providers" */
  updateAuthProviders?: Maybe<AuthProviders_Mutation_Response>
  /** update single row of the table: "auth.refresh_tokens" */
  updateAuthRefreshToken?: Maybe<AuthRefreshTokens>
  /** update single row of the table: "auth.refresh_token_types" */
  updateAuthRefreshTokenType?: Maybe<AuthRefreshTokenTypes>
  /** update data of the table: "auth.refresh_token_types" */
  updateAuthRefreshTokenTypes?: Maybe<AuthRefreshTokenTypes_Mutation_Response>
  /** update data of the table: "auth.refresh_tokens" */
  updateAuthRefreshTokens?: Maybe<AuthRefreshTokens_Mutation_Response>
  /** update single row of the table: "auth.roles" */
  updateAuthRole?: Maybe<AuthRoles>
  /** update data of the table: "auth.roles" */
  updateAuthRoles?: Maybe<AuthRoles_Mutation_Response>
  /** update single row of the table: "auth.user_providers" */
  updateAuthUserProvider?: Maybe<AuthUserProviders>
  /** update data of the table: "auth.user_providers" */
  updateAuthUserProviders?: Maybe<AuthUserProviders_Mutation_Response>
  /** update single row of the table: "auth.user_roles" */
  updateAuthUserRole?: Maybe<AuthUserRoles>
  /** update data of the table: "auth.user_roles" */
  updateAuthUserRoles?: Maybe<AuthUserRoles_Mutation_Response>
  /** update single row of the table: "auth.user_security_keys" */
  updateAuthUserSecurityKey?: Maybe<AuthUserSecurityKeys>
  /** update data of the table: "auth.user_security_keys" */
  updateAuthUserSecurityKeys?: Maybe<AuthUserSecurityKeys_Mutation_Response>
  /** update single row of the table: "storage.buckets" */
  updateBucket?: Maybe<Buckets>
  /** update data of the table: "storage.buckets" */
  updateBuckets?: Maybe<Buckets_Mutation_Response>
  /** update single row of the table: "storage.files" */
  updateFile?: Maybe<Files>
  /** update data of the table: "storage.files" */
  updateFiles?: Maybe<Files_Mutation_Response>
  /** update single row of the table: "auth.users" */
  updateUser?: Maybe<Users>
  /** update data of the table: "auth.users" */
  updateUsers?: Maybe<Users_Mutation_Response>
  /** update single row of the table: "storage.virus" */
  updateVirus?: Maybe<Virus>
  /** update data of the table: "storage.virus" */
  updateViruses?: Maybe<Virus_Mutation_Response>
  /** update data of the table: "appointments" */
  update_appointments?: Maybe<Appointments_Mutation_Response>
  /** update single row of the table: "appointments" */
  update_appointments_by_pk?: Maybe<Appointments>
  /** update multiples rows of table: "appointments" */
  update_appointments_many?: Maybe<Array<Maybe<Appointments_Mutation_Response>>>
  /** update data of the table: "article_progress" */
  update_article_progress?: Maybe<Article_Progress_Mutation_Response>
  /** update single row of the table: "article_progress" */
  update_article_progress_by_pk?: Maybe<Article_Progress>
  /** update multiples rows of table: "article_progress" */
  update_article_progress_many?: Maybe<Array<Maybe<Article_Progress_Mutation_Response>>>
  /** update data of the table: "article_sections" */
  update_article_sections?: Maybe<Article_Sections_Mutation_Response>
  /** update single row of the table: "article_sections" */
  update_article_sections_by_pk?: Maybe<Article_Sections>
  /** update multiples rows of table: "article_sections" */
  update_article_sections_many?: Maybe<Array<Maybe<Article_Sections_Mutation_Response>>>
  /** update data of the table: "articles" */
  update_articles?: Maybe<Articles_Mutation_Response>
  /** update single row of the table: "articles" */
  update_articles_by_pk?: Maybe<Articles>
  /** update multiples rows of table: "articles" */
  update_articles_many?: Maybe<Array<Maybe<Articles_Mutation_Response>>>
  /** update multiples rows of table: "auth.oauth2_auth_requests" */
  update_authOauth2AuthRequests_many?: Maybe<Array<Maybe<AuthOauth2AuthRequests_Mutation_Response>>>
  /** update multiples rows of table: "auth.oauth2_authorization_codes" */
  update_authOauth2AuthorizationCodes_many?: Maybe<
    Array<Maybe<AuthOauth2AuthorizationCodes_Mutation_Response>>
  >
  /** update multiples rows of table: "auth.oauth2_clients" */
  update_authOauth2Clients_many?: Maybe<Array<Maybe<AuthOauth2Clients_Mutation_Response>>>
  /** update multiples rows of table: "auth.oauth2_refresh_tokens" */
  update_authOauth2RefreshTokens_many?: Maybe<
    Array<Maybe<AuthOauth2RefreshTokens_Mutation_Response>>
  >
  /** update multiples rows of table: "auth.provider_requests" */
  update_authProviderRequests_many?: Maybe<Array<Maybe<AuthProviderRequests_Mutation_Response>>>
  /** update multiples rows of table: "auth.providers" */
  update_authProviders_many?: Maybe<Array<Maybe<AuthProviders_Mutation_Response>>>
  /** update multiples rows of table: "auth.refresh_token_types" */
  update_authRefreshTokenTypes_many?: Maybe<Array<Maybe<AuthRefreshTokenTypes_Mutation_Response>>>
  /** update multiples rows of table: "auth.refresh_tokens" */
  update_authRefreshTokens_many?: Maybe<Array<Maybe<AuthRefreshTokens_Mutation_Response>>>
  /** update multiples rows of table: "auth.roles" */
  update_authRoles_many?: Maybe<Array<Maybe<AuthRoles_Mutation_Response>>>
  /** update multiples rows of table: "auth.user_providers" */
  update_authUserProviders_many?: Maybe<Array<Maybe<AuthUserProviders_Mutation_Response>>>
  /** update multiples rows of table: "auth.user_roles" */
  update_authUserRoles_many?: Maybe<Array<Maybe<AuthUserRoles_Mutation_Response>>>
  /** update multiples rows of table: "auth.user_security_keys" */
  update_authUserSecurityKeys_many?: Maybe<Array<Maybe<AuthUserSecurityKeys_Mutation_Response>>>
  /** update multiples rows of table: "storage.buckets" */
  update_buckets_many?: Maybe<Array<Maybe<Buckets_Mutation_Response>>>
  /** update data of the table: "categories" */
  update_categories?: Maybe<Categories_Mutation_Response>
  /** update single row of the table: "categories" */
  update_categories_by_pk?: Maybe<Categories>
  /** update multiples rows of table: "categories" */
  update_categories_many?: Maybe<Array<Maybe<Categories_Mutation_Response>>>
  /** update data of the table: "chapters" */
  update_chapters?: Maybe<Chapters_Mutation_Response>
  /** update multiples rows of table: "chapters" */
  update_chapters_many?: Maybe<Array<Maybe<Chapters_Mutation_Response>>>
  /** update data of the table: "chat_messages" */
  update_chat_messages?: Maybe<Chat_Messages_Mutation_Response>
  /** update single row of the table: "chat_messages" */
  update_chat_messages_by_pk?: Maybe<Chat_Messages>
  /** update multiples rows of table: "chat_messages" */
  update_chat_messages_many?: Maybe<Array<Maybe<Chat_Messages_Mutation_Response>>>
  /** update data of the table: "feedback_messages" */
  update_feedback_messages?: Maybe<Feedback_Messages_Mutation_Response>
  /** update single row of the table: "feedback_messages" */
  update_feedback_messages_by_pk?: Maybe<Feedback_Messages>
  /** update multiples rows of table: "feedback_messages" */
  update_feedback_messages_many?: Maybe<Array<Maybe<Feedback_Messages_Mutation_Response>>>
  /** update multiples rows of table: "storage.files" */
  update_files_many?: Maybe<Array<Maybe<Files_Mutation_Response>>>
  /** update data of the table: "matching_question_with_chapter" */
  update_matching_question_with_chapter?: Maybe<Matching_Question_With_Chapter_Mutation_Response>
  /** update single row of the table: "matching_question_with_chapter" */
  update_matching_question_with_chapter_by_pk?: Maybe<Matching_Question_With_Chapter>
  /** update multiples rows of table: "matching_question_with_chapter" */
  update_matching_question_with_chapter_many?: Maybe<
    Array<Maybe<Matching_Question_With_Chapter_Mutation_Response>>
  >
  /** update data of the table: "midwife_profiles" */
  update_midwife_profiles?: Maybe<Midwife_Profiles_Mutation_Response>
  /** update single row of the table: "midwife_profiles" */
  update_midwife_profiles_by_pk?: Maybe<Midwife_Profiles>
  /** update multiples rows of table: "midwife_profiles" */
  update_midwife_profiles_many?: Maybe<Array<Maybe<Midwife_Profiles_Mutation_Response>>>
  /** update data of the table: "preparation" */
  update_preparation?: Maybe<Preparation_Mutation_Response>
  /** update single row of the table: "preparation" */
  update_preparation_by_pk?: Maybe<Preparation>
  /** update multiples rows of table: "preparation" */
  update_preparation_many?: Maybe<Array<Maybe<Preparation_Mutation_Response>>>
  /** update data of the table: "qm_entries" */
  update_qm_entries?: Maybe<Qm_Entries_Mutation_Response>
  /** update single row of the table: "qm_entries" */
  update_qm_entries_by_pk?: Maybe<Qm_Entries>
  /** update multiples rows of table: "qm_entries" */
  update_qm_entries_many?: Maybe<Array<Maybe<Qm_Entries_Mutation_Response>>>
  /** update data of the table: "tracking_birth" */
  update_tracking_birth?: Maybe<Tracking_Birth_Mutation_Response>
  /** update single row of the table: "tracking_birth" */
  update_tracking_birth_by_pk?: Maybe<Tracking_Birth>
  /** update multiples rows of table: "tracking_birth" */
  update_tracking_birth_many?: Maybe<Array<Maybe<Tracking_Birth_Mutation_Response>>>
  /** update data of the table: "tracking_bottle" */
  update_tracking_bottle?: Maybe<Tracking_Bottle_Mutation_Response>
  /** update single row of the table: "tracking_bottle" */
  update_tracking_bottle_by_pk?: Maybe<Tracking_Bottle>
  /** update multiples rows of table: "tracking_bottle" */
  update_tracking_bottle_many?: Maybe<Array<Maybe<Tracking_Bottle_Mutation_Response>>>
  /** update data of the table: "tracking_breast" */
  update_tracking_breast?: Maybe<Tracking_Breast_Mutation_Response>
  /** update single row of the table: "tracking_breast" */
  update_tracking_breast_by_pk?: Maybe<Tracking_Breast>
  /** update multiples rows of table: "tracking_breast" */
  update_tracking_breast_many?: Maybe<Array<Maybe<Tracking_Breast_Mutation_Response>>>
  /** update data of the table: "tracking_diaper" */
  update_tracking_diaper?: Maybe<Tracking_Diaper_Mutation_Response>
  /** update single row of the table: "tracking_diaper" */
  update_tracking_diaper_by_pk?: Maybe<Tracking_Diaper>
  /** update multiples rows of table: "tracking_diaper" */
  update_tracking_diaper_many?: Maybe<Array<Maybe<Tracking_Diaper_Mutation_Response>>>
  /** update data of the table: "tracking_mental_health" */
  update_tracking_mental_health?: Maybe<Tracking_Mental_Health_Mutation_Response>
  /** update single row of the table: "tracking_mental_health" */
  update_tracking_mental_health_by_pk?: Maybe<Tracking_Mental_Health>
  /** update multiples rows of table: "tracking_mental_health" */
  update_tracking_mental_health_many?: Maybe<Array<Maybe<Tracking_Mental_Health_Mutation_Response>>>
  /** update data of the table: "tracking_nursing" */
  update_tracking_nursing?: Maybe<Tracking_Nursing_Mutation_Response>
  /** update single row of the table: "tracking_nursing" */
  update_tracking_nursing_by_pk?: Maybe<Tracking_Nursing>
  /** update multiples rows of table: "tracking_nursing" */
  update_tracking_nursing_many?: Maybe<Array<Maybe<Tracking_Nursing_Mutation_Response>>>
  /** update data of the table: "tracking_substance" */
  update_tracking_substance?: Maybe<Tracking_Substance_Mutation_Response>
  /** update single row of the table: "tracking_substance" */
  update_tracking_substance_by_pk?: Maybe<Tracking_Substance>
  /** update multiples rows of table: "tracking_substance" */
  update_tracking_substance_many?: Maybe<Array<Maybe<Tracking_Substance_Mutation_Response>>>
  /** update data of the table: "tracking_tonguetie" */
  update_tracking_tonguetie?: Maybe<Tracking_Tonguetie_Mutation_Response>
  /** update single row of the table: "tracking_tonguetie" */
  update_tracking_tonguetie_by_pk?: Maybe<Tracking_Tonguetie>
  /** update multiples rows of table: "tracking_tonguetie" */
  update_tracking_tonguetie_many?: Maybe<Array<Maybe<Tracking_Tonguetie_Mutation_Response>>>
  /** update data of the table: "tracking_weight" */
  update_tracking_weight?: Maybe<Tracking_Weight_Mutation_Response>
  /** update single row of the table: "tracking_weight" */
  update_tracking_weight_by_pk?: Maybe<Tracking_Weight>
  /** update multiples rows of table: "tracking_weight" */
  update_tracking_weight_many?: Maybe<Array<Maybe<Tracking_Weight_Mutation_Response>>>
  /** update data of the table: "user_profiles" */
  update_user_profiles?: Maybe<User_Profiles_Mutation_Response>
  /** update single row of the table: "user_profiles" */
  update_user_profiles_by_pk?: Maybe<User_Profiles>
  /** update multiples rows of table: "user_profiles" */
  update_user_profiles_many?: Maybe<Array<Maybe<User_Profiles_Mutation_Response>>>
  /** update multiples rows of table: "auth.users" */
  update_users_many?: Maybe<Array<Maybe<Users_Mutation_Response>>>
  /** update multiples rows of table: "storage.virus" */
  update_virus_many?: Maybe<Array<Maybe<Virus_Mutation_Response>>>
  /** update data of the table: "voucher_codes" */
  update_voucher_codes?: Maybe<Voucher_Codes_Mutation_Response>
  /** update single row of the table: "voucher_codes" */
  update_voucher_codes_by_pk?: Maybe<Voucher_Codes>
  /** update multiples rows of table: "voucher_codes" */
  update_voucher_codes_many?: Maybe<Array<Maybe<Voucher_Codes_Mutation_Response>>>
}

/** mutation root */
export type Mutation_RootDeleteAuthOauth2AuthRequestArgs = {
  id: Scalars['uuid']['input']
}

/** mutation root */
export type Mutation_RootDeleteAuthOauth2AuthRequestsArgs = {
  where: AuthOauth2AuthRequests_Bool_Exp
}

/** mutation root */
export type Mutation_RootDeleteAuthOauth2AuthorizationCodeArgs = {
  id: Scalars['uuid']['input']
}

/** mutation root */
export type Mutation_RootDeleteAuthOauth2AuthorizationCodesArgs = {
  where: AuthOauth2AuthorizationCodes_Bool_Exp
}

/** mutation root */
export type Mutation_RootDeleteAuthOauth2ClientArgs = {
  clientId: Scalars['String']['input']
}

/** mutation root */
export type Mutation_RootDeleteAuthOauth2ClientsArgs = {
  where: AuthOauth2Clients_Bool_Exp
}

/** mutation root */
export type Mutation_RootDeleteAuthOauth2RefreshTokenArgs = {
  id: Scalars['uuid']['input']
}

/** mutation root */
export type Mutation_RootDeleteAuthOauth2RefreshTokensArgs = {
  where: AuthOauth2RefreshTokens_Bool_Exp
}

/** mutation root */
export type Mutation_RootDeleteAuthProviderArgs = {
  id: Scalars['String']['input']
}

/** mutation root */
export type Mutation_RootDeleteAuthProviderRequestArgs = {
  id: Scalars['uuid']['input']
}

/** mutation root */
export type Mutation_RootDeleteAuthProviderRequestsArgs = {
  where: AuthProviderRequests_Bool_Exp
}

/** mutation root */
export type Mutation_RootDeleteAuthProvidersArgs = {
  where: AuthProviders_Bool_Exp
}

/** mutation root */
export type Mutation_RootDeleteAuthRefreshTokenArgs = {
  id: Scalars['uuid']['input']
}

/** mutation root */
export type Mutation_RootDeleteAuthRefreshTokenTypeArgs = {
  value: Scalars['String']['input']
}

/** mutation root */
export type Mutation_RootDeleteAuthRefreshTokenTypesArgs = {
  where: AuthRefreshTokenTypes_Bool_Exp
}

/** mutation root */
export type Mutation_RootDeleteAuthRefreshTokensArgs = {
  where: AuthRefreshTokens_Bool_Exp
}

/** mutation root */
export type Mutation_RootDeleteAuthRoleArgs = {
  role: Scalars['String']['input']
}

/** mutation root */
export type Mutation_RootDeleteAuthRolesArgs = {
  where: AuthRoles_Bool_Exp
}

/** mutation root */
export type Mutation_RootDeleteAuthUserProviderArgs = {
  id: Scalars['uuid']['input']
}

/** mutation root */
export type Mutation_RootDeleteAuthUserProvidersArgs = {
  where: AuthUserProviders_Bool_Exp
}

/** mutation root */
export type Mutation_RootDeleteAuthUserRoleArgs = {
  id: Scalars['uuid']['input']
}

/** mutation root */
export type Mutation_RootDeleteAuthUserRolesArgs = {
  where: AuthUserRoles_Bool_Exp
}

/** mutation root */
export type Mutation_RootDeleteAuthUserSecurityKeyArgs = {
  id: Scalars['uuid']['input']
}

/** mutation root */
export type Mutation_RootDeleteAuthUserSecurityKeysArgs = {
  where: AuthUserSecurityKeys_Bool_Exp
}

/** mutation root */
export type Mutation_RootDeleteBucketArgs = {
  id: Scalars['String']['input']
}

/** mutation root */
export type Mutation_RootDeleteBucketsArgs = {
  where: Buckets_Bool_Exp
}

/** mutation root */
export type Mutation_RootDeleteFileArgs = {
  id: Scalars['uuid']['input']
}

/** mutation root */
export type Mutation_RootDeleteFilesArgs = {
  where: Files_Bool_Exp
}

/** mutation root */
export type Mutation_RootDeleteUserArgs = {
  id: Scalars['uuid']['input']
}

/** mutation root */
export type Mutation_RootDeleteUsersArgs = {
  where: Users_Bool_Exp
}

/** mutation root */
export type Mutation_RootDeleteVirusArgs = {
  id: Scalars['uuid']['input']
}

/** mutation root */
export type Mutation_RootDeleteVirusesArgs = {
  where: Virus_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_AppointmentsArgs = {
  where: Appointments_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Appointments_By_PkArgs = {
  id: Scalars['uuid']['input']
}

/** mutation root */
export type Mutation_RootDelete_Article_ProgressArgs = {
  where: Article_Progress_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Article_Progress_By_PkArgs = {
  id: Scalars['uuid']['input']
}

/** mutation root */
export type Mutation_RootDelete_Article_SectionsArgs = {
  where: Article_Sections_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Article_Sections_By_PkArgs = {
  id: Scalars['uuid']['input']
}

/** mutation root */
export type Mutation_RootDelete_ArticlesArgs = {
  where: Articles_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Articles_By_PkArgs = {
  id: Scalars['uuid']['input']
}

/** mutation root */
export type Mutation_RootDelete_CategoriesArgs = {
  where: Categories_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Categories_By_PkArgs = {
  slug: Scalars['String']['input']
}

/** mutation root */
export type Mutation_RootDelete_ChaptersArgs = {
  where: Chapters_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Chat_MessagesArgs = {
  where: Chat_Messages_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Chat_Messages_By_PkArgs = {
  id: Scalars['uuid']['input']
}

/** mutation root */
export type Mutation_RootDelete_Feedback_MessagesArgs = {
  where: Feedback_Messages_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Feedback_Messages_By_PkArgs = {
  id: Scalars['uuid']['input']
}

/** mutation root */
export type Mutation_RootDelete_Matching_Question_With_ChapterArgs = {
  where: Matching_Question_With_Chapter_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Matching_Question_With_Chapter_By_PkArgs = {
  answer_key: Scalars['String']['input']
}

/** mutation root */
export type Mutation_RootDelete_Midwife_ProfilesArgs = {
  where: Midwife_Profiles_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Midwife_Profiles_By_PkArgs = {
  id: Scalars['uuid']['input']
}

/** mutation root */
export type Mutation_RootDelete_PreparationArgs = {
  where: Preparation_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Preparation_By_PkArgs = {
  id: Scalars['uuid']['input']
}

/** mutation root */
export type Mutation_RootDelete_Qm_EntriesArgs = {
  where: Qm_Entries_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Qm_Entries_By_PkArgs = {
  id: Scalars['uuid']['input']
}

/** mutation root */
export type Mutation_RootDelete_Tracking_BirthArgs = {
  where: Tracking_Birth_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Tracking_Birth_By_PkArgs = {
  id: Scalars['uuid']['input']
}

/** mutation root */
export type Mutation_RootDelete_Tracking_BottleArgs = {
  where: Tracking_Bottle_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Tracking_Bottle_By_PkArgs = {
  id: Scalars['uuid']['input']
}

/** mutation root */
export type Mutation_RootDelete_Tracking_BreastArgs = {
  where: Tracking_Breast_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Tracking_Breast_By_PkArgs = {
  id: Scalars['uuid']['input']
}

/** mutation root */
export type Mutation_RootDelete_Tracking_DiaperArgs = {
  where: Tracking_Diaper_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Tracking_Diaper_By_PkArgs = {
  id: Scalars['uuid']['input']
}

/** mutation root */
export type Mutation_RootDelete_Tracking_Mental_HealthArgs = {
  where: Tracking_Mental_Health_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Tracking_Mental_Health_By_PkArgs = {
  id: Scalars['uuid']['input']
}

/** mutation root */
export type Mutation_RootDelete_Tracking_NursingArgs = {
  where: Tracking_Nursing_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Tracking_Nursing_By_PkArgs = {
  id: Scalars['uuid']['input']
}

/** mutation root */
export type Mutation_RootDelete_Tracking_SubstanceArgs = {
  where: Tracking_Substance_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Tracking_Substance_By_PkArgs = {
  id: Scalars['uuid']['input']
}

/** mutation root */
export type Mutation_RootDelete_Tracking_TonguetieArgs = {
  where: Tracking_Tonguetie_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Tracking_Tonguetie_By_PkArgs = {
  id: Scalars['uuid']['input']
}

/** mutation root */
export type Mutation_RootDelete_Tracking_WeightArgs = {
  where: Tracking_Weight_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Tracking_Weight_By_PkArgs = {
  id: Scalars['uuid']['input']
}

/** mutation root */
export type Mutation_RootDelete_User_ProfilesArgs = {
  where: User_Profiles_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_User_Profiles_By_PkArgs = {
  id: Scalars['uuid']['input']
}

/** mutation root */
export type Mutation_RootDelete_Voucher_CodesArgs = {
  where: Voucher_Codes_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Voucher_Codes_By_PkArgs = {
  id: Scalars['uuid']['input']
}

/** mutation root */
export type Mutation_RootInsertAuthOauth2AuthRequestArgs = {
  object: AuthOauth2AuthRequests_Insert_Input
  on_conflict?: InputMaybe<AuthOauth2AuthRequests_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertAuthOauth2AuthRequestsArgs = {
  objects: Array<AuthOauth2AuthRequests_Insert_Input>
  on_conflict?: InputMaybe<AuthOauth2AuthRequests_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertAuthOauth2AuthorizationCodeArgs = {
  object: AuthOauth2AuthorizationCodes_Insert_Input
  on_conflict?: InputMaybe<AuthOauth2AuthorizationCodes_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertAuthOauth2AuthorizationCodesArgs = {
  objects: Array<AuthOauth2AuthorizationCodes_Insert_Input>
  on_conflict?: InputMaybe<AuthOauth2AuthorizationCodes_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertAuthOauth2ClientArgs = {
  object: AuthOauth2Clients_Insert_Input
  on_conflict?: InputMaybe<AuthOauth2Clients_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertAuthOauth2ClientsArgs = {
  objects: Array<AuthOauth2Clients_Insert_Input>
  on_conflict?: InputMaybe<AuthOauth2Clients_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertAuthOauth2RefreshTokenArgs = {
  object: AuthOauth2RefreshTokens_Insert_Input
  on_conflict?: InputMaybe<AuthOauth2RefreshTokens_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertAuthOauth2RefreshTokensArgs = {
  objects: Array<AuthOauth2RefreshTokens_Insert_Input>
  on_conflict?: InputMaybe<AuthOauth2RefreshTokens_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertAuthProviderArgs = {
  object: AuthProviders_Insert_Input
  on_conflict?: InputMaybe<AuthProviders_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertAuthProviderRequestArgs = {
  object: AuthProviderRequests_Insert_Input
  on_conflict?: InputMaybe<AuthProviderRequests_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertAuthProviderRequestsArgs = {
  objects: Array<AuthProviderRequests_Insert_Input>
  on_conflict?: InputMaybe<AuthProviderRequests_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertAuthProvidersArgs = {
  objects: Array<AuthProviders_Insert_Input>
  on_conflict?: InputMaybe<AuthProviders_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertAuthRefreshTokenArgs = {
  object: AuthRefreshTokens_Insert_Input
  on_conflict?: InputMaybe<AuthRefreshTokens_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertAuthRefreshTokenTypeArgs = {
  object: AuthRefreshTokenTypes_Insert_Input
  on_conflict?: InputMaybe<AuthRefreshTokenTypes_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertAuthRefreshTokenTypesArgs = {
  objects: Array<AuthRefreshTokenTypes_Insert_Input>
  on_conflict?: InputMaybe<AuthRefreshTokenTypes_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertAuthRefreshTokensArgs = {
  objects: Array<AuthRefreshTokens_Insert_Input>
  on_conflict?: InputMaybe<AuthRefreshTokens_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertAuthRoleArgs = {
  object: AuthRoles_Insert_Input
  on_conflict?: InputMaybe<AuthRoles_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertAuthRolesArgs = {
  objects: Array<AuthRoles_Insert_Input>
  on_conflict?: InputMaybe<AuthRoles_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertAuthUserProviderArgs = {
  object: AuthUserProviders_Insert_Input
  on_conflict?: InputMaybe<AuthUserProviders_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertAuthUserProvidersArgs = {
  objects: Array<AuthUserProviders_Insert_Input>
  on_conflict?: InputMaybe<AuthUserProviders_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertAuthUserRoleArgs = {
  object: AuthUserRoles_Insert_Input
  on_conflict?: InputMaybe<AuthUserRoles_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertAuthUserRolesArgs = {
  objects: Array<AuthUserRoles_Insert_Input>
  on_conflict?: InputMaybe<AuthUserRoles_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertAuthUserSecurityKeyArgs = {
  object: AuthUserSecurityKeys_Insert_Input
  on_conflict?: InputMaybe<AuthUserSecurityKeys_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertAuthUserSecurityKeysArgs = {
  objects: Array<AuthUserSecurityKeys_Insert_Input>
  on_conflict?: InputMaybe<AuthUserSecurityKeys_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertBucketArgs = {
  object: Buckets_Insert_Input
  on_conflict?: InputMaybe<Buckets_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertBucketsArgs = {
  objects: Array<Buckets_Insert_Input>
  on_conflict?: InputMaybe<Buckets_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertFileArgs = {
  object: Files_Insert_Input
  on_conflict?: InputMaybe<Files_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertFilesArgs = {
  objects: Array<Files_Insert_Input>
  on_conflict?: InputMaybe<Files_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertUserArgs = {
  object: Users_Insert_Input
  on_conflict?: InputMaybe<Users_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertUsersArgs = {
  objects: Array<Users_Insert_Input>
  on_conflict?: InputMaybe<Users_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertVirusArgs = {
  object: Virus_Insert_Input
  on_conflict?: InputMaybe<Virus_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsertVirusesArgs = {
  objects: Array<Virus_Insert_Input>
  on_conflict?: InputMaybe<Virus_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_AppointmentsArgs = {
  objects: Array<Appointments_Insert_Input>
  on_conflict?: InputMaybe<Appointments_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Appointments_OneArgs = {
  object: Appointments_Insert_Input
  on_conflict?: InputMaybe<Appointments_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Article_ProgressArgs = {
  objects: Array<Article_Progress_Insert_Input>
  on_conflict?: InputMaybe<Article_Progress_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Article_Progress_OneArgs = {
  object: Article_Progress_Insert_Input
  on_conflict?: InputMaybe<Article_Progress_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Article_SectionsArgs = {
  objects: Array<Article_Sections_Insert_Input>
  on_conflict?: InputMaybe<Article_Sections_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Article_Sections_OneArgs = {
  object: Article_Sections_Insert_Input
  on_conflict?: InputMaybe<Article_Sections_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_ArticlesArgs = {
  objects: Array<Articles_Insert_Input>
  on_conflict?: InputMaybe<Articles_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Articles_OneArgs = {
  object: Articles_Insert_Input
  on_conflict?: InputMaybe<Articles_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_CategoriesArgs = {
  objects: Array<Categories_Insert_Input>
  on_conflict?: InputMaybe<Categories_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Categories_OneArgs = {
  object: Categories_Insert_Input
  on_conflict?: InputMaybe<Categories_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_ChaptersArgs = {
  objects: Array<Chapters_Insert_Input>
  on_conflict?: InputMaybe<Chapters_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Chapters_OneArgs = {
  object: Chapters_Insert_Input
  on_conflict?: InputMaybe<Chapters_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Chat_MessagesArgs = {
  objects: Array<Chat_Messages_Insert_Input>
  on_conflict?: InputMaybe<Chat_Messages_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Chat_Messages_OneArgs = {
  object: Chat_Messages_Insert_Input
  on_conflict?: InputMaybe<Chat_Messages_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Feedback_MessagesArgs = {
  objects: Array<Feedback_Messages_Insert_Input>
  on_conflict?: InputMaybe<Feedback_Messages_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Feedback_Messages_OneArgs = {
  object: Feedback_Messages_Insert_Input
  on_conflict?: InputMaybe<Feedback_Messages_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Matching_Question_With_ChapterArgs = {
  objects: Array<Matching_Question_With_Chapter_Insert_Input>
  on_conflict?: InputMaybe<Matching_Question_With_Chapter_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Matching_Question_With_Chapter_OneArgs = {
  object: Matching_Question_With_Chapter_Insert_Input
  on_conflict?: InputMaybe<Matching_Question_With_Chapter_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Midwife_ProfilesArgs = {
  objects: Array<Midwife_Profiles_Insert_Input>
  on_conflict?: InputMaybe<Midwife_Profiles_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Midwife_Profiles_OneArgs = {
  object: Midwife_Profiles_Insert_Input
  on_conflict?: InputMaybe<Midwife_Profiles_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_PreparationArgs = {
  objects: Array<Preparation_Insert_Input>
  on_conflict?: InputMaybe<Preparation_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Preparation_OneArgs = {
  object: Preparation_Insert_Input
  on_conflict?: InputMaybe<Preparation_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Qm_EntriesArgs = {
  objects: Array<Qm_Entries_Insert_Input>
  on_conflict?: InputMaybe<Qm_Entries_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Qm_Entries_OneArgs = {
  object: Qm_Entries_Insert_Input
  on_conflict?: InputMaybe<Qm_Entries_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tracking_BirthArgs = {
  objects: Array<Tracking_Birth_Insert_Input>
  on_conflict?: InputMaybe<Tracking_Birth_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tracking_Birth_OneArgs = {
  object: Tracking_Birth_Insert_Input
  on_conflict?: InputMaybe<Tracking_Birth_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tracking_BottleArgs = {
  objects: Array<Tracking_Bottle_Insert_Input>
  on_conflict?: InputMaybe<Tracking_Bottle_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tracking_Bottle_OneArgs = {
  object: Tracking_Bottle_Insert_Input
  on_conflict?: InputMaybe<Tracking_Bottle_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tracking_BreastArgs = {
  objects: Array<Tracking_Breast_Insert_Input>
  on_conflict?: InputMaybe<Tracking_Breast_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tracking_Breast_OneArgs = {
  object: Tracking_Breast_Insert_Input
  on_conflict?: InputMaybe<Tracking_Breast_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tracking_DiaperArgs = {
  objects: Array<Tracking_Diaper_Insert_Input>
  on_conflict?: InputMaybe<Tracking_Diaper_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tracking_Diaper_OneArgs = {
  object: Tracking_Diaper_Insert_Input
  on_conflict?: InputMaybe<Tracking_Diaper_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tracking_Mental_HealthArgs = {
  objects: Array<Tracking_Mental_Health_Insert_Input>
  on_conflict?: InputMaybe<Tracking_Mental_Health_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tracking_Mental_Health_OneArgs = {
  object: Tracking_Mental_Health_Insert_Input
  on_conflict?: InputMaybe<Tracking_Mental_Health_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tracking_NursingArgs = {
  objects: Array<Tracking_Nursing_Insert_Input>
  on_conflict?: InputMaybe<Tracking_Nursing_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tracking_Nursing_OneArgs = {
  object: Tracking_Nursing_Insert_Input
  on_conflict?: InputMaybe<Tracking_Nursing_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tracking_SubstanceArgs = {
  objects: Array<Tracking_Substance_Insert_Input>
  on_conflict?: InputMaybe<Tracking_Substance_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tracking_Substance_OneArgs = {
  object: Tracking_Substance_Insert_Input
  on_conflict?: InputMaybe<Tracking_Substance_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tracking_TonguetieArgs = {
  objects: Array<Tracking_Tonguetie_Insert_Input>
  on_conflict?: InputMaybe<Tracking_Tonguetie_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tracking_Tonguetie_OneArgs = {
  object: Tracking_Tonguetie_Insert_Input
  on_conflict?: InputMaybe<Tracking_Tonguetie_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tracking_WeightArgs = {
  objects: Array<Tracking_Weight_Insert_Input>
  on_conflict?: InputMaybe<Tracking_Weight_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tracking_Weight_OneArgs = {
  object: Tracking_Weight_Insert_Input
  on_conflict?: InputMaybe<Tracking_Weight_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_User_ProfilesArgs = {
  objects: Array<User_Profiles_Insert_Input>
  on_conflict?: InputMaybe<User_Profiles_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_User_Profiles_OneArgs = {
  object: User_Profiles_Insert_Input
  on_conflict?: InputMaybe<User_Profiles_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Voucher_CodesArgs = {
  objects: Array<Voucher_Codes_Insert_Input>
  on_conflict?: InputMaybe<Voucher_Codes_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Voucher_Codes_OneArgs = {
  object: Voucher_Codes_Insert_Input
  on_conflict?: InputMaybe<Voucher_Codes_On_Conflict>
}

/** mutation root */
export type Mutation_RootUpdateAuthOauth2AuthRequestArgs = {
  _set?: InputMaybe<AuthOauth2AuthRequests_Set_Input>
  pk_columns: AuthOauth2AuthRequests_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdateAuthOauth2AuthRequestsArgs = {
  _set?: InputMaybe<AuthOauth2AuthRequests_Set_Input>
  where: AuthOauth2AuthRequests_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdateAuthOauth2AuthorizationCodeArgs = {
  _set?: InputMaybe<AuthOauth2AuthorizationCodes_Set_Input>
  pk_columns: AuthOauth2AuthorizationCodes_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdateAuthOauth2AuthorizationCodesArgs = {
  _set?: InputMaybe<AuthOauth2AuthorizationCodes_Set_Input>
  where: AuthOauth2AuthorizationCodes_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdateAuthOauth2ClientArgs = {
  _append?: InputMaybe<AuthOauth2Clients_Append_Input>
  _delete_at_path?: InputMaybe<AuthOauth2Clients_Delete_At_Path_Input>
  _delete_elem?: InputMaybe<AuthOauth2Clients_Delete_Elem_Input>
  _delete_key?: InputMaybe<AuthOauth2Clients_Delete_Key_Input>
  _prepend?: InputMaybe<AuthOauth2Clients_Prepend_Input>
  _set?: InputMaybe<AuthOauth2Clients_Set_Input>
  pk_columns: AuthOauth2Clients_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdateAuthOauth2ClientsArgs = {
  _append?: InputMaybe<AuthOauth2Clients_Append_Input>
  _delete_at_path?: InputMaybe<AuthOauth2Clients_Delete_At_Path_Input>
  _delete_elem?: InputMaybe<AuthOauth2Clients_Delete_Elem_Input>
  _delete_key?: InputMaybe<AuthOauth2Clients_Delete_Key_Input>
  _prepend?: InputMaybe<AuthOauth2Clients_Prepend_Input>
  _set?: InputMaybe<AuthOauth2Clients_Set_Input>
  where: AuthOauth2Clients_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdateAuthOauth2RefreshTokenArgs = {
  _set?: InputMaybe<AuthOauth2RefreshTokens_Set_Input>
  pk_columns: AuthOauth2RefreshTokens_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdateAuthOauth2RefreshTokensArgs = {
  _set?: InputMaybe<AuthOauth2RefreshTokens_Set_Input>
  where: AuthOauth2RefreshTokens_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdateAuthProviderArgs = {
  _set?: InputMaybe<AuthProviders_Set_Input>
  pk_columns: AuthProviders_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdateAuthProviderRequestArgs = {
  _append?: InputMaybe<AuthProviderRequests_Append_Input>
  _delete_at_path?: InputMaybe<AuthProviderRequests_Delete_At_Path_Input>
  _delete_elem?: InputMaybe<AuthProviderRequests_Delete_Elem_Input>
  _delete_key?: InputMaybe<AuthProviderRequests_Delete_Key_Input>
  _prepend?: InputMaybe<AuthProviderRequests_Prepend_Input>
  _set?: InputMaybe<AuthProviderRequests_Set_Input>
  pk_columns: AuthProviderRequests_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdateAuthProviderRequestsArgs = {
  _append?: InputMaybe<AuthProviderRequests_Append_Input>
  _delete_at_path?: InputMaybe<AuthProviderRequests_Delete_At_Path_Input>
  _delete_elem?: InputMaybe<AuthProviderRequests_Delete_Elem_Input>
  _delete_key?: InputMaybe<AuthProviderRequests_Delete_Key_Input>
  _prepend?: InputMaybe<AuthProviderRequests_Prepend_Input>
  _set?: InputMaybe<AuthProviderRequests_Set_Input>
  where: AuthProviderRequests_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdateAuthProvidersArgs = {
  _set?: InputMaybe<AuthProviders_Set_Input>
  where: AuthProviders_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdateAuthRefreshTokenArgs = {
  _append?: InputMaybe<AuthRefreshTokens_Append_Input>
  _delete_at_path?: InputMaybe<AuthRefreshTokens_Delete_At_Path_Input>
  _delete_elem?: InputMaybe<AuthRefreshTokens_Delete_Elem_Input>
  _delete_key?: InputMaybe<AuthRefreshTokens_Delete_Key_Input>
  _prepend?: InputMaybe<AuthRefreshTokens_Prepend_Input>
  _set?: InputMaybe<AuthRefreshTokens_Set_Input>
  pk_columns: AuthRefreshTokens_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdateAuthRefreshTokenTypeArgs = {
  _set?: InputMaybe<AuthRefreshTokenTypes_Set_Input>
  pk_columns: AuthRefreshTokenTypes_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdateAuthRefreshTokenTypesArgs = {
  _set?: InputMaybe<AuthRefreshTokenTypes_Set_Input>
  where: AuthRefreshTokenTypes_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdateAuthRefreshTokensArgs = {
  _append?: InputMaybe<AuthRefreshTokens_Append_Input>
  _delete_at_path?: InputMaybe<AuthRefreshTokens_Delete_At_Path_Input>
  _delete_elem?: InputMaybe<AuthRefreshTokens_Delete_Elem_Input>
  _delete_key?: InputMaybe<AuthRefreshTokens_Delete_Key_Input>
  _prepend?: InputMaybe<AuthRefreshTokens_Prepend_Input>
  _set?: InputMaybe<AuthRefreshTokens_Set_Input>
  where: AuthRefreshTokens_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdateAuthRoleArgs = {
  _set?: InputMaybe<AuthRoles_Set_Input>
  pk_columns: AuthRoles_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdateAuthRolesArgs = {
  _set?: InputMaybe<AuthRoles_Set_Input>
  where: AuthRoles_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdateAuthUserProviderArgs = {
  _set?: InputMaybe<AuthUserProviders_Set_Input>
  pk_columns: AuthUserProviders_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdateAuthUserProvidersArgs = {
  _set?: InputMaybe<AuthUserProviders_Set_Input>
  where: AuthUserProviders_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdateAuthUserRoleArgs = {
  _set?: InputMaybe<AuthUserRoles_Set_Input>
  pk_columns: AuthUserRoles_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdateAuthUserRolesArgs = {
  _set?: InputMaybe<AuthUserRoles_Set_Input>
  where: AuthUserRoles_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdateAuthUserSecurityKeyArgs = {
  _inc?: InputMaybe<AuthUserSecurityKeys_Inc_Input>
  _set?: InputMaybe<AuthUserSecurityKeys_Set_Input>
  pk_columns: AuthUserSecurityKeys_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdateAuthUserSecurityKeysArgs = {
  _inc?: InputMaybe<AuthUserSecurityKeys_Inc_Input>
  _set?: InputMaybe<AuthUserSecurityKeys_Set_Input>
  where: AuthUserSecurityKeys_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdateBucketArgs = {
  _inc?: InputMaybe<Buckets_Inc_Input>
  _set?: InputMaybe<Buckets_Set_Input>
  pk_columns: Buckets_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdateBucketsArgs = {
  _inc?: InputMaybe<Buckets_Inc_Input>
  _set?: InputMaybe<Buckets_Set_Input>
  where: Buckets_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdateFileArgs = {
  _append?: InputMaybe<Files_Append_Input>
  _delete_at_path?: InputMaybe<Files_Delete_At_Path_Input>
  _delete_elem?: InputMaybe<Files_Delete_Elem_Input>
  _delete_key?: InputMaybe<Files_Delete_Key_Input>
  _inc?: InputMaybe<Files_Inc_Input>
  _prepend?: InputMaybe<Files_Prepend_Input>
  _set?: InputMaybe<Files_Set_Input>
  pk_columns: Files_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdateFilesArgs = {
  _append?: InputMaybe<Files_Append_Input>
  _delete_at_path?: InputMaybe<Files_Delete_At_Path_Input>
  _delete_elem?: InputMaybe<Files_Delete_Elem_Input>
  _delete_key?: InputMaybe<Files_Delete_Key_Input>
  _inc?: InputMaybe<Files_Inc_Input>
  _prepend?: InputMaybe<Files_Prepend_Input>
  _set?: InputMaybe<Files_Set_Input>
  where: Files_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdateUserArgs = {
  _append?: InputMaybe<Users_Append_Input>
  _delete_at_path?: InputMaybe<Users_Delete_At_Path_Input>
  _delete_elem?: InputMaybe<Users_Delete_Elem_Input>
  _delete_key?: InputMaybe<Users_Delete_Key_Input>
  _prepend?: InputMaybe<Users_Prepend_Input>
  _set?: InputMaybe<Users_Set_Input>
  pk_columns: Users_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdateUsersArgs = {
  _append?: InputMaybe<Users_Append_Input>
  _delete_at_path?: InputMaybe<Users_Delete_At_Path_Input>
  _delete_elem?: InputMaybe<Users_Delete_Elem_Input>
  _delete_key?: InputMaybe<Users_Delete_Key_Input>
  _prepend?: InputMaybe<Users_Prepend_Input>
  _set?: InputMaybe<Users_Set_Input>
  where: Users_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdateVirusArgs = {
  _append?: InputMaybe<Virus_Append_Input>
  _delete_at_path?: InputMaybe<Virus_Delete_At_Path_Input>
  _delete_elem?: InputMaybe<Virus_Delete_Elem_Input>
  _delete_key?: InputMaybe<Virus_Delete_Key_Input>
  _prepend?: InputMaybe<Virus_Prepend_Input>
  _set?: InputMaybe<Virus_Set_Input>
  pk_columns: Virus_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdateVirusesArgs = {
  _append?: InputMaybe<Virus_Append_Input>
  _delete_at_path?: InputMaybe<Virus_Delete_At_Path_Input>
  _delete_elem?: InputMaybe<Virus_Delete_Elem_Input>
  _delete_key?: InputMaybe<Virus_Delete_Key_Input>
  _prepend?: InputMaybe<Virus_Prepend_Input>
  _set?: InputMaybe<Virus_Set_Input>
  where: Virus_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_AppointmentsArgs = {
  _set?: InputMaybe<Appointments_Set_Input>
  where: Appointments_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Appointments_By_PkArgs = {
  _set?: InputMaybe<Appointments_Set_Input>
  pk_columns: Appointments_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Appointments_ManyArgs = {
  updates: Array<Appointments_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Article_ProgressArgs = {
  _set?: InputMaybe<Article_Progress_Set_Input>
  where: Article_Progress_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Article_Progress_By_PkArgs = {
  _set?: InputMaybe<Article_Progress_Set_Input>
  pk_columns: Article_Progress_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Article_Progress_ManyArgs = {
  updates: Array<Article_Progress_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Article_SectionsArgs = {
  _append?: InputMaybe<Article_Sections_Append_Input>
  _delete_at_path?: InputMaybe<Article_Sections_Delete_At_Path_Input>
  _delete_elem?: InputMaybe<Article_Sections_Delete_Elem_Input>
  _delete_key?: InputMaybe<Article_Sections_Delete_Key_Input>
  _inc?: InputMaybe<Article_Sections_Inc_Input>
  _prepend?: InputMaybe<Article_Sections_Prepend_Input>
  _set?: InputMaybe<Article_Sections_Set_Input>
  where: Article_Sections_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Article_Sections_By_PkArgs = {
  _append?: InputMaybe<Article_Sections_Append_Input>
  _delete_at_path?: InputMaybe<Article_Sections_Delete_At_Path_Input>
  _delete_elem?: InputMaybe<Article_Sections_Delete_Elem_Input>
  _delete_key?: InputMaybe<Article_Sections_Delete_Key_Input>
  _inc?: InputMaybe<Article_Sections_Inc_Input>
  _prepend?: InputMaybe<Article_Sections_Prepend_Input>
  _set?: InputMaybe<Article_Sections_Set_Input>
  pk_columns: Article_Sections_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Article_Sections_ManyArgs = {
  updates: Array<Article_Sections_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_ArticlesArgs = {
  _inc?: InputMaybe<Articles_Inc_Input>
  _set?: InputMaybe<Articles_Set_Input>
  where: Articles_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Articles_By_PkArgs = {
  _inc?: InputMaybe<Articles_Inc_Input>
  _set?: InputMaybe<Articles_Set_Input>
  pk_columns: Articles_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Articles_ManyArgs = {
  updates: Array<Articles_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_AuthOauth2AuthRequests_ManyArgs = {
  updates: Array<AuthOauth2AuthRequests_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_AuthOauth2AuthorizationCodes_ManyArgs = {
  updates: Array<AuthOauth2AuthorizationCodes_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_AuthOauth2Clients_ManyArgs = {
  updates: Array<AuthOauth2Clients_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_AuthOauth2RefreshTokens_ManyArgs = {
  updates: Array<AuthOauth2RefreshTokens_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_AuthProviderRequests_ManyArgs = {
  updates: Array<AuthProviderRequests_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_AuthProviders_ManyArgs = {
  updates: Array<AuthProviders_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_AuthRefreshTokenTypes_ManyArgs = {
  updates: Array<AuthRefreshTokenTypes_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_AuthRefreshTokens_ManyArgs = {
  updates: Array<AuthRefreshTokens_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_AuthRoles_ManyArgs = {
  updates: Array<AuthRoles_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_AuthUserProviders_ManyArgs = {
  updates: Array<AuthUserProviders_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_AuthUserRoles_ManyArgs = {
  updates: Array<AuthUserRoles_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_AuthUserSecurityKeys_ManyArgs = {
  updates: Array<AuthUserSecurityKeys_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Buckets_ManyArgs = {
  updates: Array<Buckets_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_CategoriesArgs = {
  _inc?: InputMaybe<Categories_Inc_Input>
  _set?: InputMaybe<Categories_Set_Input>
  where: Categories_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Categories_By_PkArgs = {
  _inc?: InputMaybe<Categories_Inc_Input>
  _set?: InputMaybe<Categories_Set_Input>
  pk_columns: Categories_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Categories_ManyArgs = {
  updates: Array<Categories_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_ChaptersArgs = {
  _append?: InputMaybe<Chapters_Append_Input>
  _delete_at_path?: InputMaybe<Chapters_Delete_At_Path_Input>
  _delete_elem?: InputMaybe<Chapters_Delete_Elem_Input>
  _delete_key?: InputMaybe<Chapters_Delete_Key_Input>
  _inc?: InputMaybe<Chapters_Inc_Input>
  _prepend?: InputMaybe<Chapters_Prepend_Input>
  _set?: InputMaybe<Chapters_Set_Input>
  where: Chapters_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Chapters_ManyArgs = {
  updates: Array<Chapters_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Chat_MessagesArgs = {
  _set?: InputMaybe<Chat_Messages_Set_Input>
  where: Chat_Messages_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Chat_Messages_By_PkArgs = {
  _set?: InputMaybe<Chat_Messages_Set_Input>
  pk_columns: Chat_Messages_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Chat_Messages_ManyArgs = {
  updates: Array<Chat_Messages_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Feedback_MessagesArgs = {
  _set?: InputMaybe<Feedback_Messages_Set_Input>
  where: Feedback_Messages_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Feedback_Messages_By_PkArgs = {
  _set?: InputMaybe<Feedback_Messages_Set_Input>
  pk_columns: Feedback_Messages_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Feedback_Messages_ManyArgs = {
  updates: Array<Feedback_Messages_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Files_ManyArgs = {
  updates: Array<Files_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Matching_Question_With_ChapterArgs = {
  _append?: InputMaybe<Matching_Question_With_Chapter_Append_Input>
  _delete_at_path?: InputMaybe<Matching_Question_With_Chapter_Delete_At_Path_Input>
  _delete_elem?: InputMaybe<Matching_Question_With_Chapter_Delete_Elem_Input>
  _delete_key?: InputMaybe<Matching_Question_With_Chapter_Delete_Key_Input>
  _prepend?: InputMaybe<Matching_Question_With_Chapter_Prepend_Input>
  _set?: InputMaybe<Matching_Question_With_Chapter_Set_Input>
  where: Matching_Question_With_Chapter_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Matching_Question_With_Chapter_By_PkArgs = {
  _append?: InputMaybe<Matching_Question_With_Chapter_Append_Input>
  _delete_at_path?: InputMaybe<Matching_Question_With_Chapter_Delete_At_Path_Input>
  _delete_elem?: InputMaybe<Matching_Question_With_Chapter_Delete_Elem_Input>
  _delete_key?: InputMaybe<Matching_Question_With_Chapter_Delete_Key_Input>
  _prepend?: InputMaybe<Matching_Question_With_Chapter_Prepend_Input>
  _set?: InputMaybe<Matching_Question_With_Chapter_Set_Input>
  pk_columns: Matching_Question_With_Chapter_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Matching_Question_With_Chapter_ManyArgs = {
  updates: Array<Matching_Question_With_Chapter_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Midwife_ProfilesArgs = {
  _set?: InputMaybe<Midwife_Profiles_Set_Input>
  where: Midwife_Profiles_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Midwife_Profiles_By_PkArgs = {
  _set?: InputMaybe<Midwife_Profiles_Set_Input>
  pk_columns: Midwife_Profiles_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Midwife_Profiles_ManyArgs = {
  updates: Array<Midwife_Profiles_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_PreparationArgs = {
  _inc?: InputMaybe<Preparation_Inc_Input>
  _set?: InputMaybe<Preparation_Set_Input>
  where: Preparation_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Preparation_By_PkArgs = {
  _inc?: InputMaybe<Preparation_Inc_Input>
  _set?: InputMaybe<Preparation_Set_Input>
  pk_columns: Preparation_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Preparation_ManyArgs = {
  updates: Array<Preparation_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Qm_EntriesArgs = {
  _append?: InputMaybe<Qm_Entries_Append_Input>
  _delete_at_path?: InputMaybe<Qm_Entries_Delete_At_Path_Input>
  _delete_elem?: InputMaybe<Qm_Entries_Delete_Elem_Input>
  _delete_key?: InputMaybe<Qm_Entries_Delete_Key_Input>
  _prepend?: InputMaybe<Qm_Entries_Prepend_Input>
  _set?: InputMaybe<Qm_Entries_Set_Input>
  where: Qm_Entries_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Qm_Entries_By_PkArgs = {
  _append?: InputMaybe<Qm_Entries_Append_Input>
  _delete_at_path?: InputMaybe<Qm_Entries_Delete_At_Path_Input>
  _delete_elem?: InputMaybe<Qm_Entries_Delete_Elem_Input>
  _delete_key?: InputMaybe<Qm_Entries_Delete_Key_Input>
  _prepend?: InputMaybe<Qm_Entries_Prepend_Input>
  _set?: InputMaybe<Qm_Entries_Set_Input>
  pk_columns: Qm_Entries_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Qm_Entries_ManyArgs = {
  updates: Array<Qm_Entries_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Tracking_BirthArgs = {
  _inc?: InputMaybe<Tracking_Birth_Inc_Input>
  _set?: InputMaybe<Tracking_Birth_Set_Input>
  where: Tracking_Birth_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Tracking_Birth_By_PkArgs = {
  _inc?: InputMaybe<Tracking_Birth_Inc_Input>
  _set?: InputMaybe<Tracking_Birth_Set_Input>
  pk_columns: Tracking_Birth_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Tracking_Birth_ManyArgs = {
  updates: Array<Tracking_Birth_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Tracking_BottleArgs = {
  _inc?: InputMaybe<Tracking_Bottle_Inc_Input>
  _set?: InputMaybe<Tracking_Bottle_Set_Input>
  where: Tracking_Bottle_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Tracking_Bottle_By_PkArgs = {
  _inc?: InputMaybe<Tracking_Bottle_Inc_Input>
  _set?: InputMaybe<Tracking_Bottle_Set_Input>
  pk_columns: Tracking_Bottle_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Tracking_Bottle_ManyArgs = {
  updates: Array<Tracking_Bottle_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Tracking_BreastArgs = {
  _inc?: InputMaybe<Tracking_Breast_Inc_Input>
  _set?: InputMaybe<Tracking_Breast_Set_Input>
  where: Tracking_Breast_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Tracking_Breast_By_PkArgs = {
  _inc?: InputMaybe<Tracking_Breast_Inc_Input>
  _set?: InputMaybe<Tracking_Breast_Set_Input>
  pk_columns: Tracking_Breast_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Tracking_Breast_ManyArgs = {
  updates: Array<Tracking_Breast_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Tracking_DiaperArgs = {
  _set?: InputMaybe<Tracking_Diaper_Set_Input>
  where: Tracking_Diaper_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Tracking_Diaper_By_PkArgs = {
  _set?: InputMaybe<Tracking_Diaper_Set_Input>
  pk_columns: Tracking_Diaper_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Tracking_Diaper_ManyArgs = {
  updates: Array<Tracking_Diaper_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Tracking_Mental_HealthArgs = {
  _inc?: InputMaybe<Tracking_Mental_Health_Inc_Input>
  _set?: InputMaybe<Tracking_Mental_Health_Set_Input>
  where: Tracking_Mental_Health_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Tracking_Mental_Health_By_PkArgs = {
  _inc?: InputMaybe<Tracking_Mental_Health_Inc_Input>
  _set?: InputMaybe<Tracking_Mental_Health_Set_Input>
  pk_columns: Tracking_Mental_Health_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Tracking_Mental_Health_ManyArgs = {
  updates: Array<Tracking_Mental_Health_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Tracking_NursingArgs = {
  _append?: InputMaybe<Tracking_Nursing_Append_Input>
  _delete_at_path?: InputMaybe<Tracking_Nursing_Delete_At_Path_Input>
  _delete_elem?: InputMaybe<Tracking_Nursing_Delete_Elem_Input>
  _delete_key?: InputMaybe<Tracking_Nursing_Delete_Key_Input>
  _inc?: InputMaybe<Tracking_Nursing_Inc_Input>
  _prepend?: InputMaybe<Tracking_Nursing_Prepend_Input>
  _set?: InputMaybe<Tracking_Nursing_Set_Input>
  where: Tracking_Nursing_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Tracking_Nursing_By_PkArgs = {
  _append?: InputMaybe<Tracking_Nursing_Append_Input>
  _delete_at_path?: InputMaybe<Tracking_Nursing_Delete_At_Path_Input>
  _delete_elem?: InputMaybe<Tracking_Nursing_Delete_Elem_Input>
  _delete_key?: InputMaybe<Tracking_Nursing_Delete_Key_Input>
  _inc?: InputMaybe<Tracking_Nursing_Inc_Input>
  _prepend?: InputMaybe<Tracking_Nursing_Prepend_Input>
  _set?: InputMaybe<Tracking_Nursing_Set_Input>
  pk_columns: Tracking_Nursing_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Tracking_Nursing_ManyArgs = {
  updates: Array<Tracking_Nursing_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Tracking_SubstanceArgs = {
  _set?: InputMaybe<Tracking_Substance_Set_Input>
  where: Tracking_Substance_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Tracking_Substance_By_PkArgs = {
  _set?: InputMaybe<Tracking_Substance_Set_Input>
  pk_columns: Tracking_Substance_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Tracking_Substance_ManyArgs = {
  updates: Array<Tracking_Substance_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Tracking_TonguetieArgs = {
  _set?: InputMaybe<Tracking_Tonguetie_Set_Input>
  where: Tracking_Tonguetie_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Tracking_Tonguetie_By_PkArgs = {
  _set?: InputMaybe<Tracking_Tonguetie_Set_Input>
  pk_columns: Tracking_Tonguetie_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Tracking_Tonguetie_ManyArgs = {
  updates: Array<Tracking_Tonguetie_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Tracking_WeightArgs = {
  _inc?: InputMaybe<Tracking_Weight_Inc_Input>
  _set?: InputMaybe<Tracking_Weight_Set_Input>
  where: Tracking_Weight_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Tracking_Weight_By_PkArgs = {
  _inc?: InputMaybe<Tracking_Weight_Inc_Input>
  _set?: InputMaybe<Tracking_Weight_Set_Input>
  pk_columns: Tracking_Weight_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Tracking_Weight_ManyArgs = {
  updates: Array<Tracking_Weight_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_User_ProfilesArgs = {
  _append?: InputMaybe<User_Profiles_Append_Input>
  _delete_at_path?: InputMaybe<User_Profiles_Delete_At_Path_Input>
  _delete_elem?: InputMaybe<User_Profiles_Delete_Elem_Input>
  _delete_key?: InputMaybe<User_Profiles_Delete_Key_Input>
  _inc?: InputMaybe<User_Profiles_Inc_Input>
  _prepend?: InputMaybe<User_Profiles_Prepend_Input>
  _set?: InputMaybe<User_Profiles_Set_Input>
  where: User_Profiles_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_User_Profiles_By_PkArgs = {
  _append?: InputMaybe<User_Profiles_Append_Input>
  _delete_at_path?: InputMaybe<User_Profiles_Delete_At_Path_Input>
  _delete_elem?: InputMaybe<User_Profiles_Delete_Elem_Input>
  _delete_key?: InputMaybe<User_Profiles_Delete_Key_Input>
  _inc?: InputMaybe<User_Profiles_Inc_Input>
  _prepend?: InputMaybe<User_Profiles_Prepend_Input>
  _set?: InputMaybe<User_Profiles_Set_Input>
  pk_columns: User_Profiles_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_User_Profiles_ManyArgs = {
  updates: Array<User_Profiles_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Users_ManyArgs = {
  updates: Array<Users_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Virus_ManyArgs = {
  updates: Array<Virus_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Voucher_CodesArgs = {
  _inc?: InputMaybe<Voucher_Codes_Inc_Input>
  _set?: InputMaybe<Voucher_Codes_Set_Input>
  where: Voucher_Codes_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Voucher_Codes_By_PkArgs = {
  _inc?: InputMaybe<Voucher_Codes_Inc_Input>
  _set?: InputMaybe<Voucher_Codes_Set_Input>
  pk_columns: Voucher_Codes_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Voucher_Codes_ManyArgs = {
  updates: Array<Voucher_Codes_Updates>
}

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last',
}

/** columns and relationships of "preparation" */
export type Preparation = {
  __typename?: 'preparation'
  abortioncriminal?: Maybe<Scalars['Boolean']['output']>
  abortionmedical?: Maybe<Scalars['Boolean']['output']>
  accessory?: Maybe<Scalars['Boolean']['output']>
  adipositas?: Maybe<Scalars['Boolean']['output']>
  adoption?: Maybe<Scalars['Boolean']['output']>
  alcohol?: Maybe<Scalars['Boolean']['output']>
  amalgam?: Maybe<Scalars['Boolean']['output']>
  antiepileptics?: Maybe<Scalars['Boolean']['output']>
  asthma?: Maybe<Scalars['Boolean']['output']>
  betterPre?: Maybe<Scalars['Boolean']['output']>
  birthcontrol?: Maybe<Scalars['Boolean']['output']>
  botox?: Maybe<Scalars['Boolean']['output']>
  cannabis?: Maybe<Scalars['Boolean']['output']>
  cardiovascular?: Maybe<Scalars['Boolean']['output']>
  cholesterin?: Maybe<Scalars['Boolean']['output']>
  cocaine?: Maybe<Scalars['Boolean']['output']>
  coffein?: Maybe<Scalars['Boolean']['output']>
  contraindication?: Maybe<Scalars['Boolean']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  crystalmeth?: Maybe<Scalars['Boolean']['output']>
  diabetes?: Maybe<Scalars['Boolean']['output']>
  diuretics?: Maybe<Scalars['Boolean']['output']>
  drugs?: Maybe<Scalars['Boolean']['output']>
  fungus?: Maybe<Scalars['Boolean']['output']>
  herpes?: Maybe<Scalars['Boolean']['output']>
  id: Scalars['uuid']['output']
  induce?: Maybe<Scalars['Boolean']['output']>
  lkg?: Maybe<Scalars['Boolean']['output']>
  magnesium?: Maybe<Scalars['Boolean']['output']>
  miscarriage?: Maybe<Scalars['Boolean']['output']>
  nicotine?: Maybe<Scalars['Boolean']['output']>
  noreason?: Maybe<Scalars['Boolean']['output']>
  opiate?: Maybe<Scalars['Boolean']['output']>
  pcos?: Maybe<Scalars['Boolean']['output']>
  personalreason?: Maybe<Scalars['Boolean']['output']>
  piercing?: Maybe<Scalars['Boolean']['output']>
  preemie?: Maybe<Scalars['Boolean']['output']>
  pregnant?: Maybe<Scalars['Boolean']['output']>
  rawmilk?: Maybe<Scalars['Boolean']['output']>
  sagging?: Maybe<Scalars['Boolean']['output']>
  sectio?: Maybe<Scalars['Boolean']['output']>
  sharedcare?: Maybe<Scalars['Boolean']['output']>
  ssw?: Maybe<Scalars['Int']['output']>
  starchild?: Maybe<Scalars['Boolean']['output']>
  status?: Maybe<Scalars['String']['output']>
  throat?: Maybe<Scalars['Boolean']['output']>
  trisomie?: Maybe<Scalars['Boolean']['output']>
  user_id: Scalars['uuid']['output']
  wantstobf?: Maybe<Scalars['Boolean']['output']>
}

/** aggregated selection of "preparation" */
export type Preparation_Aggregate = {
  __typename?: 'preparation_aggregate'
  aggregate?: Maybe<Preparation_Aggregate_Fields>
  nodes: Array<Preparation>
}

/** aggregate fields of "preparation" */
export type Preparation_Aggregate_Fields = {
  __typename?: 'preparation_aggregate_fields'
  avg?: Maybe<Preparation_Avg_Fields>
  count: Scalars['Int']['output']
  max?: Maybe<Preparation_Max_Fields>
  min?: Maybe<Preparation_Min_Fields>
  stddev?: Maybe<Preparation_Stddev_Fields>
  stddev_pop?: Maybe<Preparation_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Preparation_Stddev_Samp_Fields>
  sum?: Maybe<Preparation_Sum_Fields>
  var_pop?: Maybe<Preparation_Var_Pop_Fields>
  var_samp?: Maybe<Preparation_Var_Samp_Fields>
  variance?: Maybe<Preparation_Variance_Fields>
}

/** aggregate fields of "preparation" */
export type Preparation_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Preparation_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** aggregate avg on columns */
export type Preparation_Avg_Fields = {
  __typename?: 'preparation_avg_fields'
  ssw?: Maybe<Scalars['Float']['output']>
}

/** Boolean expression to filter rows from the table "preparation". All fields are combined with a logical 'AND'. */
export type Preparation_Bool_Exp = {
  _and?: InputMaybe<Array<Preparation_Bool_Exp>>
  _not?: InputMaybe<Preparation_Bool_Exp>
  _or?: InputMaybe<Array<Preparation_Bool_Exp>>
  abortioncriminal?: InputMaybe<Boolean_Comparison_Exp>
  abortionmedical?: InputMaybe<Boolean_Comparison_Exp>
  accessory?: InputMaybe<Boolean_Comparison_Exp>
  adipositas?: InputMaybe<Boolean_Comparison_Exp>
  adoption?: InputMaybe<Boolean_Comparison_Exp>
  alcohol?: InputMaybe<Boolean_Comparison_Exp>
  amalgam?: InputMaybe<Boolean_Comparison_Exp>
  antiepileptics?: InputMaybe<Boolean_Comparison_Exp>
  asthma?: InputMaybe<Boolean_Comparison_Exp>
  betterPre?: InputMaybe<Boolean_Comparison_Exp>
  birthcontrol?: InputMaybe<Boolean_Comparison_Exp>
  botox?: InputMaybe<Boolean_Comparison_Exp>
  cannabis?: InputMaybe<Boolean_Comparison_Exp>
  cardiovascular?: InputMaybe<Boolean_Comparison_Exp>
  cholesterin?: InputMaybe<Boolean_Comparison_Exp>
  cocaine?: InputMaybe<Boolean_Comparison_Exp>
  coffein?: InputMaybe<Boolean_Comparison_Exp>
  contraindication?: InputMaybe<Boolean_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  crystalmeth?: InputMaybe<Boolean_Comparison_Exp>
  diabetes?: InputMaybe<Boolean_Comparison_Exp>
  diuretics?: InputMaybe<Boolean_Comparison_Exp>
  drugs?: InputMaybe<Boolean_Comparison_Exp>
  fungus?: InputMaybe<Boolean_Comparison_Exp>
  herpes?: InputMaybe<Boolean_Comparison_Exp>
  id?: InputMaybe<Uuid_Comparison_Exp>
  induce?: InputMaybe<Boolean_Comparison_Exp>
  lkg?: InputMaybe<Boolean_Comparison_Exp>
  magnesium?: InputMaybe<Boolean_Comparison_Exp>
  miscarriage?: InputMaybe<Boolean_Comparison_Exp>
  nicotine?: InputMaybe<Boolean_Comparison_Exp>
  noreason?: InputMaybe<Boolean_Comparison_Exp>
  opiate?: InputMaybe<Boolean_Comparison_Exp>
  pcos?: InputMaybe<Boolean_Comparison_Exp>
  personalreason?: InputMaybe<Boolean_Comparison_Exp>
  piercing?: InputMaybe<Boolean_Comparison_Exp>
  preemie?: InputMaybe<Boolean_Comparison_Exp>
  pregnant?: InputMaybe<Boolean_Comparison_Exp>
  rawmilk?: InputMaybe<Boolean_Comparison_Exp>
  sagging?: InputMaybe<Boolean_Comparison_Exp>
  sectio?: InputMaybe<Boolean_Comparison_Exp>
  sharedcare?: InputMaybe<Boolean_Comparison_Exp>
  ssw?: InputMaybe<Int_Comparison_Exp>
  starchild?: InputMaybe<Boolean_Comparison_Exp>
  status?: InputMaybe<String_Comparison_Exp>
  throat?: InputMaybe<Boolean_Comparison_Exp>
  trisomie?: InputMaybe<Boolean_Comparison_Exp>
  user_id?: InputMaybe<Uuid_Comparison_Exp>
  wantstobf?: InputMaybe<Boolean_Comparison_Exp>
}

/** unique or primary key constraints on table "preparation" */
export enum Preparation_Constraint {
  /** unique or primary key constraint on columns "id" */
  PreparationPkey = 'preparation_pkey',
}

/** input type for incrementing numeric columns in table "preparation" */
export type Preparation_Inc_Input = {
  ssw?: InputMaybe<Scalars['Int']['input']>
}

/** input type for inserting data into table "preparation" */
export type Preparation_Insert_Input = {
  abortioncriminal?: InputMaybe<Scalars['Boolean']['input']>
  abortionmedical?: InputMaybe<Scalars['Boolean']['input']>
  accessory?: InputMaybe<Scalars['Boolean']['input']>
  adipositas?: InputMaybe<Scalars['Boolean']['input']>
  adoption?: InputMaybe<Scalars['Boolean']['input']>
  alcohol?: InputMaybe<Scalars['Boolean']['input']>
  amalgam?: InputMaybe<Scalars['Boolean']['input']>
  antiepileptics?: InputMaybe<Scalars['Boolean']['input']>
  asthma?: InputMaybe<Scalars['Boolean']['input']>
  betterPre?: InputMaybe<Scalars['Boolean']['input']>
  birthcontrol?: InputMaybe<Scalars['Boolean']['input']>
  botox?: InputMaybe<Scalars['Boolean']['input']>
  cannabis?: InputMaybe<Scalars['Boolean']['input']>
  cardiovascular?: InputMaybe<Scalars['Boolean']['input']>
  cholesterin?: InputMaybe<Scalars['Boolean']['input']>
  cocaine?: InputMaybe<Scalars['Boolean']['input']>
  coffein?: InputMaybe<Scalars['Boolean']['input']>
  contraindication?: InputMaybe<Scalars['Boolean']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  crystalmeth?: InputMaybe<Scalars['Boolean']['input']>
  diabetes?: InputMaybe<Scalars['Boolean']['input']>
  diuretics?: InputMaybe<Scalars['Boolean']['input']>
  drugs?: InputMaybe<Scalars['Boolean']['input']>
  fungus?: InputMaybe<Scalars['Boolean']['input']>
  herpes?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  induce?: InputMaybe<Scalars['Boolean']['input']>
  lkg?: InputMaybe<Scalars['Boolean']['input']>
  magnesium?: InputMaybe<Scalars['Boolean']['input']>
  miscarriage?: InputMaybe<Scalars['Boolean']['input']>
  nicotine?: InputMaybe<Scalars['Boolean']['input']>
  noreason?: InputMaybe<Scalars['Boolean']['input']>
  opiate?: InputMaybe<Scalars['Boolean']['input']>
  pcos?: InputMaybe<Scalars['Boolean']['input']>
  personalreason?: InputMaybe<Scalars['Boolean']['input']>
  piercing?: InputMaybe<Scalars['Boolean']['input']>
  preemie?: InputMaybe<Scalars['Boolean']['input']>
  pregnant?: InputMaybe<Scalars['Boolean']['input']>
  rawmilk?: InputMaybe<Scalars['Boolean']['input']>
  sagging?: InputMaybe<Scalars['Boolean']['input']>
  sectio?: InputMaybe<Scalars['Boolean']['input']>
  sharedcare?: InputMaybe<Scalars['Boolean']['input']>
  ssw?: InputMaybe<Scalars['Int']['input']>
  starchild?: InputMaybe<Scalars['Boolean']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  throat?: InputMaybe<Scalars['Boolean']['input']>
  trisomie?: InputMaybe<Scalars['Boolean']['input']>
  user_id?: InputMaybe<Scalars['uuid']['input']>
  wantstobf?: InputMaybe<Scalars['Boolean']['input']>
}

/** aggregate max on columns */
export type Preparation_Max_Fields = {
  __typename?: 'preparation_max_fields'
  created_at?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['uuid']['output']>
  ssw?: Maybe<Scalars['Int']['output']>
  status?: Maybe<Scalars['String']['output']>
  user_id?: Maybe<Scalars['uuid']['output']>
}

/** aggregate min on columns */
export type Preparation_Min_Fields = {
  __typename?: 'preparation_min_fields'
  created_at?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['uuid']['output']>
  ssw?: Maybe<Scalars['Int']['output']>
  status?: Maybe<Scalars['String']['output']>
  user_id?: Maybe<Scalars['uuid']['output']>
}

/** response of any mutation on the table "preparation" */
export type Preparation_Mutation_Response = {
  __typename?: 'preparation_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Preparation>
}

/** on_conflict condition type for table "preparation" */
export type Preparation_On_Conflict = {
  constraint: Preparation_Constraint
  update_columns?: Array<Preparation_Update_Column>
  where?: InputMaybe<Preparation_Bool_Exp>
}

/** Ordering options when selecting data from "preparation". */
export type Preparation_Order_By = {
  abortioncriminal?: InputMaybe<Order_By>
  abortionmedical?: InputMaybe<Order_By>
  accessory?: InputMaybe<Order_By>
  adipositas?: InputMaybe<Order_By>
  adoption?: InputMaybe<Order_By>
  alcohol?: InputMaybe<Order_By>
  amalgam?: InputMaybe<Order_By>
  antiepileptics?: InputMaybe<Order_By>
  asthma?: InputMaybe<Order_By>
  betterPre?: InputMaybe<Order_By>
  birthcontrol?: InputMaybe<Order_By>
  botox?: InputMaybe<Order_By>
  cannabis?: InputMaybe<Order_By>
  cardiovascular?: InputMaybe<Order_By>
  cholesterin?: InputMaybe<Order_By>
  cocaine?: InputMaybe<Order_By>
  coffein?: InputMaybe<Order_By>
  contraindication?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  crystalmeth?: InputMaybe<Order_By>
  diabetes?: InputMaybe<Order_By>
  diuretics?: InputMaybe<Order_By>
  drugs?: InputMaybe<Order_By>
  fungus?: InputMaybe<Order_By>
  herpes?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  induce?: InputMaybe<Order_By>
  lkg?: InputMaybe<Order_By>
  magnesium?: InputMaybe<Order_By>
  miscarriage?: InputMaybe<Order_By>
  nicotine?: InputMaybe<Order_By>
  noreason?: InputMaybe<Order_By>
  opiate?: InputMaybe<Order_By>
  pcos?: InputMaybe<Order_By>
  personalreason?: InputMaybe<Order_By>
  piercing?: InputMaybe<Order_By>
  preemie?: InputMaybe<Order_By>
  pregnant?: InputMaybe<Order_By>
  rawmilk?: InputMaybe<Order_By>
  sagging?: InputMaybe<Order_By>
  sectio?: InputMaybe<Order_By>
  sharedcare?: InputMaybe<Order_By>
  ssw?: InputMaybe<Order_By>
  starchild?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
  throat?: InputMaybe<Order_By>
  trisomie?: InputMaybe<Order_By>
  user_id?: InputMaybe<Order_By>
  wantstobf?: InputMaybe<Order_By>
}

/** primary key columns input for table: preparation */
export type Preparation_Pk_Columns_Input = {
  id: Scalars['uuid']['input']
}

/** select columns of table "preparation" */
export enum Preparation_Select_Column {
  /** column name */
  Abortioncriminal = 'abortioncriminal',
  /** column name */
  Abortionmedical = 'abortionmedical',
  /** column name */
  Accessory = 'accessory',
  /** column name */
  Adipositas = 'adipositas',
  /** column name */
  Adoption = 'adoption',
  /** column name */
  Alcohol = 'alcohol',
  /** column name */
  Amalgam = 'amalgam',
  /** column name */
  Antiepileptics = 'antiepileptics',
  /** column name */
  Asthma = 'asthma',
  /** column name */
  BetterPre = 'betterPre',
  /** column name */
  Birthcontrol = 'birthcontrol',
  /** column name */
  Botox = 'botox',
  /** column name */
  Cannabis = 'cannabis',
  /** column name */
  Cardiovascular = 'cardiovascular',
  /** column name */
  Cholesterin = 'cholesterin',
  /** column name */
  Cocaine = 'cocaine',
  /** column name */
  Coffein = 'coffein',
  /** column name */
  Contraindication = 'contraindication',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Crystalmeth = 'crystalmeth',
  /** column name */
  Diabetes = 'diabetes',
  /** column name */
  Diuretics = 'diuretics',
  /** column name */
  Drugs = 'drugs',
  /** column name */
  Fungus = 'fungus',
  /** column name */
  Herpes = 'herpes',
  /** column name */
  Id = 'id',
  /** column name */
  Induce = 'induce',
  /** column name */
  Lkg = 'lkg',
  /** column name */
  Magnesium = 'magnesium',
  /** column name */
  Miscarriage = 'miscarriage',
  /** column name */
  Nicotine = 'nicotine',
  /** column name */
  Noreason = 'noreason',
  /** column name */
  Opiate = 'opiate',
  /** column name */
  Pcos = 'pcos',
  /** column name */
  Personalreason = 'personalreason',
  /** column name */
  Piercing = 'piercing',
  /** column name */
  Preemie = 'preemie',
  /** column name */
  Pregnant = 'pregnant',
  /** column name */
  Rawmilk = 'rawmilk',
  /** column name */
  Sagging = 'sagging',
  /** column name */
  Sectio = 'sectio',
  /** column name */
  Sharedcare = 'sharedcare',
  /** column name */
  Ssw = 'ssw',
  /** column name */
  Starchild = 'starchild',
  /** column name */
  Status = 'status',
  /** column name */
  Throat = 'throat',
  /** column name */
  Trisomie = 'trisomie',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Wantstobf = 'wantstobf',
}

/** input type for updating data in table "preparation" */
export type Preparation_Set_Input = {
  abortioncriminal?: InputMaybe<Scalars['Boolean']['input']>
  abortionmedical?: InputMaybe<Scalars['Boolean']['input']>
  accessory?: InputMaybe<Scalars['Boolean']['input']>
  adipositas?: InputMaybe<Scalars['Boolean']['input']>
  adoption?: InputMaybe<Scalars['Boolean']['input']>
  alcohol?: InputMaybe<Scalars['Boolean']['input']>
  amalgam?: InputMaybe<Scalars['Boolean']['input']>
  antiepileptics?: InputMaybe<Scalars['Boolean']['input']>
  asthma?: InputMaybe<Scalars['Boolean']['input']>
  betterPre?: InputMaybe<Scalars['Boolean']['input']>
  birthcontrol?: InputMaybe<Scalars['Boolean']['input']>
  botox?: InputMaybe<Scalars['Boolean']['input']>
  cannabis?: InputMaybe<Scalars['Boolean']['input']>
  cardiovascular?: InputMaybe<Scalars['Boolean']['input']>
  cholesterin?: InputMaybe<Scalars['Boolean']['input']>
  cocaine?: InputMaybe<Scalars['Boolean']['input']>
  coffein?: InputMaybe<Scalars['Boolean']['input']>
  contraindication?: InputMaybe<Scalars['Boolean']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  crystalmeth?: InputMaybe<Scalars['Boolean']['input']>
  diabetes?: InputMaybe<Scalars['Boolean']['input']>
  diuretics?: InputMaybe<Scalars['Boolean']['input']>
  drugs?: InputMaybe<Scalars['Boolean']['input']>
  fungus?: InputMaybe<Scalars['Boolean']['input']>
  herpes?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  induce?: InputMaybe<Scalars['Boolean']['input']>
  lkg?: InputMaybe<Scalars['Boolean']['input']>
  magnesium?: InputMaybe<Scalars['Boolean']['input']>
  miscarriage?: InputMaybe<Scalars['Boolean']['input']>
  nicotine?: InputMaybe<Scalars['Boolean']['input']>
  noreason?: InputMaybe<Scalars['Boolean']['input']>
  opiate?: InputMaybe<Scalars['Boolean']['input']>
  pcos?: InputMaybe<Scalars['Boolean']['input']>
  personalreason?: InputMaybe<Scalars['Boolean']['input']>
  piercing?: InputMaybe<Scalars['Boolean']['input']>
  preemie?: InputMaybe<Scalars['Boolean']['input']>
  pregnant?: InputMaybe<Scalars['Boolean']['input']>
  rawmilk?: InputMaybe<Scalars['Boolean']['input']>
  sagging?: InputMaybe<Scalars['Boolean']['input']>
  sectio?: InputMaybe<Scalars['Boolean']['input']>
  sharedcare?: InputMaybe<Scalars['Boolean']['input']>
  ssw?: InputMaybe<Scalars['Int']['input']>
  starchild?: InputMaybe<Scalars['Boolean']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  throat?: InputMaybe<Scalars['Boolean']['input']>
  trisomie?: InputMaybe<Scalars['Boolean']['input']>
  user_id?: InputMaybe<Scalars['uuid']['input']>
  wantstobf?: InputMaybe<Scalars['Boolean']['input']>
}

/** aggregate stddev on columns */
export type Preparation_Stddev_Fields = {
  __typename?: 'preparation_stddev_fields'
  ssw?: Maybe<Scalars['Float']['output']>
}

/** aggregate stddev_pop on columns */
export type Preparation_Stddev_Pop_Fields = {
  __typename?: 'preparation_stddev_pop_fields'
  ssw?: Maybe<Scalars['Float']['output']>
}

/** aggregate stddev_samp on columns */
export type Preparation_Stddev_Samp_Fields = {
  __typename?: 'preparation_stddev_samp_fields'
  ssw?: Maybe<Scalars['Float']['output']>
}

/** Streaming cursor of the table "preparation" */
export type Preparation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Preparation_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Preparation_Stream_Cursor_Value_Input = {
  abortioncriminal?: InputMaybe<Scalars['Boolean']['input']>
  abortionmedical?: InputMaybe<Scalars['Boolean']['input']>
  accessory?: InputMaybe<Scalars['Boolean']['input']>
  adipositas?: InputMaybe<Scalars['Boolean']['input']>
  adoption?: InputMaybe<Scalars['Boolean']['input']>
  alcohol?: InputMaybe<Scalars['Boolean']['input']>
  amalgam?: InputMaybe<Scalars['Boolean']['input']>
  antiepileptics?: InputMaybe<Scalars['Boolean']['input']>
  asthma?: InputMaybe<Scalars['Boolean']['input']>
  betterPre?: InputMaybe<Scalars['Boolean']['input']>
  birthcontrol?: InputMaybe<Scalars['Boolean']['input']>
  botox?: InputMaybe<Scalars['Boolean']['input']>
  cannabis?: InputMaybe<Scalars['Boolean']['input']>
  cardiovascular?: InputMaybe<Scalars['Boolean']['input']>
  cholesterin?: InputMaybe<Scalars['Boolean']['input']>
  cocaine?: InputMaybe<Scalars['Boolean']['input']>
  coffein?: InputMaybe<Scalars['Boolean']['input']>
  contraindication?: InputMaybe<Scalars['Boolean']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  crystalmeth?: InputMaybe<Scalars['Boolean']['input']>
  diabetes?: InputMaybe<Scalars['Boolean']['input']>
  diuretics?: InputMaybe<Scalars['Boolean']['input']>
  drugs?: InputMaybe<Scalars['Boolean']['input']>
  fungus?: InputMaybe<Scalars['Boolean']['input']>
  herpes?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  induce?: InputMaybe<Scalars['Boolean']['input']>
  lkg?: InputMaybe<Scalars['Boolean']['input']>
  magnesium?: InputMaybe<Scalars['Boolean']['input']>
  miscarriage?: InputMaybe<Scalars['Boolean']['input']>
  nicotine?: InputMaybe<Scalars['Boolean']['input']>
  noreason?: InputMaybe<Scalars['Boolean']['input']>
  opiate?: InputMaybe<Scalars['Boolean']['input']>
  pcos?: InputMaybe<Scalars['Boolean']['input']>
  personalreason?: InputMaybe<Scalars['Boolean']['input']>
  piercing?: InputMaybe<Scalars['Boolean']['input']>
  preemie?: InputMaybe<Scalars['Boolean']['input']>
  pregnant?: InputMaybe<Scalars['Boolean']['input']>
  rawmilk?: InputMaybe<Scalars['Boolean']['input']>
  sagging?: InputMaybe<Scalars['Boolean']['input']>
  sectio?: InputMaybe<Scalars['Boolean']['input']>
  sharedcare?: InputMaybe<Scalars['Boolean']['input']>
  ssw?: InputMaybe<Scalars['Int']['input']>
  starchild?: InputMaybe<Scalars['Boolean']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  throat?: InputMaybe<Scalars['Boolean']['input']>
  trisomie?: InputMaybe<Scalars['Boolean']['input']>
  user_id?: InputMaybe<Scalars['uuid']['input']>
  wantstobf?: InputMaybe<Scalars['Boolean']['input']>
}

/** aggregate sum on columns */
export type Preparation_Sum_Fields = {
  __typename?: 'preparation_sum_fields'
  ssw?: Maybe<Scalars['Int']['output']>
}

/** update columns of table "preparation" */
export enum Preparation_Update_Column {
  /** column name */
  Abortioncriminal = 'abortioncriminal',
  /** column name */
  Abortionmedical = 'abortionmedical',
  /** column name */
  Accessory = 'accessory',
  /** column name */
  Adipositas = 'adipositas',
  /** column name */
  Adoption = 'adoption',
  /** column name */
  Alcohol = 'alcohol',
  /** column name */
  Amalgam = 'amalgam',
  /** column name */
  Antiepileptics = 'antiepileptics',
  /** column name */
  Asthma = 'asthma',
  /** column name */
  BetterPre = 'betterPre',
  /** column name */
  Birthcontrol = 'birthcontrol',
  /** column name */
  Botox = 'botox',
  /** column name */
  Cannabis = 'cannabis',
  /** column name */
  Cardiovascular = 'cardiovascular',
  /** column name */
  Cholesterin = 'cholesterin',
  /** column name */
  Cocaine = 'cocaine',
  /** column name */
  Coffein = 'coffein',
  /** column name */
  Contraindication = 'contraindication',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Crystalmeth = 'crystalmeth',
  /** column name */
  Diabetes = 'diabetes',
  /** column name */
  Diuretics = 'diuretics',
  /** column name */
  Drugs = 'drugs',
  /** column name */
  Fungus = 'fungus',
  /** column name */
  Herpes = 'herpes',
  /** column name */
  Id = 'id',
  /** column name */
  Induce = 'induce',
  /** column name */
  Lkg = 'lkg',
  /** column name */
  Magnesium = 'magnesium',
  /** column name */
  Miscarriage = 'miscarriage',
  /** column name */
  Nicotine = 'nicotine',
  /** column name */
  Noreason = 'noreason',
  /** column name */
  Opiate = 'opiate',
  /** column name */
  Pcos = 'pcos',
  /** column name */
  Personalreason = 'personalreason',
  /** column name */
  Piercing = 'piercing',
  /** column name */
  Preemie = 'preemie',
  /** column name */
  Pregnant = 'pregnant',
  /** column name */
  Rawmilk = 'rawmilk',
  /** column name */
  Sagging = 'sagging',
  /** column name */
  Sectio = 'sectio',
  /** column name */
  Sharedcare = 'sharedcare',
  /** column name */
  Ssw = 'ssw',
  /** column name */
  Starchild = 'starchild',
  /** column name */
  Status = 'status',
  /** column name */
  Throat = 'throat',
  /** column name */
  Trisomie = 'trisomie',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Wantstobf = 'wantstobf',
}

export type Preparation_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Preparation_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Preparation_Set_Input>
  /** filter the rows which have to be updated */
  where: Preparation_Bool_Exp
}

/** aggregate var_pop on columns */
export type Preparation_Var_Pop_Fields = {
  __typename?: 'preparation_var_pop_fields'
  ssw?: Maybe<Scalars['Float']['output']>
}

/** aggregate var_samp on columns */
export type Preparation_Var_Samp_Fields = {
  __typename?: 'preparation_var_samp_fields'
  ssw?: Maybe<Scalars['Float']['output']>
}

/** aggregate variance on columns */
export type Preparation_Variance_Fields = {
  __typename?: 'preparation_variance_fields'
  ssw?: Maybe<Scalars['Float']['output']>
}

/** columns and relationships of "qm_entries" */
export type Qm_Entries = {
  __typename?: 'qm_entries'
  category: Scalars['String']['output']
  created_at: Scalars['timestamptz']['output']
  id: Scalars['uuid']['output']
  status: Scalars['String']['output']
  structured_data: Scalars['jsonb']['output']
  transcript?: Maybe<Scalars['String']['output']>
  updated_at: Scalars['timestamptz']['output']
  user_id: Scalars['uuid']['output']
}

/** columns and relationships of "qm_entries" */
export type Qm_EntriesStructured_DataArgs = {
  path?: InputMaybe<Scalars['String']['input']>
}

/** aggregated selection of "qm_entries" */
export type Qm_Entries_Aggregate = {
  __typename?: 'qm_entries_aggregate'
  aggregate?: Maybe<Qm_Entries_Aggregate_Fields>
  nodes: Array<Qm_Entries>
}

/** aggregate fields of "qm_entries" */
export type Qm_Entries_Aggregate_Fields = {
  __typename?: 'qm_entries_aggregate_fields'
  count: Scalars['Int']['output']
  max?: Maybe<Qm_Entries_Max_Fields>
  min?: Maybe<Qm_Entries_Min_Fields>
}

/** aggregate fields of "qm_entries" */
export type Qm_Entries_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Qm_Entries_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** append existing jsonb value of filtered columns with new jsonb value */
export type Qm_Entries_Append_Input = {
  structured_data?: InputMaybe<Scalars['jsonb']['input']>
}

/** Boolean expression to filter rows from the table "qm_entries". All fields are combined with a logical 'AND'. */
export type Qm_Entries_Bool_Exp = {
  _and?: InputMaybe<Array<Qm_Entries_Bool_Exp>>
  _not?: InputMaybe<Qm_Entries_Bool_Exp>
  _or?: InputMaybe<Array<Qm_Entries_Bool_Exp>>
  category?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  id?: InputMaybe<Uuid_Comparison_Exp>
  status?: InputMaybe<String_Comparison_Exp>
  structured_data?: InputMaybe<Jsonb_Comparison_Exp>
  transcript?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>
  user_id?: InputMaybe<Uuid_Comparison_Exp>
}

/** unique or primary key constraints on table "qm_entries" */
export enum Qm_Entries_Constraint {
  /** unique or primary key constraint on columns "id" */
  QmEntriesPkey = 'qm_entries_pkey',
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Qm_Entries_Delete_At_Path_Input = {
  structured_data?: InputMaybe<Array<Scalars['String']['input']>>
}

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Qm_Entries_Delete_Elem_Input = {
  structured_data?: InputMaybe<Scalars['Int']['input']>
}

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Qm_Entries_Delete_Key_Input = {
  structured_data?: InputMaybe<Scalars['String']['input']>
}

/** input type for inserting data into table "qm_entries" */
export type Qm_Entries_Insert_Input = {
  category?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  structured_data?: InputMaybe<Scalars['jsonb']['input']>
  transcript?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  user_id?: InputMaybe<Scalars['uuid']['input']>
}

/** aggregate max on columns */
export type Qm_Entries_Max_Fields = {
  __typename?: 'qm_entries_max_fields'
  category?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['uuid']['output']>
  status?: Maybe<Scalars['String']['output']>
  transcript?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
  user_id?: Maybe<Scalars['uuid']['output']>
}

/** aggregate min on columns */
export type Qm_Entries_Min_Fields = {
  __typename?: 'qm_entries_min_fields'
  category?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['uuid']['output']>
  status?: Maybe<Scalars['String']['output']>
  transcript?: Maybe<Scalars['String']['output']>
  updated_at?: Maybe<Scalars['timestamptz']['output']>
  user_id?: Maybe<Scalars['uuid']['output']>
}

/** response of any mutation on the table "qm_entries" */
export type Qm_Entries_Mutation_Response = {
  __typename?: 'qm_entries_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Qm_Entries>
}

/** on_conflict condition type for table "qm_entries" */
export type Qm_Entries_On_Conflict = {
  constraint: Qm_Entries_Constraint
  update_columns?: Array<Qm_Entries_Update_Column>
  where?: InputMaybe<Qm_Entries_Bool_Exp>
}

/** Ordering options when selecting data from "qm_entries". */
export type Qm_Entries_Order_By = {
  category?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
  structured_data?: InputMaybe<Order_By>
  transcript?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  user_id?: InputMaybe<Order_By>
}

/** primary key columns input for table: qm_entries */
export type Qm_Entries_Pk_Columns_Input = {
  id: Scalars['uuid']['input']
}

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Qm_Entries_Prepend_Input = {
  structured_data?: InputMaybe<Scalars['jsonb']['input']>
}

/** select columns of table "qm_entries" */
export enum Qm_Entries_Select_Column {
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  StructuredData = 'structured_data',
  /** column name */
  Transcript = 'transcript',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
}

/** input type for updating data in table "qm_entries" */
export type Qm_Entries_Set_Input = {
  category?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  structured_data?: InputMaybe<Scalars['jsonb']['input']>
  transcript?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  user_id?: InputMaybe<Scalars['uuid']['input']>
}

/** Streaming cursor of the table "qm_entries" */
export type Qm_Entries_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Qm_Entries_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Qm_Entries_Stream_Cursor_Value_Input = {
  category?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  structured_data?: InputMaybe<Scalars['jsonb']['input']>
  transcript?: InputMaybe<Scalars['String']['input']>
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>
  user_id?: InputMaybe<Scalars['uuid']['input']>
}

/** update columns of table "qm_entries" */
export enum Qm_Entries_Update_Column {
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  StructuredData = 'structured_data',
  /** column name */
  Transcript = 'transcript',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
}

export type Qm_Entries_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Qm_Entries_Append_Input>
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Qm_Entries_Delete_At_Path_Input>
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Qm_Entries_Delete_Elem_Input>
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Qm_Entries_Delete_Key_Input>
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Qm_Entries_Prepend_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Qm_Entries_Set_Input>
  /** filter the rows which have to be updated */
  where: Qm_Entries_Bool_Exp
}

export type Query_Root = {
  __typename?: 'query_root'
  /** fetch data from the table: "appointments" */
  appointments: Array<Appointments>
  /** fetch aggregated fields from the table: "appointments" */
  appointments_aggregate: Appointments_Aggregate
  /** fetch data from the table: "appointments" using primary key columns */
  appointments_by_pk?: Maybe<Appointments>
  /** fetch data from the table: "article_progress" */
  article_progress: Array<Article_Progress>
  /** fetch aggregated fields from the table: "article_progress" */
  article_progress_aggregate: Article_Progress_Aggregate
  /** fetch data from the table: "article_progress" using primary key columns */
  article_progress_by_pk?: Maybe<Article_Progress>
  /** fetch data from the table: "article_sections" */
  article_sections: Array<Article_Sections>
  /** fetch aggregated fields from the table: "article_sections" */
  article_sections_aggregate: Article_Sections_Aggregate
  /** fetch data from the table: "article_sections" using primary key columns */
  article_sections_by_pk?: Maybe<Article_Sections>
  /** An array relationship */
  articles: Array<Articles>
  /** An aggregate relationship */
  articles_aggregate: Articles_Aggregate
  /** fetch data from the table: "articles" using primary key columns */
  articles_by_pk?: Maybe<Articles>
  /** fetch data from the table: "auth.oauth2_auth_requests" using primary key columns */
  authOauth2AuthRequest?: Maybe<AuthOauth2AuthRequests>
  /** fetch data from the table: "auth.oauth2_auth_requests" */
  authOauth2AuthRequests: Array<AuthOauth2AuthRequests>
  /** fetch aggregated fields from the table: "auth.oauth2_auth_requests" */
  authOauth2AuthRequestsAggregate: AuthOauth2AuthRequests_Aggregate
  /** fetch data from the table: "auth.oauth2_authorization_codes" using primary key columns */
  authOauth2AuthorizationCode?: Maybe<AuthOauth2AuthorizationCodes>
  /** fetch data from the table: "auth.oauth2_authorization_codes" */
  authOauth2AuthorizationCodes: Array<AuthOauth2AuthorizationCodes>
  /** fetch aggregated fields from the table: "auth.oauth2_authorization_codes" */
  authOauth2AuthorizationCodesAggregate: AuthOauth2AuthorizationCodes_Aggregate
  /** fetch data from the table: "auth.oauth2_clients" using primary key columns */
  authOauth2Client?: Maybe<AuthOauth2Clients>
  /** fetch data from the table: "auth.oauth2_clients" */
  authOauth2Clients: Array<AuthOauth2Clients>
  /** fetch aggregated fields from the table: "auth.oauth2_clients" */
  authOauth2ClientsAggregate: AuthOauth2Clients_Aggregate
  /** fetch data from the table: "auth.oauth2_refresh_tokens" using primary key columns */
  authOauth2RefreshToken?: Maybe<AuthOauth2RefreshTokens>
  /** fetch data from the table: "auth.oauth2_refresh_tokens" */
  authOauth2RefreshTokens: Array<AuthOauth2RefreshTokens>
  /** fetch aggregated fields from the table: "auth.oauth2_refresh_tokens" */
  authOauth2RefreshTokensAggregate: AuthOauth2RefreshTokens_Aggregate
  /** fetch data from the table: "auth.providers" using primary key columns */
  authProvider?: Maybe<AuthProviders>
  /** fetch data from the table: "auth.provider_requests" using primary key columns */
  authProviderRequest?: Maybe<AuthProviderRequests>
  /** fetch data from the table: "auth.provider_requests" */
  authProviderRequests: Array<AuthProviderRequests>
  /** fetch aggregated fields from the table: "auth.provider_requests" */
  authProviderRequestsAggregate: AuthProviderRequests_Aggregate
  /** fetch data from the table: "auth.providers" */
  authProviders: Array<AuthProviders>
  /** fetch aggregated fields from the table: "auth.providers" */
  authProvidersAggregate: AuthProviders_Aggregate
  /** fetch data from the table: "auth.refresh_tokens" using primary key columns */
  authRefreshToken?: Maybe<AuthRefreshTokens>
  /** fetch data from the table: "auth.refresh_token_types" using primary key columns */
  authRefreshTokenType?: Maybe<AuthRefreshTokenTypes>
  /** fetch data from the table: "auth.refresh_token_types" */
  authRefreshTokenTypes: Array<AuthRefreshTokenTypes>
  /** fetch aggregated fields from the table: "auth.refresh_token_types" */
  authRefreshTokenTypesAggregate: AuthRefreshTokenTypes_Aggregate
  /** fetch data from the table: "auth.refresh_tokens" */
  authRefreshTokens: Array<AuthRefreshTokens>
  /** fetch aggregated fields from the table: "auth.refresh_tokens" */
  authRefreshTokensAggregate: AuthRefreshTokens_Aggregate
  /** fetch data from the table: "auth.roles" using primary key columns */
  authRole?: Maybe<AuthRoles>
  /** fetch data from the table: "auth.roles" */
  authRoles: Array<AuthRoles>
  /** fetch aggregated fields from the table: "auth.roles" */
  authRolesAggregate: AuthRoles_Aggregate
  /** fetch data from the table: "auth.user_providers" using primary key columns */
  authUserProvider?: Maybe<AuthUserProviders>
  /** fetch data from the table: "auth.user_providers" */
  authUserProviders: Array<AuthUserProviders>
  /** fetch aggregated fields from the table: "auth.user_providers" */
  authUserProvidersAggregate: AuthUserProviders_Aggregate
  /** fetch data from the table: "auth.user_roles" using primary key columns */
  authUserRole?: Maybe<AuthUserRoles>
  /** fetch data from the table: "auth.user_roles" */
  authUserRoles: Array<AuthUserRoles>
  /** fetch aggregated fields from the table: "auth.user_roles" */
  authUserRolesAggregate: AuthUserRoles_Aggregate
  /** fetch data from the table: "auth.user_security_keys" using primary key columns */
  authUserSecurityKey?: Maybe<AuthUserSecurityKeys>
  /** fetch data from the table: "auth.user_security_keys" */
  authUserSecurityKeys: Array<AuthUserSecurityKeys>
  /** fetch aggregated fields from the table: "auth.user_security_keys" */
  authUserSecurityKeysAggregate: AuthUserSecurityKeys_Aggregate
  /** fetch data from the table: "storage.buckets" using primary key columns */
  bucket?: Maybe<Buckets>
  /** fetch data from the table: "storage.buckets" */
  buckets: Array<Buckets>
  /** fetch aggregated fields from the table: "storage.buckets" */
  bucketsAggregate: Buckets_Aggregate
  /** fetch data from the table: "categories" */
  categories: Array<Categories>
  /** fetch aggregated fields from the table: "categories" */
  categories_aggregate: Categories_Aggregate
  /** fetch data from the table: "categories" using primary key columns */
  categories_by_pk?: Maybe<Categories>
  /** fetch data from the table: "chapters" */
  chapters: Array<Chapters>
  /** fetch aggregated fields from the table: "chapters" */
  chapters_aggregate: Chapters_Aggregate
  /** fetch data from the table: "chat_messages" */
  chat_messages: Array<Chat_Messages>
  /** fetch aggregated fields from the table: "chat_messages" */
  chat_messages_aggregate: Chat_Messages_Aggregate
  /** fetch data from the table: "chat_messages" using primary key columns */
  chat_messages_by_pk?: Maybe<Chat_Messages>
  /** fetch data from the table: "feedback_messages" */
  feedback_messages: Array<Feedback_Messages>
  /** fetch aggregated fields from the table: "feedback_messages" */
  feedback_messages_aggregate: Feedback_Messages_Aggregate
  /** fetch data from the table: "feedback_messages" using primary key columns */
  feedback_messages_by_pk?: Maybe<Feedback_Messages>
  /** fetch data from the table: "storage.files" using primary key columns */
  file?: Maybe<Files>
  /** An array relationship */
  files: Array<Files>
  /** fetch aggregated fields from the table: "storage.files" */
  filesAggregate: Files_Aggregate
  /** fetch data from the table: "matching_question_with_chapter" */
  matching_question_with_chapter: Array<Matching_Question_With_Chapter>
  /** fetch aggregated fields from the table: "matching_question_with_chapter" */
  matching_question_with_chapter_aggregate: Matching_Question_With_Chapter_Aggregate
  /** fetch data from the table: "matching_question_with_chapter" using primary key columns */
  matching_question_with_chapter_by_pk?: Maybe<Matching_Question_With_Chapter>
  /** fetch data from the table: "midwife_profiles" */
  midwife_profiles: Array<Midwife_Profiles>
  /** fetch aggregated fields from the table: "midwife_profiles" */
  midwife_profiles_aggregate: Midwife_Profiles_Aggregate
  /** fetch data from the table: "midwife_profiles" using primary key columns */
  midwife_profiles_by_pk?: Maybe<Midwife_Profiles>
  /** fetch data from the table: "preparation" */
  preparation: Array<Preparation>
  /** fetch aggregated fields from the table: "preparation" */
  preparation_aggregate: Preparation_Aggregate
  /** fetch data from the table: "preparation" using primary key columns */
  preparation_by_pk?: Maybe<Preparation>
  /** fetch data from the table: "qm_entries" */
  qm_entries: Array<Qm_Entries>
  /** fetch aggregated fields from the table: "qm_entries" */
  qm_entries_aggregate: Qm_Entries_Aggregate
  /** fetch data from the table: "qm_entries" using primary key columns */
  qm_entries_by_pk?: Maybe<Qm_Entries>
  /** fetch data from the table: "tracking_birth" */
  tracking_birth: Array<Tracking_Birth>
  /** fetch aggregated fields from the table: "tracking_birth" */
  tracking_birth_aggregate: Tracking_Birth_Aggregate
  /** fetch data from the table: "tracking_birth" using primary key columns */
  tracking_birth_by_pk?: Maybe<Tracking_Birth>
  /** fetch data from the table: "tracking_bottle" */
  tracking_bottle: Array<Tracking_Bottle>
  /** fetch aggregated fields from the table: "tracking_bottle" */
  tracking_bottle_aggregate: Tracking_Bottle_Aggregate
  /** fetch data from the table: "tracking_bottle" using primary key columns */
  tracking_bottle_by_pk?: Maybe<Tracking_Bottle>
  /** fetch data from the table: "tracking_breast" */
  tracking_breast: Array<Tracking_Breast>
  /** fetch aggregated fields from the table: "tracking_breast" */
  tracking_breast_aggregate: Tracking_Breast_Aggregate
  /** fetch data from the table: "tracking_breast" using primary key columns */
  tracking_breast_by_pk?: Maybe<Tracking_Breast>
  /** fetch data from the table: "tracking_diaper" */
  tracking_diaper: Array<Tracking_Diaper>
  /** fetch aggregated fields from the table: "tracking_diaper" */
  tracking_diaper_aggregate: Tracking_Diaper_Aggregate
  /** fetch data from the table: "tracking_diaper" using primary key columns */
  tracking_diaper_by_pk?: Maybe<Tracking_Diaper>
  /** fetch data from the table: "tracking_mental_health" */
  tracking_mental_health: Array<Tracking_Mental_Health>
  /** fetch aggregated fields from the table: "tracking_mental_health" */
  tracking_mental_health_aggregate: Tracking_Mental_Health_Aggregate
  /** fetch data from the table: "tracking_mental_health" using primary key columns */
  tracking_mental_health_by_pk?: Maybe<Tracking_Mental_Health>
  /** fetch data from the table: "tracking_nursing" */
  tracking_nursing: Array<Tracking_Nursing>
  /** fetch aggregated fields from the table: "tracking_nursing" */
  tracking_nursing_aggregate: Tracking_Nursing_Aggregate
  /** fetch data from the table: "tracking_nursing" using primary key columns */
  tracking_nursing_by_pk?: Maybe<Tracking_Nursing>
  /** fetch data from the table: "tracking_substance" */
  tracking_substance: Array<Tracking_Substance>
  /** fetch aggregated fields from the table: "tracking_substance" */
  tracking_substance_aggregate: Tracking_Substance_Aggregate
  /** fetch data from the table: "tracking_substance" using primary key columns */
  tracking_substance_by_pk?: Maybe<Tracking_Substance>
  /** fetch data from the table: "tracking_tonguetie" */
  tracking_tonguetie: Array<Tracking_Tonguetie>
  /** fetch aggregated fields from the table: "tracking_tonguetie" */
  tracking_tonguetie_aggregate: Tracking_Tonguetie_Aggregate
  /** fetch data from the table: "tracking_tonguetie" using primary key columns */
  tracking_tonguetie_by_pk?: Maybe<Tracking_Tonguetie>
  /** fetch data from the table: "tracking_weight" */
  tracking_weight: Array<Tracking_Weight>
  /** fetch aggregated fields from the table: "tracking_weight" */
  tracking_weight_aggregate: Tracking_Weight_Aggregate
  /** fetch data from the table: "tracking_weight" using primary key columns */
  tracking_weight_by_pk?: Maybe<Tracking_Weight>
  /** fetch data from the table: "auth.users" using primary key columns */
  user?: Maybe<Users>
  /** fetch data from the table: "user_profiles" */
  user_profiles: Array<User_Profiles>
  /** fetch aggregated fields from the table: "user_profiles" */
  user_profiles_aggregate: User_Profiles_Aggregate
  /** fetch data from the table: "user_profiles" using primary key columns */
  user_profiles_by_pk?: Maybe<User_Profiles>
  /** fetch data from the table: "auth.users" */
  users: Array<Users>
  /** fetch aggregated fields from the table: "auth.users" */
  usersAggregate: Users_Aggregate
  /** fetch data from the table: "storage.virus" using primary key columns */
  virus?: Maybe<Virus>
  /** fetch data from the table: "storage.virus" */
  viruses: Array<Virus>
  /** fetch aggregated fields from the table: "storage.virus" */
  virusesAggregate: Virus_Aggregate
  /** fetch data from the table: "voucher_codes" */
  voucher_codes: Array<Voucher_Codes>
  /** fetch aggregated fields from the table: "voucher_codes" */
  voucher_codes_aggregate: Voucher_Codes_Aggregate
  /** fetch data from the table: "voucher_codes" using primary key columns */
  voucher_codes_by_pk?: Maybe<Voucher_Codes>
}

export type Query_RootAppointmentsArgs = {
  distinct_on?: InputMaybe<Array<Appointments_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Appointments_Order_By>>
  where?: InputMaybe<Appointments_Bool_Exp>
}

export type Query_RootAppointments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Appointments_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Appointments_Order_By>>
  where?: InputMaybe<Appointments_Bool_Exp>
}

export type Query_RootAppointments_By_PkArgs = {
  id: Scalars['uuid']['input']
}

export type Query_RootArticle_ProgressArgs = {
  distinct_on?: InputMaybe<Array<Article_Progress_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Article_Progress_Order_By>>
  where?: InputMaybe<Article_Progress_Bool_Exp>
}

export type Query_RootArticle_Progress_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Progress_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Article_Progress_Order_By>>
  where?: InputMaybe<Article_Progress_Bool_Exp>
}

export type Query_RootArticle_Progress_By_PkArgs = {
  id: Scalars['uuid']['input']
}

export type Query_RootArticle_SectionsArgs = {
  distinct_on?: InputMaybe<Array<Article_Sections_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Article_Sections_Order_By>>
  where?: InputMaybe<Article_Sections_Bool_Exp>
}

export type Query_RootArticle_Sections_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Sections_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Article_Sections_Order_By>>
  where?: InputMaybe<Article_Sections_Bool_Exp>
}

export type Query_RootArticle_Sections_By_PkArgs = {
  id: Scalars['uuid']['input']
}

export type Query_RootArticlesArgs = {
  distinct_on?: InputMaybe<Array<Articles_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Articles_Order_By>>
  where?: InputMaybe<Articles_Bool_Exp>
}

export type Query_RootArticles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Articles_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Articles_Order_By>>
  where?: InputMaybe<Articles_Bool_Exp>
}

export type Query_RootArticles_By_PkArgs = {
  id: Scalars['uuid']['input']
}

export type Query_RootAuthOauth2AuthRequestArgs = {
  id: Scalars['uuid']['input']
}

export type Query_RootAuthOauth2AuthRequestsArgs = {
  distinct_on?: InputMaybe<Array<AuthOauth2AuthRequests_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<AuthOauth2AuthRequests_Order_By>>
  where?: InputMaybe<AuthOauth2AuthRequests_Bool_Exp>
}

export type Query_RootAuthOauth2AuthRequestsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthOauth2AuthRequests_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<AuthOauth2AuthRequests_Order_By>>
  where?: InputMaybe<AuthOauth2AuthRequests_Bool_Exp>
}

export type Query_RootAuthOauth2AuthorizationCodeArgs = {
  id: Scalars['uuid']['input']
}

export type Query_RootAuthOauth2AuthorizationCodesArgs = {
  distinct_on?: InputMaybe<Array<AuthOauth2AuthorizationCodes_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<AuthOauth2AuthorizationCodes_Order_By>>
  where?: InputMaybe<AuthOauth2AuthorizationCodes_Bool_Exp>
}

export type Query_RootAuthOauth2AuthorizationCodesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthOauth2AuthorizationCodes_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<AuthOauth2AuthorizationCodes_Order_By>>
  where?: InputMaybe<AuthOauth2AuthorizationCodes_Bool_Exp>
}

export type Query_RootAuthOauth2ClientArgs = {
  clientId: Scalars['String']['input']
}

export type Query_RootAuthOauth2ClientsArgs = {
  distinct_on?: InputMaybe<Array<AuthOauth2Clients_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<AuthOauth2Clients_Order_By>>
  where?: InputMaybe<AuthOauth2Clients_Bool_Exp>
}

export type Query_RootAuthOauth2ClientsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthOauth2Clients_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<AuthOauth2Clients_Order_By>>
  where?: InputMaybe<AuthOauth2Clients_Bool_Exp>
}

export type Query_RootAuthOauth2RefreshTokenArgs = {
  id: Scalars['uuid']['input']
}

export type Query_RootAuthOauth2RefreshTokensArgs = {
  distinct_on?: InputMaybe<Array<AuthOauth2RefreshTokens_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<AuthOauth2RefreshTokens_Order_By>>
  where?: InputMaybe<AuthOauth2RefreshTokens_Bool_Exp>
}

export type Query_RootAuthOauth2RefreshTokensAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthOauth2RefreshTokens_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<AuthOauth2RefreshTokens_Order_By>>
  where?: InputMaybe<AuthOauth2RefreshTokens_Bool_Exp>
}

export type Query_RootAuthProviderArgs = {
  id: Scalars['String']['input']
}

export type Query_RootAuthProviderRequestArgs = {
  id: Scalars['uuid']['input']
}

export type Query_RootAuthProviderRequestsArgs = {
  distinct_on?: InputMaybe<Array<AuthProviderRequests_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<AuthProviderRequests_Order_By>>
  where?: InputMaybe<AuthProviderRequests_Bool_Exp>
}

export type Query_RootAuthProviderRequestsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthProviderRequests_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<AuthProviderRequests_Order_By>>
  where?: InputMaybe<AuthProviderRequests_Bool_Exp>
}

export type Query_RootAuthProvidersArgs = {
  distinct_on?: InputMaybe<Array<AuthProviders_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<AuthProviders_Order_By>>
  where?: InputMaybe<AuthProviders_Bool_Exp>
}

export type Query_RootAuthProvidersAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthProviders_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<AuthProviders_Order_By>>
  where?: InputMaybe<AuthProviders_Bool_Exp>
}

export type Query_RootAuthRefreshTokenArgs = {
  id: Scalars['uuid']['input']
}

export type Query_RootAuthRefreshTokenTypeArgs = {
  value: Scalars['String']['input']
}

export type Query_RootAuthRefreshTokenTypesArgs = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokenTypes_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<AuthRefreshTokenTypes_Order_By>>
  where?: InputMaybe<AuthRefreshTokenTypes_Bool_Exp>
}

export type Query_RootAuthRefreshTokenTypesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokenTypes_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<AuthRefreshTokenTypes_Order_By>>
  where?: InputMaybe<AuthRefreshTokenTypes_Bool_Exp>
}

export type Query_RootAuthRefreshTokensArgs = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokens_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<AuthRefreshTokens_Order_By>>
  where?: InputMaybe<AuthRefreshTokens_Bool_Exp>
}

export type Query_RootAuthRefreshTokensAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokens_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<AuthRefreshTokens_Order_By>>
  where?: InputMaybe<AuthRefreshTokens_Bool_Exp>
}

export type Query_RootAuthRoleArgs = {
  role: Scalars['String']['input']
}

export type Query_RootAuthRolesArgs = {
  distinct_on?: InputMaybe<Array<AuthRoles_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<AuthRoles_Order_By>>
  where?: InputMaybe<AuthRoles_Bool_Exp>
}

export type Query_RootAuthRolesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthRoles_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<AuthRoles_Order_By>>
  where?: InputMaybe<AuthRoles_Bool_Exp>
}

export type Query_RootAuthUserProviderArgs = {
  id: Scalars['uuid']['input']
}

export type Query_RootAuthUserProvidersArgs = {
  distinct_on?: InputMaybe<Array<AuthUserProviders_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<AuthUserProviders_Order_By>>
  where?: InputMaybe<AuthUserProviders_Bool_Exp>
}

export type Query_RootAuthUserProvidersAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthUserProviders_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<AuthUserProviders_Order_By>>
  where?: InputMaybe<AuthUserProviders_Bool_Exp>
}

export type Query_RootAuthUserRoleArgs = {
  id: Scalars['uuid']['input']
}

export type Query_RootAuthUserRolesArgs = {
  distinct_on?: InputMaybe<Array<AuthUserRoles_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<AuthUserRoles_Order_By>>
  where?: InputMaybe<AuthUserRoles_Bool_Exp>
}

export type Query_RootAuthUserRolesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthUserRoles_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<AuthUserRoles_Order_By>>
  where?: InputMaybe<AuthUserRoles_Bool_Exp>
}

export type Query_RootAuthUserSecurityKeyArgs = {
  id: Scalars['uuid']['input']
}

export type Query_RootAuthUserSecurityKeysArgs = {
  distinct_on?: InputMaybe<Array<AuthUserSecurityKeys_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<AuthUserSecurityKeys_Order_By>>
  where?: InputMaybe<AuthUserSecurityKeys_Bool_Exp>
}

export type Query_RootAuthUserSecurityKeysAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthUserSecurityKeys_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<AuthUserSecurityKeys_Order_By>>
  where?: InputMaybe<AuthUserSecurityKeys_Bool_Exp>
}

export type Query_RootBucketArgs = {
  id: Scalars['String']['input']
}

export type Query_RootBucketsArgs = {
  distinct_on?: InputMaybe<Array<Buckets_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Buckets_Order_By>>
  where?: InputMaybe<Buckets_Bool_Exp>
}

export type Query_RootBucketsAggregateArgs = {
  distinct_on?: InputMaybe<Array<Buckets_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Buckets_Order_By>>
  where?: InputMaybe<Buckets_Bool_Exp>
}

export type Query_RootCategoriesArgs = {
  distinct_on?: InputMaybe<Array<Categories_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Categories_Order_By>>
  where?: InputMaybe<Categories_Bool_Exp>
}

export type Query_RootCategories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Categories_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Categories_Order_By>>
  where?: InputMaybe<Categories_Bool_Exp>
}

export type Query_RootCategories_By_PkArgs = {
  slug: Scalars['String']['input']
}

export type Query_RootChaptersArgs = {
  distinct_on?: InputMaybe<Array<Chapters_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Chapters_Order_By>>
  where?: InputMaybe<Chapters_Bool_Exp>
}

export type Query_RootChapters_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Chapters_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Chapters_Order_By>>
  where?: InputMaybe<Chapters_Bool_Exp>
}

export type Query_RootChat_MessagesArgs = {
  distinct_on?: InputMaybe<Array<Chat_Messages_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Chat_Messages_Order_By>>
  where?: InputMaybe<Chat_Messages_Bool_Exp>
}

export type Query_RootChat_Messages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Chat_Messages_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Chat_Messages_Order_By>>
  where?: InputMaybe<Chat_Messages_Bool_Exp>
}

export type Query_RootChat_Messages_By_PkArgs = {
  id: Scalars['uuid']['input']
}

export type Query_RootFeedback_MessagesArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Messages_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Feedback_Messages_Order_By>>
  where?: InputMaybe<Feedback_Messages_Bool_Exp>
}

export type Query_RootFeedback_Messages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Messages_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Feedback_Messages_Order_By>>
  where?: InputMaybe<Feedback_Messages_Bool_Exp>
}

export type Query_RootFeedback_Messages_By_PkArgs = {
  id: Scalars['uuid']['input']
}

export type Query_RootFileArgs = {
  id: Scalars['uuid']['input']
}

export type Query_RootFilesArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Files_Order_By>>
  where?: InputMaybe<Files_Bool_Exp>
}

export type Query_RootFilesAggregateArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Files_Order_By>>
  where?: InputMaybe<Files_Bool_Exp>
}

export type Query_RootMatching_Question_With_ChapterArgs = {
  distinct_on?: InputMaybe<Array<Matching_Question_With_Chapter_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Matching_Question_With_Chapter_Order_By>>
  where?: InputMaybe<Matching_Question_With_Chapter_Bool_Exp>
}

export type Query_RootMatching_Question_With_Chapter_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Matching_Question_With_Chapter_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Matching_Question_With_Chapter_Order_By>>
  where?: InputMaybe<Matching_Question_With_Chapter_Bool_Exp>
}

export type Query_RootMatching_Question_With_Chapter_By_PkArgs = {
  answer_key: Scalars['String']['input']
}

export type Query_RootMidwife_ProfilesArgs = {
  distinct_on?: InputMaybe<Array<Midwife_Profiles_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Midwife_Profiles_Order_By>>
  where?: InputMaybe<Midwife_Profiles_Bool_Exp>
}

export type Query_RootMidwife_Profiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Midwife_Profiles_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Midwife_Profiles_Order_By>>
  where?: InputMaybe<Midwife_Profiles_Bool_Exp>
}

export type Query_RootMidwife_Profiles_By_PkArgs = {
  id: Scalars['uuid']['input']
}

export type Query_RootPreparationArgs = {
  distinct_on?: InputMaybe<Array<Preparation_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Preparation_Order_By>>
  where?: InputMaybe<Preparation_Bool_Exp>
}

export type Query_RootPreparation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Preparation_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Preparation_Order_By>>
  where?: InputMaybe<Preparation_Bool_Exp>
}

export type Query_RootPreparation_By_PkArgs = {
  id: Scalars['uuid']['input']
}

export type Query_RootQm_EntriesArgs = {
  distinct_on?: InputMaybe<Array<Qm_Entries_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Qm_Entries_Order_By>>
  where?: InputMaybe<Qm_Entries_Bool_Exp>
}

export type Query_RootQm_Entries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Qm_Entries_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Qm_Entries_Order_By>>
  where?: InputMaybe<Qm_Entries_Bool_Exp>
}

export type Query_RootQm_Entries_By_PkArgs = {
  id: Scalars['uuid']['input']
}

export type Query_RootTracking_BirthArgs = {
  distinct_on?: InputMaybe<Array<Tracking_Birth_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Tracking_Birth_Order_By>>
  where?: InputMaybe<Tracking_Birth_Bool_Exp>
}

export type Query_RootTracking_Birth_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tracking_Birth_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Tracking_Birth_Order_By>>
  where?: InputMaybe<Tracking_Birth_Bool_Exp>
}

export type Query_RootTracking_Birth_By_PkArgs = {
  id: Scalars['uuid']['input']
}

export type Query_RootTracking_BottleArgs = {
  distinct_on?: InputMaybe<Array<Tracking_Bottle_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Tracking_Bottle_Order_By>>
  where?: InputMaybe<Tracking_Bottle_Bool_Exp>
}

export type Query_RootTracking_Bottle_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tracking_Bottle_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Tracking_Bottle_Order_By>>
  where?: InputMaybe<Tracking_Bottle_Bool_Exp>
}

export type Query_RootTracking_Bottle_By_PkArgs = {
  id: Scalars['uuid']['input']
}

export type Query_RootTracking_BreastArgs = {
  distinct_on?: InputMaybe<Array<Tracking_Breast_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Tracking_Breast_Order_By>>
  where?: InputMaybe<Tracking_Breast_Bool_Exp>
}

export type Query_RootTracking_Breast_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tracking_Breast_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Tracking_Breast_Order_By>>
  where?: InputMaybe<Tracking_Breast_Bool_Exp>
}

export type Query_RootTracking_Breast_By_PkArgs = {
  id: Scalars['uuid']['input']
}

export type Query_RootTracking_DiaperArgs = {
  distinct_on?: InputMaybe<Array<Tracking_Diaper_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Tracking_Diaper_Order_By>>
  where?: InputMaybe<Tracking_Diaper_Bool_Exp>
}

export type Query_RootTracking_Diaper_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tracking_Diaper_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Tracking_Diaper_Order_By>>
  where?: InputMaybe<Tracking_Diaper_Bool_Exp>
}

export type Query_RootTracking_Diaper_By_PkArgs = {
  id: Scalars['uuid']['input']
}

export type Query_RootTracking_Mental_HealthArgs = {
  distinct_on?: InputMaybe<Array<Tracking_Mental_Health_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Tracking_Mental_Health_Order_By>>
  where?: InputMaybe<Tracking_Mental_Health_Bool_Exp>
}

export type Query_RootTracking_Mental_Health_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tracking_Mental_Health_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Tracking_Mental_Health_Order_By>>
  where?: InputMaybe<Tracking_Mental_Health_Bool_Exp>
}

export type Query_RootTracking_Mental_Health_By_PkArgs = {
  id: Scalars['uuid']['input']
}

export type Query_RootTracking_NursingArgs = {
  distinct_on?: InputMaybe<Array<Tracking_Nursing_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Tracking_Nursing_Order_By>>
  where?: InputMaybe<Tracking_Nursing_Bool_Exp>
}

export type Query_RootTracking_Nursing_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tracking_Nursing_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Tracking_Nursing_Order_By>>
  where?: InputMaybe<Tracking_Nursing_Bool_Exp>
}

export type Query_RootTracking_Nursing_By_PkArgs = {
  id: Scalars['uuid']['input']
}

export type Query_RootTracking_SubstanceArgs = {
  distinct_on?: InputMaybe<Array<Tracking_Substance_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Tracking_Substance_Order_By>>
  where?: InputMaybe<Tracking_Substance_Bool_Exp>
}

export type Query_RootTracking_Substance_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tracking_Substance_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Tracking_Substance_Order_By>>
  where?: InputMaybe<Tracking_Substance_Bool_Exp>
}

export type Query_RootTracking_Substance_By_PkArgs = {
  id: Scalars['uuid']['input']
}

export type Query_RootTracking_TonguetieArgs = {
  distinct_on?: InputMaybe<Array<Tracking_Tonguetie_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Tracking_Tonguetie_Order_By>>
  where?: InputMaybe<Tracking_Tonguetie_Bool_Exp>
}

export type Query_RootTracking_Tonguetie_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tracking_Tonguetie_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Tracking_Tonguetie_Order_By>>
  where?: InputMaybe<Tracking_Tonguetie_Bool_Exp>
}

export type Query_RootTracking_Tonguetie_By_PkArgs = {
  id: Scalars['uuid']['input']
}

export type Query_RootTracking_WeightArgs = {
  distinct_on?: InputMaybe<Array<Tracking_Weight_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Tracking_Weight_Order_By>>
  where?: InputMaybe<Tracking_Weight_Bool_Exp>
}

export type Query_RootTracking_Weight_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tracking_Weight_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Tracking_Weight_Order_By>>
  where?: InputMaybe<Tracking_Weight_Bool_Exp>
}

export type Query_RootTracking_Weight_By_PkArgs = {
  id: Scalars['uuid']['input']
}

export type Query_RootUserArgs = {
  id: Scalars['uuid']['input']
}

export type Query_RootUser_ProfilesArgs = {
  distinct_on?: InputMaybe<Array<User_Profiles_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<User_Profiles_Order_By>>
  where?: InputMaybe<User_Profiles_Bool_Exp>
}

export type Query_RootUser_Profiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Profiles_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<User_Profiles_Order_By>>
  where?: InputMaybe<User_Profiles_Bool_Exp>
}

export type Query_RootUser_Profiles_By_PkArgs = {
  id: Scalars['uuid']['input']
}

export type Query_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Users_Order_By>>
  where?: InputMaybe<Users_Bool_Exp>
}

export type Query_RootUsersAggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Users_Order_By>>
  where?: InputMaybe<Users_Bool_Exp>
}

export type Query_RootVirusArgs = {
  id: Scalars['uuid']['input']
}

export type Query_RootVirusesArgs = {
  distinct_on?: InputMaybe<Array<Virus_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Virus_Order_By>>
  where?: InputMaybe<Virus_Bool_Exp>
}

export type Query_RootVirusesAggregateArgs = {
  distinct_on?: InputMaybe<Array<Virus_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Virus_Order_By>>
  where?: InputMaybe<Virus_Bool_Exp>
}

export type Query_RootVoucher_CodesArgs = {
  distinct_on?: InputMaybe<Array<Voucher_Codes_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Voucher_Codes_Order_By>>
  where?: InputMaybe<Voucher_Codes_Bool_Exp>
}

export type Query_RootVoucher_Codes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Voucher_Codes_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Voucher_Codes_Order_By>>
  where?: InputMaybe<Voucher_Codes_Bool_Exp>
}

export type Query_RootVoucher_Codes_By_PkArgs = {
  id: Scalars['uuid']['input']
}

export type Subscription_Root = {
  __typename?: 'subscription_root'
  /** fetch data from the table: "appointments" */
  appointments: Array<Appointments>
  /** fetch aggregated fields from the table: "appointments" */
  appointments_aggregate: Appointments_Aggregate
  /** fetch data from the table: "appointments" using primary key columns */
  appointments_by_pk?: Maybe<Appointments>
  /** fetch data from the table in a streaming manner: "appointments" */
  appointments_stream: Array<Appointments>
  /** fetch data from the table: "article_progress" */
  article_progress: Array<Article_Progress>
  /** fetch aggregated fields from the table: "article_progress" */
  article_progress_aggregate: Article_Progress_Aggregate
  /** fetch data from the table: "article_progress" using primary key columns */
  article_progress_by_pk?: Maybe<Article_Progress>
  /** fetch data from the table in a streaming manner: "article_progress" */
  article_progress_stream: Array<Article_Progress>
  /** fetch data from the table: "article_sections" */
  article_sections: Array<Article_Sections>
  /** fetch aggregated fields from the table: "article_sections" */
  article_sections_aggregate: Article_Sections_Aggregate
  /** fetch data from the table: "article_sections" using primary key columns */
  article_sections_by_pk?: Maybe<Article_Sections>
  /** fetch data from the table in a streaming manner: "article_sections" */
  article_sections_stream: Array<Article_Sections>
  /** An array relationship */
  articles: Array<Articles>
  /** An aggregate relationship */
  articles_aggregate: Articles_Aggregate
  /** fetch data from the table: "articles" using primary key columns */
  articles_by_pk?: Maybe<Articles>
  /** fetch data from the table in a streaming manner: "articles" */
  articles_stream: Array<Articles>
  /** fetch data from the table: "auth.oauth2_auth_requests" using primary key columns */
  authOauth2AuthRequest?: Maybe<AuthOauth2AuthRequests>
  /** fetch data from the table: "auth.oauth2_auth_requests" */
  authOauth2AuthRequests: Array<AuthOauth2AuthRequests>
  /** fetch aggregated fields from the table: "auth.oauth2_auth_requests" */
  authOauth2AuthRequestsAggregate: AuthOauth2AuthRequests_Aggregate
  /** fetch data from the table in a streaming manner: "auth.oauth2_auth_requests" */
  authOauth2AuthRequests_stream: Array<AuthOauth2AuthRequests>
  /** fetch data from the table: "auth.oauth2_authorization_codes" using primary key columns */
  authOauth2AuthorizationCode?: Maybe<AuthOauth2AuthorizationCodes>
  /** fetch data from the table: "auth.oauth2_authorization_codes" */
  authOauth2AuthorizationCodes: Array<AuthOauth2AuthorizationCodes>
  /** fetch aggregated fields from the table: "auth.oauth2_authorization_codes" */
  authOauth2AuthorizationCodesAggregate: AuthOauth2AuthorizationCodes_Aggregate
  /** fetch data from the table in a streaming manner: "auth.oauth2_authorization_codes" */
  authOauth2AuthorizationCodes_stream: Array<AuthOauth2AuthorizationCodes>
  /** fetch data from the table: "auth.oauth2_clients" using primary key columns */
  authOauth2Client?: Maybe<AuthOauth2Clients>
  /** fetch data from the table: "auth.oauth2_clients" */
  authOauth2Clients: Array<AuthOauth2Clients>
  /** fetch aggregated fields from the table: "auth.oauth2_clients" */
  authOauth2ClientsAggregate: AuthOauth2Clients_Aggregate
  /** fetch data from the table in a streaming manner: "auth.oauth2_clients" */
  authOauth2Clients_stream: Array<AuthOauth2Clients>
  /** fetch data from the table: "auth.oauth2_refresh_tokens" using primary key columns */
  authOauth2RefreshToken?: Maybe<AuthOauth2RefreshTokens>
  /** fetch data from the table: "auth.oauth2_refresh_tokens" */
  authOauth2RefreshTokens: Array<AuthOauth2RefreshTokens>
  /** fetch aggregated fields from the table: "auth.oauth2_refresh_tokens" */
  authOauth2RefreshTokensAggregate: AuthOauth2RefreshTokens_Aggregate
  /** fetch data from the table in a streaming manner: "auth.oauth2_refresh_tokens" */
  authOauth2RefreshTokens_stream: Array<AuthOauth2RefreshTokens>
  /** fetch data from the table: "auth.providers" using primary key columns */
  authProvider?: Maybe<AuthProviders>
  /** fetch data from the table: "auth.provider_requests" using primary key columns */
  authProviderRequest?: Maybe<AuthProviderRequests>
  /** fetch data from the table: "auth.provider_requests" */
  authProviderRequests: Array<AuthProviderRequests>
  /** fetch aggregated fields from the table: "auth.provider_requests" */
  authProviderRequestsAggregate: AuthProviderRequests_Aggregate
  /** fetch data from the table in a streaming manner: "auth.provider_requests" */
  authProviderRequests_stream: Array<AuthProviderRequests>
  /** fetch data from the table: "auth.providers" */
  authProviders: Array<AuthProviders>
  /** fetch aggregated fields from the table: "auth.providers" */
  authProvidersAggregate: AuthProviders_Aggregate
  /** fetch data from the table in a streaming manner: "auth.providers" */
  authProviders_stream: Array<AuthProviders>
  /** fetch data from the table: "auth.refresh_tokens" using primary key columns */
  authRefreshToken?: Maybe<AuthRefreshTokens>
  /** fetch data from the table: "auth.refresh_token_types" using primary key columns */
  authRefreshTokenType?: Maybe<AuthRefreshTokenTypes>
  /** fetch data from the table: "auth.refresh_token_types" */
  authRefreshTokenTypes: Array<AuthRefreshTokenTypes>
  /** fetch aggregated fields from the table: "auth.refresh_token_types" */
  authRefreshTokenTypesAggregate: AuthRefreshTokenTypes_Aggregate
  /** fetch data from the table in a streaming manner: "auth.refresh_token_types" */
  authRefreshTokenTypes_stream: Array<AuthRefreshTokenTypes>
  /** fetch data from the table: "auth.refresh_tokens" */
  authRefreshTokens: Array<AuthRefreshTokens>
  /** fetch aggregated fields from the table: "auth.refresh_tokens" */
  authRefreshTokensAggregate: AuthRefreshTokens_Aggregate
  /** fetch data from the table in a streaming manner: "auth.refresh_tokens" */
  authRefreshTokens_stream: Array<AuthRefreshTokens>
  /** fetch data from the table: "auth.roles" using primary key columns */
  authRole?: Maybe<AuthRoles>
  /** fetch data from the table: "auth.roles" */
  authRoles: Array<AuthRoles>
  /** fetch aggregated fields from the table: "auth.roles" */
  authRolesAggregate: AuthRoles_Aggregate
  /** fetch data from the table in a streaming manner: "auth.roles" */
  authRoles_stream: Array<AuthRoles>
  /** fetch data from the table: "auth.user_providers" using primary key columns */
  authUserProvider?: Maybe<AuthUserProviders>
  /** fetch data from the table: "auth.user_providers" */
  authUserProviders: Array<AuthUserProviders>
  /** fetch aggregated fields from the table: "auth.user_providers" */
  authUserProvidersAggregate: AuthUserProviders_Aggregate
  /** fetch data from the table in a streaming manner: "auth.user_providers" */
  authUserProviders_stream: Array<AuthUserProviders>
  /** fetch data from the table: "auth.user_roles" using primary key columns */
  authUserRole?: Maybe<AuthUserRoles>
  /** fetch data from the table: "auth.user_roles" */
  authUserRoles: Array<AuthUserRoles>
  /** fetch aggregated fields from the table: "auth.user_roles" */
  authUserRolesAggregate: AuthUserRoles_Aggregate
  /** fetch data from the table in a streaming manner: "auth.user_roles" */
  authUserRoles_stream: Array<AuthUserRoles>
  /** fetch data from the table: "auth.user_security_keys" using primary key columns */
  authUserSecurityKey?: Maybe<AuthUserSecurityKeys>
  /** fetch data from the table: "auth.user_security_keys" */
  authUserSecurityKeys: Array<AuthUserSecurityKeys>
  /** fetch aggregated fields from the table: "auth.user_security_keys" */
  authUserSecurityKeysAggregate: AuthUserSecurityKeys_Aggregate
  /** fetch data from the table in a streaming manner: "auth.user_security_keys" */
  authUserSecurityKeys_stream: Array<AuthUserSecurityKeys>
  /** fetch data from the table: "storage.buckets" using primary key columns */
  bucket?: Maybe<Buckets>
  /** fetch data from the table: "storage.buckets" */
  buckets: Array<Buckets>
  /** fetch aggregated fields from the table: "storage.buckets" */
  bucketsAggregate: Buckets_Aggregate
  /** fetch data from the table in a streaming manner: "storage.buckets" */
  buckets_stream: Array<Buckets>
  /** fetch data from the table: "categories" */
  categories: Array<Categories>
  /** fetch aggregated fields from the table: "categories" */
  categories_aggregate: Categories_Aggregate
  /** fetch data from the table: "categories" using primary key columns */
  categories_by_pk?: Maybe<Categories>
  /** fetch data from the table in a streaming manner: "categories" */
  categories_stream: Array<Categories>
  /** fetch data from the table: "chapters" */
  chapters: Array<Chapters>
  /** fetch aggregated fields from the table: "chapters" */
  chapters_aggregate: Chapters_Aggregate
  /** fetch data from the table in a streaming manner: "chapters" */
  chapters_stream: Array<Chapters>
  /** fetch data from the table: "chat_messages" */
  chat_messages: Array<Chat_Messages>
  /** fetch aggregated fields from the table: "chat_messages" */
  chat_messages_aggregate: Chat_Messages_Aggregate
  /** fetch data from the table: "chat_messages" using primary key columns */
  chat_messages_by_pk?: Maybe<Chat_Messages>
  /** fetch data from the table in a streaming manner: "chat_messages" */
  chat_messages_stream: Array<Chat_Messages>
  /** fetch data from the table: "feedback_messages" */
  feedback_messages: Array<Feedback_Messages>
  /** fetch aggregated fields from the table: "feedback_messages" */
  feedback_messages_aggregate: Feedback_Messages_Aggregate
  /** fetch data from the table: "feedback_messages" using primary key columns */
  feedback_messages_by_pk?: Maybe<Feedback_Messages>
  /** fetch data from the table in a streaming manner: "feedback_messages" */
  feedback_messages_stream: Array<Feedback_Messages>
  /** fetch data from the table: "storage.files" using primary key columns */
  file?: Maybe<Files>
  /** An array relationship */
  files: Array<Files>
  /** fetch aggregated fields from the table: "storage.files" */
  filesAggregate: Files_Aggregate
  /** fetch data from the table in a streaming manner: "storage.files" */
  files_stream: Array<Files>
  /** fetch data from the table: "matching_question_with_chapter" */
  matching_question_with_chapter: Array<Matching_Question_With_Chapter>
  /** fetch aggregated fields from the table: "matching_question_with_chapter" */
  matching_question_with_chapter_aggregate: Matching_Question_With_Chapter_Aggregate
  /** fetch data from the table: "matching_question_with_chapter" using primary key columns */
  matching_question_with_chapter_by_pk?: Maybe<Matching_Question_With_Chapter>
  /** fetch data from the table in a streaming manner: "matching_question_with_chapter" */
  matching_question_with_chapter_stream: Array<Matching_Question_With_Chapter>
  /** fetch data from the table: "midwife_profiles" */
  midwife_profiles: Array<Midwife_Profiles>
  /** fetch aggregated fields from the table: "midwife_profiles" */
  midwife_profiles_aggregate: Midwife_Profiles_Aggregate
  /** fetch data from the table: "midwife_profiles" using primary key columns */
  midwife_profiles_by_pk?: Maybe<Midwife_Profiles>
  /** fetch data from the table in a streaming manner: "midwife_profiles" */
  midwife_profiles_stream: Array<Midwife_Profiles>
  /** fetch data from the table: "preparation" */
  preparation: Array<Preparation>
  /** fetch aggregated fields from the table: "preparation" */
  preparation_aggregate: Preparation_Aggregate
  /** fetch data from the table: "preparation" using primary key columns */
  preparation_by_pk?: Maybe<Preparation>
  /** fetch data from the table in a streaming manner: "preparation" */
  preparation_stream: Array<Preparation>
  /** fetch data from the table: "qm_entries" */
  qm_entries: Array<Qm_Entries>
  /** fetch aggregated fields from the table: "qm_entries" */
  qm_entries_aggregate: Qm_Entries_Aggregate
  /** fetch data from the table: "qm_entries" using primary key columns */
  qm_entries_by_pk?: Maybe<Qm_Entries>
  /** fetch data from the table in a streaming manner: "qm_entries" */
  qm_entries_stream: Array<Qm_Entries>
  /** fetch data from the table: "tracking_birth" */
  tracking_birth: Array<Tracking_Birth>
  /** fetch aggregated fields from the table: "tracking_birth" */
  tracking_birth_aggregate: Tracking_Birth_Aggregate
  /** fetch data from the table: "tracking_birth" using primary key columns */
  tracking_birth_by_pk?: Maybe<Tracking_Birth>
  /** fetch data from the table in a streaming manner: "tracking_birth" */
  tracking_birth_stream: Array<Tracking_Birth>
  /** fetch data from the table: "tracking_bottle" */
  tracking_bottle: Array<Tracking_Bottle>
  /** fetch aggregated fields from the table: "tracking_bottle" */
  tracking_bottle_aggregate: Tracking_Bottle_Aggregate
  /** fetch data from the table: "tracking_bottle" using primary key columns */
  tracking_bottle_by_pk?: Maybe<Tracking_Bottle>
  /** fetch data from the table in a streaming manner: "tracking_bottle" */
  tracking_bottle_stream: Array<Tracking_Bottle>
  /** fetch data from the table: "tracking_breast" */
  tracking_breast: Array<Tracking_Breast>
  /** fetch aggregated fields from the table: "tracking_breast" */
  tracking_breast_aggregate: Tracking_Breast_Aggregate
  /** fetch data from the table: "tracking_breast" using primary key columns */
  tracking_breast_by_pk?: Maybe<Tracking_Breast>
  /** fetch data from the table in a streaming manner: "tracking_breast" */
  tracking_breast_stream: Array<Tracking_Breast>
  /** fetch data from the table: "tracking_diaper" */
  tracking_diaper: Array<Tracking_Diaper>
  /** fetch aggregated fields from the table: "tracking_diaper" */
  tracking_diaper_aggregate: Tracking_Diaper_Aggregate
  /** fetch data from the table: "tracking_diaper" using primary key columns */
  tracking_diaper_by_pk?: Maybe<Tracking_Diaper>
  /** fetch data from the table in a streaming manner: "tracking_diaper" */
  tracking_diaper_stream: Array<Tracking_Diaper>
  /** fetch data from the table: "tracking_mental_health" */
  tracking_mental_health: Array<Tracking_Mental_Health>
  /** fetch aggregated fields from the table: "tracking_mental_health" */
  tracking_mental_health_aggregate: Tracking_Mental_Health_Aggregate
  /** fetch data from the table: "tracking_mental_health" using primary key columns */
  tracking_mental_health_by_pk?: Maybe<Tracking_Mental_Health>
  /** fetch data from the table in a streaming manner: "tracking_mental_health" */
  tracking_mental_health_stream: Array<Tracking_Mental_Health>
  /** fetch data from the table: "tracking_nursing" */
  tracking_nursing: Array<Tracking_Nursing>
  /** fetch aggregated fields from the table: "tracking_nursing" */
  tracking_nursing_aggregate: Tracking_Nursing_Aggregate
  /** fetch data from the table: "tracking_nursing" using primary key columns */
  tracking_nursing_by_pk?: Maybe<Tracking_Nursing>
  /** fetch data from the table in a streaming manner: "tracking_nursing" */
  tracking_nursing_stream: Array<Tracking_Nursing>
  /** fetch data from the table: "tracking_substance" */
  tracking_substance: Array<Tracking_Substance>
  /** fetch aggregated fields from the table: "tracking_substance" */
  tracking_substance_aggregate: Tracking_Substance_Aggregate
  /** fetch data from the table: "tracking_substance" using primary key columns */
  tracking_substance_by_pk?: Maybe<Tracking_Substance>
  /** fetch data from the table in a streaming manner: "tracking_substance" */
  tracking_substance_stream: Array<Tracking_Substance>
  /** fetch data from the table: "tracking_tonguetie" */
  tracking_tonguetie: Array<Tracking_Tonguetie>
  /** fetch aggregated fields from the table: "tracking_tonguetie" */
  tracking_tonguetie_aggregate: Tracking_Tonguetie_Aggregate
  /** fetch data from the table: "tracking_tonguetie" using primary key columns */
  tracking_tonguetie_by_pk?: Maybe<Tracking_Tonguetie>
  /** fetch data from the table in a streaming manner: "tracking_tonguetie" */
  tracking_tonguetie_stream: Array<Tracking_Tonguetie>
  /** fetch data from the table: "tracking_weight" */
  tracking_weight: Array<Tracking_Weight>
  /** fetch aggregated fields from the table: "tracking_weight" */
  tracking_weight_aggregate: Tracking_Weight_Aggregate
  /** fetch data from the table: "tracking_weight" using primary key columns */
  tracking_weight_by_pk?: Maybe<Tracking_Weight>
  /** fetch data from the table in a streaming manner: "tracking_weight" */
  tracking_weight_stream: Array<Tracking_Weight>
  /** fetch data from the table: "auth.users" using primary key columns */
  user?: Maybe<Users>
  /** fetch data from the table: "user_profiles" */
  user_profiles: Array<User_Profiles>
  /** fetch aggregated fields from the table: "user_profiles" */
  user_profiles_aggregate: User_Profiles_Aggregate
  /** fetch data from the table: "user_profiles" using primary key columns */
  user_profiles_by_pk?: Maybe<User_Profiles>
  /** fetch data from the table in a streaming manner: "user_profiles" */
  user_profiles_stream: Array<User_Profiles>
  /** fetch data from the table: "auth.users" */
  users: Array<Users>
  /** fetch aggregated fields from the table: "auth.users" */
  usersAggregate: Users_Aggregate
  /** fetch data from the table in a streaming manner: "auth.users" */
  users_stream: Array<Users>
  /** fetch data from the table: "storage.virus" using primary key columns */
  virus?: Maybe<Virus>
  /** fetch data from the table in a streaming manner: "storage.virus" */
  virus_stream: Array<Virus>
  /** fetch data from the table: "storage.virus" */
  viruses: Array<Virus>
  /** fetch aggregated fields from the table: "storage.virus" */
  virusesAggregate: Virus_Aggregate
  /** fetch data from the table: "voucher_codes" */
  voucher_codes: Array<Voucher_Codes>
  /** fetch aggregated fields from the table: "voucher_codes" */
  voucher_codes_aggregate: Voucher_Codes_Aggregate
  /** fetch data from the table: "voucher_codes" using primary key columns */
  voucher_codes_by_pk?: Maybe<Voucher_Codes>
  /** fetch data from the table in a streaming manner: "voucher_codes" */
  voucher_codes_stream: Array<Voucher_Codes>
}

export type Subscription_RootAppointmentsArgs = {
  distinct_on?: InputMaybe<Array<Appointments_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Appointments_Order_By>>
  where?: InputMaybe<Appointments_Bool_Exp>
}

export type Subscription_RootAppointments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Appointments_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Appointments_Order_By>>
  where?: InputMaybe<Appointments_Bool_Exp>
}

export type Subscription_RootAppointments_By_PkArgs = {
  id: Scalars['uuid']['input']
}

export type Subscription_RootAppointments_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Appointments_Stream_Cursor_Input>>
  where?: InputMaybe<Appointments_Bool_Exp>
}

export type Subscription_RootArticle_ProgressArgs = {
  distinct_on?: InputMaybe<Array<Article_Progress_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Article_Progress_Order_By>>
  where?: InputMaybe<Article_Progress_Bool_Exp>
}

export type Subscription_RootArticle_Progress_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Progress_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Article_Progress_Order_By>>
  where?: InputMaybe<Article_Progress_Bool_Exp>
}

export type Subscription_RootArticle_Progress_By_PkArgs = {
  id: Scalars['uuid']['input']
}

export type Subscription_RootArticle_Progress_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Article_Progress_Stream_Cursor_Input>>
  where?: InputMaybe<Article_Progress_Bool_Exp>
}

export type Subscription_RootArticle_SectionsArgs = {
  distinct_on?: InputMaybe<Array<Article_Sections_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Article_Sections_Order_By>>
  where?: InputMaybe<Article_Sections_Bool_Exp>
}

export type Subscription_RootArticle_Sections_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Article_Sections_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Article_Sections_Order_By>>
  where?: InputMaybe<Article_Sections_Bool_Exp>
}

export type Subscription_RootArticle_Sections_By_PkArgs = {
  id: Scalars['uuid']['input']
}

export type Subscription_RootArticle_Sections_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Article_Sections_Stream_Cursor_Input>>
  where?: InputMaybe<Article_Sections_Bool_Exp>
}

export type Subscription_RootArticlesArgs = {
  distinct_on?: InputMaybe<Array<Articles_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Articles_Order_By>>
  where?: InputMaybe<Articles_Bool_Exp>
}

export type Subscription_RootArticles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Articles_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Articles_Order_By>>
  where?: InputMaybe<Articles_Bool_Exp>
}

export type Subscription_RootArticles_By_PkArgs = {
  id: Scalars['uuid']['input']
}

export type Subscription_RootArticles_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Articles_Stream_Cursor_Input>>
  where?: InputMaybe<Articles_Bool_Exp>
}

export type Subscription_RootAuthOauth2AuthRequestArgs = {
  id: Scalars['uuid']['input']
}

export type Subscription_RootAuthOauth2AuthRequestsArgs = {
  distinct_on?: InputMaybe<Array<AuthOauth2AuthRequests_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<AuthOauth2AuthRequests_Order_By>>
  where?: InputMaybe<AuthOauth2AuthRequests_Bool_Exp>
}

export type Subscription_RootAuthOauth2AuthRequestsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthOauth2AuthRequests_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<AuthOauth2AuthRequests_Order_By>>
  where?: InputMaybe<AuthOauth2AuthRequests_Bool_Exp>
}

export type Subscription_RootAuthOauth2AuthRequests_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<AuthOauth2AuthRequests_Stream_Cursor_Input>>
  where?: InputMaybe<AuthOauth2AuthRequests_Bool_Exp>
}

export type Subscription_RootAuthOauth2AuthorizationCodeArgs = {
  id: Scalars['uuid']['input']
}

export type Subscription_RootAuthOauth2AuthorizationCodesArgs = {
  distinct_on?: InputMaybe<Array<AuthOauth2AuthorizationCodes_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<AuthOauth2AuthorizationCodes_Order_By>>
  where?: InputMaybe<AuthOauth2AuthorizationCodes_Bool_Exp>
}

export type Subscription_RootAuthOauth2AuthorizationCodesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthOauth2AuthorizationCodes_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<AuthOauth2AuthorizationCodes_Order_By>>
  where?: InputMaybe<AuthOauth2AuthorizationCodes_Bool_Exp>
}

export type Subscription_RootAuthOauth2AuthorizationCodes_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<AuthOauth2AuthorizationCodes_Stream_Cursor_Input>>
  where?: InputMaybe<AuthOauth2AuthorizationCodes_Bool_Exp>
}

export type Subscription_RootAuthOauth2ClientArgs = {
  clientId: Scalars['String']['input']
}

export type Subscription_RootAuthOauth2ClientsArgs = {
  distinct_on?: InputMaybe<Array<AuthOauth2Clients_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<AuthOauth2Clients_Order_By>>
  where?: InputMaybe<AuthOauth2Clients_Bool_Exp>
}

export type Subscription_RootAuthOauth2ClientsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthOauth2Clients_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<AuthOauth2Clients_Order_By>>
  where?: InputMaybe<AuthOauth2Clients_Bool_Exp>
}

export type Subscription_RootAuthOauth2Clients_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<AuthOauth2Clients_Stream_Cursor_Input>>
  where?: InputMaybe<AuthOauth2Clients_Bool_Exp>
}

export type Subscription_RootAuthOauth2RefreshTokenArgs = {
  id: Scalars['uuid']['input']
}

export type Subscription_RootAuthOauth2RefreshTokensArgs = {
  distinct_on?: InputMaybe<Array<AuthOauth2RefreshTokens_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<AuthOauth2RefreshTokens_Order_By>>
  where?: InputMaybe<AuthOauth2RefreshTokens_Bool_Exp>
}

export type Subscription_RootAuthOauth2RefreshTokensAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthOauth2RefreshTokens_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<AuthOauth2RefreshTokens_Order_By>>
  where?: InputMaybe<AuthOauth2RefreshTokens_Bool_Exp>
}

export type Subscription_RootAuthOauth2RefreshTokens_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<AuthOauth2RefreshTokens_Stream_Cursor_Input>>
  where?: InputMaybe<AuthOauth2RefreshTokens_Bool_Exp>
}

export type Subscription_RootAuthProviderArgs = {
  id: Scalars['String']['input']
}

export type Subscription_RootAuthProviderRequestArgs = {
  id: Scalars['uuid']['input']
}

export type Subscription_RootAuthProviderRequestsArgs = {
  distinct_on?: InputMaybe<Array<AuthProviderRequests_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<AuthProviderRequests_Order_By>>
  where?: InputMaybe<AuthProviderRequests_Bool_Exp>
}

export type Subscription_RootAuthProviderRequestsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthProviderRequests_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<AuthProviderRequests_Order_By>>
  where?: InputMaybe<AuthProviderRequests_Bool_Exp>
}

export type Subscription_RootAuthProviderRequests_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<AuthProviderRequests_Stream_Cursor_Input>>
  where?: InputMaybe<AuthProviderRequests_Bool_Exp>
}

export type Subscription_RootAuthProvidersArgs = {
  distinct_on?: InputMaybe<Array<AuthProviders_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<AuthProviders_Order_By>>
  where?: InputMaybe<AuthProviders_Bool_Exp>
}

export type Subscription_RootAuthProvidersAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthProviders_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<AuthProviders_Order_By>>
  where?: InputMaybe<AuthProviders_Bool_Exp>
}

export type Subscription_RootAuthProviders_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<AuthProviders_Stream_Cursor_Input>>
  where?: InputMaybe<AuthProviders_Bool_Exp>
}

export type Subscription_RootAuthRefreshTokenArgs = {
  id: Scalars['uuid']['input']
}

export type Subscription_RootAuthRefreshTokenTypeArgs = {
  value: Scalars['String']['input']
}

export type Subscription_RootAuthRefreshTokenTypesArgs = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokenTypes_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<AuthRefreshTokenTypes_Order_By>>
  where?: InputMaybe<AuthRefreshTokenTypes_Bool_Exp>
}

export type Subscription_RootAuthRefreshTokenTypesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokenTypes_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<AuthRefreshTokenTypes_Order_By>>
  where?: InputMaybe<AuthRefreshTokenTypes_Bool_Exp>
}

export type Subscription_RootAuthRefreshTokenTypes_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<AuthRefreshTokenTypes_Stream_Cursor_Input>>
  where?: InputMaybe<AuthRefreshTokenTypes_Bool_Exp>
}

export type Subscription_RootAuthRefreshTokensArgs = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokens_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<AuthRefreshTokens_Order_By>>
  where?: InputMaybe<AuthRefreshTokens_Bool_Exp>
}

export type Subscription_RootAuthRefreshTokensAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokens_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<AuthRefreshTokens_Order_By>>
  where?: InputMaybe<AuthRefreshTokens_Bool_Exp>
}

export type Subscription_RootAuthRefreshTokens_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<AuthRefreshTokens_Stream_Cursor_Input>>
  where?: InputMaybe<AuthRefreshTokens_Bool_Exp>
}

export type Subscription_RootAuthRoleArgs = {
  role: Scalars['String']['input']
}

export type Subscription_RootAuthRolesArgs = {
  distinct_on?: InputMaybe<Array<AuthRoles_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<AuthRoles_Order_By>>
  where?: InputMaybe<AuthRoles_Bool_Exp>
}

export type Subscription_RootAuthRolesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthRoles_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<AuthRoles_Order_By>>
  where?: InputMaybe<AuthRoles_Bool_Exp>
}

export type Subscription_RootAuthRoles_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<AuthRoles_Stream_Cursor_Input>>
  where?: InputMaybe<AuthRoles_Bool_Exp>
}

export type Subscription_RootAuthUserProviderArgs = {
  id: Scalars['uuid']['input']
}

export type Subscription_RootAuthUserProvidersArgs = {
  distinct_on?: InputMaybe<Array<AuthUserProviders_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<AuthUserProviders_Order_By>>
  where?: InputMaybe<AuthUserProviders_Bool_Exp>
}

export type Subscription_RootAuthUserProvidersAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthUserProviders_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<AuthUserProviders_Order_By>>
  where?: InputMaybe<AuthUserProviders_Bool_Exp>
}

export type Subscription_RootAuthUserProviders_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<AuthUserProviders_Stream_Cursor_Input>>
  where?: InputMaybe<AuthUserProviders_Bool_Exp>
}

export type Subscription_RootAuthUserRoleArgs = {
  id: Scalars['uuid']['input']
}

export type Subscription_RootAuthUserRolesArgs = {
  distinct_on?: InputMaybe<Array<AuthUserRoles_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<AuthUserRoles_Order_By>>
  where?: InputMaybe<AuthUserRoles_Bool_Exp>
}

export type Subscription_RootAuthUserRolesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthUserRoles_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<AuthUserRoles_Order_By>>
  where?: InputMaybe<AuthUserRoles_Bool_Exp>
}

export type Subscription_RootAuthUserRoles_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<AuthUserRoles_Stream_Cursor_Input>>
  where?: InputMaybe<AuthUserRoles_Bool_Exp>
}

export type Subscription_RootAuthUserSecurityKeyArgs = {
  id: Scalars['uuid']['input']
}

export type Subscription_RootAuthUserSecurityKeysArgs = {
  distinct_on?: InputMaybe<Array<AuthUserSecurityKeys_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<AuthUserSecurityKeys_Order_By>>
  where?: InputMaybe<AuthUserSecurityKeys_Bool_Exp>
}

export type Subscription_RootAuthUserSecurityKeysAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthUserSecurityKeys_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<AuthUserSecurityKeys_Order_By>>
  where?: InputMaybe<AuthUserSecurityKeys_Bool_Exp>
}

export type Subscription_RootAuthUserSecurityKeys_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<AuthUserSecurityKeys_Stream_Cursor_Input>>
  where?: InputMaybe<AuthUserSecurityKeys_Bool_Exp>
}

export type Subscription_RootBucketArgs = {
  id: Scalars['String']['input']
}

export type Subscription_RootBucketsArgs = {
  distinct_on?: InputMaybe<Array<Buckets_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Buckets_Order_By>>
  where?: InputMaybe<Buckets_Bool_Exp>
}

export type Subscription_RootBucketsAggregateArgs = {
  distinct_on?: InputMaybe<Array<Buckets_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Buckets_Order_By>>
  where?: InputMaybe<Buckets_Bool_Exp>
}

export type Subscription_RootBuckets_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Buckets_Stream_Cursor_Input>>
  where?: InputMaybe<Buckets_Bool_Exp>
}

export type Subscription_RootCategoriesArgs = {
  distinct_on?: InputMaybe<Array<Categories_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Categories_Order_By>>
  where?: InputMaybe<Categories_Bool_Exp>
}

export type Subscription_RootCategories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Categories_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Categories_Order_By>>
  where?: InputMaybe<Categories_Bool_Exp>
}

export type Subscription_RootCategories_By_PkArgs = {
  slug: Scalars['String']['input']
}

export type Subscription_RootCategories_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Categories_Stream_Cursor_Input>>
  where?: InputMaybe<Categories_Bool_Exp>
}

export type Subscription_RootChaptersArgs = {
  distinct_on?: InputMaybe<Array<Chapters_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Chapters_Order_By>>
  where?: InputMaybe<Chapters_Bool_Exp>
}

export type Subscription_RootChapters_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Chapters_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Chapters_Order_By>>
  where?: InputMaybe<Chapters_Bool_Exp>
}

export type Subscription_RootChapters_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Chapters_Stream_Cursor_Input>>
  where?: InputMaybe<Chapters_Bool_Exp>
}

export type Subscription_RootChat_MessagesArgs = {
  distinct_on?: InputMaybe<Array<Chat_Messages_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Chat_Messages_Order_By>>
  where?: InputMaybe<Chat_Messages_Bool_Exp>
}

export type Subscription_RootChat_Messages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Chat_Messages_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Chat_Messages_Order_By>>
  where?: InputMaybe<Chat_Messages_Bool_Exp>
}

export type Subscription_RootChat_Messages_By_PkArgs = {
  id: Scalars['uuid']['input']
}

export type Subscription_RootChat_Messages_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Chat_Messages_Stream_Cursor_Input>>
  where?: InputMaybe<Chat_Messages_Bool_Exp>
}

export type Subscription_RootFeedback_MessagesArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Messages_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Feedback_Messages_Order_By>>
  where?: InputMaybe<Feedback_Messages_Bool_Exp>
}

export type Subscription_RootFeedback_Messages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Messages_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Feedback_Messages_Order_By>>
  where?: InputMaybe<Feedback_Messages_Bool_Exp>
}

export type Subscription_RootFeedback_Messages_By_PkArgs = {
  id: Scalars['uuid']['input']
}

export type Subscription_RootFeedback_Messages_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Feedback_Messages_Stream_Cursor_Input>>
  where?: InputMaybe<Feedback_Messages_Bool_Exp>
}

export type Subscription_RootFileArgs = {
  id: Scalars['uuid']['input']
}

export type Subscription_RootFilesArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Files_Order_By>>
  where?: InputMaybe<Files_Bool_Exp>
}

export type Subscription_RootFilesAggregateArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Files_Order_By>>
  where?: InputMaybe<Files_Bool_Exp>
}

export type Subscription_RootFiles_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Files_Stream_Cursor_Input>>
  where?: InputMaybe<Files_Bool_Exp>
}

export type Subscription_RootMatching_Question_With_ChapterArgs = {
  distinct_on?: InputMaybe<Array<Matching_Question_With_Chapter_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Matching_Question_With_Chapter_Order_By>>
  where?: InputMaybe<Matching_Question_With_Chapter_Bool_Exp>
}

export type Subscription_RootMatching_Question_With_Chapter_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Matching_Question_With_Chapter_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Matching_Question_With_Chapter_Order_By>>
  where?: InputMaybe<Matching_Question_With_Chapter_Bool_Exp>
}

export type Subscription_RootMatching_Question_With_Chapter_By_PkArgs = {
  answer_key: Scalars['String']['input']
}

export type Subscription_RootMatching_Question_With_Chapter_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Matching_Question_With_Chapter_Stream_Cursor_Input>>
  where?: InputMaybe<Matching_Question_With_Chapter_Bool_Exp>
}

export type Subscription_RootMidwife_ProfilesArgs = {
  distinct_on?: InputMaybe<Array<Midwife_Profiles_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Midwife_Profiles_Order_By>>
  where?: InputMaybe<Midwife_Profiles_Bool_Exp>
}

export type Subscription_RootMidwife_Profiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Midwife_Profiles_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Midwife_Profiles_Order_By>>
  where?: InputMaybe<Midwife_Profiles_Bool_Exp>
}

export type Subscription_RootMidwife_Profiles_By_PkArgs = {
  id: Scalars['uuid']['input']
}

export type Subscription_RootMidwife_Profiles_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Midwife_Profiles_Stream_Cursor_Input>>
  where?: InputMaybe<Midwife_Profiles_Bool_Exp>
}

export type Subscription_RootPreparationArgs = {
  distinct_on?: InputMaybe<Array<Preparation_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Preparation_Order_By>>
  where?: InputMaybe<Preparation_Bool_Exp>
}

export type Subscription_RootPreparation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Preparation_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Preparation_Order_By>>
  where?: InputMaybe<Preparation_Bool_Exp>
}

export type Subscription_RootPreparation_By_PkArgs = {
  id: Scalars['uuid']['input']
}

export type Subscription_RootPreparation_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Preparation_Stream_Cursor_Input>>
  where?: InputMaybe<Preparation_Bool_Exp>
}

export type Subscription_RootQm_EntriesArgs = {
  distinct_on?: InputMaybe<Array<Qm_Entries_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Qm_Entries_Order_By>>
  where?: InputMaybe<Qm_Entries_Bool_Exp>
}

export type Subscription_RootQm_Entries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Qm_Entries_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Qm_Entries_Order_By>>
  where?: InputMaybe<Qm_Entries_Bool_Exp>
}

export type Subscription_RootQm_Entries_By_PkArgs = {
  id: Scalars['uuid']['input']
}

export type Subscription_RootQm_Entries_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Qm_Entries_Stream_Cursor_Input>>
  where?: InputMaybe<Qm_Entries_Bool_Exp>
}

export type Subscription_RootTracking_BirthArgs = {
  distinct_on?: InputMaybe<Array<Tracking_Birth_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Tracking_Birth_Order_By>>
  where?: InputMaybe<Tracking_Birth_Bool_Exp>
}

export type Subscription_RootTracking_Birth_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tracking_Birth_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Tracking_Birth_Order_By>>
  where?: InputMaybe<Tracking_Birth_Bool_Exp>
}

export type Subscription_RootTracking_Birth_By_PkArgs = {
  id: Scalars['uuid']['input']
}

export type Subscription_RootTracking_Birth_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Tracking_Birth_Stream_Cursor_Input>>
  where?: InputMaybe<Tracking_Birth_Bool_Exp>
}

export type Subscription_RootTracking_BottleArgs = {
  distinct_on?: InputMaybe<Array<Tracking_Bottle_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Tracking_Bottle_Order_By>>
  where?: InputMaybe<Tracking_Bottle_Bool_Exp>
}

export type Subscription_RootTracking_Bottle_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tracking_Bottle_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Tracking_Bottle_Order_By>>
  where?: InputMaybe<Tracking_Bottle_Bool_Exp>
}

export type Subscription_RootTracking_Bottle_By_PkArgs = {
  id: Scalars['uuid']['input']
}

export type Subscription_RootTracking_Bottle_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Tracking_Bottle_Stream_Cursor_Input>>
  where?: InputMaybe<Tracking_Bottle_Bool_Exp>
}

export type Subscription_RootTracking_BreastArgs = {
  distinct_on?: InputMaybe<Array<Tracking_Breast_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Tracking_Breast_Order_By>>
  where?: InputMaybe<Tracking_Breast_Bool_Exp>
}

export type Subscription_RootTracking_Breast_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tracking_Breast_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Tracking_Breast_Order_By>>
  where?: InputMaybe<Tracking_Breast_Bool_Exp>
}

export type Subscription_RootTracking_Breast_By_PkArgs = {
  id: Scalars['uuid']['input']
}

export type Subscription_RootTracking_Breast_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Tracking_Breast_Stream_Cursor_Input>>
  where?: InputMaybe<Tracking_Breast_Bool_Exp>
}

export type Subscription_RootTracking_DiaperArgs = {
  distinct_on?: InputMaybe<Array<Tracking_Diaper_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Tracking_Diaper_Order_By>>
  where?: InputMaybe<Tracking_Diaper_Bool_Exp>
}

export type Subscription_RootTracking_Diaper_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tracking_Diaper_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Tracking_Diaper_Order_By>>
  where?: InputMaybe<Tracking_Diaper_Bool_Exp>
}

export type Subscription_RootTracking_Diaper_By_PkArgs = {
  id: Scalars['uuid']['input']
}

export type Subscription_RootTracking_Diaper_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Tracking_Diaper_Stream_Cursor_Input>>
  where?: InputMaybe<Tracking_Diaper_Bool_Exp>
}

export type Subscription_RootTracking_Mental_HealthArgs = {
  distinct_on?: InputMaybe<Array<Tracking_Mental_Health_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Tracking_Mental_Health_Order_By>>
  where?: InputMaybe<Tracking_Mental_Health_Bool_Exp>
}

export type Subscription_RootTracking_Mental_Health_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tracking_Mental_Health_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Tracking_Mental_Health_Order_By>>
  where?: InputMaybe<Tracking_Mental_Health_Bool_Exp>
}

export type Subscription_RootTracking_Mental_Health_By_PkArgs = {
  id: Scalars['uuid']['input']
}

export type Subscription_RootTracking_Mental_Health_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Tracking_Mental_Health_Stream_Cursor_Input>>
  where?: InputMaybe<Tracking_Mental_Health_Bool_Exp>
}

export type Subscription_RootTracking_NursingArgs = {
  distinct_on?: InputMaybe<Array<Tracking_Nursing_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Tracking_Nursing_Order_By>>
  where?: InputMaybe<Tracking_Nursing_Bool_Exp>
}

export type Subscription_RootTracking_Nursing_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tracking_Nursing_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Tracking_Nursing_Order_By>>
  where?: InputMaybe<Tracking_Nursing_Bool_Exp>
}

export type Subscription_RootTracking_Nursing_By_PkArgs = {
  id: Scalars['uuid']['input']
}

export type Subscription_RootTracking_Nursing_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Tracking_Nursing_Stream_Cursor_Input>>
  where?: InputMaybe<Tracking_Nursing_Bool_Exp>
}

export type Subscription_RootTracking_SubstanceArgs = {
  distinct_on?: InputMaybe<Array<Tracking_Substance_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Tracking_Substance_Order_By>>
  where?: InputMaybe<Tracking_Substance_Bool_Exp>
}

export type Subscription_RootTracking_Substance_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tracking_Substance_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Tracking_Substance_Order_By>>
  where?: InputMaybe<Tracking_Substance_Bool_Exp>
}

export type Subscription_RootTracking_Substance_By_PkArgs = {
  id: Scalars['uuid']['input']
}

export type Subscription_RootTracking_Substance_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Tracking_Substance_Stream_Cursor_Input>>
  where?: InputMaybe<Tracking_Substance_Bool_Exp>
}

export type Subscription_RootTracking_TonguetieArgs = {
  distinct_on?: InputMaybe<Array<Tracking_Tonguetie_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Tracking_Tonguetie_Order_By>>
  where?: InputMaybe<Tracking_Tonguetie_Bool_Exp>
}

export type Subscription_RootTracking_Tonguetie_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tracking_Tonguetie_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Tracking_Tonguetie_Order_By>>
  where?: InputMaybe<Tracking_Tonguetie_Bool_Exp>
}

export type Subscription_RootTracking_Tonguetie_By_PkArgs = {
  id: Scalars['uuid']['input']
}

export type Subscription_RootTracking_Tonguetie_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Tracking_Tonguetie_Stream_Cursor_Input>>
  where?: InputMaybe<Tracking_Tonguetie_Bool_Exp>
}

export type Subscription_RootTracking_WeightArgs = {
  distinct_on?: InputMaybe<Array<Tracking_Weight_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Tracking_Weight_Order_By>>
  where?: InputMaybe<Tracking_Weight_Bool_Exp>
}

export type Subscription_RootTracking_Weight_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tracking_Weight_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Tracking_Weight_Order_By>>
  where?: InputMaybe<Tracking_Weight_Bool_Exp>
}

export type Subscription_RootTracking_Weight_By_PkArgs = {
  id: Scalars['uuid']['input']
}

export type Subscription_RootTracking_Weight_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Tracking_Weight_Stream_Cursor_Input>>
  where?: InputMaybe<Tracking_Weight_Bool_Exp>
}

export type Subscription_RootUserArgs = {
  id: Scalars['uuid']['input']
}

export type Subscription_RootUser_ProfilesArgs = {
  distinct_on?: InputMaybe<Array<User_Profiles_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<User_Profiles_Order_By>>
  where?: InputMaybe<User_Profiles_Bool_Exp>
}

export type Subscription_RootUser_Profiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Profiles_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<User_Profiles_Order_By>>
  where?: InputMaybe<User_Profiles_Bool_Exp>
}

export type Subscription_RootUser_Profiles_By_PkArgs = {
  id: Scalars['uuid']['input']
}

export type Subscription_RootUser_Profiles_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<User_Profiles_Stream_Cursor_Input>>
  where?: InputMaybe<User_Profiles_Bool_Exp>
}

export type Subscription_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Users_Order_By>>
  where?: InputMaybe<Users_Bool_Exp>
}

export type Subscription_RootUsersAggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Users_Order_By>>
  where?: InputMaybe<Users_Bool_Exp>
}

export type Subscription_RootUsers_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Users_Stream_Cursor_Input>>
  where?: InputMaybe<Users_Bool_Exp>
}

export type Subscription_RootVirusArgs = {
  id: Scalars['uuid']['input']
}

export type Subscription_RootVirus_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Virus_Stream_Cursor_Input>>
  where?: InputMaybe<Virus_Bool_Exp>
}

export type Subscription_RootVirusesArgs = {
  distinct_on?: InputMaybe<Array<Virus_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Virus_Order_By>>
  where?: InputMaybe<Virus_Bool_Exp>
}

export type Subscription_RootVirusesAggregateArgs = {
  distinct_on?: InputMaybe<Array<Virus_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Virus_Order_By>>
  where?: InputMaybe<Virus_Bool_Exp>
}

export type Subscription_RootVoucher_CodesArgs = {
  distinct_on?: InputMaybe<Array<Voucher_Codes_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Voucher_Codes_Order_By>>
  where?: InputMaybe<Voucher_Codes_Bool_Exp>
}

export type Subscription_RootVoucher_Codes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Voucher_Codes_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<Voucher_Codes_Order_By>>
  where?: InputMaybe<Voucher_Codes_Bool_Exp>
}

export type Subscription_RootVoucher_Codes_By_PkArgs = {
  id: Scalars['uuid']['input']
}

export type Subscription_RootVoucher_Codes_StreamArgs = {
  batch_size: Scalars['Int']['input']
  cursor: Array<InputMaybe<Voucher_Codes_Stream_Cursor_Input>>
  where?: InputMaybe<Voucher_Codes_Bool_Exp>
}

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']['input']>
  _gt?: InputMaybe<Scalars['timestamptz']['input']>
  _gte?: InputMaybe<Scalars['timestamptz']['input']>
  _in?: InputMaybe<Array<Scalars['timestamptz']['input']>>
  _is_null?: InputMaybe<Scalars['Boolean']['input']>
  _lt?: InputMaybe<Scalars['timestamptz']['input']>
  _lte?: InputMaybe<Scalars['timestamptz']['input']>
  _neq?: InputMaybe<Scalars['timestamptz']['input']>
  _nin?: InputMaybe<Array<Scalars['timestamptz']['input']>>
}

/** columns and relationships of "tracking_birth" */
export type Tracking_Birth = {
  __typename?: 'tracking_birth'
  bf_first_hour?: Maybe<Scalars['Boolean']['output']>
  birth_date: Scalars['date']['output']
  birth_mode?: Maybe<Scalars['String']['output']>
  birth_weight: Scalars['Int']['output']
  born_at?: Maybe<Scalars['timestamptz']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  id: Scalars['uuid']['output']
  sex: Scalars['String']['output']
  /** An object relationship */
  user?: Maybe<Users>
  user_id: Scalars['uuid']['output']
}

/** aggregated selection of "tracking_birth" */
export type Tracking_Birth_Aggregate = {
  __typename?: 'tracking_birth_aggregate'
  aggregate?: Maybe<Tracking_Birth_Aggregate_Fields>
  nodes: Array<Tracking_Birth>
}

/** aggregate fields of "tracking_birth" */
export type Tracking_Birth_Aggregate_Fields = {
  __typename?: 'tracking_birth_aggregate_fields'
  avg?: Maybe<Tracking_Birth_Avg_Fields>
  count: Scalars['Int']['output']
  max?: Maybe<Tracking_Birth_Max_Fields>
  min?: Maybe<Tracking_Birth_Min_Fields>
  stddev?: Maybe<Tracking_Birth_Stddev_Fields>
  stddev_pop?: Maybe<Tracking_Birth_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Tracking_Birth_Stddev_Samp_Fields>
  sum?: Maybe<Tracking_Birth_Sum_Fields>
  var_pop?: Maybe<Tracking_Birth_Var_Pop_Fields>
  var_samp?: Maybe<Tracking_Birth_Var_Samp_Fields>
  variance?: Maybe<Tracking_Birth_Variance_Fields>
}

/** aggregate fields of "tracking_birth" */
export type Tracking_Birth_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tracking_Birth_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** aggregate avg on columns */
export type Tracking_Birth_Avg_Fields = {
  __typename?: 'tracking_birth_avg_fields'
  birth_weight?: Maybe<Scalars['Float']['output']>
}

/** Boolean expression to filter rows from the table "tracking_birth". All fields are combined with a logical 'AND'. */
export type Tracking_Birth_Bool_Exp = {
  _and?: InputMaybe<Array<Tracking_Birth_Bool_Exp>>
  _not?: InputMaybe<Tracking_Birth_Bool_Exp>
  _or?: InputMaybe<Array<Tracking_Birth_Bool_Exp>>
  bf_first_hour?: InputMaybe<Boolean_Comparison_Exp>
  birth_date?: InputMaybe<Date_Comparison_Exp>
  birth_mode?: InputMaybe<String_Comparison_Exp>
  birth_weight?: InputMaybe<Int_Comparison_Exp>
  born_at?: InputMaybe<Timestamptz_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  id?: InputMaybe<Uuid_Comparison_Exp>
  sex?: InputMaybe<String_Comparison_Exp>
  user?: InputMaybe<Users_Bool_Exp>
  user_id?: InputMaybe<Uuid_Comparison_Exp>
}

/** unique or primary key constraints on table "tracking_birth" */
export enum Tracking_Birth_Constraint {
  /** unique or primary key constraint on columns "id" */
  TrackingBirthPkey = 'tracking_birth_pkey',
  /** unique or primary key constraint on columns "user_id" */
  TrackingBirthUserIdKey = 'tracking_birth_user_id_key',
}

/** input type for incrementing numeric columns in table "tracking_birth" */
export type Tracking_Birth_Inc_Input = {
  birth_weight?: InputMaybe<Scalars['Int']['input']>
}

/** input type for inserting data into table "tracking_birth" */
export type Tracking_Birth_Insert_Input = {
  bf_first_hour?: InputMaybe<Scalars['Boolean']['input']>
  birth_date?: InputMaybe<Scalars['date']['input']>
  birth_mode?: InputMaybe<Scalars['String']['input']>
  birth_weight?: InputMaybe<Scalars['Int']['input']>
  born_at?: InputMaybe<Scalars['timestamptz']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  sex?: InputMaybe<Scalars['String']['input']>
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>
  user_id?: InputMaybe<Scalars['uuid']['input']>
}

/** aggregate max on columns */
export type Tracking_Birth_Max_Fields = {
  __typename?: 'tracking_birth_max_fields'
  birth_date?: Maybe<Scalars['date']['output']>
  birth_mode?: Maybe<Scalars['String']['output']>
  birth_weight?: Maybe<Scalars['Int']['output']>
  born_at?: Maybe<Scalars['timestamptz']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['uuid']['output']>
  sex?: Maybe<Scalars['String']['output']>
  user_id?: Maybe<Scalars['uuid']['output']>
}

/** aggregate min on columns */
export type Tracking_Birth_Min_Fields = {
  __typename?: 'tracking_birth_min_fields'
  birth_date?: Maybe<Scalars['date']['output']>
  birth_mode?: Maybe<Scalars['String']['output']>
  birth_weight?: Maybe<Scalars['Int']['output']>
  born_at?: Maybe<Scalars['timestamptz']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['uuid']['output']>
  sex?: Maybe<Scalars['String']['output']>
  user_id?: Maybe<Scalars['uuid']['output']>
}

/** response of any mutation on the table "tracking_birth" */
export type Tracking_Birth_Mutation_Response = {
  __typename?: 'tracking_birth_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Tracking_Birth>
}

/** on_conflict condition type for table "tracking_birth" */
export type Tracking_Birth_On_Conflict = {
  constraint: Tracking_Birth_Constraint
  update_columns?: Array<Tracking_Birth_Update_Column>
  where?: InputMaybe<Tracking_Birth_Bool_Exp>
}

/** Ordering options when selecting data from "tracking_birth". */
export type Tracking_Birth_Order_By = {
  bf_first_hour?: InputMaybe<Order_By>
  birth_date?: InputMaybe<Order_By>
  birth_mode?: InputMaybe<Order_By>
  birth_weight?: InputMaybe<Order_By>
  born_at?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  sex?: InputMaybe<Order_By>
  user?: InputMaybe<Users_Order_By>
  user_id?: InputMaybe<Order_By>
}

/** primary key columns input for table: tracking_birth */
export type Tracking_Birth_Pk_Columns_Input = {
  id: Scalars['uuid']['input']
}

/** select columns of table "tracking_birth" */
export enum Tracking_Birth_Select_Column {
  /** column name */
  BfFirstHour = 'bf_first_hour',
  /** column name */
  BirthDate = 'birth_date',
  /** column name */
  BirthMode = 'birth_mode',
  /** column name */
  BirthWeight = 'birth_weight',
  /** column name */
  BornAt = 'born_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Sex = 'sex',
  /** column name */
  UserId = 'user_id',
}

/** input type for updating data in table "tracking_birth" */
export type Tracking_Birth_Set_Input = {
  bf_first_hour?: InputMaybe<Scalars['Boolean']['input']>
  birth_date?: InputMaybe<Scalars['date']['input']>
  birth_mode?: InputMaybe<Scalars['String']['input']>
  birth_weight?: InputMaybe<Scalars['Int']['input']>
  born_at?: InputMaybe<Scalars['timestamptz']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  sex?: InputMaybe<Scalars['String']['input']>
  user_id?: InputMaybe<Scalars['uuid']['input']>
}

/** aggregate stddev on columns */
export type Tracking_Birth_Stddev_Fields = {
  __typename?: 'tracking_birth_stddev_fields'
  birth_weight?: Maybe<Scalars['Float']['output']>
}

/** aggregate stddev_pop on columns */
export type Tracking_Birth_Stddev_Pop_Fields = {
  __typename?: 'tracking_birth_stddev_pop_fields'
  birth_weight?: Maybe<Scalars['Float']['output']>
}

/** aggregate stddev_samp on columns */
export type Tracking_Birth_Stddev_Samp_Fields = {
  __typename?: 'tracking_birth_stddev_samp_fields'
  birth_weight?: Maybe<Scalars['Float']['output']>
}

/** Streaming cursor of the table "tracking_birth" */
export type Tracking_Birth_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tracking_Birth_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Tracking_Birth_Stream_Cursor_Value_Input = {
  bf_first_hour?: InputMaybe<Scalars['Boolean']['input']>
  birth_date?: InputMaybe<Scalars['date']['input']>
  birth_mode?: InputMaybe<Scalars['String']['input']>
  birth_weight?: InputMaybe<Scalars['Int']['input']>
  born_at?: InputMaybe<Scalars['timestamptz']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  sex?: InputMaybe<Scalars['String']['input']>
  user_id?: InputMaybe<Scalars['uuid']['input']>
}

/** aggregate sum on columns */
export type Tracking_Birth_Sum_Fields = {
  __typename?: 'tracking_birth_sum_fields'
  birth_weight?: Maybe<Scalars['Int']['output']>
}

/** update columns of table "tracking_birth" */
export enum Tracking_Birth_Update_Column {
  /** column name */
  BfFirstHour = 'bf_first_hour',
  /** column name */
  BirthDate = 'birth_date',
  /** column name */
  BirthMode = 'birth_mode',
  /** column name */
  BirthWeight = 'birth_weight',
  /** column name */
  BornAt = 'born_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Sex = 'sex',
  /** column name */
  UserId = 'user_id',
}

export type Tracking_Birth_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tracking_Birth_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tracking_Birth_Set_Input>
  /** filter the rows which have to be updated */
  where: Tracking_Birth_Bool_Exp
}

/** aggregate var_pop on columns */
export type Tracking_Birth_Var_Pop_Fields = {
  __typename?: 'tracking_birth_var_pop_fields'
  birth_weight?: Maybe<Scalars['Float']['output']>
}

/** aggregate var_samp on columns */
export type Tracking_Birth_Var_Samp_Fields = {
  __typename?: 'tracking_birth_var_samp_fields'
  birth_weight?: Maybe<Scalars['Float']['output']>
}

/** aggregate variance on columns */
export type Tracking_Birth_Variance_Fields = {
  __typename?: 'tracking_birth_variance_fields'
  birth_weight?: Maybe<Scalars['Float']['output']>
}

/** columns and relationships of "tracking_bottle" */
export type Tracking_Bottle = {
  __typename?: 'tracking_bottle'
  amount_ml?: Maybe<Scalars['Int']['output']>
  created_at: Scalars['timestamptz']['output']
  id: Scalars['uuid']['output']
  milk_source?: Maybe<Scalars['String']['output']>
  milk_type?: Maybe<Scalars['String']['output']>
  notes?: Maybe<Scalars['String']['output']>
  timestamp: Scalars['timestamptz']['output']
  /** An object relationship */
  user: Users
  user_id: Scalars['uuid']['output']
}

/** aggregated selection of "tracking_bottle" */
export type Tracking_Bottle_Aggregate = {
  __typename?: 'tracking_bottle_aggregate'
  aggregate?: Maybe<Tracking_Bottle_Aggregate_Fields>
  nodes: Array<Tracking_Bottle>
}

/** aggregate fields of "tracking_bottle" */
export type Tracking_Bottle_Aggregate_Fields = {
  __typename?: 'tracking_bottle_aggregate_fields'
  avg?: Maybe<Tracking_Bottle_Avg_Fields>
  count: Scalars['Int']['output']
  max?: Maybe<Tracking_Bottle_Max_Fields>
  min?: Maybe<Tracking_Bottle_Min_Fields>
  stddev?: Maybe<Tracking_Bottle_Stddev_Fields>
  stddev_pop?: Maybe<Tracking_Bottle_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Tracking_Bottle_Stddev_Samp_Fields>
  sum?: Maybe<Tracking_Bottle_Sum_Fields>
  var_pop?: Maybe<Tracking_Bottle_Var_Pop_Fields>
  var_samp?: Maybe<Tracking_Bottle_Var_Samp_Fields>
  variance?: Maybe<Tracking_Bottle_Variance_Fields>
}

/** aggregate fields of "tracking_bottle" */
export type Tracking_Bottle_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tracking_Bottle_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** aggregate avg on columns */
export type Tracking_Bottle_Avg_Fields = {
  __typename?: 'tracking_bottle_avg_fields'
  amount_ml?: Maybe<Scalars['Float']['output']>
}

/** Boolean expression to filter rows from the table "tracking_bottle". All fields are combined with a logical 'AND'. */
export type Tracking_Bottle_Bool_Exp = {
  _and?: InputMaybe<Array<Tracking_Bottle_Bool_Exp>>
  _not?: InputMaybe<Tracking_Bottle_Bool_Exp>
  _or?: InputMaybe<Array<Tracking_Bottle_Bool_Exp>>
  amount_ml?: InputMaybe<Int_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  id?: InputMaybe<Uuid_Comparison_Exp>
  milk_source?: InputMaybe<String_Comparison_Exp>
  milk_type?: InputMaybe<String_Comparison_Exp>
  notes?: InputMaybe<String_Comparison_Exp>
  timestamp?: InputMaybe<Timestamptz_Comparison_Exp>
  user?: InputMaybe<Users_Bool_Exp>
  user_id?: InputMaybe<Uuid_Comparison_Exp>
}

/** unique or primary key constraints on table "tracking_bottle" */
export enum Tracking_Bottle_Constraint {
  /** unique or primary key constraint on columns "id" */
  TrackingBottlePkey = 'tracking_bottle_pkey',
}

/** input type for incrementing numeric columns in table "tracking_bottle" */
export type Tracking_Bottle_Inc_Input = {
  amount_ml?: InputMaybe<Scalars['Int']['input']>
}

/** input type for inserting data into table "tracking_bottle" */
export type Tracking_Bottle_Insert_Input = {
  amount_ml?: InputMaybe<Scalars['Int']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  milk_source?: InputMaybe<Scalars['String']['input']>
  milk_type?: InputMaybe<Scalars['String']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  timestamp?: InputMaybe<Scalars['timestamptz']['input']>
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>
  user_id?: InputMaybe<Scalars['uuid']['input']>
}

/** aggregate max on columns */
export type Tracking_Bottle_Max_Fields = {
  __typename?: 'tracking_bottle_max_fields'
  amount_ml?: Maybe<Scalars['Int']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['uuid']['output']>
  milk_source?: Maybe<Scalars['String']['output']>
  milk_type?: Maybe<Scalars['String']['output']>
  notes?: Maybe<Scalars['String']['output']>
  timestamp?: Maybe<Scalars['timestamptz']['output']>
  user_id?: Maybe<Scalars['uuid']['output']>
}

/** aggregate min on columns */
export type Tracking_Bottle_Min_Fields = {
  __typename?: 'tracking_bottle_min_fields'
  amount_ml?: Maybe<Scalars['Int']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['uuid']['output']>
  milk_source?: Maybe<Scalars['String']['output']>
  milk_type?: Maybe<Scalars['String']['output']>
  notes?: Maybe<Scalars['String']['output']>
  timestamp?: Maybe<Scalars['timestamptz']['output']>
  user_id?: Maybe<Scalars['uuid']['output']>
}

/** response of any mutation on the table "tracking_bottle" */
export type Tracking_Bottle_Mutation_Response = {
  __typename?: 'tracking_bottle_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Tracking_Bottle>
}

/** on_conflict condition type for table "tracking_bottle" */
export type Tracking_Bottle_On_Conflict = {
  constraint: Tracking_Bottle_Constraint
  update_columns?: Array<Tracking_Bottle_Update_Column>
  where?: InputMaybe<Tracking_Bottle_Bool_Exp>
}

/** Ordering options when selecting data from "tracking_bottle". */
export type Tracking_Bottle_Order_By = {
  amount_ml?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  milk_source?: InputMaybe<Order_By>
  milk_type?: InputMaybe<Order_By>
  notes?: InputMaybe<Order_By>
  timestamp?: InputMaybe<Order_By>
  user?: InputMaybe<Users_Order_By>
  user_id?: InputMaybe<Order_By>
}

/** primary key columns input for table: tracking_bottle */
export type Tracking_Bottle_Pk_Columns_Input = {
  id: Scalars['uuid']['input']
}

/** select columns of table "tracking_bottle" */
export enum Tracking_Bottle_Select_Column {
  /** column name */
  AmountMl = 'amount_ml',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  MilkSource = 'milk_source',
  /** column name */
  MilkType = 'milk_type',
  /** column name */
  Notes = 'notes',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  UserId = 'user_id',
}

/** input type for updating data in table "tracking_bottle" */
export type Tracking_Bottle_Set_Input = {
  amount_ml?: InputMaybe<Scalars['Int']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  milk_source?: InputMaybe<Scalars['String']['input']>
  milk_type?: InputMaybe<Scalars['String']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  timestamp?: InputMaybe<Scalars['timestamptz']['input']>
  user_id?: InputMaybe<Scalars['uuid']['input']>
}

/** aggregate stddev on columns */
export type Tracking_Bottle_Stddev_Fields = {
  __typename?: 'tracking_bottle_stddev_fields'
  amount_ml?: Maybe<Scalars['Float']['output']>
}

/** aggregate stddev_pop on columns */
export type Tracking_Bottle_Stddev_Pop_Fields = {
  __typename?: 'tracking_bottle_stddev_pop_fields'
  amount_ml?: Maybe<Scalars['Float']['output']>
}

/** aggregate stddev_samp on columns */
export type Tracking_Bottle_Stddev_Samp_Fields = {
  __typename?: 'tracking_bottle_stddev_samp_fields'
  amount_ml?: Maybe<Scalars['Float']['output']>
}

/** Streaming cursor of the table "tracking_bottle" */
export type Tracking_Bottle_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tracking_Bottle_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Tracking_Bottle_Stream_Cursor_Value_Input = {
  amount_ml?: InputMaybe<Scalars['Int']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  milk_source?: InputMaybe<Scalars['String']['input']>
  milk_type?: InputMaybe<Scalars['String']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  timestamp?: InputMaybe<Scalars['timestamptz']['input']>
  user_id?: InputMaybe<Scalars['uuid']['input']>
}

/** aggregate sum on columns */
export type Tracking_Bottle_Sum_Fields = {
  __typename?: 'tracking_bottle_sum_fields'
  amount_ml?: Maybe<Scalars['Int']['output']>
}

/** update columns of table "tracking_bottle" */
export enum Tracking_Bottle_Update_Column {
  /** column name */
  AmountMl = 'amount_ml',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  MilkSource = 'milk_source',
  /** column name */
  MilkType = 'milk_type',
  /** column name */
  Notes = 'notes',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  UserId = 'user_id',
}

export type Tracking_Bottle_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tracking_Bottle_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tracking_Bottle_Set_Input>
  /** filter the rows which have to be updated */
  where: Tracking_Bottle_Bool_Exp
}

/** aggregate var_pop on columns */
export type Tracking_Bottle_Var_Pop_Fields = {
  __typename?: 'tracking_bottle_var_pop_fields'
  amount_ml?: Maybe<Scalars['Float']['output']>
}

/** aggregate var_samp on columns */
export type Tracking_Bottle_Var_Samp_Fields = {
  __typename?: 'tracking_bottle_var_samp_fields'
  amount_ml?: Maybe<Scalars['Float']['output']>
}

/** aggregate variance on columns */
export type Tracking_Bottle_Variance_Fields = {
  __typename?: 'tracking_bottle_variance_fields'
  amount_ml?: Maybe<Scalars['Float']['output']>
}

/** columns and relationships of "tracking_breast" */
export type Tracking_Breast = {
  __typename?: 'tracking_breast'
  created_at?: Maybe<Scalars['timestamptz']['output']>
  engorgement?: Maybe<Scalars['Boolean']['output']>
  id: Scalars['uuid']['output']
  lumps?: Maybe<Scalars['Boolean']['output']>
  notes?: Maybe<Scalars['String']['output']>
  pain?: Maybe<Scalars['Boolean']['output']>
  pain_level?: Maybe<Scalars['Int']['output']>
  side?: Maybe<Scalars['String']['output']>
  timestamp: Scalars['timestamptz']['output']
  /** An object relationship */
  user: Users
  user_id: Scalars['uuid']['output']
}

/** aggregated selection of "tracking_breast" */
export type Tracking_Breast_Aggregate = {
  __typename?: 'tracking_breast_aggregate'
  aggregate?: Maybe<Tracking_Breast_Aggregate_Fields>
  nodes: Array<Tracking_Breast>
}

/** aggregate fields of "tracking_breast" */
export type Tracking_Breast_Aggregate_Fields = {
  __typename?: 'tracking_breast_aggregate_fields'
  avg?: Maybe<Tracking_Breast_Avg_Fields>
  count: Scalars['Int']['output']
  max?: Maybe<Tracking_Breast_Max_Fields>
  min?: Maybe<Tracking_Breast_Min_Fields>
  stddev?: Maybe<Tracking_Breast_Stddev_Fields>
  stddev_pop?: Maybe<Tracking_Breast_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Tracking_Breast_Stddev_Samp_Fields>
  sum?: Maybe<Tracking_Breast_Sum_Fields>
  var_pop?: Maybe<Tracking_Breast_Var_Pop_Fields>
  var_samp?: Maybe<Tracking_Breast_Var_Samp_Fields>
  variance?: Maybe<Tracking_Breast_Variance_Fields>
}

/** aggregate fields of "tracking_breast" */
export type Tracking_Breast_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tracking_Breast_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** aggregate avg on columns */
export type Tracking_Breast_Avg_Fields = {
  __typename?: 'tracking_breast_avg_fields'
  pain_level?: Maybe<Scalars['Float']['output']>
}

/** Boolean expression to filter rows from the table "tracking_breast". All fields are combined with a logical 'AND'. */
export type Tracking_Breast_Bool_Exp = {
  _and?: InputMaybe<Array<Tracking_Breast_Bool_Exp>>
  _not?: InputMaybe<Tracking_Breast_Bool_Exp>
  _or?: InputMaybe<Array<Tracking_Breast_Bool_Exp>>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  engorgement?: InputMaybe<Boolean_Comparison_Exp>
  id?: InputMaybe<Uuid_Comparison_Exp>
  lumps?: InputMaybe<Boolean_Comparison_Exp>
  notes?: InputMaybe<String_Comparison_Exp>
  pain?: InputMaybe<Boolean_Comparison_Exp>
  pain_level?: InputMaybe<Int_Comparison_Exp>
  side?: InputMaybe<String_Comparison_Exp>
  timestamp?: InputMaybe<Timestamptz_Comparison_Exp>
  user?: InputMaybe<Users_Bool_Exp>
  user_id?: InputMaybe<Uuid_Comparison_Exp>
}

/** unique or primary key constraints on table "tracking_breast" */
export enum Tracking_Breast_Constraint {
  /** unique or primary key constraint on columns "id" */
  TrackingBreastPkey = 'tracking_breast_pkey',
}

/** input type for incrementing numeric columns in table "tracking_breast" */
export type Tracking_Breast_Inc_Input = {
  pain_level?: InputMaybe<Scalars['Int']['input']>
}

/** input type for inserting data into table "tracking_breast" */
export type Tracking_Breast_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  engorgement?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  lumps?: InputMaybe<Scalars['Boolean']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  pain?: InputMaybe<Scalars['Boolean']['input']>
  pain_level?: InputMaybe<Scalars['Int']['input']>
  side?: InputMaybe<Scalars['String']['input']>
  timestamp?: InputMaybe<Scalars['timestamptz']['input']>
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>
  user_id?: InputMaybe<Scalars['uuid']['input']>
}

/** aggregate max on columns */
export type Tracking_Breast_Max_Fields = {
  __typename?: 'tracking_breast_max_fields'
  created_at?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['uuid']['output']>
  notes?: Maybe<Scalars['String']['output']>
  pain_level?: Maybe<Scalars['Int']['output']>
  side?: Maybe<Scalars['String']['output']>
  timestamp?: Maybe<Scalars['timestamptz']['output']>
  user_id?: Maybe<Scalars['uuid']['output']>
}

/** aggregate min on columns */
export type Tracking_Breast_Min_Fields = {
  __typename?: 'tracking_breast_min_fields'
  created_at?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['uuid']['output']>
  notes?: Maybe<Scalars['String']['output']>
  pain_level?: Maybe<Scalars['Int']['output']>
  side?: Maybe<Scalars['String']['output']>
  timestamp?: Maybe<Scalars['timestamptz']['output']>
  user_id?: Maybe<Scalars['uuid']['output']>
}

/** response of any mutation on the table "tracking_breast" */
export type Tracking_Breast_Mutation_Response = {
  __typename?: 'tracking_breast_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Tracking_Breast>
}

/** on_conflict condition type for table "tracking_breast" */
export type Tracking_Breast_On_Conflict = {
  constraint: Tracking_Breast_Constraint
  update_columns?: Array<Tracking_Breast_Update_Column>
  where?: InputMaybe<Tracking_Breast_Bool_Exp>
}

/** Ordering options when selecting data from "tracking_breast". */
export type Tracking_Breast_Order_By = {
  created_at?: InputMaybe<Order_By>
  engorgement?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  lumps?: InputMaybe<Order_By>
  notes?: InputMaybe<Order_By>
  pain?: InputMaybe<Order_By>
  pain_level?: InputMaybe<Order_By>
  side?: InputMaybe<Order_By>
  timestamp?: InputMaybe<Order_By>
  user?: InputMaybe<Users_Order_By>
  user_id?: InputMaybe<Order_By>
}

/** primary key columns input for table: tracking_breast */
export type Tracking_Breast_Pk_Columns_Input = {
  id: Scalars['uuid']['input']
}

/** select columns of table "tracking_breast" */
export enum Tracking_Breast_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Engorgement = 'engorgement',
  /** column name */
  Id = 'id',
  /** column name */
  Lumps = 'lumps',
  /** column name */
  Notes = 'notes',
  /** column name */
  Pain = 'pain',
  /** column name */
  PainLevel = 'pain_level',
  /** column name */
  Side = 'side',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  UserId = 'user_id',
}

/** input type for updating data in table "tracking_breast" */
export type Tracking_Breast_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  engorgement?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  lumps?: InputMaybe<Scalars['Boolean']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  pain?: InputMaybe<Scalars['Boolean']['input']>
  pain_level?: InputMaybe<Scalars['Int']['input']>
  side?: InputMaybe<Scalars['String']['input']>
  timestamp?: InputMaybe<Scalars['timestamptz']['input']>
  user_id?: InputMaybe<Scalars['uuid']['input']>
}

/** aggregate stddev on columns */
export type Tracking_Breast_Stddev_Fields = {
  __typename?: 'tracking_breast_stddev_fields'
  pain_level?: Maybe<Scalars['Float']['output']>
}

/** aggregate stddev_pop on columns */
export type Tracking_Breast_Stddev_Pop_Fields = {
  __typename?: 'tracking_breast_stddev_pop_fields'
  pain_level?: Maybe<Scalars['Float']['output']>
}

/** aggregate stddev_samp on columns */
export type Tracking_Breast_Stddev_Samp_Fields = {
  __typename?: 'tracking_breast_stddev_samp_fields'
  pain_level?: Maybe<Scalars['Float']['output']>
}

/** Streaming cursor of the table "tracking_breast" */
export type Tracking_Breast_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tracking_Breast_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Tracking_Breast_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  engorgement?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  lumps?: InputMaybe<Scalars['Boolean']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  pain?: InputMaybe<Scalars['Boolean']['input']>
  pain_level?: InputMaybe<Scalars['Int']['input']>
  side?: InputMaybe<Scalars['String']['input']>
  timestamp?: InputMaybe<Scalars['timestamptz']['input']>
  user_id?: InputMaybe<Scalars['uuid']['input']>
}

/** aggregate sum on columns */
export type Tracking_Breast_Sum_Fields = {
  __typename?: 'tracking_breast_sum_fields'
  pain_level?: Maybe<Scalars['Int']['output']>
}

/** update columns of table "tracking_breast" */
export enum Tracking_Breast_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Engorgement = 'engorgement',
  /** column name */
  Id = 'id',
  /** column name */
  Lumps = 'lumps',
  /** column name */
  Notes = 'notes',
  /** column name */
  Pain = 'pain',
  /** column name */
  PainLevel = 'pain_level',
  /** column name */
  Side = 'side',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  UserId = 'user_id',
}

export type Tracking_Breast_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tracking_Breast_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tracking_Breast_Set_Input>
  /** filter the rows which have to be updated */
  where: Tracking_Breast_Bool_Exp
}

/** aggregate var_pop on columns */
export type Tracking_Breast_Var_Pop_Fields = {
  __typename?: 'tracking_breast_var_pop_fields'
  pain_level?: Maybe<Scalars['Float']['output']>
}

/** aggregate var_samp on columns */
export type Tracking_Breast_Var_Samp_Fields = {
  __typename?: 'tracking_breast_var_samp_fields'
  pain_level?: Maybe<Scalars['Float']['output']>
}

/** aggregate variance on columns */
export type Tracking_Breast_Variance_Fields = {
  __typename?: 'tracking_breast_variance_fields'
  pain_level?: Maybe<Scalars['Float']['output']>
}

/** columns and relationships of "tracking_diaper" */
export type Tracking_Diaper = {
  __typename?: 'tracking_diaper'
  created_at?: Maybe<Scalars['timestamptz']['output']>
  id: Scalars['uuid']['output']
  notes?: Maybe<Scalars['String']['output']>
  stool?: Maybe<Scalars['Boolean']['output']>
  stool_color?: Maybe<Scalars['String']['output']>
  stool_consistency?: Maybe<Scalars['String']['output']>
  timestamp: Scalars['timestamptz']['output']
  /** An object relationship */
  user: Users
  user_id: Scalars['uuid']['output']
  wet?: Maybe<Scalars['Boolean']['output']>
}

/** aggregated selection of "tracking_diaper" */
export type Tracking_Diaper_Aggregate = {
  __typename?: 'tracking_diaper_aggregate'
  aggregate?: Maybe<Tracking_Diaper_Aggregate_Fields>
  nodes: Array<Tracking_Diaper>
}

/** aggregate fields of "tracking_diaper" */
export type Tracking_Diaper_Aggregate_Fields = {
  __typename?: 'tracking_diaper_aggregate_fields'
  count: Scalars['Int']['output']
  max?: Maybe<Tracking_Diaper_Max_Fields>
  min?: Maybe<Tracking_Diaper_Min_Fields>
}

/** aggregate fields of "tracking_diaper" */
export type Tracking_Diaper_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tracking_Diaper_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** Boolean expression to filter rows from the table "tracking_diaper". All fields are combined with a logical 'AND'. */
export type Tracking_Diaper_Bool_Exp = {
  _and?: InputMaybe<Array<Tracking_Diaper_Bool_Exp>>
  _not?: InputMaybe<Tracking_Diaper_Bool_Exp>
  _or?: InputMaybe<Array<Tracking_Diaper_Bool_Exp>>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  id?: InputMaybe<Uuid_Comparison_Exp>
  notes?: InputMaybe<String_Comparison_Exp>
  stool?: InputMaybe<Boolean_Comparison_Exp>
  stool_color?: InputMaybe<String_Comparison_Exp>
  stool_consistency?: InputMaybe<String_Comparison_Exp>
  timestamp?: InputMaybe<Timestamptz_Comparison_Exp>
  user?: InputMaybe<Users_Bool_Exp>
  user_id?: InputMaybe<Uuid_Comparison_Exp>
  wet?: InputMaybe<Boolean_Comparison_Exp>
}

/** unique or primary key constraints on table "tracking_diaper" */
export enum Tracking_Diaper_Constraint {
  /** unique or primary key constraint on columns "id" */
  TrackingDiaperPkey = 'tracking_diaper_pkey',
}

/** input type for inserting data into table "tracking_diaper" */
export type Tracking_Diaper_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  stool?: InputMaybe<Scalars['Boolean']['input']>
  stool_color?: InputMaybe<Scalars['String']['input']>
  stool_consistency?: InputMaybe<Scalars['String']['input']>
  timestamp?: InputMaybe<Scalars['timestamptz']['input']>
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>
  user_id?: InputMaybe<Scalars['uuid']['input']>
  wet?: InputMaybe<Scalars['Boolean']['input']>
}

/** aggregate max on columns */
export type Tracking_Diaper_Max_Fields = {
  __typename?: 'tracking_diaper_max_fields'
  created_at?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['uuid']['output']>
  notes?: Maybe<Scalars['String']['output']>
  stool_color?: Maybe<Scalars['String']['output']>
  stool_consistency?: Maybe<Scalars['String']['output']>
  timestamp?: Maybe<Scalars['timestamptz']['output']>
  user_id?: Maybe<Scalars['uuid']['output']>
}

/** aggregate min on columns */
export type Tracking_Diaper_Min_Fields = {
  __typename?: 'tracking_diaper_min_fields'
  created_at?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['uuid']['output']>
  notes?: Maybe<Scalars['String']['output']>
  stool_color?: Maybe<Scalars['String']['output']>
  stool_consistency?: Maybe<Scalars['String']['output']>
  timestamp?: Maybe<Scalars['timestamptz']['output']>
  user_id?: Maybe<Scalars['uuid']['output']>
}

/** response of any mutation on the table "tracking_diaper" */
export type Tracking_Diaper_Mutation_Response = {
  __typename?: 'tracking_diaper_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Tracking_Diaper>
}

/** on_conflict condition type for table "tracking_diaper" */
export type Tracking_Diaper_On_Conflict = {
  constraint: Tracking_Diaper_Constraint
  update_columns?: Array<Tracking_Diaper_Update_Column>
  where?: InputMaybe<Tracking_Diaper_Bool_Exp>
}

/** Ordering options when selecting data from "tracking_diaper". */
export type Tracking_Diaper_Order_By = {
  created_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  notes?: InputMaybe<Order_By>
  stool?: InputMaybe<Order_By>
  stool_color?: InputMaybe<Order_By>
  stool_consistency?: InputMaybe<Order_By>
  timestamp?: InputMaybe<Order_By>
  user?: InputMaybe<Users_Order_By>
  user_id?: InputMaybe<Order_By>
  wet?: InputMaybe<Order_By>
}

/** primary key columns input for table: tracking_diaper */
export type Tracking_Diaper_Pk_Columns_Input = {
  id: Scalars['uuid']['input']
}

/** select columns of table "tracking_diaper" */
export enum Tracking_Diaper_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Notes = 'notes',
  /** column name */
  Stool = 'stool',
  /** column name */
  StoolColor = 'stool_color',
  /** column name */
  StoolConsistency = 'stool_consistency',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Wet = 'wet',
}

/** input type for updating data in table "tracking_diaper" */
export type Tracking_Diaper_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  stool?: InputMaybe<Scalars['Boolean']['input']>
  stool_color?: InputMaybe<Scalars['String']['input']>
  stool_consistency?: InputMaybe<Scalars['String']['input']>
  timestamp?: InputMaybe<Scalars['timestamptz']['input']>
  user_id?: InputMaybe<Scalars['uuid']['input']>
  wet?: InputMaybe<Scalars['Boolean']['input']>
}

/** Streaming cursor of the table "tracking_diaper" */
export type Tracking_Diaper_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tracking_Diaper_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Tracking_Diaper_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  stool?: InputMaybe<Scalars['Boolean']['input']>
  stool_color?: InputMaybe<Scalars['String']['input']>
  stool_consistency?: InputMaybe<Scalars['String']['input']>
  timestamp?: InputMaybe<Scalars['timestamptz']['input']>
  user_id?: InputMaybe<Scalars['uuid']['input']>
  wet?: InputMaybe<Scalars['Boolean']['input']>
}

/** update columns of table "tracking_diaper" */
export enum Tracking_Diaper_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Notes = 'notes',
  /** column name */
  Stool = 'stool',
  /** column name */
  StoolColor = 'stool_color',
  /** column name */
  StoolConsistency = 'stool_consistency',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Wet = 'wet',
}

export type Tracking_Diaper_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tracking_Diaper_Set_Input>
  /** filter the rows which have to be updated */
  where: Tracking_Diaper_Bool_Exp
}

/** columns and relationships of "tracking_mental_health" */
export type Tracking_Mental_Health = {
  __typename?: 'tracking_mental_health'
  created_at?: Maybe<Scalars['timestamptz']['output']>
  id: Scalars['uuid']['output']
  level: Scalars['Int']['output']
  notes?: Maybe<Scalars['String']['output']>
  timestamp: Scalars['timestamptz']['output']
  /** An object relationship */
  user: Users
  user_id: Scalars['uuid']['output']
}

/** aggregated selection of "tracking_mental_health" */
export type Tracking_Mental_Health_Aggregate = {
  __typename?: 'tracking_mental_health_aggregate'
  aggregate?: Maybe<Tracking_Mental_Health_Aggregate_Fields>
  nodes: Array<Tracking_Mental_Health>
}

/** aggregate fields of "tracking_mental_health" */
export type Tracking_Mental_Health_Aggregate_Fields = {
  __typename?: 'tracking_mental_health_aggregate_fields'
  avg?: Maybe<Tracking_Mental_Health_Avg_Fields>
  count: Scalars['Int']['output']
  max?: Maybe<Tracking_Mental_Health_Max_Fields>
  min?: Maybe<Tracking_Mental_Health_Min_Fields>
  stddev?: Maybe<Tracking_Mental_Health_Stddev_Fields>
  stddev_pop?: Maybe<Tracking_Mental_Health_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Tracking_Mental_Health_Stddev_Samp_Fields>
  sum?: Maybe<Tracking_Mental_Health_Sum_Fields>
  var_pop?: Maybe<Tracking_Mental_Health_Var_Pop_Fields>
  var_samp?: Maybe<Tracking_Mental_Health_Var_Samp_Fields>
  variance?: Maybe<Tracking_Mental_Health_Variance_Fields>
}

/** aggregate fields of "tracking_mental_health" */
export type Tracking_Mental_Health_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tracking_Mental_Health_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** aggregate avg on columns */
export type Tracking_Mental_Health_Avg_Fields = {
  __typename?: 'tracking_mental_health_avg_fields'
  level?: Maybe<Scalars['Float']['output']>
}

/** Boolean expression to filter rows from the table "tracking_mental_health". All fields are combined with a logical 'AND'. */
export type Tracking_Mental_Health_Bool_Exp = {
  _and?: InputMaybe<Array<Tracking_Mental_Health_Bool_Exp>>
  _not?: InputMaybe<Tracking_Mental_Health_Bool_Exp>
  _or?: InputMaybe<Array<Tracking_Mental_Health_Bool_Exp>>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  id?: InputMaybe<Uuid_Comparison_Exp>
  level?: InputMaybe<Int_Comparison_Exp>
  notes?: InputMaybe<String_Comparison_Exp>
  timestamp?: InputMaybe<Timestamptz_Comparison_Exp>
  user?: InputMaybe<Users_Bool_Exp>
  user_id?: InputMaybe<Uuid_Comparison_Exp>
}

/** unique or primary key constraints on table "tracking_mental_health" */
export enum Tracking_Mental_Health_Constraint {
  /** unique or primary key constraint on columns "id" */
  TrackingMentalHealthPkey = 'tracking_mental_health_pkey',
}

/** input type for incrementing numeric columns in table "tracking_mental_health" */
export type Tracking_Mental_Health_Inc_Input = {
  level?: InputMaybe<Scalars['Int']['input']>
}

/** input type for inserting data into table "tracking_mental_health" */
export type Tracking_Mental_Health_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  timestamp?: InputMaybe<Scalars['timestamptz']['input']>
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>
  user_id?: InputMaybe<Scalars['uuid']['input']>
}

/** aggregate max on columns */
export type Tracking_Mental_Health_Max_Fields = {
  __typename?: 'tracking_mental_health_max_fields'
  created_at?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['uuid']['output']>
  level?: Maybe<Scalars['Int']['output']>
  notes?: Maybe<Scalars['String']['output']>
  timestamp?: Maybe<Scalars['timestamptz']['output']>
  user_id?: Maybe<Scalars['uuid']['output']>
}

/** aggregate min on columns */
export type Tracking_Mental_Health_Min_Fields = {
  __typename?: 'tracking_mental_health_min_fields'
  created_at?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['uuid']['output']>
  level?: Maybe<Scalars['Int']['output']>
  notes?: Maybe<Scalars['String']['output']>
  timestamp?: Maybe<Scalars['timestamptz']['output']>
  user_id?: Maybe<Scalars['uuid']['output']>
}

/** response of any mutation on the table "tracking_mental_health" */
export type Tracking_Mental_Health_Mutation_Response = {
  __typename?: 'tracking_mental_health_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Tracking_Mental_Health>
}

/** on_conflict condition type for table "tracking_mental_health" */
export type Tracking_Mental_Health_On_Conflict = {
  constraint: Tracking_Mental_Health_Constraint
  update_columns?: Array<Tracking_Mental_Health_Update_Column>
  where?: InputMaybe<Tracking_Mental_Health_Bool_Exp>
}

/** Ordering options when selecting data from "tracking_mental_health". */
export type Tracking_Mental_Health_Order_By = {
  created_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  level?: InputMaybe<Order_By>
  notes?: InputMaybe<Order_By>
  timestamp?: InputMaybe<Order_By>
  user?: InputMaybe<Users_Order_By>
  user_id?: InputMaybe<Order_By>
}

/** primary key columns input for table: tracking_mental_health */
export type Tracking_Mental_Health_Pk_Columns_Input = {
  id: Scalars['uuid']['input']
}

/** select columns of table "tracking_mental_health" */
export enum Tracking_Mental_Health_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Level = 'level',
  /** column name */
  Notes = 'notes',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  UserId = 'user_id',
}

/** input type for updating data in table "tracking_mental_health" */
export type Tracking_Mental_Health_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  timestamp?: InputMaybe<Scalars['timestamptz']['input']>
  user_id?: InputMaybe<Scalars['uuid']['input']>
}

/** aggregate stddev on columns */
export type Tracking_Mental_Health_Stddev_Fields = {
  __typename?: 'tracking_mental_health_stddev_fields'
  level?: Maybe<Scalars['Float']['output']>
}

/** aggregate stddev_pop on columns */
export type Tracking_Mental_Health_Stddev_Pop_Fields = {
  __typename?: 'tracking_mental_health_stddev_pop_fields'
  level?: Maybe<Scalars['Float']['output']>
}

/** aggregate stddev_samp on columns */
export type Tracking_Mental_Health_Stddev_Samp_Fields = {
  __typename?: 'tracking_mental_health_stddev_samp_fields'
  level?: Maybe<Scalars['Float']['output']>
}

/** Streaming cursor of the table "tracking_mental_health" */
export type Tracking_Mental_Health_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tracking_Mental_Health_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Tracking_Mental_Health_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  level?: InputMaybe<Scalars['Int']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  timestamp?: InputMaybe<Scalars['timestamptz']['input']>
  user_id?: InputMaybe<Scalars['uuid']['input']>
}

/** aggregate sum on columns */
export type Tracking_Mental_Health_Sum_Fields = {
  __typename?: 'tracking_mental_health_sum_fields'
  level?: Maybe<Scalars['Int']['output']>
}

/** update columns of table "tracking_mental_health" */
export enum Tracking_Mental_Health_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Level = 'level',
  /** column name */
  Notes = 'notes',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  UserId = 'user_id',
}

export type Tracking_Mental_Health_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tracking_Mental_Health_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tracking_Mental_Health_Set_Input>
  /** filter the rows which have to be updated */
  where: Tracking_Mental_Health_Bool_Exp
}

/** aggregate var_pop on columns */
export type Tracking_Mental_Health_Var_Pop_Fields = {
  __typename?: 'tracking_mental_health_var_pop_fields'
  level?: Maybe<Scalars['Float']['output']>
}

/** aggregate var_samp on columns */
export type Tracking_Mental_Health_Var_Samp_Fields = {
  __typename?: 'tracking_mental_health_var_samp_fields'
  level?: Maybe<Scalars['Float']['output']>
}

/** aggregate variance on columns */
export type Tracking_Mental_Health_Variance_Fields = {
  __typename?: 'tracking_mental_health_variance_fields'
  level?: Maybe<Scalars['Float']['output']>
}

/** columns and relationships of "tracking_nursing" */
export type Tracking_Nursing = {
  __typename?: 'tracking_nursing'
  breast_inflamed?: Maybe<Scalars['Boolean']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  duration_minutes?: Maybe<Scalars['Int']['output']>
  id: Scalars['uuid']['output']
  nipple_cracked?: Maybe<Scalars['Boolean']['output']>
  notes?: Maybe<Scalars['String']['output']>
  pain?: Maybe<Scalars['Boolean']['output']>
  pain_level?: Maybe<Scalars['Int']['output']>
  position?: Maybe<Scalars['String']['output']>
  side?: Maybe<Scalars['String']['output']>
  timestamp: Scalars['timestamptz']['output']
  tools?: Maybe<Scalars['jsonb']['output']>
  /** An object relationship */
  user: Users
  user_id: Scalars['uuid']['output']
}

/** columns and relationships of "tracking_nursing" */
export type Tracking_NursingToolsArgs = {
  path?: InputMaybe<Scalars['String']['input']>
}

/** aggregated selection of "tracking_nursing" */
export type Tracking_Nursing_Aggregate = {
  __typename?: 'tracking_nursing_aggregate'
  aggregate?: Maybe<Tracking_Nursing_Aggregate_Fields>
  nodes: Array<Tracking_Nursing>
}

/** aggregate fields of "tracking_nursing" */
export type Tracking_Nursing_Aggregate_Fields = {
  __typename?: 'tracking_nursing_aggregate_fields'
  avg?: Maybe<Tracking_Nursing_Avg_Fields>
  count: Scalars['Int']['output']
  max?: Maybe<Tracking_Nursing_Max_Fields>
  min?: Maybe<Tracking_Nursing_Min_Fields>
  stddev?: Maybe<Tracking_Nursing_Stddev_Fields>
  stddev_pop?: Maybe<Tracking_Nursing_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Tracking_Nursing_Stddev_Samp_Fields>
  sum?: Maybe<Tracking_Nursing_Sum_Fields>
  var_pop?: Maybe<Tracking_Nursing_Var_Pop_Fields>
  var_samp?: Maybe<Tracking_Nursing_Var_Samp_Fields>
  variance?: Maybe<Tracking_Nursing_Variance_Fields>
}

/** aggregate fields of "tracking_nursing" */
export type Tracking_Nursing_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tracking_Nursing_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** append existing jsonb value of filtered columns with new jsonb value */
export type Tracking_Nursing_Append_Input = {
  tools?: InputMaybe<Scalars['jsonb']['input']>
}

/** aggregate avg on columns */
export type Tracking_Nursing_Avg_Fields = {
  __typename?: 'tracking_nursing_avg_fields'
  duration_minutes?: Maybe<Scalars['Float']['output']>
  pain_level?: Maybe<Scalars['Float']['output']>
}

/** Boolean expression to filter rows from the table "tracking_nursing". All fields are combined with a logical 'AND'. */
export type Tracking_Nursing_Bool_Exp = {
  _and?: InputMaybe<Array<Tracking_Nursing_Bool_Exp>>
  _not?: InputMaybe<Tracking_Nursing_Bool_Exp>
  _or?: InputMaybe<Array<Tracking_Nursing_Bool_Exp>>
  breast_inflamed?: InputMaybe<Boolean_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  duration_minutes?: InputMaybe<Int_Comparison_Exp>
  id?: InputMaybe<Uuid_Comparison_Exp>
  nipple_cracked?: InputMaybe<Boolean_Comparison_Exp>
  notes?: InputMaybe<String_Comparison_Exp>
  pain?: InputMaybe<Boolean_Comparison_Exp>
  pain_level?: InputMaybe<Int_Comparison_Exp>
  position?: InputMaybe<String_Comparison_Exp>
  side?: InputMaybe<String_Comparison_Exp>
  timestamp?: InputMaybe<Timestamptz_Comparison_Exp>
  tools?: InputMaybe<Jsonb_Comparison_Exp>
  user?: InputMaybe<Users_Bool_Exp>
  user_id?: InputMaybe<Uuid_Comparison_Exp>
}

/** unique or primary key constraints on table "tracking_nursing" */
export enum Tracking_Nursing_Constraint {
  /** unique or primary key constraint on columns "id" */
  TrackingNursingPkey = 'tracking_nursing_pkey',
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Tracking_Nursing_Delete_At_Path_Input = {
  tools?: InputMaybe<Array<Scalars['String']['input']>>
}

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Tracking_Nursing_Delete_Elem_Input = {
  tools?: InputMaybe<Scalars['Int']['input']>
}

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Tracking_Nursing_Delete_Key_Input = {
  tools?: InputMaybe<Scalars['String']['input']>
}

/** input type for incrementing numeric columns in table "tracking_nursing" */
export type Tracking_Nursing_Inc_Input = {
  duration_minutes?: InputMaybe<Scalars['Int']['input']>
  pain_level?: InputMaybe<Scalars['Int']['input']>
}

/** input type for inserting data into table "tracking_nursing" */
export type Tracking_Nursing_Insert_Input = {
  breast_inflamed?: InputMaybe<Scalars['Boolean']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  duration_minutes?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  nipple_cracked?: InputMaybe<Scalars['Boolean']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  pain?: InputMaybe<Scalars['Boolean']['input']>
  pain_level?: InputMaybe<Scalars['Int']['input']>
  position?: InputMaybe<Scalars['String']['input']>
  side?: InputMaybe<Scalars['String']['input']>
  timestamp?: InputMaybe<Scalars['timestamptz']['input']>
  tools?: InputMaybe<Scalars['jsonb']['input']>
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>
  user_id?: InputMaybe<Scalars['uuid']['input']>
}

/** aggregate max on columns */
export type Tracking_Nursing_Max_Fields = {
  __typename?: 'tracking_nursing_max_fields'
  created_at?: Maybe<Scalars['timestamptz']['output']>
  duration_minutes?: Maybe<Scalars['Int']['output']>
  id?: Maybe<Scalars['uuid']['output']>
  notes?: Maybe<Scalars['String']['output']>
  pain_level?: Maybe<Scalars['Int']['output']>
  position?: Maybe<Scalars['String']['output']>
  side?: Maybe<Scalars['String']['output']>
  timestamp?: Maybe<Scalars['timestamptz']['output']>
  user_id?: Maybe<Scalars['uuid']['output']>
}

/** aggregate min on columns */
export type Tracking_Nursing_Min_Fields = {
  __typename?: 'tracking_nursing_min_fields'
  created_at?: Maybe<Scalars['timestamptz']['output']>
  duration_minutes?: Maybe<Scalars['Int']['output']>
  id?: Maybe<Scalars['uuid']['output']>
  notes?: Maybe<Scalars['String']['output']>
  pain_level?: Maybe<Scalars['Int']['output']>
  position?: Maybe<Scalars['String']['output']>
  side?: Maybe<Scalars['String']['output']>
  timestamp?: Maybe<Scalars['timestamptz']['output']>
  user_id?: Maybe<Scalars['uuid']['output']>
}

/** response of any mutation on the table "tracking_nursing" */
export type Tracking_Nursing_Mutation_Response = {
  __typename?: 'tracking_nursing_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Tracking_Nursing>
}

/** on_conflict condition type for table "tracking_nursing" */
export type Tracking_Nursing_On_Conflict = {
  constraint: Tracking_Nursing_Constraint
  update_columns?: Array<Tracking_Nursing_Update_Column>
  where?: InputMaybe<Tracking_Nursing_Bool_Exp>
}

/** Ordering options when selecting data from "tracking_nursing". */
export type Tracking_Nursing_Order_By = {
  breast_inflamed?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  duration_minutes?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  nipple_cracked?: InputMaybe<Order_By>
  notes?: InputMaybe<Order_By>
  pain?: InputMaybe<Order_By>
  pain_level?: InputMaybe<Order_By>
  position?: InputMaybe<Order_By>
  side?: InputMaybe<Order_By>
  timestamp?: InputMaybe<Order_By>
  tools?: InputMaybe<Order_By>
  user?: InputMaybe<Users_Order_By>
  user_id?: InputMaybe<Order_By>
}

/** primary key columns input for table: tracking_nursing */
export type Tracking_Nursing_Pk_Columns_Input = {
  id: Scalars['uuid']['input']
}

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Tracking_Nursing_Prepend_Input = {
  tools?: InputMaybe<Scalars['jsonb']['input']>
}

/** select columns of table "tracking_nursing" */
export enum Tracking_Nursing_Select_Column {
  /** column name */
  BreastInflamed = 'breast_inflamed',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DurationMinutes = 'duration_minutes',
  /** column name */
  Id = 'id',
  /** column name */
  NippleCracked = 'nipple_cracked',
  /** column name */
  Notes = 'notes',
  /** column name */
  Pain = 'pain',
  /** column name */
  PainLevel = 'pain_level',
  /** column name */
  Position = 'position',
  /** column name */
  Side = 'side',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  Tools = 'tools',
  /** column name */
  UserId = 'user_id',
}

/** input type for updating data in table "tracking_nursing" */
export type Tracking_Nursing_Set_Input = {
  breast_inflamed?: InputMaybe<Scalars['Boolean']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  duration_minutes?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  nipple_cracked?: InputMaybe<Scalars['Boolean']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  pain?: InputMaybe<Scalars['Boolean']['input']>
  pain_level?: InputMaybe<Scalars['Int']['input']>
  position?: InputMaybe<Scalars['String']['input']>
  side?: InputMaybe<Scalars['String']['input']>
  timestamp?: InputMaybe<Scalars['timestamptz']['input']>
  tools?: InputMaybe<Scalars['jsonb']['input']>
  user_id?: InputMaybe<Scalars['uuid']['input']>
}

/** aggregate stddev on columns */
export type Tracking_Nursing_Stddev_Fields = {
  __typename?: 'tracking_nursing_stddev_fields'
  duration_minutes?: Maybe<Scalars['Float']['output']>
  pain_level?: Maybe<Scalars['Float']['output']>
}

/** aggregate stddev_pop on columns */
export type Tracking_Nursing_Stddev_Pop_Fields = {
  __typename?: 'tracking_nursing_stddev_pop_fields'
  duration_minutes?: Maybe<Scalars['Float']['output']>
  pain_level?: Maybe<Scalars['Float']['output']>
}

/** aggregate stddev_samp on columns */
export type Tracking_Nursing_Stddev_Samp_Fields = {
  __typename?: 'tracking_nursing_stddev_samp_fields'
  duration_minutes?: Maybe<Scalars['Float']['output']>
  pain_level?: Maybe<Scalars['Float']['output']>
}

/** Streaming cursor of the table "tracking_nursing" */
export type Tracking_Nursing_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tracking_Nursing_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Tracking_Nursing_Stream_Cursor_Value_Input = {
  breast_inflamed?: InputMaybe<Scalars['Boolean']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  duration_minutes?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  nipple_cracked?: InputMaybe<Scalars['Boolean']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  pain?: InputMaybe<Scalars['Boolean']['input']>
  pain_level?: InputMaybe<Scalars['Int']['input']>
  position?: InputMaybe<Scalars['String']['input']>
  side?: InputMaybe<Scalars['String']['input']>
  timestamp?: InputMaybe<Scalars['timestamptz']['input']>
  tools?: InputMaybe<Scalars['jsonb']['input']>
  user_id?: InputMaybe<Scalars['uuid']['input']>
}

/** aggregate sum on columns */
export type Tracking_Nursing_Sum_Fields = {
  __typename?: 'tracking_nursing_sum_fields'
  duration_minutes?: Maybe<Scalars['Int']['output']>
  pain_level?: Maybe<Scalars['Int']['output']>
}

/** update columns of table "tracking_nursing" */
export enum Tracking_Nursing_Update_Column {
  /** column name */
  BreastInflamed = 'breast_inflamed',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DurationMinutes = 'duration_minutes',
  /** column name */
  Id = 'id',
  /** column name */
  NippleCracked = 'nipple_cracked',
  /** column name */
  Notes = 'notes',
  /** column name */
  Pain = 'pain',
  /** column name */
  PainLevel = 'pain_level',
  /** column name */
  Position = 'position',
  /** column name */
  Side = 'side',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  Tools = 'tools',
  /** column name */
  UserId = 'user_id',
}

export type Tracking_Nursing_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Tracking_Nursing_Append_Input>
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Tracking_Nursing_Delete_At_Path_Input>
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Tracking_Nursing_Delete_Elem_Input>
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Tracking_Nursing_Delete_Key_Input>
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tracking_Nursing_Inc_Input>
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Tracking_Nursing_Prepend_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tracking_Nursing_Set_Input>
  /** filter the rows which have to be updated */
  where: Tracking_Nursing_Bool_Exp
}

/** aggregate var_pop on columns */
export type Tracking_Nursing_Var_Pop_Fields = {
  __typename?: 'tracking_nursing_var_pop_fields'
  duration_minutes?: Maybe<Scalars['Float']['output']>
  pain_level?: Maybe<Scalars['Float']['output']>
}

/** aggregate var_samp on columns */
export type Tracking_Nursing_Var_Samp_Fields = {
  __typename?: 'tracking_nursing_var_samp_fields'
  duration_minutes?: Maybe<Scalars['Float']['output']>
  pain_level?: Maybe<Scalars['Float']['output']>
}

/** aggregate variance on columns */
export type Tracking_Nursing_Variance_Fields = {
  __typename?: 'tracking_nursing_variance_fields'
  duration_minutes?: Maybe<Scalars['Float']['output']>
  pain_level?: Maybe<Scalars['Float']['output']>
}

/** columns and relationships of "tracking_substance" */
export type Tracking_Substance = {
  __typename?: 'tracking_substance'
  category: Scalars['String']['output']
  created_at: Scalars['timestamptz']['output']
  id: Scalars['uuid']['output']
  name: Scalars['String']['output']
  notes?: Maybe<Scalars['String']['output']>
  timestamp: Scalars['timestamptz']['output']
  user_id: Scalars['uuid']['output']
}

/** aggregated selection of "tracking_substance" */
export type Tracking_Substance_Aggregate = {
  __typename?: 'tracking_substance_aggregate'
  aggregate?: Maybe<Tracking_Substance_Aggregate_Fields>
  nodes: Array<Tracking_Substance>
}

/** aggregate fields of "tracking_substance" */
export type Tracking_Substance_Aggregate_Fields = {
  __typename?: 'tracking_substance_aggregate_fields'
  count: Scalars['Int']['output']
  max?: Maybe<Tracking_Substance_Max_Fields>
  min?: Maybe<Tracking_Substance_Min_Fields>
}

/** aggregate fields of "tracking_substance" */
export type Tracking_Substance_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tracking_Substance_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** Boolean expression to filter rows from the table "tracking_substance". All fields are combined with a logical 'AND'. */
export type Tracking_Substance_Bool_Exp = {
  _and?: InputMaybe<Array<Tracking_Substance_Bool_Exp>>
  _not?: InputMaybe<Tracking_Substance_Bool_Exp>
  _or?: InputMaybe<Array<Tracking_Substance_Bool_Exp>>
  category?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  id?: InputMaybe<Uuid_Comparison_Exp>
  name?: InputMaybe<String_Comparison_Exp>
  notes?: InputMaybe<String_Comparison_Exp>
  timestamp?: InputMaybe<Timestamptz_Comparison_Exp>
  user_id?: InputMaybe<Uuid_Comparison_Exp>
}

/** unique or primary key constraints on table "tracking_substance" */
export enum Tracking_Substance_Constraint {
  /** unique or primary key constraint on columns "id" */
  TrackingSubstancePkey = 'tracking_substance_pkey',
}

/** input type for inserting data into table "tracking_substance" */
export type Tracking_Substance_Insert_Input = {
  category?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  timestamp?: InputMaybe<Scalars['timestamptz']['input']>
  user_id?: InputMaybe<Scalars['uuid']['input']>
}

/** aggregate max on columns */
export type Tracking_Substance_Max_Fields = {
  __typename?: 'tracking_substance_max_fields'
  category?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['uuid']['output']>
  name?: Maybe<Scalars['String']['output']>
  notes?: Maybe<Scalars['String']['output']>
  timestamp?: Maybe<Scalars['timestamptz']['output']>
  user_id?: Maybe<Scalars['uuid']['output']>
}

/** aggregate min on columns */
export type Tracking_Substance_Min_Fields = {
  __typename?: 'tracking_substance_min_fields'
  category?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['uuid']['output']>
  name?: Maybe<Scalars['String']['output']>
  notes?: Maybe<Scalars['String']['output']>
  timestamp?: Maybe<Scalars['timestamptz']['output']>
  user_id?: Maybe<Scalars['uuid']['output']>
}

/** response of any mutation on the table "tracking_substance" */
export type Tracking_Substance_Mutation_Response = {
  __typename?: 'tracking_substance_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Tracking_Substance>
}

/** on_conflict condition type for table "tracking_substance" */
export type Tracking_Substance_On_Conflict = {
  constraint: Tracking_Substance_Constraint
  update_columns?: Array<Tracking_Substance_Update_Column>
  where?: InputMaybe<Tracking_Substance_Bool_Exp>
}

/** Ordering options when selecting data from "tracking_substance". */
export type Tracking_Substance_Order_By = {
  category?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  name?: InputMaybe<Order_By>
  notes?: InputMaybe<Order_By>
  timestamp?: InputMaybe<Order_By>
  user_id?: InputMaybe<Order_By>
}

/** primary key columns input for table: tracking_substance */
export type Tracking_Substance_Pk_Columns_Input = {
  id: Scalars['uuid']['input']
}

/** select columns of table "tracking_substance" */
export enum Tracking_Substance_Select_Column {
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Notes = 'notes',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  UserId = 'user_id',
}

/** input type for updating data in table "tracking_substance" */
export type Tracking_Substance_Set_Input = {
  category?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  timestamp?: InputMaybe<Scalars['timestamptz']['input']>
  user_id?: InputMaybe<Scalars['uuid']['input']>
}

/** Streaming cursor of the table "tracking_substance" */
export type Tracking_Substance_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tracking_Substance_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Tracking_Substance_Stream_Cursor_Value_Input = {
  category?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  timestamp?: InputMaybe<Scalars['timestamptz']['input']>
  user_id?: InputMaybe<Scalars['uuid']['input']>
}

/** update columns of table "tracking_substance" */
export enum Tracking_Substance_Update_Column {
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Notes = 'notes',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  UserId = 'user_id',
}

export type Tracking_Substance_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tracking_Substance_Set_Input>
  /** filter the rows which have to be updated */
  where: Tracking_Substance_Bool_Exp
}

/** columns and relationships of "tracking_tonguetie" */
export type Tracking_Tonguetie = {
  __typename?: 'tracking_tonguetie'
  anterior: Scalars['Boolean']['output']
  consideration: Scalars['Boolean']['output']
  created_at: Scalars['timestamptz']['output']
  diagnosed: Scalars['Boolean']['output']
  id: Scalars['uuid']['output']
  notes?: Maybe<Scalars['String']['output']>
  posterior: Scalars['Boolean']['output']
  timestamp: Scalars['timestamptz']['output']
  treated: Scalars['Boolean']['output']
  treated_by?: Maybe<Scalars['String']['output']>
  user_id: Scalars['uuid']['output']
}

/** aggregated selection of "tracking_tonguetie" */
export type Tracking_Tonguetie_Aggregate = {
  __typename?: 'tracking_tonguetie_aggregate'
  aggregate?: Maybe<Tracking_Tonguetie_Aggregate_Fields>
  nodes: Array<Tracking_Tonguetie>
}

/** aggregate fields of "tracking_tonguetie" */
export type Tracking_Tonguetie_Aggregate_Fields = {
  __typename?: 'tracking_tonguetie_aggregate_fields'
  count: Scalars['Int']['output']
  max?: Maybe<Tracking_Tonguetie_Max_Fields>
  min?: Maybe<Tracking_Tonguetie_Min_Fields>
}

/** aggregate fields of "tracking_tonguetie" */
export type Tracking_Tonguetie_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tracking_Tonguetie_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** Boolean expression to filter rows from the table "tracking_tonguetie". All fields are combined with a logical 'AND'. */
export type Tracking_Tonguetie_Bool_Exp = {
  _and?: InputMaybe<Array<Tracking_Tonguetie_Bool_Exp>>
  _not?: InputMaybe<Tracking_Tonguetie_Bool_Exp>
  _or?: InputMaybe<Array<Tracking_Tonguetie_Bool_Exp>>
  anterior?: InputMaybe<Boolean_Comparison_Exp>
  consideration?: InputMaybe<Boolean_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  diagnosed?: InputMaybe<Boolean_Comparison_Exp>
  id?: InputMaybe<Uuid_Comparison_Exp>
  notes?: InputMaybe<String_Comparison_Exp>
  posterior?: InputMaybe<Boolean_Comparison_Exp>
  timestamp?: InputMaybe<Timestamptz_Comparison_Exp>
  treated?: InputMaybe<Boolean_Comparison_Exp>
  treated_by?: InputMaybe<String_Comparison_Exp>
  user_id?: InputMaybe<Uuid_Comparison_Exp>
}

/** unique or primary key constraints on table "tracking_tonguetie" */
export enum Tracking_Tonguetie_Constraint {
  /** unique or primary key constraint on columns "id" */
  TrackingTonguetiePkey = 'tracking_tonguetie_pkey',
}

/** input type for inserting data into table "tracking_tonguetie" */
export type Tracking_Tonguetie_Insert_Input = {
  anterior?: InputMaybe<Scalars['Boolean']['input']>
  consideration?: InputMaybe<Scalars['Boolean']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  diagnosed?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  posterior?: InputMaybe<Scalars['Boolean']['input']>
  timestamp?: InputMaybe<Scalars['timestamptz']['input']>
  treated?: InputMaybe<Scalars['Boolean']['input']>
  treated_by?: InputMaybe<Scalars['String']['input']>
  user_id?: InputMaybe<Scalars['uuid']['input']>
}

/** aggregate max on columns */
export type Tracking_Tonguetie_Max_Fields = {
  __typename?: 'tracking_tonguetie_max_fields'
  created_at?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['uuid']['output']>
  notes?: Maybe<Scalars['String']['output']>
  timestamp?: Maybe<Scalars['timestamptz']['output']>
  treated_by?: Maybe<Scalars['String']['output']>
  user_id?: Maybe<Scalars['uuid']['output']>
}

/** aggregate min on columns */
export type Tracking_Tonguetie_Min_Fields = {
  __typename?: 'tracking_tonguetie_min_fields'
  created_at?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['uuid']['output']>
  notes?: Maybe<Scalars['String']['output']>
  timestamp?: Maybe<Scalars['timestamptz']['output']>
  treated_by?: Maybe<Scalars['String']['output']>
  user_id?: Maybe<Scalars['uuid']['output']>
}

/** response of any mutation on the table "tracking_tonguetie" */
export type Tracking_Tonguetie_Mutation_Response = {
  __typename?: 'tracking_tonguetie_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Tracking_Tonguetie>
}

/** on_conflict condition type for table "tracking_tonguetie" */
export type Tracking_Tonguetie_On_Conflict = {
  constraint: Tracking_Tonguetie_Constraint
  update_columns?: Array<Tracking_Tonguetie_Update_Column>
  where?: InputMaybe<Tracking_Tonguetie_Bool_Exp>
}

/** Ordering options when selecting data from "tracking_tonguetie". */
export type Tracking_Tonguetie_Order_By = {
  anterior?: InputMaybe<Order_By>
  consideration?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  diagnosed?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  notes?: InputMaybe<Order_By>
  posterior?: InputMaybe<Order_By>
  timestamp?: InputMaybe<Order_By>
  treated?: InputMaybe<Order_By>
  treated_by?: InputMaybe<Order_By>
  user_id?: InputMaybe<Order_By>
}

/** primary key columns input for table: tracking_tonguetie */
export type Tracking_Tonguetie_Pk_Columns_Input = {
  id: Scalars['uuid']['input']
}

/** select columns of table "tracking_tonguetie" */
export enum Tracking_Tonguetie_Select_Column {
  /** column name */
  Anterior = 'anterior',
  /** column name */
  Consideration = 'consideration',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Diagnosed = 'diagnosed',
  /** column name */
  Id = 'id',
  /** column name */
  Notes = 'notes',
  /** column name */
  Posterior = 'posterior',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  Treated = 'treated',
  /** column name */
  TreatedBy = 'treated_by',
  /** column name */
  UserId = 'user_id',
}

/** input type for updating data in table "tracking_tonguetie" */
export type Tracking_Tonguetie_Set_Input = {
  anterior?: InputMaybe<Scalars['Boolean']['input']>
  consideration?: InputMaybe<Scalars['Boolean']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  diagnosed?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  posterior?: InputMaybe<Scalars['Boolean']['input']>
  timestamp?: InputMaybe<Scalars['timestamptz']['input']>
  treated?: InputMaybe<Scalars['Boolean']['input']>
  treated_by?: InputMaybe<Scalars['String']['input']>
  user_id?: InputMaybe<Scalars['uuid']['input']>
}

/** Streaming cursor of the table "tracking_tonguetie" */
export type Tracking_Tonguetie_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tracking_Tonguetie_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Tracking_Tonguetie_Stream_Cursor_Value_Input = {
  anterior?: InputMaybe<Scalars['Boolean']['input']>
  consideration?: InputMaybe<Scalars['Boolean']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  diagnosed?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  posterior?: InputMaybe<Scalars['Boolean']['input']>
  timestamp?: InputMaybe<Scalars['timestamptz']['input']>
  treated?: InputMaybe<Scalars['Boolean']['input']>
  treated_by?: InputMaybe<Scalars['String']['input']>
  user_id?: InputMaybe<Scalars['uuid']['input']>
}

/** update columns of table "tracking_tonguetie" */
export enum Tracking_Tonguetie_Update_Column {
  /** column name */
  Anterior = 'anterior',
  /** column name */
  Consideration = 'consideration',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Diagnosed = 'diagnosed',
  /** column name */
  Id = 'id',
  /** column name */
  Notes = 'notes',
  /** column name */
  Posterior = 'posterior',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  Treated = 'treated',
  /** column name */
  TreatedBy = 'treated_by',
  /** column name */
  UserId = 'user_id',
}

export type Tracking_Tonguetie_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tracking_Tonguetie_Set_Input>
  /** filter the rows which have to be updated */
  where: Tracking_Tonguetie_Bool_Exp
}

/** columns and relationships of "tracking_weight" */
export type Tracking_Weight = {
  __typename?: 'tracking_weight'
  created_at?: Maybe<Scalars['timestamptz']['output']>
  id: Scalars['uuid']['output']
  notes?: Maybe<Scalars['String']['output']>
  timestamp: Scalars['timestamptz']['output']
  /** An object relationship */
  user: Users
  user_id: Scalars['uuid']['output']
  weight_grams: Scalars['Int']['output']
}

/** aggregated selection of "tracking_weight" */
export type Tracking_Weight_Aggregate = {
  __typename?: 'tracking_weight_aggregate'
  aggregate?: Maybe<Tracking_Weight_Aggregate_Fields>
  nodes: Array<Tracking_Weight>
}

/** aggregate fields of "tracking_weight" */
export type Tracking_Weight_Aggregate_Fields = {
  __typename?: 'tracking_weight_aggregate_fields'
  avg?: Maybe<Tracking_Weight_Avg_Fields>
  count: Scalars['Int']['output']
  max?: Maybe<Tracking_Weight_Max_Fields>
  min?: Maybe<Tracking_Weight_Min_Fields>
  stddev?: Maybe<Tracking_Weight_Stddev_Fields>
  stddev_pop?: Maybe<Tracking_Weight_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Tracking_Weight_Stddev_Samp_Fields>
  sum?: Maybe<Tracking_Weight_Sum_Fields>
  var_pop?: Maybe<Tracking_Weight_Var_Pop_Fields>
  var_samp?: Maybe<Tracking_Weight_Var_Samp_Fields>
  variance?: Maybe<Tracking_Weight_Variance_Fields>
}

/** aggregate fields of "tracking_weight" */
export type Tracking_Weight_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tracking_Weight_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** aggregate avg on columns */
export type Tracking_Weight_Avg_Fields = {
  __typename?: 'tracking_weight_avg_fields'
  weight_grams?: Maybe<Scalars['Float']['output']>
}

/** Boolean expression to filter rows from the table "tracking_weight". All fields are combined with a logical 'AND'. */
export type Tracking_Weight_Bool_Exp = {
  _and?: InputMaybe<Array<Tracking_Weight_Bool_Exp>>
  _not?: InputMaybe<Tracking_Weight_Bool_Exp>
  _or?: InputMaybe<Array<Tracking_Weight_Bool_Exp>>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  id?: InputMaybe<Uuid_Comparison_Exp>
  notes?: InputMaybe<String_Comparison_Exp>
  timestamp?: InputMaybe<Timestamptz_Comparison_Exp>
  user?: InputMaybe<Users_Bool_Exp>
  user_id?: InputMaybe<Uuid_Comparison_Exp>
  weight_grams?: InputMaybe<Int_Comparison_Exp>
}

/** unique or primary key constraints on table "tracking_weight" */
export enum Tracking_Weight_Constraint {
  /** unique or primary key constraint on columns "id" */
  TrackingWeightPkey = 'tracking_weight_pkey',
}

/** input type for incrementing numeric columns in table "tracking_weight" */
export type Tracking_Weight_Inc_Input = {
  weight_grams?: InputMaybe<Scalars['Int']['input']>
}

/** input type for inserting data into table "tracking_weight" */
export type Tracking_Weight_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  timestamp?: InputMaybe<Scalars['timestamptz']['input']>
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>
  user_id?: InputMaybe<Scalars['uuid']['input']>
  weight_grams?: InputMaybe<Scalars['Int']['input']>
}

/** aggregate max on columns */
export type Tracking_Weight_Max_Fields = {
  __typename?: 'tracking_weight_max_fields'
  created_at?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['uuid']['output']>
  notes?: Maybe<Scalars['String']['output']>
  timestamp?: Maybe<Scalars['timestamptz']['output']>
  user_id?: Maybe<Scalars['uuid']['output']>
  weight_grams?: Maybe<Scalars['Int']['output']>
}

/** aggregate min on columns */
export type Tracking_Weight_Min_Fields = {
  __typename?: 'tracking_weight_min_fields'
  created_at?: Maybe<Scalars['timestamptz']['output']>
  id?: Maybe<Scalars['uuid']['output']>
  notes?: Maybe<Scalars['String']['output']>
  timestamp?: Maybe<Scalars['timestamptz']['output']>
  user_id?: Maybe<Scalars['uuid']['output']>
  weight_grams?: Maybe<Scalars['Int']['output']>
}

/** response of any mutation on the table "tracking_weight" */
export type Tracking_Weight_Mutation_Response = {
  __typename?: 'tracking_weight_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Tracking_Weight>
}

/** on_conflict condition type for table "tracking_weight" */
export type Tracking_Weight_On_Conflict = {
  constraint: Tracking_Weight_Constraint
  update_columns?: Array<Tracking_Weight_Update_Column>
  where?: InputMaybe<Tracking_Weight_Bool_Exp>
}

/** Ordering options when selecting data from "tracking_weight". */
export type Tracking_Weight_Order_By = {
  created_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  notes?: InputMaybe<Order_By>
  timestamp?: InputMaybe<Order_By>
  user?: InputMaybe<Users_Order_By>
  user_id?: InputMaybe<Order_By>
  weight_grams?: InputMaybe<Order_By>
}

/** primary key columns input for table: tracking_weight */
export type Tracking_Weight_Pk_Columns_Input = {
  id: Scalars['uuid']['input']
}

/** select columns of table "tracking_weight" */
export enum Tracking_Weight_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Notes = 'notes',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  UserId = 'user_id',
  /** column name */
  WeightGrams = 'weight_grams',
}

/** input type for updating data in table "tracking_weight" */
export type Tracking_Weight_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  timestamp?: InputMaybe<Scalars['timestamptz']['input']>
  user_id?: InputMaybe<Scalars['uuid']['input']>
  weight_grams?: InputMaybe<Scalars['Int']['input']>
}

/** aggregate stddev on columns */
export type Tracking_Weight_Stddev_Fields = {
  __typename?: 'tracking_weight_stddev_fields'
  weight_grams?: Maybe<Scalars['Float']['output']>
}

/** aggregate stddev_pop on columns */
export type Tracking_Weight_Stddev_Pop_Fields = {
  __typename?: 'tracking_weight_stddev_pop_fields'
  weight_grams?: Maybe<Scalars['Float']['output']>
}

/** aggregate stddev_samp on columns */
export type Tracking_Weight_Stddev_Samp_Fields = {
  __typename?: 'tracking_weight_stddev_samp_fields'
  weight_grams?: Maybe<Scalars['Float']['output']>
}

/** Streaming cursor of the table "tracking_weight" */
export type Tracking_Weight_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tracking_Weight_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Tracking_Weight_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  timestamp?: InputMaybe<Scalars['timestamptz']['input']>
  user_id?: InputMaybe<Scalars['uuid']['input']>
  weight_grams?: InputMaybe<Scalars['Int']['input']>
}

/** aggregate sum on columns */
export type Tracking_Weight_Sum_Fields = {
  __typename?: 'tracking_weight_sum_fields'
  weight_grams?: Maybe<Scalars['Int']['output']>
}

/** update columns of table "tracking_weight" */
export enum Tracking_Weight_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Notes = 'notes',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  UserId = 'user_id',
  /** column name */
  WeightGrams = 'weight_grams',
}

export type Tracking_Weight_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tracking_Weight_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tracking_Weight_Set_Input>
  /** filter the rows which have to be updated */
  where: Tracking_Weight_Bool_Exp
}

/** aggregate var_pop on columns */
export type Tracking_Weight_Var_Pop_Fields = {
  __typename?: 'tracking_weight_var_pop_fields'
  weight_grams?: Maybe<Scalars['Float']['output']>
}

/** aggregate var_samp on columns */
export type Tracking_Weight_Var_Samp_Fields = {
  __typename?: 'tracking_weight_var_samp_fields'
  weight_grams?: Maybe<Scalars['Float']['output']>
}

/** aggregate variance on columns */
export type Tracking_Weight_Variance_Fields = {
  __typename?: 'tracking_weight_variance_fields'
  weight_grams?: Maybe<Scalars['Float']['output']>
}

/** columns and relationships of "user_profiles" */
export type User_Profiles = {
  __typename?: 'user_profiles'
  ai_consent_at?: Maybe<Scalars['timestamptz']['output']>
  avatar_file_id?: Maybe<Scalars['uuid']['output']>
  completed_chapters?: Maybe<Scalars['jsonb']['output']>
  connected_midwife_id?: Maybe<Scalars['uuid']['output']>
  created_at: Scalars['timestamptz']['output']
  current_article_slug?: Maybe<Scalars['String']['output']>
  current_audio_position?: Maybe<Scalars['Int']['output']>
  current_chapter_slug?: Maybe<Scalars['String']['output']>
  due_date?: Maybe<Scalars['date']['output']>
  hide_intro_sections?: Maybe<Scalars['Boolean']['output']>
  hide_outro_sections?: Maybe<Scalars['Boolean']['output']>
  id: Scalars['uuid']['output']
  paid?: Maybe<Scalars['Boolean']['output']>
  qm_consent_at?: Maybe<Scalars['timestamptz']['output']>
  /** An object relationship */
  user: Users
  user_id: Scalars['uuid']['output']
}

/** columns and relationships of "user_profiles" */
export type User_ProfilesCompleted_ChaptersArgs = {
  path?: InputMaybe<Scalars['String']['input']>
}

/** aggregated selection of "user_profiles" */
export type User_Profiles_Aggregate = {
  __typename?: 'user_profiles_aggregate'
  aggregate?: Maybe<User_Profiles_Aggregate_Fields>
  nodes: Array<User_Profiles>
}

export type User_Profiles_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<User_Profiles_Aggregate_Bool_Exp_Bool_And>
  bool_or?: InputMaybe<User_Profiles_Aggregate_Bool_Exp_Bool_Or>
  count?: InputMaybe<User_Profiles_Aggregate_Bool_Exp_Count>
}

export type User_Profiles_Aggregate_Bool_Exp_Bool_And = {
  arguments: User_Profiles_Select_Column_User_Profiles_Aggregate_Bool_Exp_Bool_And_Arguments_Columns
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<User_Profiles_Bool_Exp>
  predicate: Boolean_Comparison_Exp
}

export type User_Profiles_Aggregate_Bool_Exp_Bool_Or = {
  arguments: User_Profiles_Select_Column_User_Profiles_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<User_Profiles_Bool_Exp>
  predicate: Boolean_Comparison_Exp
}

export type User_Profiles_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Profiles_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<User_Profiles_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "user_profiles" */
export type User_Profiles_Aggregate_Fields = {
  __typename?: 'user_profiles_aggregate_fields'
  avg?: Maybe<User_Profiles_Avg_Fields>
  count: Scalars['Int']['output']
  max?: Maybe<User_Profiles_Max_Fields>
  min?: Maybe<User_Profiles_Min_Fields>
  stddev?: Maybe<User_Profiles_Stddev_Fields>
  stddev_pop?: Maybe<User_Profiles_Stddev_Pop_Fields>
  stddev_samp?: Maybe<User_Profiles_Stddev_Samp_Fields>
  sum?: Maybe<User_Profiles_Sum_Fields>
  var_pop?: Maybe<User_Profiles_Var_Pop_Fields>
  var_samp?: Maybe<User_Profiles_Var_Samp_Fields>
  variance?: Maybe<User_Profiles_Variance_Fields>
}

/** aggregate fields of "user_profiles" */
export type User_Profiles_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Profiles_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** order by aggregate values of table "user_profiles" */
export type User_Profiles_Aggregate_Order_By = {
  avg?: InputMaybe<User_Profiles_Avg_Order_By>
  count?: InputMaybe<Order_By>
  max?: InputMaybe<User_Profiles_Max_Order_By>
  min?: InputMaybe<User_Profiles_Min_Order_By>
  stddev?: InputMaybe<User_Profiles_Stddev_Order_By>
  stddev_pop?: InputMaybe<User_Profiles_Stddev_Pop_Order_By>
  stddev_samp?: InputMaybe<User_Profiles_Stddev_Samp_Order_By>
  sum?: InputMaybe<User_Profiles_Sum_Order_By>
  var_pop?: InputMaybe<User_Profiles_Var_Pop_Order_By>
  var_samp?: InputMaybe<User_Profiles_Var_Samp_Order_By>
  variance?: InputMaybe<User_Profiles_Variance_Order_By>
}

/** append existing jsonb value of filtered columns with new jsonb value */
export type User_Profiles_Append_Input = {
  completed_chapters?: InputMaybe<Scalars['jsonb']['input']>
}

/** input type for inserting array relation for remote table "user_profiles" */
export type User_Profiles_Arr_Rel_Insert_Input = {
  data: Array<User_Profiles_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<User_Profiles_On_Conflict>
}

/** aggregate avg on columns */
export type User_Profiles_Avg_Fields = {
  __typename?: 'user_profiles_avg_fields'
  current_audio_position?: Maybe<Scalars['Float']['output']>
}

/** order by avg() on columns of table "user_profiles" */
export type User_Profiles_Avg_Order_By = {
  current_audio_position?: InputMaybe<Order_By>
}

/** Boolean expression to filter rows from the table "user_profiles". All fields are combined with a logical 'AND'. */
export type User_Profiles_Bool_Exp = {
  _and?: InputMaybe<Array<User_Profiles_Bool_Exp>>
  _not?: InputMaybe<User_Profiles_Bool_Exp>
  _or?: InputMaybe<Array<User_Profiles_Bool_Exp>>
  ai_consent_at?: InputMaybe<Timestamptz_Comparison_Exp>
  avatar_file_id?: InputMaybe<Uuid_Comparison_Exp>
  completed_chapters?: InputMaybe<Jsonb_Comparison_Exp>
  connected_midwife_id?: InputMaybe<Uuid_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  current_article_slug?: InputMaybe<String_Comparison_Exp>
  current_audio_position?: InputMaybe<Int_Comparison_Exp>
  current_chapter_slug?: InputMaybe<String_Comparison_Exp>
  due_date?: InputMaybe<Date_Comparison_Exp>
  hide_intro_sections?: InputMaybe<Boolean_Comparison_Exp>
  hide_outro_sections?: InputMaybe<Boolean_Comparison_Exp>
  id?: InputMaybe<Uuid_Comparison_Exp>
  paid?: InputMaybe<Boolean_Comparison_Exp>
  qm_consent_at?: InputMaybe<Timestamptz_Comparison_Exp>
  user?: InputMaybe<Users_Bool_Exp>
  user_id?: InputMaybe<Uuid_Comparison_Exp>
}

/** unique or primary key constraints on table "user_profiles" */
export enum User_Profiles_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserProfilesPkey = 'user_profiles_pkey',
  /** unique or primary key constraint on columns "user_id" */
  UserProfilesUserIdKey = 'user_profiles_user_id_key',
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type User_Profiles_Delete_At_Path_Input = {
  completed_chapters?: InputMaybe<Array<Scalars['String']['input']>>
}

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type User_Profiles_Delete_Elem_Input = {
  completed_chapters?: InputMaybe<Scalars['Int']['input']>
}

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type User_Profiles_Delete_Key_Input = {
  completed_chapters?: InputMaybe<Scalars['String']['input']>
}

/** input type for incrementing numeric columns in table "user_profiles" */
export type User_Profiles_Inc_Input = {
  current_audio_position?: InputMaybe<Scalars['Int']['input']>
}

/** input type for inserting data into table "user_profiles" */
export type User_Profiles_Insert_Input = {
  ai_consent_at?: InputMaybe<Scalars['timestamptz']['input']>
  avatar_file_id?: InputMaybe<Scalars['uuid']['input']>
  completed_chapters?: InputMaybe<Scalars['jsonb']['input']>
  connected_midwife_id?: InputMaybe<Scalars['uuid']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  current_article_slug?: InputMaybe<Scalars['String']['input']>
  current_audio_position?: InputMaybe<Scalars['Int']['input']>
  current_chapter_slug?: InputMaybe<Scalars['String']['input']>
  due_date?: InputMaybe<Scalars['date']['input']>
  hide_intro_sections?: InputMaybe<Scalars['Boolean']['input']>
  hide_outro_sections?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  paid?: InputMaybe<Scalars['Boolean']['input']>
  qm_consent_at?: InputMaybe<Scalars['timestamptz']['input']>
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>
  user_id?: InputMaybe<Scalars['uuid']['input']>
}

/** aggregate max on columns */
export type User_Profiles_Max_Fields = {
  __typename?: 'user_profiles_max_fields'
  ai_consent_at?: Maybe<Scalars['timestamptz']['output']>
  avatar_file_id?: Maybe<Scalars['uuid']['output']>
  connected_midwife_id?: Maybe<Scalars['uuid']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  current_article_slug?: Maybe<Scalars['String']['output']>
  current_audio_position?: Maybe<Scalars['Int']['output']>
  current_chapter_slug?: Maybe<Scalars['String']['output']>
  due_date?: Maybe<Scalars['date']['output']>
  id?: Maybe<Scalars['uuid']['output']>
  qm_consent_at?: Maybe<Scalars['timestamptz']['output']>
  user_id?: Maybe<Scalars['uuid']['output']>
}

/** order by max() on columns of table "user_profiles" */
export type User_Profiles_Max_Order_By = {
  ai_consent_at?: InputMaybe<Order_By>
  avatar_file_id?: InputMaybe<Order_By>
  connected_midwife_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  current_article_slug?: InputMaybe<Order_By>
  current_audio_position?: InputMaybe<Order_By>
  current_chapter_slug?: InputMaybe<Order_By>
  due_date?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  qm_consent_at?: InputMaybe<Order_By>
  user_id?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type User_Profiles_Min_Fields = {
  __typename?: 'user_profiles_min_fields'
  ai_consent_at?: Maybe<Scalars['timestamptz']['output']>
  avatar_file_id?: Maybe<Scalars['uuid']['output']>
  connected_midwife_id?: Maybe<Scalars['uuid']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  current_article_slug?: Maybe<Scalars['String']['output']>
  current_audio_position?: Maybe<Scalars['Int']['output']>
  current_chapter_slug?: Maybe<Scalars['String']['output']>
  due_date?: Maybe<Scalars['date']['output']>
  id?: Maybe<Scalars['uuid']['output']>
  qm_consent_at?: Maybe<Scalars['timestamptz']['output']>
  user_id?: Maybe<Scalars['uuid']['output']>
}

/** order by min() on columns of table "user_profiles" */
export type User_Profiles_Min_Order_By = {
  ai_consent_at?: InputMaybe<Order_By>
  avatar_file_id?: InputMaybe<Order_By>
  connected_midwife_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  current_article_slug?: InputMaybe<Order_By>
  current_audio_position?: InputMaybe<Order_By>
  current_chapter_slug?: InputMaybe<Order_By>
  due_date?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  qm_consent_at?: InputMaybe<Order_By>
  user_id?: InputMaybe<Order_By>
}

/** response of any mutation on the table "user_profiles" */
export type User_Profiles_Mutation_Response = {
  __typename?: 'user_profiles_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<User_Profiles>
}

/** input type for inserting object relation for remote table "user_profiles" */
export type User_Profiles_Obj_Rel_Insert_Input = {
  data: User_Profiles_Insert_Input
  /** upsert condition */
  on_conflict?: InputMaybe<User_Profiles_On_Conflict>
}

/** on_conflict condition type for table "user_profiles" */
export type User_Profiles_On_Conflict = {
  constraint: User_Profiles_Constraint
  update_columns?: Array<User_Profiles_Update_Column>
  where?: InputMaybe<User_Profiles_Bool_Exp>
}

/** Ordering options when selecting data from "user_profiles". */
export type User_Profiles_Order_By = {
  ai_consent_at?: InputMaybe<Order_By>
  avatar_file_id?: InputMaybe<Order_By>
  completed_chapters?: InputMaybe<Order_By>
  connected_midwife_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  current_article_slug?: InputMaybe<Order_By>
  current_audio_position?: InputMaybe<Order_By>
  current_chapter_slug?: InputMaybe<Order_By>
  due_date?: InputMaybe<Order_By>
  hide_intro_sections?: InputMaybe<Order_By>
  hide_outro_sections?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  paid?: InputMaybe<Order_By>
  qm_consent_at?: InputMaybe<Order_By>
  user?: InputMaybe<Users_Order_By>
  user_id?: InputMaybe<Order_By>
}

/** primary key columns input for table: user_profiles */
export type User_Profiles_Pk_Columns_Input = {
  id: Scalars['uuid']['input']
}

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type User_Profiles_Prepend_Input = {
  completed_chapters?: InputMaybe<Scalars['jsonb']['input']>
}

/** select columns of table "user_profiles" */
export enum User_Profiles_Select_Column {
  /** column name */
  AiConsentAt = 'ai_consent_at',
  /** column name */
  AvatarFileId = 'avatar_file_id',
  /** column name */
  CompletedChapters = 'completed_chapters',
  /** column name */
  ConnectedMidwifeId = 'connected_midwife_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrentArticleSlug = 'current_article_slug',
  /** column name */
  CurrentAudioPosition = 'current_audio_position',
  /** column name */
  CurrentChapterSlug = 'current_chapter_slug',
  /** column name */
  DueDate = 'due_date',
  /** column name */
  HideIntroSections = 'hide_intro_sections',
  /** column name */
  HideOutroSections = 'hide_outro_sections',
  /** column name */
  Id = 'id',
  /** column name */
  Paid = 'paid',
  /** column name */
  QmConsentAt = 'qm_consent_at',
  /** column name */
  UserId = 'user_id',
}

/** select "user_profiles_aggregate_bool_exp_bool_and_arguments_columns" columns of table "user_profiles" */
export enum User_Profiles_Select_Column_User_Profiles_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  HideIntroSections = 'hide_intro_sections',
  /** column name */
  HideOutroSections = 'hide_outro_sections',
  /** column name */
  Paid = 'paid',
}

/** select "user_profiles_aggregate_bool_exp_bool_or_arguments_columns" columns of table "user_profiles" */
export enum User_Profiles_Select_Column_User_Profiles_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  HideIntroSections = 'hide_intro_sections',
  /** column name */
  HideOutroSections = 'hide_outro_sections',
  /** column name */
  Paid = 'paid',
}

/** input type for updating data in table "user_profiles" */
export type User_Profiles_Set_Input = {
  ai_consent_at?: InputMaybe<Scalars['timestamptz']['input']>
  avatar_file_id?: InputMaybe<Scalars['uuid']['input']>
  completed_chapters?: InputMaybe<Scalars['jsonb']['input']>
  connected_midwife_id?: InputMaybe<Scalars['uuid']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  current_article_slug?: InputMaybe<Scalars['String']['input']>
  current_audio_position?: InputMaybe<Scalars['Int']['input']>
  current_chapter_slug?: InputMaybe<Scalars['String']['input']>
  due_date?: InputMaybe<Scalars['date']['input']>
  hide_intro_sections?: InputMaybe<Scalars['Boolean']['input']>
  hide_outro_sections?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  paid?: InputMaybe<Scalars['Boolean']['input']>
  qm_consent_at?: InputMaybe<Scalars['timestamptz']['input']>
  user_id?: InputMaybe<Scalars['uuid']['input']>
}

/** aggregate stddev on columns */
export type User_Profiles_Stddev_Fields = {
  __typename?: 'user_profiles_stddev_fields'
  current_audio_position?: Maybe<Scalars['Float']['output']>
}

/** order by stddev() on columns of table "user_profiles" */
export type User_Profiles_Stddev_Order_By = {
  current_audio_position?: InputMaybe<Order_By>
}

/** aggregate stddev_pop on columns */
export type User_Profiles_Stddev_Pop_Fields = {
  __typename?: 'user_profiles_stddev_pop_fields'
  current_audio_position?: Maybe<Scalars['Float']['output']>
}

/** order by stddev_pop() on columns of table "user_profiles" */
export type User_Profiles_Stddev_Pop_Order_By = {
  current_audio_position?: InputMaybe<Order_By>
}

/** aggregate stddev_samp on columns */
export type User_Profiles_Stddev_Samp_Fields = {
  __typename?: 'user_profiles_stddev_samp_fields'
  current_audio_position?: Maybe<Scalars['Float']['output']>
}

/** order by stddev_samp() on columns of table "user_profiles" */
export type User_Profiles_Stddev_Samp_Order_By = {
  current_audio_position?: InputMaybe<Order_By>
}

/** Streaming cursor of the table "user_profiles" */
export type User_Profiles_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Profiles_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type User_Profiles_Stream_Cursor_Value_Input = {
  ai_consent_at?: InputMaybe<Scalars['timestamptz']['input']>
  avatar_file_id?: InputMaybe<Scalars['uuid']['input']>
  completed_chapters?: InputMaybe<Scalars['jsonb']['input']>
  connected_midwife_id?: InputMaybe<Scalars['uuid']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  current_article_slug?: InputMaybe<Scalars['String']['input']>
  current_audio_position?: InputMaybe<Scalars['Int']['input']>
  current_chapter_slug?: InputMaybe<Scalars['String']['input']>
  due_date?: InputMaybe<Scalars['date']['input']>
  hide_intro_sections?: InputMaybe<Scalars['Boolean']['input']>
  hide_outro_sections?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  paid?: InputMaybe<Scalars['Boolean']['input']>
  qm_consent_at?: InputMaybe<Scalars['timestamptz']['input']>
  user_id?: InputMaybe<Scalars['uuid']['input']>
}

/** aggregate sum on columns */
export type User_Profiles_Sum_Fields = {
  __typename?: 'user_profiles_sum_fields'
  current_audio_position?: Maybe<Scalars['Int']['output']>
}

/** order by sum() on columns of table "user_profiles" */
export type User_Profiles_Sum_Order_By = {
  current_audio_position?: InputMaybe<Order_By>
}

/** update columns of table "user_profiles" */
export enum User_Profiles_Update_Column {
  /** column name */
  AiConsentAt = 'ai_consent_at',
  /** column name */
  AvatarFileId = 'avatar_file_id',
  /** column name */
  CompletedChapters = 'completed_chapters',
  /** column name */
  ConnectedMidwifeId = 'connected_midwife_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrentArticleSlug = 'current_article_slug',
  /** column name */
  CurrentAudioPosition = 'current_audio_position',
  /** column name */
  CurrentChapterSlug = 'current_chapter_slug',
  /** column name */
  DueDate = 'due_date',
  /** column name */
  HideIntroSections = 'hide_intro_sections',
  /** column name */
  HideOutroSections = 'hide_outro_sections',
  /** column name */
  Id = 'id',
  /** column name */
  Paid = 'paid',
  /** column name */
  QmConsentAt = 'qm_consent_at',
  /** column name */
  UserId = 'user_id',
}

export type User_Profiles_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<User_Profiles_Append_Input>
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<User_Profiles_Delete_At_Path_Input>
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<User_Profiles_Delete_Elem_Input>
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<User_Profiles_Delete_Key_Input>
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Profiles_Inc_Input>
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<User_Profiles_Prepend_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Profiles_Set_Input>
  /** filter the rows which have to be updated */
  where: User_Profiles_Bool_Exp
}

/** aggregate var_pop on columns */
export type User_Profiles_Var_Pop_Fields = {
  __typename?: 'user_profiles_var_pop_fields'
  current_audio_position?: Maybe<Scalars['Float']['output']>
}

/** order by var_pop() on columns of table "user_profiles" */
export type User_Profiles_Var_Pop_Order_By = {
  current_audio_position?: InputMaybe<Order_By>
}

/** aggregate var_samp on columns */
export type User_Profiles_Var_Samp_Fields = {
  __typename?: 'user_profiles_var_samp_fields'
  current_audio_position?: Maybe<Scalars['Float']['output']>
}

/** order by var_samp() on columns of table "user_profiles" */
export type User_Profiles_Var_Samp_Order_By = {
  current_audio_position?: InputMaybe<Order_By>
}

/** aggregate variance on columns */
export type User_Profiles_Variance_Fields = {
  __typename?: 'user_profiles_variance_fields'
  current_audio_position?: Maybe<Scalars['Float']['output']>
}

/** order by variance() on columns of table "user_profiles" */
export type User_Profiles_Variance_Order_By = {
  current_audio_position?: InputMaybe<Order_By>
}

/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type Users = {
  __typename?: 'users'
  activeMfaType?: Maybe<Scalars['String']['output']>
  avatarUrl: Scalars['String']['output']
  createdAt: Scalars['timestamptz']['output']
  currentChallenge?: Maybe<Scalars['String']['output']>
  defaultRole: Scalars['String']['output']
  /** An object relationship */
  defaultRoleByRole: AuthRoles
  disabled: Scalars['Boolean']['output']
  displayName: Scalars['String']['output']
  email?: Maybe<Scalars['citext']['output']>
  emailVerified: Scalars['Boolean']['output']
  id: Scalars['uuid']['output']
  isAnonymous: Scalars['Boolean']['output']
  lastSeen?: Maybe<Scalars['timestamptz']['output']>
  locale: Scalars['String']['output']
  metadata?: Maybe<Scalars['jsonb']['output']>
  /** An object relationship */
  midwife_profile?: Maybe<Midwife_Profiles>
  newEmail?: Maybe<Scalars['citext']['output']>
  /** An array relationship */
  oauth2AuthRequests: Array<AuthOauth2AuthRequests>
  /** An aggregate relationship */
  oauth2AuthRequests_aggregate: AuthOauth2AuthRequests_Aggregate
  /** An array relationship */
  oauth2RefreshTokens: Array<AuthOauth2RefreshTokens>
  /** An aggregate relationship */
  oauth2RefreshTokens_aggregate: AuthOauth2RefreshTokens_Aggregate
  otpHash?: Maybe<Scalars['String']['output']>
  otpHashExpiresAt: Scalars['timestamptz']['output']
  otpMethodLastUsed?: Maybe<Scalars['String']['output']>
  passwordHash?: Maybe<Scalars['String']['output']>
  phoneNumber?: Maybe<Scalars['String']['output']>
  phoneNumberVerified: Scalars['Boolean']['output']
  /** An array relationship */
  refreshTokens: Array<AuthRefreshTokens>
  /** An aggregate relationship */
  refreshTokens_aggregate: AuthRefreshTokens_Aggregate
  /** An array relationship */
  roles: Array<AuthUserRoles>
  /** An aggregate relationship */
  roles_aggregate: AuthUserRoles_Aggregate
  /** An array relationship */
  securityKeys: Array<AuthUserSecurityKeys>
  /** An aggregate relationship */
  securityKeys_aggregate: AuthUserSecurityKeys_Aggregate
  ticket?: Maybe<Scalars['String']['output']>
  ticketExpiresAt: Scalars['timestamptz']['output']
  totpSecret?: Maybe<Scalars['String']['output']>
  updatedAt: Scalars['timestamptz']['output']
  /** An array relationship */
  userProviders: Array<AuthUserProviders>
  /** An aggregate relationship */
  userProviders_aggregate: AuthUserProviders_Aggregate
  /** An object relationship */
  user_profile?: Maybe<User_Profiles>
}

/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>
}

/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersOauth2AuthRequestsArgs = {
  distinct_on?: InputMaybe<Array<AuthOauth2AuthRequests_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<AuthOauth2AuthRequests_Order_By>>
  where?: InputMaybe<AuthOauth2AuthRequests_Bool_Exp>
}

/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersOauth2AuthRequests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthOauth2AuthRequests_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<AuthOauth2AuthRequests_Order_By>>
  where?: InputMaybe<AuthOauth2AuthRequests_Bool_Exp>
}

/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersOauth2RefreshTokensArgs = {
  distinct_on?: InputMaybe<Array<AuthOauth2RefreshTokens_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<AuthOauth2RefreshTokens_Order_By>>
  where?: InputMaybe<AuthOauth2RefreshTokens_Bool_Exp>
}

/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersOauth2RefreshTokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthOauth2RefreshTokens_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<AuthOauth2RefreshTokens_Order_By>>
  where?: InputMaybe<AuthOauth2RefreshTokens_Bool_Exp>
}

/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersRefreshTokensArgs = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokens_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<AuthRefreshTokens_Order_By>>
  where?: InputMaybe<AuthRefreshTokens_Bool_Exp>
}

/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersRefreshTokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokens_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<AuthRefreshTokens_Order_By>>
  where?: InputMaybe<AuthRefreshTokens_Bool_Exp>
}

/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersRolesArgs = {
  distinct_on?: InputMaybe<Array<AuthUserRoles_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<AuthUserRoles_Order_By>>
  where?: InputMaybe<AuthUserRoles_Bool_Exp>
}

/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersRoles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthUserRoles_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<AuthUserRoles_Order_By>>
  where?: InputMaybe<AuthUserRoles_Bool_Exp>
}

/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersSecurityKeysArgs = {
  distinct_on?: InputMaybe<Array<AuthUserSecurityKeys_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<AuthUserSecurityKeys_Order_By>>
  where?: InputMaybe<AuthUserSecurityKeys_Bool_Exp>
}

/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersSecurityKeys_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthUserSecurityKeys_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<AuthUserSecurityKeys_Order_By>>
  where?: InputMaybe<AuthUserSecurityKeys_Bool_Exp>
}

/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersUserProvidersArgs = {
  distinct_on?: InputMaybe<Array<AuthUserProviders_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<AuthUserProviders_Order_By>>
  where?: InputMaybe<AuthUserProviders_Bool_Exp>
}

/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersUserProviders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthUserProviders_Select_Column>>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  order_by?: InputMaybe<Array<AuthUserProviders_Order_By>>
  where?: InputMaybe<AuthUserProviders_Bool_Exp>
}

/** aggregated selection of "auth.users" */
export type Users_Aggregate = {
  __typename?: 'users_aggregate'
  aggregate?: Maybe<Users_Aggregate_Fields>
  nodes: Array<Users>
}

export type Users_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Users_Aggregate_Bool_Exp_Bool_And>
  bool_or?: InputMaybe<Users_Aggregate_Bool_Exp_Bool_Or>
  count?: InputMaybe<Users_Aggregate_Bool_Exp_Count>
}

export type Users_Aggregate_Bool_Exp_Bool_And = {
  arguments: Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_And_Arguments_Columns
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Users_Bool_Exp>
  predicate: Boolean_Comparison_Exp
}

export type Users_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Users_Bool_Exp>
  predicate: Boolean_Comparison_Exp
}

export type Users_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Users_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
  filter?: InputMaybe<Users_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "auth.users" */
export type Users_Aggregate_Fields = {
  __typename?: 'users_aggregate_fields'
  count: Scalars['Int']['output']
  max?: Maybe<Users_Max_Fields>
  min?: Maybe<Users_Min_Fields>
}

/** aggregate fields of "auth.users" */
export type Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Users_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** order by aggregate values of table "auth.users" */
export type Users_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Users_Max_Order_By>
  min?: InputMaybe<Users_Min_Order_By>
}

/** append existing jsonb value of filtered columns with new jsonb value */
export type Users_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>
}

/** input type for inserting array relation for remote table "auth.users" */
export type Users_Arr_Rel_Insert_Input = {
  data: Array<Users_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Users_On_Conflict>
}

/** Boolean expression to filter rows from the table "auth.users". All fields are combined with a logical 'AND'. */
export type Users_Bool_Exp = {
  _and?: InputMaybe<Array<Users_Bool_Exp>>
  _not?: InputMaybe<Users_Bool_Exp>
  _or?: InputMaybe<Array<Users_Bool_Exp>>
  activeMfaType?: InputMaybe<String_Comparison_Exp>
  avatarUrl?: InputMaybe<String_Comparison_Exp>
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>
  currentChallenge?: InputMaybe<String_Comparison_Exp>
  defaultRole?: InputMaybe<String_Comparison_Exp>
  defaultRoleByRole?: InputMaybe<AuthRoles_Bool_Exp>
  disabled?: InputMaybe<Boolean_Comparison_Exp>
  displayName?: InputMaybe<String_Comparison_Exp>
  email?: InputMaybe<Citext_Comparison_Exp>
  emailVerified?: InputMaybe<Boolean_Comparison_Exp>
  id?: InputMaybe<Uuid_Comparison_Exp>
  isAnonymous?: InputMaybe<Boolean_Comparison_Exp>
  lastSeen?: InputMaybe<Timestamptz_Comparison_Exp>
  locale?: InputMaybe<String_Comparison_Exp>
  metadata?: InputMaybe<Jsonb_Comparison_Exp>
  midwife_profile?: InputMaybe<Midwife_Profiles_Bool_Exp>
  newEmail?: InputMaybe<Citext_Comparison_Exp>
  oauth2AuthRequests?: InputMaybe<AuthOauth2AuthRequests_Bool_Exp>
  oauth2AuthRequests_aggregate?: InputMaybe<AuthOauth2AuthRequests_Aggregate_Bool_Exp>
  oauth2RefreshTokens?: InputMaybe<AuthOauth2RefreshTokens_Bool_Exp>
  oauth2RefreshTokens_aggregate?: InputMaybe<AuthOauth2RefreshTokens_Aggregate_Bool_Exp>
  otpHash?: InputMaybe<String_Comparison_Exp>
  otpHashExpiresAt?: InputMaybe<Timestamptz_Comparison_Exp>
  otpMethodLastUsed?: InputMaybe<String_Comparison_Exp>
  passwordHash?: InputMaybe<String_Comparison_Exp>
  phoneNumber?: InputMaybe<String_Comparison_Exp>
  phoneNumberVerified?: InputMaybe<Boolean_Comparison_Exp>
  refreshTokens?: InputMaybe<AuthRefreshTokens_Bool_Exp>
  refreshTokens_aggregate?: InputMaybe<AuthRefreshTokens_Aggregate_Bool_Exp>
  roles?: InputMaybe<AuthUserRoles_Bool_Exp>
  roles_aggregate?: InputMaybe<AuthUserRoles_Aggregate_Bool_Exp>
  securityKeys?: InputMaybe<AuthUserSecurityKeys_Bool_Exp>
  securityKeys_aggregate?: InputMaybe<AuthUserSecurityKeys_Aggregate_Bool_Exp>
  ticket?: InputMaybe<String_Comparison_Exp>
  ticketExpiresAt?: InputMaybe<Timestamptz_Comparison_Exp>
  totpSecret?: InputMaybe<String_Comparison_Exp>
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>
  userProviders?: InputMaybe<AuthUserProviders_Bool_Exp>
  userProviders_aggregate?: InputMaybe<AuthUserProviders_Aggregate_Bool_Exp>
  user_profile?: InputMaybe<User_Profiles_Bool_Exp>
}

/** unique or primary key constraints on table "auth.users" */
export enum Users_Constraint {
  /** unique or primary key constraint on columns "email" */
  UsersEmailKey = 'users_email_key',
  /** unique or primary key constraint on columns "phone_number" */
  UsersPhoneNumberKey = 'users_phone_number_key',
  /** unique or primary key constraint on columns "id" */
  UsersPkey = 'users_pkey',
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Users_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']['input']>>
}

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Users_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']['input']>
}

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Users_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']['input']>
}

/** input type for inserting data into table "auth.users" */
export type Users_Insert_Input = {
  activeMfaType?: InputMaybe<Scalars['String']['input']>
  avatarUrl?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>
  currentChallenge?: InputMaybe<Scalars['String']['input']>
  defaultRole?: InputMaybe<Scalars['String']['input']>
  defaultRoleByRole?: InputMaybe<AuthRoles_Obj_Rel_Insert_Input>
  disabled?: InputMaybe<Scalars['Boolean']['input']>
  displayName?: InputMaybe<Scalars['String']['input']>
  email?: InputMaybe<Scalars['citext']['input']>
  emailVerified?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  isAnonymous?: InputMaybe<Scalars['Boolean']['input']>
  lastSeen?: InputMaybe<Scalars['timestamptz']['input']>
  locale?: InputMaybe<Scalars['String']['input']>
  metadata?: InputMaybe<Scalars['jsonb']['input']>
  midwife_profile?: InputMaybe<Midwife_Profiles_Obj_Rel_Insert_Input>
  newEmail?: InputMaybe<Scalars['citext']['input']>
  oauth2AuthRequests?: InputMaybe<AuthOauth2AuthRequests_Arr_Rel_Insert_Input>
  oauth2RefreshTokens?: InputMaybe<AuthOauth2RefreshTokens_Arr_Rel_Insert_Input>
  otpHash?: InputMaybe<Scalars['String']['input']>
  otpHashExpiresAt?: InputMaybe<Scalars['timestamptz']['input']>
  otpMethodLastUsed?: InputMaybe<Scalars['String']['input']>
  passwordHash?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<Scalars['String']['input']>
  phoneNumberVerified?: InputMaybe<Scalars['Boolean']['input']>
  refreshTokens?: InputMaybe<AuthRefreshTokens_Arr_Rel_Insert_Input>
  roles?: InputMaybe<AuthUserRoles_Arr_Rel_Insert_Input>
  securityKeys?: InputMaybe<AuthUserSecurityKeys_Arr_Rel_Insert_Input>
  ticket?: InputMaybe<Scalars['String']['input']>
  ticketExpiresAt?: InputMaybe<Scalars['timestamptz']['input']>
  totpSecret?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>
  userProviders?: InputMaybe<AuthUserProviders_Arr_Rel_Insert_Input>
  user_profile?: InputMaybe<User_Profiles_Obj_Rel_Insert_Input>
}

/** aggregate max on columns */
export type Users_Max_Fields = {
  __typename?: 'users_max_fields'
  activeMfaType?: Maybe<Scalars['String']['output']>
  avatarUrl?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['timestamptz']['output']>
  currentChallenge?: Maybe<Scalars['String']['output']>
  defaultRole?: Maybe<Scalars['String']['output']>
  displayName?: Maybe<Scalars['String']['output']>
  email?: Maybe<Scalars['citext']['output']>
  id?: Maybe<Scalars['uuid']['output']>
  lastSeen?: Maybe<Scalars['timestamptz']['output']>
  locale?: Maybe<Scalars['String']['output']>
  newEmail?: Maybe<Scalars['citext']['output']>
  otpHash?: Maybe<Scalars['String']['output']>
  otpHashExpiresAt?: Maybe<Scalars['timestamptz']['output']>
  otpMethodLastUsed?: Maybe<Scalars['String']['output']>
  passwordHash?: Maybe<Scalars['String']['output']>
  phoneNumber?: Maybe<Scalars['String']['output']>
  ticket?: Maybe<Scalars['String']['output']>
  ticketExpiresAt?: Maybe<Scalars['timestamptz']['output']>
  totpSecret?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['timestamptz']['output']>
}

/** order by max() on columns of table "auth.users" */
export type Users_Max_Order_By = {
  activeMfaType?: InputMaybe<Order_By>
  avatarUrl?: InputMaybe<Order_By>
  createdAt?: InputMaybe<Order_By>
  currentChallenge?: InputMaybe<Order_By>
  defaultRole?: InputMaybe<Order_By>
  displayName?: InputMaybe<Order_By>
  email?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  lastSeen?: InputMaybe<Order_By>
  locale?: InputMaybe<Order_By>
  newEmail?: InputMaybe<Order_By>
  otpHash?: InputMaybe<Order_By>
  otpHashExpiresAt?: InputMaybe<Order_By>
  otpMethodLastUsed?: InputMaybe<Order_By>
  passwordHash?: InputMaybe<Order_By>
  phoneNumber?: InputMaybe<Order_By>
  ticket?: InputMaybe<Order_By>
  ticketExpiresAt?: InputMaybe<Order_By>
  totpSecret?: InputMaybe<Order_By>
  updatedAt?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Users_Min_Fields = {
  __typename?: 'users_min_fields'
  activeMfaType?: Maybe<Scalars['String']['output']>
  avatarUrl?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['timestamptz']['output']>
  currentChallenge?: Maybe<Scalars['String']['output']>
  defaultRole?: Maybe<Scalars['String']['output']>
  displayName?: Maybe<Scalars['String']['output']>
  email?: Maybe<Scalars['citext']['output']>
  id?: Maybe<Scalars['uuid']['output']>
  lastSeen?: Maybe<Scalars['timestamptz']['output']>
  locale?: Maybe<Scalars['String']['output']>
  newEmail?: Maybe<Scalars['citext']['output']>
  otpHash?: Maybe<Scalars['String']['output']>
  otpHashExpiresAt?: Maybe<Scalars['timestamptz']['output']>
  otpMethodLastUsed?: Maybe<Scalars['String']['output']>
  passwordHash?: Maybe<Scalars['String']['output']>
  phoneNumber?: Maybe<Scalars['String']['output']>
  ticket?: Maybe<Scalars['String']['output']>
  ticketExpiresAt?: Maybe<Scalars['timestamptz']['output']>
  totpSecret?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['timestamptz']['output']>
}

/** order by min() on columns of table "auth.users" */
export type Users_Min_Order_By = {
  activeMfaType?: InputMaybe<Order_By>
  avatarUrl?: InputMaybe<Order_By>
  createdAt?: InputMaybe<Order_By>
  currentChallenge?: InputMaybe<Order_By>
  defaultRole?: InputMaybe<Order_By>
  displayName?: InputMaybe<Order_By>
  email?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  lastSeen?: InputMaybe<Order_By>
  locale?: InputMaybe<Order_By>
  newEmail?: InputMaybe<Order_By>
  otpHash?: InputMaybe<Order_By>
  otpHashExpiresAt?: InputMaybe<Order_By>
  otpMethodLastUsed?: InputMaybe<Order_By>
  passwordHash?: InputMaybe<Order_By>
  phoneNumber?: InputMaybe<Order_By>
  ticket?: InputMaybe<Order_By>
  ticketExpiresAt?: InputMaybe<Order_By>
  totpSecret?: InputMaybe<Order_By>
  updatedAt?: InputMaybe<Order_By>
}

/** response of any mutation on the table "auth.users" */
export type Users_Mutation_Response = {
  __typename?: 'users_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Users>
}

/** input type for inserting object relation for remote table "auth.users" */
export type Users_Obj_Rel_Insert_Input = {
  data: Users_Insert_Input
  /** upsert condition */
  on_conflict?: InputMaybe<Users_On_Conflict>
}

/** on_conflict condition type for table "auth.users" */
export type Users_On_Conflict = {
  constraint: Users_Constraint
  update_columns?: Array<Users_Update_Column>
  where?: InputMaybe<Users_Bool_Exp>
}

/** Ordering options when selecting data from "auth.users". */
export type Users_Order_By = {
  activeMfaType?: InputMaybe<Order_By>
  avatarUrl?: InputMaybe<Order_By>
  createdAt?: InputMaybe<Order_By>
  currentChallenge?: InputMaybe<Order_By>
  defaultRole?: InputMaybe<Order_By>
  defaultRoleByRole?: InputMaybe<AuthRoles_Order_By>
  disabled?: InputMaybe<Order_By>
  displayName?: InputMaybe<Order_By>
  email?: InputMaybe<Order_By>
  emailVerified?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  isAnonymous?: InputMaybe<Order_By>
  lastSeen?: InputMaybe<Order_By>
  locale?: InputMaybe<Order_By>
  metadata?: InputMaybe<Order_By>
  midwife_profile?: InputMaybe<Midwife_Profiles_Order_By>
  newEmail?: InputMaybe<Order_By>
  oauth2AuthRequests_aggregate?: InputMaybe<AuthOauth2AuthRequests_Aggregate_Order_By>
  oauth2RefreshTokens_aggregate?: InputMaybe<AuthOauth2RefreshTokens_Aggregate_Order_By>
  otpHash?: InputMaybe<Order_By>
  otpHashExpiresAt?: InputMaybe<Order_By>
  otpMethodLastUsed?: InputMaybe<Order_By>
  passwordHash?: InputMaybe<Order_By>
  phoneNumber?: InputMaybe<Order_By>
  phoneNumberVerified?: InputMaybe<Order_By>
  refreshTokens_aggregate?: InputMaybe<AuthRefreshTokens_Aggregate_Order_By>
  roles_aggregate?: InputMaybe<AuthUserRoles_Aggregate_Order_By>
  securityKeys_aggregate?: InputMaybe<AuthUserSecurityKeys_Aggregate_Order_By>
  ticket?: InputMaybe<Order_By>
  ticketExpiresAt?: InputMaybe<Order_By>
  totpSecret?: InputMaybe<Order_By>
  updatedAt?: InputMaybe<Order_By>
  userProviders_aggregate?: InputMaybe<AuthUserProviders_Aggregate_Order_By>
  user_profile?: InputMaybe<User_Profiles_Order_By>
}

/** primary key columns input for table: auth.users */
export type Users_Pk_Columns_Input = {
  id: Scalars['uuid']['input']
}

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Users_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>
}

/** select columns of table "auth.users" */
export enum Users_Select_Column {
  /** column name */
  ActiveMfaType = 'activeMfaType',
  /** column name */
  AvatarUrl = 'avatarUrl',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CurrentChallenge = 'currentChallenge',
  /** column name */
  DefaultRole = 'defaultRole',
  /** column name */
  Disabled = 'disabled',
  /** column name */
  DisplayName = 'displayName',
  /** column name */
  Email = 'email',
  /** column name */
  EmailVerified = 'emailVerified',
  /** column name */
  Id = 'id',
  /** column name */
  IsAnonymous = 'isAnonymous',
  /** column name */
  LastSeen = 'lastSeen',
  /** column name */
  Locale = 'locale',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  NewEmail = 'newEmail',
  /** column name */
  OtpHash = 'otpHash',
  /** column name */
  OtpHashExpiresAt = 'otpHashExpiresAt',
  /** column name */
  OtpMethodLastUsed = 'otpMethodLastUsed',
  /** column name */
  PasswordHash = 'passwordHash',
  /** column name */
  PhoneNumber = 'phoneNumber',
  /** column name */
  PhoneNumberVerified = 'phoneNumberVerified',
  /** column name */
  Ticket = 'ticket',
  /** column name */
  TicketExpiresAt = 'ticketExpiresAt',
  /** column name */
  TotpSecret = 'totpSecret',
  /** column name */
  UpdatedAt = 'updatedAt',
}

/** select "users_aggregate_bool_exp_bool_and_arguments_columns" columns of table "auth.users" */
export enum Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Disabled = 'disabled',
  /** column name */
  EmailVerified = 'emailVerified',
  /** column name */
  IsAnonymous = 'isAnonymous',
  /** column name */
  PhoneNumberVerified = 'phoneNumberVerified',
}

/** select "users_aggregate_bool_exp_bool_or_arguments_columns" columns of table "auth.users" */
export enum Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Disabled = 'disabled',
  /** column name */
  EmailVerified = 'emailVerified',
  /** column name */
  IsAnonymous = 'isAnonymous',
  /** column name */
  PhoneNumberVerified = 'phoneNumberVerified',
}

/** input type for updating data in table "auth.users" */
export type Users_Set_Input = {
  activeMfaType?: InputMaybe<Scalars['String']['input']>
  avatarUrl?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>
  currentChallenge?: InputMaybe<Scalars['String']['input']>
  defaultRole?: InputMaybe<Scalars['String']['input']>
  disabled?: InputMaybe<Scalars['Boolean']['input']>
  displayName?: InputMaybe<Scalars['String']['input']>
  email?: InputMaybe<Scalars['citext']['input']>
  emailVerified?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  isAnonymous?: InputMaybe<Scalars['Boolean']['input']>
  lastSeen?: InputMaybe<Scalars['timestamptz']['input']>
  locale?: InputMaybe<Scalars['String']['input']>
  metadata?: InputMaybe<Scalars['jsonb']['input']>
  newEmail?: InputMaybe<Scalars['citext']['input']>
  otpHash?: InputMaybe<Scalars['String']['input']>
  otpHashExpiresAt?: InputMaybe<Scalars['timestamptz']['input']>
  otpMethodLastUsed?: InputMaybe<Scalars['String']['input']>
  passwordHash?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<Scalars['String']['input']>
  phoneNumberVerified?: InputMaybe<Scalars['Boolean']['input']>
  ticket?: InputMaybe<Scalars['String']['input']>
  ticketExpiresAt?: InputMaybe<Scalars['timestamptz']['input']>
  totpSecret?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>
}

/** Streaming cursor of the table "users" */
export type Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Users_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Users_Stream_Cursor_Value_Input = {
  activeMfaType?: InputMaybe<Scalars['String']['input']>
  avatarUrl?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>
  currentChallenge?: InputMaybe<Scalars['String']['input']>
  defaultRole?: InputMaybe<Scalars['String']['input']>
  disabled?: InputMaybe<Scalars['Boolean']['input']>
  displayName?: InputMaybe<Scalars['String']['input']>
  email?: InputMaybe<Scalars['citext']['input']>
  emailVerified?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  isAnonymous?: InputMaybe<Scalars['Boolean']['input']>
  lastSeen?: InputMaybe<Scalars['timestamptz']['input']>
  locale?: InputMaybe<Scalars['String']['input']>
  metadata?: InputMaybe<Scalars['jsonb']['input']>
  newEmail?: InputMaybe<Scalars['citext']['input']>
  otpHash?: InputMaybe<Scalars['String']['input']>
  otpHashExpiresAt?: InputMaybe<Scalars['timestamptz']['input']>
  otpMethodLastUsed?: InputMaybe<Scalars['String']['input']>
  passwordHash?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<Scalars['String']['input']>
  phoneNumberVerified?: InputMaybe<Scalars['Boolean']['input']>
  ticket?: InputMaybe<Scalars['String']['input']>
  ticketExpiresAt?: InputMaybe<Scalars['timestamptz']['input']>
  totpSecret?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>
}

/** update columns of table "auth.users" */
export enum Users_Update_Column {
  /** column name */
  ActiveMfaType = 'activeMfaType',
  /** column name */
  AvatarUrl = 'avatarUrl',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CurrentChallenge = 'currentChallenge',
  /** column name */
  DefaultRole = 'defaultRole',
  /** column name */
  Disabled = 'disabled',
  /** column name */
  DisplayName = 'displayName',
  /** column name */
  Email = 'email',
  /** column name */
  EmailVerified = 'emailVerified',
  /** column name */
  Id = 'id',
  /** column name */
  IsAnonymous = 'isAnonymous',
  /** column name */
  LastSeen = 'lastSeen',
  /** column name */
  Locale = 'locale',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  NewEmail = 'newEmail',
  /** column name */
  OtpHash = 'otpHash',
  /** column name */
  OtpHashExpiresAt = 'otpHashExpiresAt',
  /** column name */
  OtpMethodLastUsed = 'otpMethodLastUsed',
  /** column name */
  PasswordHash = 'passwordHash',
  /** column name */
  PhoneNumber = 'phoneNumber',
  /** column name */
  PhoneNumberVerified = 'phoneNumberVerified',
  /** column name */
  Ticket = 'ticket',
  /** column name */
  TicketExpiresAt = 'ticketExpiresAt',
  /** column name */
  TotpSecret = 'totpSecret',
  /** column name */
  UpdatedAt = 'updatedAt',
}

export type Users_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Users_Append_Input>
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Users_Delete_At_Path_Input>
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Users_Delete_Elem_Input>
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Users_Delete_Key_Input>
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Users_Prepend_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Users_Set_Input>
  /** filter the rows which have to be updated */
  where: Users_Bool_Exp
}

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']['input']>
  _gt?: InputMaybe<Scalars['uuid']['input']>
  _gte?: InputMaybe<Scalars['uuid']['input']>
  _in?: InputMaybe<Array<Scalars['uuid']['input']>>
  _is_null?: InputMaybe<Scalars['Boolean']['input']>
  _lt?: InputMaybe<Scalars['uuid']['input']>
  _lte?: InputMaybe<Scalars['uuid']['input']>
  _neq?: InputMaybe<Scalars['uuid']['input']>
  _nin?: InputMaybe<Array<Scalars['uuid']['input']>>
}

/** columns and relationships of "storage.virus" */
export type Virus = {
  __typename?: 'virus'
  createdAt: Scalars['timestamptz']['output']
  /** An object relationship */
  file: Files
  fileId: Scalars['uuid']['output']
  filename: Scalars['String']['output']
  id: Scalars['uuid']['output']
  updatedAt: Scalars['timestamptz']['output']
  userSession: Scalars['jsonb']['output']
  virus: Scalars['String']['output']
}

/** columns and relationships of "storage.virus" */
export type VirusUserSessionArgs = {
  path?: InputMaybe<Scalars['String']['input']>
}

/** aggregated selection of "storage.virus" */
export type Virus_Aggregate = {
  __typename?: 'virus_aggregate'
  aggregate?: Maybe<Virus_Aggregate_Fields>
  nodes: Array<Virus>
}

/** aggregate fields of "storage.virus" */
export type Virus_Aggregate_Fields = {
  __typename?: 'virus_aggregate_fields'
  count: Scalars['Int']['output']
  max?: Maybe<Virus_Max_Fields>
  min?: Maybe<Virus_Min_Fields>
}

/** aggregate fields of "storage.virus" */
export type Virus_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Virus_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** append existing jsonb value of filtered columns with new jsonb value */
export type Virus_Append_Input = {
  userSession?: InputMaybe<Scalars['jsonb']['input']>
}

/** Boolean expression to filter rows from the table "storage.virus". All fields are combined with a logical 'AND'. */
export type Virus_Bool_Exp = {
  _and?: InputMaybe<Array<Virus_Bool_Exp>>
  _not?: InputMaybe<Virus_Bool_Exp>
  _or?: InputMaybe<Array<Virus_Bool_Exp>>
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>
  file?: InputMaybe<Files_Bool_Exp>
  fileId?: InputMaybe<Uuid_Comparison_Exp>
  filename?: InputMaybe<String_Comparison_Exp>
  id?: InputMaybe<Uuid_Comparison_Exp>
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>
  userSession?: InputMaybe<Jsonb_Comparison_Exp>
  virus?: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "storage.virus" */
export enum Virus_Constraint {
  /** unique or primary key constraint on columns "id" */
  VirusPkey = 'virus_pkey',
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Virus_Delete_At_Path_Input = {
  userSession?: InputMaybe<Array<Scalars['String']['input']>>
}

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Virus_Delete_Elem_Input = {
  userSession?: InputMaybe<Scalars['Int']['input']>
}

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Virus_Delete_Key_Input = {
  userSession?: InputMaybe<Scalars['String']['input']>
}

/** input type for inserting data into table "storage.virus" */
export type Virus_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>
  file?: InputMaybe<Files_Obj_Rel_Insert_Input>
  fileId?: InputMaybe<Scalars['uuid']['input']>
  filename?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>
  userSession?: InputMaybe<Scalars['jsonb']['input']>
  virus?: InputMaybe<Scalars['String']['input']>
}

/** aggregate max on columns */
export type Virus_Max_Fields = {
  __typename?: 'virus_max_fields'
  createdAt?: Maybe<Scalars['timestamptz']['output']>
  fileId?: Maybe<Scalars['uuid']['output']>
  filename?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['uuid']['output']>
  updatedAt?: Maybe<Scalars['timestamptz']['output']>
  virus?: Maybe<Scalars['String']['output']>
}

/** aggregate min on columns */
export type Virus_Min_Fields = {
  __typename?: 'virus_min_fields'
  createdAt?: Maybe<Scalars['timestamptz']['output']>
  fileId?: Maybe<Scalars['uuid']['output']>
  filename?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['uuid']['output']>
  updatedAt?: Maybe<Scalars['timestamptz']['output']>
  virus?: Maybe<Scalars['String']['output']>
}

/** response of any mutation on the table "storage.virus" */
export type Virus_Mutation_Response = {
  __typename?: 'virus_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Virus>
}

/** on_conflict condition type for table "storage.virus" */
export type Virus_On_Conflict = {
  constraint: Virus_Constraint
  update_columns?: Array<Virus_Update_Column>
  where?: InputMaybe<Virus_Bool_Exp>
}

/** Ordering options when selecting data from "storage.virus". */
export type Virus_Order_By = {
  createdAt?: InputMaybe<Order_By>
  file?: InputMaybe<Files_Order_By>
  fileId?: InputMaybe<Order_By>
  filename?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  updatedAt?: InputMaybe<Order_By>
  userSession?: InputMaybe<Order_By>
  virus?: InputMaybe<Order_By>
}

/** primary key columns input for table: storage.virus */
export type Virus_Pk_Columns_Input = {
  id: Scalars['uuid']['input']
}

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Virus_Prepend_Input = {
  userSession?: InputMaybe<Scalars['jsonb']['input']>
}

/** select columns of table "storage.virus" */
export enum Virus_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  FileId = 'fileId',
  /** column name */
  Filename = 'filename',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserSession = 'userSession',
  /** column name */
  Virus = 'virus',
}

/** input type for updating data in table "storage.virus" */
export type Virus_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>
  fileId?: InputMaybe<Scalars['uuid']['input']>
  filename?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>
  userSession?: InputMaybe<Scalars['jsonb']['input']>
  virus?: InputMaybe<Scalars['String']['input']>
}

/** Streaming cursor of the table "virus" */
export type Virus_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Virus_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Virus_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>
  fileId?: InputMaybe<Scalars['uuid']['input']>
  filename?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>
  userSession?: InputMaybe<Scalars['jsonb']['input']>
  virus?: InputMaybe<Scalars['String']['input']>
}

/** update columns of table "storage.virus" */
export enum Virus_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  FileId = 'fileId',
  /** column name */
  Filename = 'filename',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserSession = 'userSession',
  /** column name */
  Virus = 'virus',
}

export type Virus_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Virus_Append_Input>
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Virus_Delete_At_Path_Input>
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Virus_Delete_Elem_Input>
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Virus_Delete_Key_Input>
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Virus_Prepend_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Virus_Set_Input>
  /** filter the rows which have to be updated */
  where: Virus_Bool_Exp
}

/** columns and relationships of "voucher_codes" */
export type Voucher_Codes = {
  __typename?: 'voucher_codes'
  active: Scalars['Boolean']['output']
  code: Scalars['String']['output']
  created_at?: Maybe<Scalars['timestamptz']['output']>
  discount_percent: Scalars['Int']['output']
  id: Scalars['uuid']['output']
  midwife_id: Scalars['uuid']['output']
  /** An object relationship */
  midwife_profile?: Maybe<Midwife_Profiles>
}

/** aggregated selection of "voucher_codes" */
export type Voucher_Codes_Aggregate = {
  __typename?: 'voucher_codes_aggregate'
  aggregate?: Maybe<Voucher_Codes_Aggregate_Fields>
  nodes: Array<Voucher_Codes>
}

/** aggregate fields of "voucher_codes" */
export type Voucher_Codes_Aggregate_Fields = {
  __typename?: 'voucher_codes_aggregate_fields'
  avg?: Maybe<Voucher_Codes_Avg_Fields>
  count: Scalars['Int']['output']
  max?: Maybe<Voucher_Codes_Max_Fields>
  min?: Maybe<Voucher_Codes_Min_Fields>
  stddev?: Maybe<Voucher_Codes_Stddev_Fields>
  stddev_pop?: Maybe<Voucher_Codes_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Voucher_Codes_Stddev_Samp_Fields>
  sum?: Maybe<Voucher_Codes_Sum_Fields>
  var_pop?: Maybe<Voucher_Codes_Var_Pop_Fields>
  var_samp?: Maybe<Voucher_Codes_Var_Samp_Fields>
  variance?: Maybe<Voucher_Codes_Variance_Fields>
}

/** aggregate fields of "voucher_codes" */
export type Voucher_Codes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Voucher_Codes_Select_Column>>
  distinct?: InputMaybe<Scalars['Boolean']['input']>
}

/** aggregate avg on columns */
export type Voucher_Codes_Avg_Fields = {
  __typename?: 'voucher_codes_avg_fields'
  discount_percent?: Maybe<Scalars['Float']['output']>
}

/** Boolean expression to filter rows from the table "voucher_codes". All fields are combined with a logical 'AND'. */
export type Voucher_Codes_Bool_Exp = {
  _and?: InputMaybe<Array<Voucher_Codes_Bool_Exp>>
  _not?: InputMaybe<Voucher_Codes_Bool_Exp>
  _or?: InputMaybe<Array<Voucher_Codes_Bool_Exp>>
  active?: InputMaybe<Boolean_Comparison_Exp>
  code?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  discount_percent?: InputMaybe<Int_Comparison_Exp>
  id?: InputMaybe<Uuid_Comparison_Exp>
  midwife_id?: InputMaybe<Uuid_Comparison_Exp>
  midwife_profile?: InputMaybe<Midwife_Profiles_Bool_Exp>
}

/** unique or primary key constraints on table "voucher_codes" */
export enum Voucher_Codes_Constraint {
  /** unique or primary key constraint on columns "code" */
  VoucherCodesCodeKey = 'voucher_codes_code_key',
  /** unique or primary key constraint on columns "id" */
  VoucherCodesPkey = 'voucher_codes_pkey',
}

/** input type for incrementing numeric columns in table "voucher_codes" */
export type Voucher_Codes_Inc_Input = {
  discount_percent?: InputMaybe<Scalars['Int']['input']>
}

/** input type for inserting data into table "voucher_codes" */
export type Voucher_Codes_Insert_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>
  code?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  discount_percent?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  midwife_id?: InputMaybe<Scalars['uuid']['input']>
  midwife_profile?: InputMaybe<Midwife_Profiles_Obj_Rel_Insert_Input>
}

/** aggregate max on columns */
export type Voucher_Codes_Max_Fields = {
  __typename?: 'voucher_codes_max_fields'
  code?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  discount_percent?: Maybe<Scalars['Int']['output']>
  id?: Maybe<Scalars['uuid']['output']>
  midwife_id?: Maybe<Scalars['uuid']['output']>
}

/** aggregate min on columns */
export type Voucher_Codes_Min_Fields = {
  __typename?: 'voucher_codes_min_fields'
  code?: Maybe<Scalars['String']['output']>
  created_at?: Maybe<Scalars['timestamptz']['output']>
  discount_percent?: Maybe<Scalars['Int']['output']>
  id?: Maybe<Scalars['uuid']['output']>
  midwife_id?: Maybe<Scalars['uuid']['output']>
}

/** response of any mutation on the table "voucher_codes" */
export type Voucher_Codes_Mutation_Response = {
  __typename?: 'voucher_codes_mutation_response'
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output']
  /** data from the rows affected by the mutation */
  returning: Array<Voucher_Codes>
}

/** input type for inserting object relation for remote table "voucher_codes" */
export type Voucher_Codes_Obj_Rel_Insert_Input = {
  data: Voucher_Codes_Insert_Input
  /** upsert condition */
  on_conflict?: InputMaybe<Voucher_Codes_On_Conflict>
}

/** on_conflict condition type for table "voucher_codes" */
export type Voucher_Codes_On_Conflict = {
  constraint: Voucher_Codes_Constraint
  update_columns?: Array<Voucher_Codes_Update_Column>
  where?: InputMaybe<Voucher_Codes_Bool_Exp>
}

/** Ordering options when selecting data from "voucher_codes". */
export type Voucher_Codes_Order_By = {
  active?: InputMaybe<Order_By>
  code?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  discount_percent?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  midwife_id?: InputMaybe<Order_By>
  midwife_profile?: InputMaybe<Midwife_Profiles_Order_By>
}

/** primary key columns input for table: voucher_codes */
export type Voucher_Codes_Pk_Columns_Input = {
  id: Scalars['uuid']['input']
}

/** select columns of table "voucher_codes" */
export enum Voucher_Codes_Select_Column {
  /** column name */
  Active = 'active',
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DiscountPercent = 'discount_percent',
  /** column name */
  Id = 'id',
  /** column name */
  MidwifeId = 'midwife_id',
}

/** input type for updating data in table "voucher_codes" */
export type Voucher_Codes_Set_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>
  code?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  discount_percent?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  midwife_id?: InputMaybe<Scalars['uuid']['input']>
}

/** aggregate stddev on columns */
export type Voucher_Codes_Stddev_Fields = {
  __typename?: 'voucher_codes_stddev_fields'
  discount_percent?: Maybe<Scalars['Float']['output']>
}

/** aggregate stddev_pop on columns */
export type Voucher_Codes_Stddev_Pop_Fields = {
  __typename?: 'voucher_codes_stddev_pop_fields'
  discount_percent?: Maybe<Scalars['Float']['output']>
}

/** aggregate stddev_samp on columns */
export type Voucher_Codes_Stddev_Samp_Fields = {
  __typename?: 'voucher_codes_stddev_samp_fields'
  discount_percent?: Maybe<Scalars['Float']['output']>
}

/** Streaming cursor of the table "voucher_codes" */
export type Voucher_Codes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Voucher_Codes_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Voucher_Codes_Stream_Cursor_Value_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>
  code?: InputMaybe<Scalars['String']['input']>
  created_at?: InputMaybe<Scalars['timestamptz']['input']>
  discount_percent?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['uuid']['input']>
  midwife_id?: InputMaybe<Scalars['uuid']['input']>
}

/** aggregate sum on columns */
export type Voucher_Codes_Sum_Fields = {
  __typename?: 'voucher_codes_sum_fields'
  discount_percent?: Maybe<Scalars['Int']['output']>
}

/** update columns of table "voucher_codes" */
export enum Voucher_Codes_Update_Column {
  /** column name */
  Active = 'active',
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DiscountPercent = 'discount_percent',
  /** column name */
  Id = 'id',
  /** column name */
  MidwifeId = 'midwife_id',
}

export type Voucher_Codes_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Voucher_Codes_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Voucher_Codes_Set_Input>
  /** filter the rows which have to be updated */
  where: Voucher_Codes_Bool_Exp
}

/** aggregate var_pop on columns */
export type Voucher_Codes_Var_Pop_Fields = {
  __typename?: 'voucher_codes_var_pop_fields'
  discount_percent?: Maybe<Scalars['Float']['output']>
}

/** aggregate var_samp on columns */
export type Voucher_Codes_Var_Samp_Fields = {
  __typename?: 'voucher_codes_var_samp_fields'
  discount_percent?: Maybe<Scalars['Float']['output']>
}

/** aggregate variance on columns */
export type Voucher_Codes_Variance_Fields = {
  __typename?: 'voucher_codes_variance_fields'
  discount_percent?: Maybe<Scalars['Float']['output']>
}

export type InsertChapterMutationVariables = Exact<{
  title: Scalars['String']['input']
  subtitle?: InputMaybe<Scalars['String']['input']>
  slug: Scalars['String']['input']
  summary: Scalars['String']['input']
  hook?: InputMaybe<Scalars['String']['input']>
  takeaway?: InputMaybe<Scalars['String']['input']>
  category_slug?: InputMaybe<Scalars['String']['input']>
  content_type?: InputMaybe<Scalars['String']['input']>
  slider?: InputMaybe<Scalars['String']['input']>
}>

export type InsertChapterMutation = {
  __typename?: 'mutation_root'
  insert_chapters_one?: { __typename?: 'chapters'; id: string; slug?: string | null } | null
}

export type UpdateChapterSliderMutationVariables = Exact<{
  id: Scalars['uuid']['input']
  slider?: InputMaybe<Scalars['String']['input']>
}>

export type UpdateChapterSliderMutation = {
  __typename?: 'mutation_root'
  update_chapters?: { __typename?: 'chapters_mutation_response'; affected_rows: number } | null
}

export type UpdateChapterMutationVariables = Exact<{
  id: Scalars['uuid']['input']
  title: Scalars['String']['input']
  subtitle?: InputMaybe<Scalars['String']['input']>
  slug: Scalars['String']['input']
  summary: Scalars['String']['input']
  hook?: InputMaybe<Scalars['String']['input']>
  takeaway?: InputMaybe<Scalars['String']['input']>
  category_slug?: InputMaybe<Scalars['String']['input']>
  content_type?: InputMaybe<Scalars['String']['input']>
}>

export type UpdateChapterMutation = {
  __typename?: 'mutation_root'
  update_chapters?: { __typename?: 'chapters_mutation_response'; affected_rows: number } | null
}

export type UpdateArticlesChapterSlugMutationVariables = Exact<{
  old_slug: Scalars['String']['input']
  new_slug: Scalars['String']['input']
}>

export type UpdateArticlesChapterSlugMutation = {
  __typename?: 'mutation_root'
  update_articles?: { __typename?: 'articles_mutation_response'; affected_rows: number } | null
}

export type InsertArticleMutationVariables = Exact<{
  slug: Scalars['String']['input']
  title: Scalars['String']['input']
  subtitle?: InputMaybe<Scalars['String']['input']>
  chapter_slug: Scalars['String']['input']
  article_position: Scalars['Int']['input']
  content_markdown: Scalars['String']['input']
  sources?: InputMaybe<Scalars['String']['input']>
  audio?: InputMaybe<Scalars['uuid']['input']>
  duration?: InputMaybe<Scalars['Int']['input']>
  hook?: InputMaybe<Scalars['String']['input']>
  takeaway?: InputMaybe<Scalars['String']['input']>
  summary?: InputMaybe<Scalars['String']['input']>
  image_id?: InputMaybe<Scalars['String']['input']>
  image_alt?: InputMaybe<Scalars['String']['input']>
  live?: InputMaybe<Scalars['Boolean']['input']>
}>

export type InsertArticleMutation = {
  __typename?: 'mutation_root'
  insert_articles_one?: { __typename?: 'articles'; slug: string; id: string } | null
}

export type DeleteArticleSectionsMutationVariables = Exact<{
  article_id: Scalars['uuid']['input']
}>

export type DeleteArticleSectionsMutation = {
  __typename?: 'mutation_root'
  delete_article_sections?: {
    __typename?: 'article_sections_mutation_response'
    affected_rows: number
  } | null
}

export type InsertArticleSectionsMutationVariables = Exact<{
  objects: Array<Article_Sections_Insert_Input> | Article_Sections_Insert_Input
}>

export type InsertArticleSectionsMutation = {
  __typename?: 'mutation_root'
  insert_article_sections?: {
    __typename?: 'article_sections_mutation_response'
    affected_rows: number
  } | null
}

export type UpdateArticleMutationVariables = Exact<{
  old_slug: Scalars['String']['input']
  new_slug: Scalars['String']['input']
  title: Scalars['String']['input']
  subtitle?: InputMaybe<Scalars['String']['input']>
  chapter_slug: Scalars['String']['input']
  article_position: Scalars['Int']['input']
  content_markdown: Scalars['String']['input']
  sources?: InputMaybe<Scalars['String']['input']>
  audio?: InputMaybe<Scalars['uuid']['input']>
  duration?: InputMaybe<Scalars['Int']['input']>
  hook?: InputMaybe<Scalars['String']['input']>
  takeaway?: InputMaybe<Scalars['String']['input']>
  summary?: InputMaybe<Scalars['String']['input']>
  image_id?: InputMaybe<Scalars['String']['input']>
  image_alt?: InputMaybe<Scalars['String']['input']>
  live?: InputMaybe<Scalars['Boolean']['input']>
}>

export type UpdateArticleMutation = {
  __typename?: 'mutation_root'
  update_articles?: { __typename?: 'articles_mutation_response'; affected_rows: number } | null
}

export type DeleteChapterMutationVariables = Exact<{
  id: Scalars['uuid']['input']
}>

export type DeleteChapterMutation = {
  __typename?: 'mutation_root'
  delete_chapters?: { __typename?: 'chapters_mutation_response'; affected_rows: number } | null
}

export type GetChapterArticlesTitlesQueryVariables = Exact<{
  chapter_slug: Scalars['String']['input']
}>

export type GetChapterArticlesTitlesQuery = {
  __typename?: 'query_root'
  articles: Array<{ __typename?: 'articles'; slug: string; title: string }>
}

export type DeleteArticlesByChapterMutationVariables = Exact<{
  chapter_slug: Scalars['String']['input']
}>

export type DeleteArticlesByChapterMutation = {
  __typename?: 'mutation_root'
  delete_articles?: { __typename?: 'articles_mutation_response'; affected_rows: number } | null
}

export type GetChapterFirstArticleQueryVariables = Exact<{
  chapter_slug: Scalars['String']['input']
}>

export type GetChapterFirstArticleQuery = {
  __typename?: 'query_root'
  articles: Array<{
    __typename?: 'articles'
    slug: string
    image_id?: string | null
    image_alt?: string | null
  }>
}

export type UpdateArticleImageMutationVariables = Exact<{
  slug: Scalars['String']['input']
  image_id?: InputMaybe<Scalars['String']['input']>
  image_alt?: InputMaybe<Scalars['String']['input']>
}>

export type UpdateArticleImageMutation = {
  __typename?: 'mutation_root'
  update_articles?: { __typename?: 'articles_mutation_response'; affected_rows: number } | null
}

export type GetChapterArticlesDurationQueryVariables = Exact<{
  chapter_slug: Scalars['String']['input']
}>

export type GetChapterArticlesDurationQuery = {
  __typename?: 'query_root'
  articles: Array<{
    __typename?: 'articles'
    duration?: number | null
    sections: Array<{ __typename?: 'article_sections'; duration?: number | null }>
  }>
}

export type GetChapterArticlesForReorderQueryVariables = Exact<{
  chapter_slug: Scalars['String']['input']
}>

export type GetChapterArticlesForReorderQuery = {
  __typename?: 'query_root'
  articles: Array<{ __typename?: 'articles'; slug: string; article_position?: number | null }>
}

export type GetArticlesWithoutDurationQueryVariables = Exact<{ [key: string]: never }>

export type GetArticlesWithoutDurationQuery = {
  __typename?: 'query_root'
  articles: Array<{
    __typename?: 'articles'
    slug: string
    title: string
    audio?: string | null
    chapter_slug: string
  }>
}

export type UpdateArticleDurationMutationVariables = Exact<{
  slug: Scalars['String']['input']
  duration?: InputMaybe<Scalars['Int']['input']>
}>

export type UpdateArticleDurationMutation = {
  __typename?: 'mutation_root'
  update_articles?: { __typename?: 'articles_mutation_response'; affected_rows: number } | null
}

export type GetChapterSlugsForCmsQueryVariables = Exact<{ [key: string]: never }>

export type GetChapterSlugsForCmsQuery = {
  __typename?: 'query_root'
  chapters: Array<{ __typename?: 'chapters'; slug?: string | null }>
}

export type UpdateChapterDurationMutationVariables = Exact<{
  slug: Scalars['String']['input']
  duration?: InputMaybe<Scalars['Int']['input']>
}>

export type UpdateChapterDurationMutation = {
  __typename?: 'mutation_root'
  update_chapters?: { __typename?: 'chapters_mutation_response'; affected_rows: number } | null
}

export type DeleteArticleMutationVariables = Exact<{
  slug: Scalars['String']['input']
}>

export type DeleteArticleMutation = {
  __typename?: 'mutation_root'
  delete_articles?: { __typename?: 'articles_mutation_response'; affected_rows: number } | null
}

export type GetChapterForArticleFormQueryVariables = Exact<{
  slug: Scalars['String']['input']
}>

export type GetChapterForArticleFormQuery = {
  __typename?: 'query_root'
  chapters: Array<{
    __typename?: 'chapters'
    id: string
    slug?: string | null
    title: string
    subtitle?: string | null
    summary: string
    hook?: string | null
    takeaway?: string | null
    category_slug?: string | null
    content_type?: string | null
    slider?: string | null
    articles: Array<{
      __typename?: 'articles'
      id: string
      slug: string
      title: string
      subtitle?: string | null
      article_position?: number | null
      content_markdown: string
      sources?: string | null
      audio?: string | null
      duration?: number | null
      hook?: string | null
      takeaway?: string | null
      summary?: string | null
      image_id?: string | null
      image_alt?: string | null
      live: boolean
      sections: Array<{
        __typename?: 'article_sections'
        id: string
        section_type: string
        topic?: string | null
        content_markdown?: string | null
        images: unknown
        audio?: string | null
        duration?: number | null
        position: number
      }>
    }>
  }>
}

export type GetAllChaptersWithArticlesQueryVariables = Exact<{ [key: string]: never }>

export type GetAllChaptersWithArticlesQuery = {
  __typename?: 'query_root'
  chapters: Array<{
    __typename?: 'chapters'
    id: string
    slug?: string | null
    title: string
    chapter_position?: number | null
    category_slug?: string | null
    slider?: string | null
    articles: Array<{
      __typename?: 'articles'
      slug: string
      title: string
      article_position?: number | null
      live: boolean
    }>
  }>
}

export type UpdateChapterPositionMutationVariables = Exact<{
  id: Scalars['uuid']['input']
  position: Scalars['Int']['input']
}>

export type UpdateChapterPositionMutation = {
  __typename?: 'mutation_root'
  update_chapters?: { __typename?: 'chapters_mutation_response'; affected_rows: number } | null
}

export type UpdateArticlePositionMutationVariables = Exact<{
  slug: Scalars['String']['input']
  position: Scalars['Int']['input']
}>

export type UpdateArticlePositionMutation = {
  __typename?: 'mutation_root'
  update_articles?: { __typename?: 'articles_mutation_response'; affected_rows: number } | null
}

export type GetMaxArticlePositionQueryVariables = Exact<{
  chapter_slug: Scalars['String']['input']
}>

export type GetMaxArticlePositionQuery = {
  __typename?: 'query_root'
  articles: Array<{ __typename?: 'articles'; article_position?: number | null }>
}

export type GetImageFilesQueryVariables = Exact<{
  where: Files_Bool_Exp
  limit: Scalars['Int']['input']
}>

export type GetImageFilesQuery = {
  __typename?: 'query_root'
  files: Array<{
    __typename?: 'files'
    id: string
    name?: string | null
    mimeType?: string | null
    createdAt: string
  }>
}

export type GetChapterImageUsageQueryVariables = Exact<{ [key: string]: never }>

export type GetChapterImageUsageQuery = {
  __typename?: 'query_root'
  articles: Array<{
    __typename?: 'articles'
    slug: string
    title: string
    chapter_slug: string
    image_id?: string | null
  }>
  article_sections: Array<{
    __typename?: 'article_sections'
    id: string
    images: unknown
    article: { __typename?: 'articles'; slug: string; title: string; chapter_slug: string }
  }>
}

export type GetImageFileIdsQueryVariables = Exact<{ [key: string]: never }>

export type GetImageFileIdsQuery = {
  __typename?: 'query_root'
  files: Array<{ __typename?: 'files'; id: string }>
}

export type GetAllCategoriesQueryVariables = Exact<{ [key: string]: never }>

export type GetAllCategoriesQuery = {
  __typename?: 'query_root'
  categories: Array<{
    __typename?: 'categories'
    slug: string
    title: string
    position?: number | null
  }>
}

export type UpdateCategoryPositionMutationVariables = Exact<{
  slug: Scalars['String']['input']
  position: Scalars['Int']['input']
}>

export type UpdateCategoryPositionMutation = {
  __typename?: 'mutation_root'
  update_categories?: { __typename?: 'categories_mutation_response'; affected_rows: number } | null
}

export type InsertCategoryMutationVariables = Exact<{
  slug: Scalars['String']['input']
  title: Scalars['String']['input']
}>

export type InsertCategoryMutation = {
  __typename?: 'mutation_root'
  insert_categories_one?: { __typename?: 'categories'; slug: string } | null
}

export type UpdateCategoryTitleMutationVariables = Exact<{
  slug: Scalars['String']['input']
  title: Scalars['String']['input']
}>

export type UpdateCategoryTitleMutation = {
  __typename?: 'mutation_root'
  update_categories?: { __typename?: 'categories_mutation_response'; affected_rows: number } | null
}

export type DeleteCategoryMutationVariables = Exact<{
  slug: Scalars['String']['input']
}>

export type DeleteCategoryMutation = {
  __typename?: 'mutation_root'
  delete_categories?: { __typename?: 'categories_mutation_response'; affected_rows: number } | null
}

export type GetMatchingQuestionsQueryVariables = Exact<{ [key: string]: never }>

export type GetMatchingQuestionsQuery = {
  __typename?: 'query_root'
  matching_question_with_chapter: Array<{
    __typename?: 'matching_question_with_chapter'
    answer_key: string
    article_slugs?: unknown | null
    criterion?: unknown | null
    exclusive: boolean
  }>
}

export type GetArticlesForMappingQueryVariables = Exact<{ [key: string]: never }>

export type GetArticlesForMappingQuery = {
  __typename?: 'query_root'
  articles: Array<{ __typename?: 'articles'; slug: string; title: string; chapter_slug: string }>
  chapters: Array<{ __typename?: 'chapters'; slug?: string | null; title: string }>
}

export type UpsertMatchingQuestionChapterMutationVariables = Exact<{
  answer_key: Scalars['String']['input']
  article_slugs?: InputMaybe<Scalars['jsonb']['input']>
  criterion?: InputMaybe<Scalars['jsonb']['input']>
  exclusive?: InputMaybe<Scalars['Boolean']['input']>
}>

export type UpsertMatchingQuestionChapterMutation = {
  __typename?: 'mutation_root'
  insert_matching_question_with_chapter_one?: {
    __typename?: 'matching_question_with_chapter'
    answer_key: string
    article_slugs?: unknown | null
    criterion?: unknown | null
    exclusive: boolean
  } | null
}

export type GetArticleLinkTargetsQueryVariables = Exact<{ [key: string]: never }>

export type GetArticleLinkTargetsQuery = {
  __typename?: 'query_root'
  chapters: Array<{
    __typename?: 'chapters'
    slug?: string | null
    title: string
    articles: Array<{ __typename?: 'articles'; slug: string; title: string }>
  }>
}

export type GetAllChaptersForPreviewQueryVariables = Exact<{ [key: string]: never }>

export type GetAllChaptersForPreviewQuery = {
  __typename?: 'query_root'
  chapters: Array<{
    __typename?: 'chapters'
    id: string
    slug?: string | null
    title: string
    subtitle?: string | null
    summary: string
    hook?: string | null
    takeaway?: string | null
    category_slug?: string | null
    content_type?: string | null
    duration?: number | null
    merken: boolean
    articles: Array<{
      __typename?: 'articles'
      slug: string
      title: string
      subtitle?: string | null
      hook?: string | null
      live: boolean
    }>
    cover: Array<{ __typename?: 'articles'; image_id?: string | null; image_alt?: string | null }>
  }>
  categories: Array<{ __typename?: 'categories'; slug: string; title: string }>
}

export type GetChapterWithArticlesForPreviewQueryVariables = Exact<{
  slug: Scalars['String']['input']
}>

export type GetChapterWithArticlesForPreviewQuery = {
  __typename?: 'query_root'
  chapters: Array<{
    __typename?: 'chapters'
    id: string
    slug?: string | null
    title: string
    subtitle?: string | null
    summary: string
    hook?: string | null
    takeaway?: string | null
    category_slug?: string | null
    duration?: number | null
    content_type?: string | null
    slider?: string | null
    articles: Array<{
      __typename?: 'articles'
      id: string
      slug: string
      article_position?: number | null
      title: string
      subtitle?: string | null
      content_markdown: string
      sources?: string | null
      audio?: string | null
      duration?: number | null
      hook?: string | null
      takeaway?: string | null
      summary?: string | null
      image_id?: string | null
      image_alt?: string | null
      live: boolean
      sections: Array<{
        __typename?: 'article_sections'
        id: string
        section_type: string
        topic?: string | null
        content_markdown?: string | null
        images: unknown
        audio?: string | null
        duration?: number | null
        position: number
      }>
    }>
    cover: Array<{ __typename?: 'articles'; image_id?: string | null; image_alt?: string | null }>
  }>
}

export type GetChaptersWithCriteriaQueryVariables = Exact<{ [key: string]: never }>

export type GetChaptersWithCriteriaQuery = {
  __typename?: 'query_root'
  categories: Array<{ __typename?: 'categories'; slug: string; title: string }>
  chapters: Array<{
    __typename?: 'chapters'
    slug?: string | null
    title: string
    category_slug?: string | null
    slider?: string | null
    baby_age_min_weeks?: number | null
    baby_age_max_weeks?: number | null
    selection_criterion: unknown
    articles: Array<{ __typename?: 'articles'; slug: string; title: string }>
  }>
}

export type UpdateChapterCriteriaMutationVariables = Exact<{
  slug: Scalars['String']['input']
  slider?: InputMaybe<Scalars['String']['input']>
  baby_age_min_weeks?: InputMaybe<Scalars['Int']['input']>
  baby_age_max_weeks?: InputMaybe<Scalars['Int']['input']>
  selection_class?: InputMaybe<Scalars['jsonb']['input']>
  selection_criterion?: InputMaybe<Scalars['jsonb']['input']>
}>

export type UpdateChapterCriteriaMutation = {
  __typename?: 'mutation_root'
  update_chapters?: { __typename?: 'chapters_mutation_response'; affected_rows: number } | null
}

export type GetMidwifeAppointmentsQueryVariables = Exact<{
  midwife_user_id: Scalars['uuid']['input']
}>

export type GetMidwifeAppointmentsQuery = {
  __typename?: 'query_root'
  appointments: Array<{
    __typename?: 'appointments'
    id: string
    start_time: string
    end_time: string
    patient_user_id?: string | null
  }>
}

export type InsertAppointmentsMutationVariables = Exact<{
  objects: Array<Appointments_Insert_Input> | Appointments_Insert_Input
}>

export type InsertAppointmentsMutation = {
  __typename?: 'mutation_root'
  insert_appointments?: {
    __typename?: 'appointments_mutation_response'
    returning: Array<{ __typename?: 'appointments'; id: string }>
  } | null
}

export type DeleteAppointmentMutationVariables = Exact<{
  id: Scalars['uuid']['input']
}>

export type DeleteAppointmentMutation = {
  __typename?: 'mutation_root'
  delete_appointments_by_pk?: { __typename?: 'appointments'; id: string } | null
}

export type ReleaseAppointmentMutationVariables = Exact<{
  id: Scalars['uuid']['input']
}>

export type ReleaseAppointmentMutation = {
  __typename?: 'mutation_root'
  update_appointments_by_pk?: {
    __typename?: 'appointments'
    id: string
    patient_user_id?: string | null
  } | null
}

export type GetConnectedMidwifeForBookingQueryVariables = Exact<{
  userId: Scalars['uuid']['input']
}>

export type GetConnectedMidwifeForBookingQuery = {
  __typename?: 'query_root'
  user_profiles: Array<{
    __typename?: 'user_profiles'
    id: string
    connected_midwife_id?: string | null
  }>
}

export type GetMyBookedAppointmentQueryVariables = Exact<{
  userId: Scalars['uuid']['input']
}>

export type GetMyBookedAppointmentQuery = {
  __typename?: 'query_root'
  appointments: Array<{
    __typename?: 'appointments'
    id: string
    start_time: string
    end_time: string
  }>
}

export type BookAppointmentDirectMutationVariables = Exact<{
  appointmentId: Scalars['uuid']['input']
  patientUserId: Scalars['uuid']['input']
}>

export type BookAppointmentDirectMutation = {
  __typename?: 'mutation_root'
  update_appointments_by_pk?: {
    __typename?: 'appointments'
    id: string
    patient_user_id?: string | null
  } | null
}

export type CancelMyAppointmentMutationVariables = Exact<{
  appointmentId: Scalars['uuid']['input']
}>

export type CancelMyAppointmentMutation = {
  __typename?: 'mutation_root'
  update_appointments_by_pk?: {
    __typename?: 'appointments'
    id: string
    patient_user_id?: string | null
  } | null
}

export type EnsureUserProfileMutationVariables = Exact<{
  userId: Scalars['uuid']['input']
}>

export type EnsureUserProfileMutation = {
  __typename?: 'mutation_root'
  insert_user_profiles_one?: { __typename?: 'user_profiles'; id: string } | null
}

export type ChatMessagesSubscriptionVariables = Exact<{
  patientUserId: Scalars['uuid']['input']
  midwifeUserId: Scalars['uuid']['input']
}>

export type ChatMessagesSubscription = {
  __typename?: 'subscription_root'
  chat_messages: Array<{
    __typename?: 'chat_messages'
    id: string
    sender_user_id: string
    body: string
    read_at?: string | null
    created_at: string
  }>
}

export type UnreadChatMessagesSubscriptionVariables = Exact<{
  userId: Scalars['uuid']['input']
}>

export type UnreadChatMessagesSubscription = {
  __typename?: 'subscription_root'
  chat_messages: Array<{
    __typename?: 'chat_messages'
    id: string
    patient_user_id: string
    midwife_user_id: string
  }>
}

export type LatestChatMessagesSubscriptionVariables = Exact<{ [key: string]: never }>

export type LatestChatMessagesSubscription = {
  __typename?: 'subscription_root'
  chat_messages: Array<{
    __typename?: 'chat_messages'
    id: string
    patient_user_id: string
    sender_user_id: string
    body: string
    read_at?: string | null
    created_at: string
  }>
}

export type SendChatMessageAsWomanMutationVariables = Exact<{
  body: Scalars['String']['input']
}>

export type SendChatMessageAsWomanMutation = {
  __typename?: 'mutation_root'
  insert_chat_messages_one?: { __typename?: 'chat_messages'; id: string } | null
}

export type SendChatMessageAsMidwifeMutationVariables = Exact<{
  patientUserId: Scalars['uuid']['input']
  body: Scalars['String']['input']
}>

export type SendChatMessageAsMidwifeMutation = {
  __typename?: 'mutation_root'
  insert_chat_messages_one?: { __typename?: 'chat_messages'; id: string } | null
}

export type MarkChatMessagesReadMutationVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input']
  readAt: Scalars['timestamptz']['input']
}>

export type MarkChatMessagesReadMutation = {
  __typename?: 'mutation_root'
  update_chat_messages?: {
    __typename?: 'chat_messages_mutation_response'
    returning: Array<{ __typename?: 'chat_messages'; id: string; read_at?: string | null }>
  } | null
}

export type GetChatConnectionQueryVariables = Exact<{
  userId: Scalars['uuid']['input']
}>

export type GetChatConnectionQuery = {
  __typename?: 'query_root'
  user_profiles: Array<{
    __typename?: 'user_profiles'
    id: string
    connected_midwife_id?: string | null
  }>
}

export type GetChatPartnerQueryVariables = Exact<{
  userId: Scalars['uuid']['input']
}>

export type GetChatPartnerQuery = {
  __typename?: 'query_root'
  users: Array<{ __typename?: 'users'; id: string; metadata?: unknown | null }>
}

export type GetChatPatientsQueryVariables = Exact<{ [key: string]: never }>

export type GetChatPatientsQuery = {
  __typename?: 'query_root'
  user_profiles: Array<{
    __typename?: 'user_profiles'
    id: string
    user_id: string
    user: { __typename?: 'users'; id: string; displayName: string; metadata?: unknown | null }
  }>
}

export type LatestChatMessageWithMidwifeSubscriptionVariables = Exact<{
  midwifeUserId: Scalars['uuid']['input']
}>

export type LatestChatMessageWithMidwifeSubscription = {
  __typename?: 'subscription_root'
  chat_messages: Array<{
    __typename?: 'chat_messages'
    id: string
    sender_user_id: string
    body: string
    created_at: string
  }>
}

export type FeedbackMessagesSubscriptionVariables = Exact<{
  memberUserId: Scalars['uuid']['input']
}>

export type FeedbackMessagesSubscription = {
  __typename?: 'subscription_root'
  feedback_messages: Array<{
    __typename?: 'feedback_messages'
    id: string
    is_from_member: boolean
    body: string
    read_at?: string | null
    created_at: string
  }>
}

export type UnreadFeedbackMessagesSubscriptionVariables = Exact<{
  fromMember: Scalars['Boolean']['input']
}>

export type UnreadFeedbackMessagesSubscription = {
  __typename?: 'subscription_root'
  feedback_messages: Array<{ __typename?: 'feedback_messages'; id: string; member_user_id: string }>
}

export type LatestFeedbackMessagesSubscriptionVariables = Exact<{ [key: string]: never }>

export type LatestFeedbackMessagesSubscription = {
  __typename?: 'subscription_root'
  feedback_messages: Array<{
    __typename?: 'feedback_messages'
    id: string
    member_user_id: string
    is_from_member: boolean
    body: string
    created_at: string
  }>
}

export type SendFeedbackAsMemberMutationVariables = Exact<{
  body: Scalars['String']['input']
}>

export type SendFeedbackAsMemberMutation = {
  __typename?: 'mutation_root'
  insert_feedback_messages_one?: { __typename?: 'feedback_messages'; id: string } | null
}

export type SendFeedbackAsInstituteMutationVariables = Exact<{
  memberUserId: Scalars['uuid']['input']
  body: Scalars['String']['input']
}>

export type SendFeedbackAsInstituteMutation = {
  __typename?: 'mutation_root'
  insert_feedback_messages_one?: { __typename?: 'feedback_messages'; id: string } | null
}

export type MarkFeedbackMessagesReadMutationVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input']
  readAt: Scalars['timestamptz']['input']
}>

export type MarkFeedbackMessagesReadMutation = {
  __typename?: 'mutation_root'
  update_feedback_messages?: {
    __typename?: 'feedback_messages_mutation_response'
    returning: Array<{ __typename?: 'feedback_messages'; id: string; read_at?: string | null }>
  } | null
}

export type GetFeedbackMembersQueryVariables = Exact<{
  womenIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input']
}>

export type GetFeedbackMembersQuery = {
  __typename?: 'query_root'
  users: Array<{
    __typename?: 'users'
    id: string
    displayName: string
    email?: any | null
    defaultRole: string
    metadata?: unknown | null
  }>
}

export type GetFeedbackMemberQueryVariables = Exact<{
  userId: Scalars['uuid']['input']
}>

export type GetFeedbackMemberQuery = {
  __typename?: 'query_root'
  users: Array<{
    __typename?: 'users'
    id: string
    displayName: string
    email?: any | null
    defaultRole: string
    metadata?: unknown | null
  }>
}

export type ChapterCoverFieldsFragment = {
  __typename?: 'chapters'
  cover: Array<{ __typename?: 'articles'; image_id?: string | null; image_alt?: string | null }>
}

export type ArticleSectionFieldsFragment = {
  __typename?: 'article_sections'
  id: string
  section_type: string
  topic?: string | null
  content_markdown?: string | null
  images: unknown
  audio?: string | null
  duration?: number | null
  position: number
}

export type ShortChapterArticleFieldsFragment = {
  __typename?: 'articles'
  slug: string
  title: string
  subtitle?: string | null
  content_markdown: string
  sources?: string | null
  audio?: string | null
  duration?: number | null
  article_position?: number | null
  hook?: string | null
  takeaway?: string | null
  summary?: string | null
  sections: Array<{
    __typename?: 'article_sections'
    id: string
    section_type: string
    topic?: string | null
    content_markdown?: string | null
    images: unknown
    audio?: string | null
    duration?: number | null
    position: number
  }>
}

export type SaveProgressMutationVariables = Exact<{
  userId: Scalars['uuid']['input']
  chapterSlug?: InputMaybe<Scalars['String']['input']>
  articleSlug?: InputMaybe<Scalars['String']['input']>
  audioPosition?: InputMaybe<Scalars['Int']['input']>
}>

export type SaveProgressMutation = {
  __typename?: 'mutation_root'
  insert_user_profiles_one?: { __typename?: 'user_profiles'; id: string } | null
}

export type GetUserProgressQueryVariables = Exact<{
  userId: Scalars['uuid']['input']
}>

export type GetUserProgressQuery = {
  __typename?: 'query_root'
  user_profiles: Array<{
    __typename?: 'user_profiles'
    id: string
    current_chapter_slug?: string | null
    current_article_slug?: string | null
    current_audio_position?: number | null
  }>
}

export type GetLastReadingPositionQueryVariables = Exact<{
  userId: Scalars['uuid']['input']
}>

export type GetLastReadingPositionQuery = {
  __typename?: 'query_root'
  user_profiles: Array<{
    __typename?: 'user_profiles'
    id: string
    current_chapter_slug?: string | null
    current_article_slug?: string | null
  }>
}

export type GetLearningProgressQueryVariables = Exact<{
  userId: Scalars['uuid']['input']
}>

export type GetLearningProgressQuery = {
  __typename?: 'query_root'
  article_progress: Array<{
    __typename?: 'article_progress'
    id: string
    article_slug: string
    chapter_slug: string
  }>
  user_profiles: Array<{
    __typename?: 'user_profiles'
    id: string
    completed_chapters?: unknown | null
  }>
}

export type MarkArticleCompleteMutationVariables = Exact<{
  userId: Scalars['uuid']['input']
  articleSlug: Scalars['String']['input']
  chapterSlug: Scalars['String']['input']
}>

export type MarkArticleCompleteMutation = {
  __typename?: 'mutation_root'
  insert_article_progress_one?: {
    __typename?: 'article_progress'
    id: string
    article_slug: string
    chapter_slug: string
  } | null
}

export type SetCompletedChaptersMutationVariables = Exact<{
  userId: Scalars['uuid']['input']
  chapters: Scalars['jsonb']['input']
}>

export type SetCompletedChaptersMutation = {
  __typename?: 'mutation_root'
  insert_user_profiles_one?: {
    __typename?: 'user_profiles'
    id: string
    completed_chapters?: unknown | null
  } | null
}

export type AdvanceCurrentChapterMutationVariables = Exact<{
  userId: Scalars['uuid']['input']
  chapterSlug: Scalars['String']['input']
}>

export type AdvanceCurrentChapterMutation = {
  __typename?: 'mutation_root'
  insert_user_profiles_one?: { __typename?: 'user_profiles'; id: string } | null
}

export type GetVorbereitungCourseQueryVariables = Exact<{ [key: string]: never }>

export type GetVorbereitungCourseQuery = {
  __typename?: 'query_root'
  chapters: Array<{
    __typename?: 'chapters'
    id: string
    slug?: string | null
    title: string
    subtitle?: string | null
    summary: string
    hook?: string | null
    duration?: number | null
    content_type?: string | null
    merken: boolean
    articles: Array<{
      __typename?: 'articles'
      slug: string
      title: string
      subtitle?: string | null
      hook?: string | null
      duration?: number | null
      sections: Array<{
        __typename?: 'article_sections'
        topic?: string | null
        duration?: number | null
      }>
    }>
    cover: Array<{ __typename?: 'articles'; image_id?: string | null; image_alt?: string | null }>
  }>
  categories: Array<{ __typename?: 'categories'; title: string }>
}

export type GetDiscoverChaptersQueryVariables = Exact<{ [key: string]: never }>

export type GetDiscoverChaptersQuery = {
  __typename?: 'query_root'
  chapters: Array<{
    __typename?: 'chapters'
    id: string
    slug?: string | null
    title: string
    subtitle?: string | null
    summary: string
    hook?: string | null
    duration?: number | null
    category_slug?: string | null
    content_type?: string | null
    merken: boolean
    articles: Array<{
      __typename?: 'articles'
      slug: string
      title: string
      subtitle?: string | null
      hook?: string | null
      duration?: number | null
      sections: Array<{
        __typename?: 'article_sections'
        topic?: string | null
        duration?: number | null
      }>
    }>
    cover: Array<{ __typename?: 'articles'; image_id?: string | null; image_alt?: string | null }>
  }>
  categories: Array<{
    __typename?: 'categories'
    slug: string
    title: string
    position?: number | null
  }>
}

export type GetMyTitlesChaptersQueryVariables = Exact<{ [key: string]: never }>

export type GetMyTitlesChaptersQuery = {
  __typename?: 'query_root'
  chapters: Array<{
    __typename?: 'chapters'
    id: string
    slug?: string | null
    title: string
    subtitle?: string | null
    summary: string
    duration?: number | null
    content_type?: string | null
    category_slug?: string | null
    merken: boolean
    merken_at?: string | null
    articles: Array<{
      __typename?: 'articles'
      id: string
      slug: string
      title: string
      subtitle?: string | null
      summary?: string | null
      image_id?: string | null
      image_alt?: string | null
      article_position?: number | null
      duration?: number | null
      sections: Array<{
        __typename?: 'article_sections'
        topic?: string | null
        duration?: number | null
      }>
    }>
    cover: Array<{ __typename?: 'articles'; image_id?: string | null; image_alt?: string | null }>
  }>
  categories: Array<{ __typename?: 'categories'; slug: string; title: string }>
}

export type GetSliderChaptersQueryVariables = Exact<{ [key: string]: never }>

export type GetSliderChaptersQuery = {
  __typename?: 'query_root'
  chapters: Array<{
    __typename?: 'chapters'
    id: string
    slug?: string | null
    title: string
    subtitle?: string | null
    hook?: string | null
    duration?: number | null
    content_type?: string | null
    category_slug?: string | null
    slider?: string | null
    merken: boolean
    articles: Array<{
      __typename?: 'articles'
      slug: string
      title: string
      subtitle?: string | null
      hook?: string | null
      duration?: number | null
      sections: Array<{
        __typename?: 'article_sections'
        topic?: string | null
        duration?: number | null
      }>
    }>
    cover: Array<{ __typename?: 'articles'; image_id?: string | null; image_alt?: string | null }>
  }>
}

export type GetAllChapterSlugsQueryVariables = Exact<{ [key: string]: never }>

export type GetAllChapterSlugsQuery = {
  __typename?: 'query_root'
  chapters: Array<{
    __typename?: 'chapters'
    id: string
    slug?: string | null
    category_slug?: string | null
  }>
}

export type GetChapterSlugsForReadingQueryVariables = Exact<{ [key: string]: never }>

export type GetChapterSlugsForReadingQuery = {
  __typename?: 'query_root'
  chapters: Array<{ __typename?: 'chapters'; id: string; slug?: string | null }>
}

export type GetChapterWithArticlesQueryVariables = Exact<{
  slug: Scalars['String']['input']
}>

export type GetChapterWithArticlesQuery = {
  __typename?: 'query_root'
  chapters: Array<{
    __typename?: 'chapters'
    id: string
    slug?: string | null
    title: string
    subtitle?: string | null
    summary: string
    hook?: string | null
    takeaway?: string | null
    duration?: number | null
    created_at: string
    articles: Array<{
      __typename?: 'articles'
      slug: string
      article_position?: number | null
      title: string
      subtitle?: string | null
      duration?: number | null
      hook?: string | null
      takeaway?: string | null
      summary?: string | null
      sections: Array<{
        __typename?: 'article_sections'
        id: string
        topic?: string | null
        duration?: number | null
      }>
    }>
    cover: Array<{ __typename?: 'articles'; image_id?: string | null; image_alt?: string | null }>
  }>
}

export type GetChapterArticlesQueryVariables = Exact<{
  chapterSlug: Scalars['String']['input']
}>

export type GetChapterArticlesQuery = {
  __typename?: 'query_root'
  chapters: Array<{
    __typename?: 'chapters'
    id: string
    title: string
    summary: string
    hook?: string | null
    duration?: number | null
    merken: boolean
    articles: Array<{
      __typename?: 'articles'
      slug: string
      title: string
      subtitle?: string | null
      content_markdown: string
      sources?: string | null
      audio?: string | null
      article_position?: number | null
      duration?: number | null
      hook?: string | null
      takeaway?: string | null
      summary?: string | null
      image_id?: string | null
      image_alt?: string | null
      sections: Array<{
        __typename?: 'article_sections'
        id: string
        section_type: string
        topic?: string | null
        content_markdown?: string | null
        images: unknown
        audio?: string | null
        duration?: number | null
        position: number
      }>
    }>
  }>
}

export type GetShortChapterArticlesQueryVariables = Exact<{
  slug: Scalars['String']['input']
}>

export type GetShortChapterArticlesQuery = {
  __typename?: 'query_root'
  chapters: Array<{
    __typename?: 'chapters'
    id: string
    articles: Array<{
      __typename?: 'articles'
      slug: string
      title: string
      subtitle?: string | null
      content_markdown: string
      sources?: string | null
      audio?: string | null
      duration?: number | null
      article_position?: number | null
      hook?: string | null
      takeaway?: string | null
      summary?: string | null
      sections: Array<{
        __typename?: 'article_sections'
        id: string
        section_type: string
        topic?: string | null
        content_markdown?: string | null
        images: unknown
        audio?: string | null
        duration?: number | null
        position: number
      }>
    }>
  }>
}

export type GetShortChapterQueryVariables = Exact<{
  slug: Scalars['String']['input']
}>

export type GetShortChapterQuery = {
  __typename?: 'query_root'
  chapters: Array<{
    __typename?: 'chapters'
    id: string
    title: string
    subtitle?: string | null
    summary: string
    hook?: string | null
    takeaway?: string | null
    duration?: number | null
    cover: Array<{ __typename?: 'articles'; image_id?: string | null; image_alt?: string | null }>
  }>
}

export type GetArticleVisibilityDataQueryVariables = Exact<{ [key: string]: never }>

export type GetArticleVisibilityDataQuery = {
  __typename?: 'query_root'
  matching_question_with_chapter: Array<{
    __typename?: 'matching_question_with_chapter'
    answer_key: string
    article_slugs?: unknown | null
    criterion?: unknown | null
    exclusive: boolean
  }>
  preparation: Array<{
    __typename?: 'preparation'
    id: string
    miscarriage?: boolean | null
    starchild?: boolean | null
    abortionmedical?: boolean | null
    abortioncriminal?: boolean | null
    adoption?: boolean | null
    induce?: boolean | null
    sagging?: boolean | null
    sharedcare?: boolean | null
    betterPre?: boolean | null
    personalreason?: boolean | null
    rawmilk?: boolean | null
    magnesium?: boolean | null
    amalgam?: boolean | null
    piercing?: boolean | null
    herpes?: boolean | null
    fungus?: boolean | null
    throat?: boolean | null
    diabetes?: boolean | null
    pcos?: boolean | null
    accessory?: boolean | null
    contraindication?: boolean | null
    sectio?: boolean | null
    preemie?: boolean | null
    lkg?: boolean | null
    trisomie?: boolean | null
    drugs?: boolean | null
  }>
}

export type UpdateChapterMerkenMutationVariables = Exact<{
  id: Scalars['uuid']['input']
  merken: Scalars['Boolean']['input']
  merkenAt?: InputMaybe<Scalars['timestamptz']['input']>
}>

export type UpdateChapterMerkenMutation = {
  __typename?: 'mutation_root'
  update_chapters?: {
    __typename?: 'chapters_mutation_response'
    affected_rows: number
    returning: Array<{
      __typename?: 'chapters'
      id: string
      merken: boolean
      merken_at?: string | null
    }>
  } | null
}

export type SetMerkenForChaptersMutationVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input']
  merken: Scalars['Boolean']['input']
  merkenAt?: InputMaybe<Scalars['timestamptz']['input']>
}>

export type SetMerkenForChaptersMutation = {
  __typename?: 'mutation_root'
  update_chapters?: {
    __typename?: 'chapters_mutation_response'
    returning: Array<{
      __typename?: 'chapters'
      id: string
      merken: boolean
      merken_at?: string | null
    }>
  } | null
}

export type GetUsersQueryVariables = Exact<{ [key: string]: never }>

export type GetUsersQuery = {
  __typename?: 'query_root'
  users: Array<{
    __typename?: 'users'
    id: string
    displayName: string
    email?: any | null
    defaultRole: string
    metadata?: unknown | null
    user_profile?: { __typename?: 'user_profiles'; id: string; paid?: boolean | null } | null
  }>
}

export type GetMidwifeCodeQueryVariables = Exact<{
  userId: Scalars['uuid']['input']
}>

export type GetMidwifeCodeQuery = {
  __typename?: 'query_root'
  midwife_profiles: Array<{
    __typename?: 'midwife_profiles'
    id: string
    midwife_code?: string | null
  }>
}

export type GetConnectedPatientsQueryVariables = Exact<{ [key: string]: never }>

export type GetConnectedPatientsQuery = {
  __typename?: 'query_root'
  user_profiles: Array<{
    __typename?: 'user_profiles'
    id: string
    user_id: string
    user: {
      __typename?: 'users'
      id: string
      email?: any | null
      displayName: string
      metadata?: unknown | null
    }
  }>
}

export type GetPatientTrackingQueryVariables = Exact<{
  user_id: Scalars['uuid']['input']
}>

export type GetPatientTrackingQuery = {
  __typename?: 'query_root'
  user_profiles: Array<{
    __typename?: 'user_profiles'
    id: string
    qm_consent_at?: string | null
    ai_consent_at?: string | null
    user: { __typename?: 'users'; id: string; displayName: string; metadata?: unknown | null }
  }>
  tracking_birth: Array<{
    __typename?: 'tracking_birth'
    id: string
    birth_date: string
    birth_weight: number
    sex: string
    bf_first_hour?: boolean | null
  }>
  tracking_nursing: Array<{
    __typename?: 'tracking_nursing'
    id: string
    timestamp: string
    duration_minutes?: number | null
    side?: string | null
    position?: string | null
    pain?: boolean | null
    pain_level?: number | null
  }>
  tracking_weight: Array<{
    __typename?: 'tracking_weight'
    id: string
    timestamp: string
    weight_grams: number
  }>
  tracking_diaper: Array<{
    __typename?: 'tracking_diaper'
    id: string
    timestamp: string
    wet?: boolean | null
    stool?: boolean | null
    stool_color?: string | null
  }>
  tracking_breast: Array<{
    __typename?: 'tracking_breast'
    id: string
    timestamp: string
    side?: string | null
    pain?: boolean | null
    pain_level?: number | null
    engorgement?: boolean | null
    lumps?: boolean | null
  }>
}

export type GetMidwifeProfileQueryVariables = Exact<{
  userId: Scalars['uuid']['input']
}>

export type GetMidwifeProfileQuery = {
  __typename?: 'query_root'
  midwife_profiles: Array<{
    __typename?: 'midwife_profiles'
    id: string
    midwife_code?: string | null
  }>
}

export type GetQmEntriesQueryVariables = Exact<{ [key: string]: never }>

export type GetQmEntriesQuery = {
  __typename?: 'query_root'
  qm_entries: Array<{
    __typename?: 'qm_entries'
    id: string
    category: string
    structured_data: unknown
    transcript?: string | null
    status: string
    created_at: string
  }>
}

export type InsertQmEntryMutationVariables = Exact<{
  category: Scalars['String']['input']
  structured_data: Scalars['jsonb']['input']
  transcript?: InputMaybe<Scalars['String']['input']>
}>

export type InsertQmEntryMutation = {
  __typename?: 'mutation_root'
  insert_qm_entries_one?: { __typename?: 'qm_entries'; id: string } | null
}

export type DeleteQmEntryMutationVariables = Exact<{
  id: Scalars['uuid']['input']
}>

export type DeleteQmEntryMutation = {
  __typename?: 'mutation_root'
  delete_qm_entries_by_pk?: { __typename?: 'qm_entries'; id: string } | null
}

export type GetCompanionStateQueryVariables = Exact<{
  userId: Scalars['uuid']['input']
}>

export type GetCompanionStateQuery = {
  __typename?: 'query_root'
  tracking_birth: Array<{ __typename?: 'tracking_birth'; id: string }>
  user_profiles: Array<{
    __typename?: 'user_profiles'
    id: string
    due_date?: string | null
    connected_midwife_id?: string | null
  }>
  preparation: Array<{ __typename?: 'preparation'; id: string; status?: string | null }>
}

export type UpsertDueDateMutationVariables = Exact<{
  userId: Scalars['uuid']['input']
  dueDate?: InputMaybe<Scalars['date']['input']>
}>

export type UpsertDueDateMutation = {
  __typename?: 'mutation_root'
  insert_user_profiles_one?: {
    __typename?: 'user_profiles'
    id: string
    due_date?: string | null
  } | null
}

export type GetConsentsQueryVariables = Exact<{
  userId: Scalars['uuid']['input']
}>

export type GetConsentsQuery = {
  __typename?: 'query_root'
  user_profiles: Array<{
    __typename?: 'user_profiles'
    id: string
    qm_consent_at?: string | null
    ai_consent_at?: string | null
  }>
}

export type UpsertConsentsMutationVariables = Exact<{
  userId: Scalars['uuid']['input']
  qmConsentAt?: InputMaybe<Scalars['timestamptz']['input']>
  aiConsentAt?: InputMaybe<Scalars['timestamptz']['input']>
}>

export type UpsertConsentsMutation = {
  __typename?: 'mutation_root'
  insert_user_profiles_one?: {
    __typename?: 'user_profiles'
    id: string
    qm_consent_at?: string | null
    ai_consent_at?: string | null
  } | null
}

export type SaveBirthOnboardingMutationVariables = Exact<{
  userId: Scalars['uuid']['input']
  dueDate?: InputMaybe<Scalars['date']['input']>
  birthDate: Scalars['date']['input']
  bornAt?: InputMaybe<Scalars['timestamptz']['input']>
  birthWeight: Scalars['Int']['input']
  sex: Scalars['String']['input']
  bfFirstHour?: InputMaybe<Scalars['Boolean']['input']>
}>

export type SaveBirthOnboardingMutation = {
  __typename?: 'mutation_root'
  insert_user_profiles_one?: {
    __typename?: 'user_profiles'
    id: string
    due_date?: string | null
  } | null
  insert_tracking_birth_one?: { __typename?: 'tracking_birth'; id: string } | null
}

export type GetPreparationQueryVariables = Exact<{ [key: string]: never }>

export type GetPreparationQuery = {
  __typename?: 'query_root'
  preparation: Array<{
    __typename?: 'preparation'
    id: string
    status?: string | null
    miscarriage?: boolean | null
    starchild?: boolean | null
    abortionmedical?: boolean | null
    abortioncriminal?: boolean | null
    adoption?: boolean | null
    induce?: boolean | null
    sagging?: boolean | null
    sharedcare?: boolean | null
    betterPre?: boolean | null
    personalreason?: boolean | null
    rawmilk?: boolean | null
    magnesium?: boolean | null
    amalgam?: boolean | null
    piercing?: boolean | null
    herpes?: boolean | null
    fungus?: boolean | null
    throat?: boolean | null
    diabetes?: boolean | null
    pcos?: boolean | null
    accessory?: boolean | null
    contraindication?: boolean | null
    sectio?: boolean | null
    preemie?: boolean | null
    lkg?: boolean | null
    trisomie?: boolean | null
    drugs?: boolean | null
  }>
}

export type InsertPreparationMutationVariables = Exact<{ [key: string]: never }>

export type InsertPreparationMutation = {
  __typename?: 'mutation_root'
  insert_preparation_one?: { __typename?: 'preparation'; id: string } | null
}

export type UpdatePreparationMutationVariables = Exact<{
  id: Scalars['uuid']['input']
  set: Preparation_Set_Input
}>

export type UpdatePreparationMutation = {
  __typename?: 'mutation_root'
  update_preparation_by_pk?: {
    __typename?: 'preparation'
    id: string
    status?: string | null
  } | null
}

export type GetUserPaidStatusQueryVariables = Exact<{
  userId: Scalars['uuid']['input']
}>

export type GetUserPaidStatusQuery = {
  __typename?: 'query_root'
  user_profiles: Array<{ __typename?: 'user_profiles'; id: string; paid?: boolean | null }>
}

export type SetUserPaidMutationVariables = Exact<{
  userId: Scalars['uuid']['input']
}>

export type SetUserPaidMutation = {
  __typename?: 'mutation_root'
  insert_user_profiles_one?: {
    __typename?: 'user_profiles'
    id: string
    paid?: boolean | null
  } | null
}

export type GetUserProfileQueryVariables = Exact<{
  userId: Scalars['uuid']['input']
}>

export type GetUserProfileQuery = {
  __typename?: 'query_root'
  user_profiles: Array<{
    __typename?: 'user_profiles'
    id: string
    avatar_file_id?: string | null
    paid?: boolean | null
    connected_midwife_id?: string | null
  }>
}

export type GetUserProfileInternalQueryVariables = Exact<{
  userId: Scalars['uuid']['input']
}>

export type GetUserProfileInternalQuery = {
  __typename?: 'query_root'
  user_profiles: Array<{ __typename?: 'user_profiles'; id: string; avatar_file_id?: string | null }>
}

export type UpsertUserProfileMutationVariables = Exact<{
  userId: Scalars['uuid']['input']
  avatarFileId: Scalars['uuid']['input']
}>

export type UpsertUserProfileMutation = {
  __typename?: 'mutation_root'
  insert_user_profiles_one?: {
    __typename?: 'user_profiles'
    id: string
    avatar_file_id?: string | null
  } | null
}

export type GetBirthDataQueryVariables = Exact<{
  userId: Scalars['uuid']['input']
}>

export type GetBirthDataQuery = {
  __typename?: 'query_root'
  tracking_birth: Array<{
    __typename?: 'tracking_birth'
    id: string
    birth_date: string
    born_at?: string | null
    birth_weight: number
    sex: string
    bf_first_hour?: boolean | null
  }>
}

export type UpsertBirthDataMutationVariables = Exact<{
  userId: Scalars['uuid']['input']
  birthDate: Scalars['date']['input']
  bornAt?: InputMaybe<Scalars['timestamptz']['input']>
  birthWeight: Scalars['Int']['input']
  sex: Scalars['String']['input']
  bfFirstHour?: InputMaybe<Scalars['Boolean']['input']>
}>

export type UpsertBirthDataMutation = {
  __typename?: 'mutation_root'
  insert_tracking_birth_one?: { __typename?: 'tracking_birth'; id: string } | null
}

export type DeleteBirthDataAndTrackingMutationVariables = Exact<{
  userId: Scalars['uuid']['input']
}>

export type DeleteBirthDataAndTrackingMutation = {
  __typename?: 'mutation_root'
  delete_tracking_nursing?: {
    __typename?: 'tracking_nursing_mutation_response'
    affected_rows: number
  } | null
  delete_tracking_diaper?: {
    __typename?: 'tracking_diaper_mutation_response'
    affected_rows: number
  } | null
  delete_tracking_breast?: {
    __typename?: 'tracking_breast_mutation_response'
    affected_rows: number
  } | null
  delete_tracking_weight?: {
    __typename?: 'tracking_weight_mutation_response'
    affected_rows: number
  } | null
  delete_tracking_substance?: {
    __typename?: 'tracking_substance_mutation_response'
    affected_rows: number
  } | null
  delete_tracking_mental_health?: {
    __typename?: 'tracking_mental_health_mutation_response'
    affected_rows: number
  } | null
  delete_tracking_tonguetie?: {
    __typename?: 'tracking_tonguetie_mutation_response'
    affected_rows: number
  } | null
  delete_tracking_birth?: {
    __typename?: 'tracking_birth_mutation_response'
    affected_rows: number
  } | null
}

export type GetMidwifeByIdQueryVariables = Exact<{
  userId: Scalars['uuid']['input']
}>

export type GetMidwifeByIdQuery = {
  __typename?: 'query_root'
  users: Array<{ __typename?: 'users'; id: string; metadata?: unknown | null }>
}

export type GetMidwifeByCodeQueryVariables = Exact<{
  code: Scalars['String']['input']
}>

export type GetMidwifeByCodeQuery = {
  __typename?: 'query_root'
  midwife_profiles: Array<{
    __typename?: 'midwife_profiles'
    user_id: string
    user?: { __typename?: 'users'; id: string; metadata?: unknown | null } | null
  }>
}

export type UpdateConnectedMidwifeMutationVariables = Exact<{
  userId: Scalars['uuid']['input']
  midwifeId?: InputMaybe<Scalars['uuid']['input']>
}>

export type UpdateConnectedMidwifeMutation = {
  __typename?: 'mutation_root'
  update_user_profiles?: {
    __typename?: 'user_profiles_mutation_response'
    returning: Array<{
      __typename?: 'user_profiles'
      id: string
      connected_midwife_id?: string | null
    }>
  } | null
}

export type TogglePaidStatusMutationVariables = Exact<{
  userId: Scalars['uuid']['input']
  paid: Scalars['Boolean']['input']
}>

export type TogglePaidStatusMutation = {
  __typename?: 'mutation_root'
  insert_user_profiles_one?: {
    __typename?: 'user_profiles'
    id: string
    paid?: boolean | null
  } | null
}

export type ClearCompletedChaptersMutationVariables = Exact<{
  userId: Scalars['uuid']['input']
}>

export type ClearCompletedChaptersMutation = {
  __typename?: 'mutation_root'
  update_user_profiles?: {
    __typename?: 'user_profiles_mutation_response'
    returning: Array<{
      __typename?: 'user_profiles'
      id: string
      completed_chapters?: unknown | null
    }>
  } | null
}

export type UpdateUserNameMutationVariables = Exact<{
  userId: Scalars['uuid']['input']
  metadata: Scalars['jsonb']['input']
}>

export type UpdateUserNameMutation = {
  __typename?: 'mutation_root'
  updateUser?: { __typename?: 'users'; id: string; metadata?: unknown | null } | null
}

export type GetTrackingBirthDataQueryVariables = Exact<{
  user_id: Scalars['uuid']['input']
}>

export type GetTrackingBirthDataQuery = {
  __typename?: 'query_root'
  tracking_birth: Array<{
    __typename?: 'tracking_birth'
    id: string
    birth_date: string
    born_at?: string | null
    birth_weight: number
    sex: string
    bf_first_hour?: boolean | null
  }>
}

export type GetPainAndBirthDataQueryVariables = Exact<{
  user_id: Scalars['uuid']['input']
}>

export type GetPainAndBirthDataQuery = {
  __typename?: 'query_root'
  tracking_nursing: Array<{
    __typename?: 'tracking_nursing'
    id: string
    timestamp: string
    pain_level?: number | null
    duration_minutes?: number | null
    side?: string | null
    position?: string | null
    tools?: unknown | null
    notes?: string | null
  }>
  tracking_breast: Array<{
    __typename?: 'tracking_breast'
    id: string
    timestamp: string
    pain_level?: number | null
    side?: string | null
    engorgement?: boolean | null
    lumps?: boolean | null
    notes?: string | null
  }>
  tracking_mental_health: Array<{
    __typename?: 'tracking_mental_health'
    id: string
    timestamp: string
    level: number
    notes?: string | null
  }>
  tracking_birth: Array<{ __typename?: 'tracking_birth'; id: string; birth_date: string }>
}

export type GetWeightAndBirthDataQueryVariables = Exact<{
  user_id: Scalars['uuid']['input']
}>

export type GetWeightAndBirthDataQuery = {
  __typename?: 'query_root'
  tracking_weight: Array<{
    __typename?: 'tracking_weight'
    id: string
    timestamp: string
    weight_grams: number
  }>
  tracking_birth: Array<{
    __typename?: 'tracking_birth'
    id: string
    birth_date: string
    birth_weight: number
    sex: string
  }>
}

export type GetBreastSideAndBirthDataQueryVariables = Exact<{
  user_id: Scalars['uuid']['input']
  since: Scalars['timestamptz']['input']
}>

export type GetBreastSideAndBirthDataQuery = {
  __typename?: 'query_root'
  tracking_nursing: Array<{
    __typename?: 'tracking_nursing'
    id: string
    timestamp: string
    side?: string | null
  }>
  tracking_breast: Array<{
    __typename?: 'tracking_breast'
    id: string
    timestamp: string
    side?: string | null
  }>
  tracking_birth: Array<{ __typename?: 'tracking_birth'; id: string; birth_date: string }>
  lastNursingSide: Array<{
    __typename?: 'tracking_nursing'
    id: string
    timestamp: string
    side?: string | null
  }>
  lastBreastSide: Array<{
    __typename?: 'tracking_breast'
    id: string
    timestamp: string
    side?: string | null
  }>
}

export type GetNursingDiaperAndBirthDataQueryVariables = Exact<{
  user_id: Scalars['uuid']['input']
  since: Scalars['timestamptz']['input']
}>

export type GetNursingDiaperAndBirthDataQuery = {
  __typename?: 'query_root'
  tracking_nursing: Array<{ __typename?: 'tracking_nursing'; id: string; timestamp: string }>
  tracking_bottle: Array<{
    __typename?: 'tracking_bottle'
    id: string
    timestamp: string
    milk_type?: string | null
    milk_source?: string | null
  }>
  tracking_diaper: Array<{ __typename?: 'tracking_diaper'; id: string; timestamp: string }>
  tracking_birth: Array<{ __typename?: 'tracking_birth'; id: string; birth_date: string }>
}

export type GetTrackingDashboardDataQueryVariables = Exact<{
  user_id: Scalars['uuid']['input']
  today_start: Scalars['timestamptz']['input']
  today_end: Scalars['timestamptz']['input']
}>

export type GetTrackingDashboardDataQuery = {
  __typename?: 'query_root'
  nursing_today: Array<{ __typename?: 'tracking_nursing'; id: string }>
  pain_nursing: Array<{
    __typename?: 'tracking_nursing'
    id: string
    timestamp: string
    pain_level?: number | null
  }>
  pain_breast: Array<{
    __typename?: 'tracking_breast'
    id: string
    timestamp: string
    pain_level?: number | null
  }>
  weight_all: Array<{
    __typename?: 'tracking_weight'
    id: string
    weight_grams: number
    timestamp: string
  }>
  birth_data: Array<{
    __typename?: 'tracking_birth'
    id: string
    birth_weight: number
    birth_date: string
  }>
}

export type GetBirthMilestoneDataQueryVariables = Exact<{
  user_id: Scalars['uuid']['input']
}>

export type GetBirthMilestoneDataQuery = {
  __typename?: 'query_root'
  tracking_weight: Array<{
    __typename?: 'tracking_weight'
    id: string
    weight_grams: number
    timestamp: string
  }>
  tracking_tonguetie: Array<{
    __typename?: 'tracking_tonguetie'
    id: string
    consideration: boolean
    diagnosed: boolean
    anterior: boolean
    posterior: boolean
    treated: boolean
  }>
}

export type GetMamaPainTodayDataQueryVariables = Exact<{
  user_id: Scalars['uuid']['input']
}>

export type GetMamaPainTodayDataQuery = {
  __typename?: 'query_root'
  tracking_nursing: Array<{
    __typename?: 'tracking_nursing'
    id: string
    timestamp: string
    pain_level?: number | null
  }>
  tracking_breast: Array<{
    __typename?: 'tracking_breast'
    id: string
    timestamp: string
    pain_level?: number | null
  }>
  lastNursingSide: Array<{ __typename?: 'tracking_nursing'; id: string; side?: string | null }>
}

export type GetNursingWeekDataQueryVariables = Exact<{
  user_id: Scalars['uuid']['input']
  since: Scalars['timestamptz']['input']
}>

export type GetNursingWeekDataQuery = {
  __typename?: 'query_root'
  tracking_nursing: Array<{ __typename?: 'tracking_nursing'; id: string; timestamp: string }>
}

export type GetSubstancesAndToolsDataQueryVariables = Exact<{
  user_id: Scalars['uuid']['input']
  since: Scalars['timestamptz']['input']
}>

export type GetSubstancesAndToolsDataQuery = {
  __typename?: 'query_root'
  tracking_substance: Array<{
    __typename?: 'tracking_substance'
    id: string
    category: string
    name: string
  }>
  tracking_nursing: Array<{ __typename?: 'tracking_nursing'; id: string; tools?: unknown | null }>
}

export type GetTrackingEventsQueryVariables = Exact<{
  user_id: Scalars['uuid']['input']
  since: Scalars['timestamptz']['input']
  until: Scalars['timestamptz']['input']
}>

export type GetTrackingEventsQuery = {
  __typename?: 'query_root'
  tracking_nursing: Array<{
    __typename?: 'tracking_nursing'
    id: string
    timestamp: string
    duration_minutes?: number | null
    side?: string | null
    position?: string | null
    tools?: unknown | null
    pain?: boolean | null
    pain_level?: number | null
    notes?: string | null
  }>
  tracking_weight: Array<{
    __typename?: 'tracking_weight'
    id: string
    timestamp: string
    weight_grams: number
    notes?: string | null
  }>
  tracking_diaper: Array<{
    __typename?: 'tracking_diaper'
    id: string
    timestamp: string
    wet?: boolean | null
    stool?: boolean | null
    stool_color?: string | null
    stool_consistency?: string | null
    notes?: string | null
  }>
  tracking_breast: Array<{
    __typename?: 'tracking_breast'
    id: string
    timestamp: string
    side?: string | null
    engorgement?: boolean | null
    pain?: boolean | null
    pain_level?: number | null
    lumps?: boolean | null
    notes?: string | null
  }>
}

export type GetSubstanceEventsQueryVariables = Exact<{
  user_id: Scalars['uuid']['input']
  since: Scalars['timestamptz']['input']
  until: Scalars['timestamptz']['input']
}>

export type GetSubstanceEventsQuery = {
  __typename?: 'query_root'
  tracking_substance: Array<{
    __typename?: 'tracking_substance'
    id: string
    timestamp: string
    category: string
    name: string
    notes?: string | null
  }>
  tracking_nursing: Array<{
    __typename?: 'tracking_nursing'
    id: string
    timestamp: string
    tools?: unknown | null
    notes?: string | null
  }>
}

export type InsertNursingMutationVariables = Exact<{
  object: Tracking_Nursing_Insert_Input
}>

export type InsertNursingMutation = {
  __typename?: 'mutation_root'
  insert_tracking_nursing_one?: { __typename?: 'tracking_nursing'; id: string } | null
}

export type UpdateNursingMutationVariables = Exact<{
  id: Scalars['uuid']['input']
  timestamp: Scalars['timestamptz']['input']
  duration_minutes?: InputMaybe<Scalars['Int']['input']>
  side?: InputMaybe<Scalars['String']['input']>
  position?: InputMaybe<Scalars['String']['input']>
  tools?: InputMaybe<Scalars['jsonb']['input']>
  pain: Scalars['Boolean']['input']
  pain_level?: InputMaybe<Scalars['Int']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
}>

export type UpdateNursingMutation = {
  __typename?: 'mutation_root'
  update_tracking_nursing_by_pk?: {
    __typename?: 'tracking_nursing'
    id: string
    timestamp: string
    duration_minutes?: number | null
    side?: string | null
    position?: string | null
    tools?: unknown | null
    pain?: boolean | null
    pain_level?: number | null
    notes?: string | null
  } | null
}

export type InsertWeightMutationVariables = Exact<{
  object: Tracking_Weight_Insert_Input
}>

export type InsertWeightMutation = {
  __typename?: 'mutation_root'
  insert_tracking_weight_one?: { __typename?: 'tracking_weight'; id: string } | null
}

export type UpdateWeightMutationVariables = Exact<{
  id: Scalars['uuid']['input']
  weight_grams: Scalars['Int']['input']
  timestamp: Scalars['timestamptz']['input']
  notes?: InputMaybe<Scalars['String']['input']>
}>

export type UpdateWeightMutation = {
  __typename?: 'mutation_root'
  update_tracking_weight_by_pk?: {
    __typename?: 'tracking_weight'
    id: string
    weight_grams: number
    timestamp: string
    notes?: string | null
  } | null
}

export type InsertDiaperMutationVariables = Exact<{
  object: Tracking_Diaper_Insert_Input
}>

export type InsertDiaperMutation = {
  __typename?: 'mutation_root'
  insert_tracking_diaper_one?: { __typename?: 'tracking_diaper'; id: string } | null
}

export type InsertBreastMutationVariables = Exact<{
  object: Tracking_Breast_Insert_Input
}>

export type InsertBreastMutation = {
  __typename?: 'mutation_root'
  insert_tracking_breast_one?: { __typename?: 'tracking_breast'; id: string } | null
}

export type UpdateBreastMutationVariables = Exact<{
  id: Scalars['uuid']['input']
  timestamp: Scalars['timestamptz']['input']
  side?: InputMaybe<Scalars['String']['input']>
  engorgement: Scalars['Boolean']['input']
  pain: Scalars['Boolean']['input']
  pain_level?: InputMaybe<Scalars['Int']['input']>
  lumps: Scalars['Boolean']['input']
  notes?: InputMaybe<Scalars['String']['input']>
}>

export type UpdateBreastMutation = {
  __typename?: 'mutation_root'
  update_tracking_breast_by_pk?: {
    __typename?: 'tracking_breast'
    id: string
    timestamp: string
    side?: string | null
    engorgement?: boolean | null
    pain?: boolean | null
    pain_level?: number | null
    lumps?: boolean | null
    notes?: string | null
  } | null
}

export type InsertSubstanceMutationVariables = Exact<{
  object: Tracking_Substance_Insert_Input
}>

export type InsertSubstanceMutation = {
  __typename?: 'mutation_root'
  insert_tracking_substance_one?: { __typename?: 'tracking_substance'; id: string } | null
}

export type InsertMentalHealthMutationVariables = Exact<{
  object: Tracking_Mental_Health_Insert_Input
}>

export type InsertMentalHealthMutation = {
  __typename?: 'mutation_root'
  insert_tracking_mental_health_one?: { __typename?: 'tracking_mental_health'; id: string } | null
}

export type UpdateMentalHealthMutationVariables = Exact<{
  id: Scalars['uuid']['input']
  timestamp: Scalars['timestamptz']['input']
  level: Scalars['Int']['input']
  notes?: InputMaybe<Scalars['String']['input']>
}>

export type UpdateMentalHealthMutation = {
  __typename?: 'mutation_root'
  update_tracking_mental_health_by_pk?: {
    __typename?: 'tracking_mental_health'
    id: string
    timestamp: string
    level: number
    notes?: string | null
  } | null
}

export type InsertTongueTieMutationVariables = Exact<{
  object: Tracking_Tonguetie_Insert_Input
}>

export type InsertTongueTieMutation = {
  __typename?: 'mutation_root'
  insert_tracking_tonguetie_one?: { __typename?: 'tracking_tonguetie'; id: string } | null
}

export type UpdateTongueTieMutationVariables = Exact<{
  id: Scalars['uuid']['input']
  timestamp: Scalars['timestamptz']['input']
  consideration: Scalars['Boolean']['input']
  diagnosed: Scalars['Boolean']['input']
  anterior: Scalars['Boolean']['input']
  posterior: Scalars['Boolean']['input']
  treated: Scalars['Boolean']['input']
  treated_by?: InputMaybe<Scalars['String']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
}>

export type UpdateTongueTieMutation = {
  __typename?: 'mutation_root'
  update_tracking_tonguetie_by_pk?: {
    __typename?: 'tracking_tonguetie'
    id: string
    timestamp: string
    consideration: boolean
    diagnosed: boolean
    anterior: boolean
    posterior: boolean
    treated: boolean
    treated_by?: string | null
    notes?: string | null
  } | null
}

export type DeleteNursingMutationVariables = Exact<{
  id: Scalars['uuid']['input']
}>

export type DeleteNursingMutation = {
  __typename?: 'mutation_root'
  delete_tracking_nursing_by_pk?: { __typename?: 'tracking_nursing'; id: string } | null
}

export type DeleteWeightMutationVariables = Exact<{
  id: Scalars['uuid']['input']
}>

export type DeleteWeightMutation = {
  __typename?: 'mutation_root'
  delete_tracking_weight_by_pk?: { __typename?: 'tracking_weight'; id: string } | null
}

export type DeleteDiaperMutationVariables = Exact<{
  id: Scalars['uuid']['input']
}>

export type DeleteDiaperMutation = {
  __typename?: 'mutation_root'
  delete_tracking_diaper_by_pk?: { __typename?: 'tracking_diaper'; id: string } | null
}

export type DeleteBreastMutationVariables = Exact<{
  id: Scalars['uuid']['input']
}>

export type DeleteBreastMutation = {
  __typename?: 'mutation_root'
  delete_tracking_breast_by_pk?: { __typename?: 'tracking_breast'; id: string } | null
}

export type DeleteSubstanceMutationVariables = Exact<{
  id: Scalars['uuid']['input']
}>

export type DeleteSubstanceMutation = {
  __typename?: 'mutation_root'
  delete_tracking_substance_by_pk?: { __typename?: 'tracking_substance'; id: string } | null
}

export type DeleteMentalHealthMutationVariables = Exact<{
  id: Scalars['uuid']['input']
}>

export type DeleteMentalHealthMutation = {
  __typename?: 'mutation_root'
  delete_tracking_mental_health_by_pk?: { __typename?: 'tracking_mental_health'; id: string } | null
}

export type DeleteFutureWeightsMutationVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input']
}>

export type DeleteFutureWeightsMutation = {
  __typename?: 'mutation_root'
  delete_tracking_weight?: {
    __typename?: 'tracking_weight_mutation_response'
    affected_rows: number
    returning: Array<{ __typename?: 'tracking_weight'; id: string }>
  } | null
}

export type InsertBottleMutationVariables = Exact<{
  object: Tracking_Bottle_Insert_Input
}>

export type InsertBottleMutation = {
  __typename?: 'mutation_root'
  insert_tracking_bottle_one?: { __typename?: 'tracking_bottle'; id: string } | null
}

export type GetReadingPreferencesQueryVariables = Exact<{
  userId: Scalars['uuid']['input']
}>

export type GetReadingPreferencesQuery = {
  __typename?: 'query_root'
  user_profiles: Array<{
    __typename?: 'user_profiles'
    id: string
    hide_intro_sections?: boolean | null
    hide_outro_sections?: boolean | null
  }>
}

export type SetReadingPreferencesMutationVariables = Exact<{
  userId: Scalars['uuid']['input']
  hideIntro: Scalars['Boolean']['input']
  hideOutro: Scalars['Boolean']['input']
}>

export type SetReadingPreferencesMutation = {
  __typename?: 'mutation_root'
  insert_user_profiles_one?: {
    __typename?: 'user_profiles'
    id: string
    hide_intro_sections?: boolean | null
    hide_outro_sections?: boolean | null
  } | null
}

export const ChapterCoverFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChapterCoverFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'chapters' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'cover' },
            name: { kind: 'Name', value: 'articles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'article_position' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'image_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'image_alt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ChapterCoverFieldsFragment, unknown>
export const ArticleSectionFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ArticleSectionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'article_sections' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'section_type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'topic' } },
          { kind: 'Field', name: { kind: 'Name', value: 'content_markdown' } },
          { kind: 'Field', name: { kind: 'Name', value: 'images' } },
          { kind: 'Field', name: { kind: 'Name', value: 'audio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'position' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ArticleSectionFieldsFragment, unknown>
export const ShortChapterArticleFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ShortChapterArticleFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'articles' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'content_markdown' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sources' } },
          { kind: 'Field', name: { kind: 'Name', value: 'audio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'article_position' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hook' } },
          { kind: 'Field', name: { kind: 'Name', value: 'takeaway' } },
          { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sections' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'position' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ArticleSectionFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ArticleSectionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'article_sections' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'section_type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'topic' } },
          { kind: 'Field', name: { kind: 'Name', value: 'content_markdown' } },
          { kind: 'Field', name: { kind: 'Name', value: 'images' } },
          { kind: 'Field', name: { kind: 'Name', value: 'audio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'position' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ShortChapterArticleFieldsFragment, unknown>
export const InsertChapterDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'InsertChapter' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'subtitle' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'summary' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'hook' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'takeaway' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'category_slug' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'content_type' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'slider' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insert_chapters_one' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'object' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'title' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'subtitle' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'subtitle' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'slug' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'summary' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'summary' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'hook' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'hook' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'takeaway' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'takeaway' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'category_slug' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'category_slug' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'content_type' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'content_type' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'slider' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'slider' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InsertChapterMutation, InsertChapterMutationVariables>
export const UpdateChapterSliderDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateChapterSlider' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'slider' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_chapters' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'slider' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'slider' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateChapterSliderMutation, UpdateChapterSliderMutationVariables>
export const UpdateChapterDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateChapter' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'subtitle' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'summary' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'hook' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'takeaway' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'category_slug' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'content_type' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_chapters' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'title' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'subtitle' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'subtitle' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'slug' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'summary' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'summary' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'hook' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'hook' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'takeaway' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'takeaway' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'category_slug' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'category_slug' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'content_type' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'content_type' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateChapterMutation, UpdateChapterMutationVariables>
export const UpdateArticlesChapterSlugDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateArticlesChapterSlug' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'old_slug' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'new_slug' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_articles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'chapter_slug' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'old_slug' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'chapter_slug' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'new_slug' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateArticlesChapterSlugMutation,
  UpdateArticlesChapterSlugMutationVariables
>
export const InsertArticleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'InsertArticle' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'subtitle' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'chapter_slug' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'article_position' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'content_markdown' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sources' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'audio' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'duration' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'hook' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'takeaway' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'summary' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'image_id' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'image_alt' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'live' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insert_articles_one' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'object' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'slug' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'title' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'subtitle' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'subtitle' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'chapter_slug' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'chapter_slug' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'article_position' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'article_position' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'content_markdown' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'content_markdown' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sources' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'sources' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'audio' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'audio' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'duration' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'duration' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'hook' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'hook' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'takeaway' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'takeaway' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'summary' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'summary' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'image_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'image_id' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'image_alt' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'image_alt' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'live' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'live' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InsertArticleMutation, InsertArticleMutationVariables>
export const DeleteArticleSectionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteArticleSections' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'article_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'delete_article_sections' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'article_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'article_id' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteArticleSectionsMutation, DeleteArticleSectionsMutationVariables>
export const InsertArticleSectionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'InsertArticleSections' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'objects' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'article_sections_insert_input' },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insert_article_sections' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'objects' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'objects' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InsertArticleSectionsMutation, InsertArticleSectionsMutationVariables>
export const UpdateArticleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateArticle' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'old_slug' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'new_slug' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'subtitle' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'chapter_slug' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'article_position' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'content_markdown' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sources' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'audio' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'duration' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'hook' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'takeaway' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'summary' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'image_id' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'image_alt' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'live' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_articles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'slug' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'old_slug' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'slug' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'new_slug' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'title' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'subtitle' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'subtitle' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'chapter_slug' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'chapter_slug' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'article_position' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'article_position' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'content_markdown' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'content_markdown' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sources' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'sources' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'audio' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'audio' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'duration' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'duration' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'hook' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'hook' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'takeaway' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'takeaway' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'summary' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'summary' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'image_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'image_id' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'image_alt' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'image_alt' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'live' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'live' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateArticleMutation, UpdateArticleMutationVariables>
export const DeleteChapterDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteChapter' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'delete_chapters' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteChapterMutation, DeleteChapterMutationVariables>
export const GetChapterArticlesTitlesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetChapterArticlesTitles' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'chapter_slug' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'articles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'chapter_slug' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'chapter_slug' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'article_position' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetChapterArticlesTitlesQuery, GetChapterArticlesTitlesQueryVariables>
export const DeleteArticlesByChapterDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteArticlesByChapter' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'chapter_slug' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'delete_articles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'chapter_slug' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'chapter_slug' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteArticlesByChapterMutation,
  DeleteArticlesByChapterMutationVariables
>
export const GetChapterFirstArticleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetChapterFirstArticle' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'chapter_slug' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'articles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'chapter_slug' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'chapter_slug' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'article_position' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'image_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'image_alt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetChapterFirstArticleQuery, GetChapterFirstArticleQueryVariables>
export const UpdateArticleImageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateArticleImage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'image_id' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'image_alt' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_articles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'slug' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'image_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'image_id' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'image_alt' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'image_alt' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateArticleImageMutation, UpdateArticleImageMutationVariables>
export const GetChapterArticlesDurationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetChapterArticlesDuration' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'chapter_slug' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'articles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'chapter_slug' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'chapter_slug' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sections' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'duration' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetChapterArticlesDurationQuery,
  GetChapterArticlesDurationQueryVariables
>
export const GetChapterArticlesForReorderDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetChapterArticlesForReorder' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'chapter_slug' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'articles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'chapter_slug' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'chapter_slug' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'article_position' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'article_position' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetChapterArticlesForReorderQuery,
  GetChapterArticlesForReorderQueryVariables
>
export const GetArticlesWithoutDurationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetArticlesWithoutDuration' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'articles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'audio' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_is_null' },
                            value: { kind: 'BooleanValue', value: false },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'duration' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_is_null' },
                            value: { kind: 'BooleanValue', value: true },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'audio' } },
                { kind: 'Field', name: { kind: 'Name', value: 'chapter_slug' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetArticlesWithoutDurationQuery,
  GetArticlesWithoutDurationQueryVariables
>
export const UpdateArticleDurationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateArticleDuration' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'duration' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_articles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'slug' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'duration' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'duration' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateArticleDurationMutation, UpdateArticleDurationMutationVariables>
export const GetChapterSlugsForCmsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetChapterSlugsForCms' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'chapters' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetChapterSlugsForCmsQuery, GetChapterSlugsForCmsQueryVariables>
export const UpdateChapterDurationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateChapterDuration' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'duration' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_chapters' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'slug' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'duration' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'duration' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateChapterDurationMutation, UpdateChapterDurationMutationVariables>
export const DeleteArticleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteArticle' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'delete_articles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'slug' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteArticleMutation, DeleteArticleMutationVariables>
export const GetChapterForArticleFormDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetChapterForArticleForm' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'chapters' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'slug' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hook' } },
                { kind: 'Field', name: { kind: 'Name', value: 'takeaway' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category_slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'content_type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slider' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'articles' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'order_by' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'article_position' },
                            value: { kind: 'EnumValue', value: 'asc' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'article_position' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'content_markdown' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sources' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'audio' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hook' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'takeaway' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'image_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'image_alt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'live' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sections' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'order_by' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'position' },
                                  value: { kind: 'EnumValue', value: 'asc' },
                                },
                              ],
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'ArticleSectionFields' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ArticleSectionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'article_sections' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'section_type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'topic' } },
          { kind: 'Field', name: { kind: 'Name', value: 'content_markdown' } },
          { kind: 'Field', name: { kind: 'Name', value: 'images' } },
          { kind: 'Field', name: { kind: 'Name', value: 'audio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'position' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetChapterForArticleFormQuery, GetChapterForArticleFormQueryVariables>
export const GetAllChaptersWithArticlesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetAllChaptersWithArticles' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'chapters' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'chapter_position' },
                      value: { kind: 'EnumValue', value: 'asc_nulls_last' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'created_at' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'chapter_position' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category_slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slider' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'articles' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'order_by' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'article_position' },
                            value: { kind: 'EnumValue', value: 'asc' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'article_position' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'live' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetAllChaptersWithArticlesQuery,
  GetAllChaptersWithArticlesQueryVariables
>
export const UpdateChapterPositionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateChapterPosition' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'position' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_chapters' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'chapter_position' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'position' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateChapterPositionMutation, UpdateChapterPositionMutationVariables>
export const UpdateArticlePositionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateArticlePosition' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'position' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_articles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'slug' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'article_position' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'position' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateArticlePositionMutation, UpdateArticlePositionMutationVariables>
export const GetMaxArticlePositionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetMaxArticlePosition' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'chapter_slug' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'articles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'chapter_slug' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'chapter_slug' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'article_position' },
                      value: { kind: 'EnumValue', value: 'desc' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'article_position' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetMaxArticlePositionQuery, GetMaxArticlePositionQueryVariables>
export const GetImageFilesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetImageFiles' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'files_bool_exp' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'createdAt' },
                      value: { kind: 'EnumValue', value: 'desc' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetImageFilesQuery, GetImageFilesQueryVariables>
export const GetChapterImageUsageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetChapterImageUsage' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'articles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'image_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_is_null' },
                            value: { kind: 'BooleanValue', value: false },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'chapter_slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'image_id' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'article_sections' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'images' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_is_null' },
                            value: { kind: 'BooleanValue', value: false },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'images' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'article' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'chapter_slug' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetChapterImageUsageQuery, GetChapterImageUsageQueryVariables>
export const GetImageFileIdsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetImageFileIds' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'mimeType' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_like' },
                            value: { kind: 'StringValue', value: 'image/%', block: false },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetImageFileIdsQuery, GetImageFileIdsQueryVariables>
export const GetAllCategoriesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetAllCategories' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'categories' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'position' },
                      value: { kind: 'EnumValue', value: 'asc_nulls_last' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'title' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'position' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAllCategoriesQuery, GetAllCategoriesQueryVariables>
export const UpdateCategoryPositionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateCategoryPosition' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'position' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_categories' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'slug' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'position' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'position' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateCategoryPositionMutation,
  UpdateCategoryPositionMutationVariables
>
export const InsertCategoryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'InsertCategory' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insert_categories_one' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'object' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'slug' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'title' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InsertCategoryMutation, InsertCategoryMutationVariables>
export const UpdateCategoryTitleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateCategoryTitle' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_categories' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'slug' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'title' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateCategoryTitleMutation, UpdateCategoryTitleMutationVariables>
export const DeleteCategoryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteCategory' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'delete_categories' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'slug' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteCategoryMutation, DeleteCategoryMutationVariables>
export const GetMatchingQuestionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetMatchingQuestions' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'matching_question_with_chapter' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'answer_key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'article_slugs' } },
                { kind: 'Field', name: { kind: 'Name', value: 'criterion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'exclusive' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetMatchingQuestionsQuery, GetMatchingQuestionsQueryVariables>
export const GetArticlesForMappingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetArticlesForMapping' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'articles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ListValue',
                  values: [
                    {
                      kind: 'ObjectValue',
                      fields: [
                        {
                          kind: 'ObjectField',
                          name: { kind: 'Name', value: 'chapter_slug' },
                          value: { kind: 'EnumValue', value: 'asc' },
                        },
                      ],
                    },
                    {
                      kind: 'ObjectValue',
                      fields: [
                        {
                          kind: 'ObjectField',
                          name: { kind: 'Name', value: 'article_position' },
                          value: { kind: 'EnumValue', value: 'asc' },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'chapter_slug' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'chapters' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetArticlesForMappingQuery, GetArticlesForMappingQueryVariables>
export const UpsertMatchingQuestionChapterDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpsertMatchingQuestionChapter' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'answer_key' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'article_slugs' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'jsonb' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'criterion' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'jsonb' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'exclusive' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insert_matching_question_with_chapter_one' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'object' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'answer_key' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'answer_key' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'article_slugs' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'article_slugs' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'criterion' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'criterion' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'exclusive' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'exclusive' } },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'on_conflict' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'constraint' },
                      value: { kind: 'EnumValue', value: 'matching_question_with_chapter_pkey' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'update_columns' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          { kind: 'EnumValue', value: 'article_slugs' },
                          { kind: 'EnumValue', value: 'criterion' },
                          { kind: 'EnumValue', value: 'exclusive' },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'answer_key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'article_slugs' } },
                { kind: 'Field', name: { kind: 'Name', value: 'criterion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'exclusive' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpsertMatchingQuestionChapterMutation,
  UpsertMatchingQuestionChapterMutationVariables
>
export const GetArticleLinkTargetsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetArticleLinkTargets' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'chapters' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'chapter_position' },
                      value: { kind: 'EnumValue', value: 'asc_nulls_last' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'created_at' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'articles' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'order_by' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'article_position' },
                            value: { kind: 'EnumValue', value: 'asc' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetArticleLinkTargetsQuery, GetArticleLinkTargetsQueryVariables>
export const GetAllChaptersForPreviewDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetAllChaptersForPreview' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'chapters' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'chapter_position' },
                      value: { kind: 'EnumValue', value: 'asc_nulls_last' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'created_at' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChapterCoverFields' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hook' } },
                { kind: 'Field', name: { kind: 'Name', value: 'takeaway' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category_slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'content_type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'merken' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'articles' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hook' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'live' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'categories' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'position' },
                      value: { kind: 'EnumValue', value: 'asc_nulls_last' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'title' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChapterCoverFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'chapters' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'cover' },
            name: { kind: 'Name', value: 'articles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'article_position' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'image_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'image_alt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAllChaptersForPreviewQuery, GetAllChaptersForPreviewQueryVariables>
export const GetChapterWithArticlesForPreviewDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetChapterWithArticlesForPreview' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'chapters' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'slug' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChapterCoverFields' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hook' } },
                { kind: 'Field', name: { kind: 'Name', value: 'takeaway' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category_slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'content_type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slider' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'articles' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'order_by' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'article_position' },
                            value: { kind: 'EnumValue', value: 'asc' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'article_position' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'content_markdown' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sources' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'audio' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hook' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'takeaway' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'image_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'image_alt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'live' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sections' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'order_by' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'position' },
                                  value: { kind: 'EnumValue', value: 'asc' },
                                },
                              ],
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'ArticleSectionFields' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChapterCoverFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'chapters' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'cover' },
            name: { kind: 'Name', value: 'articles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'article_position' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'image_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'image_alt' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ArticleSectionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'article_sections' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'section_type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'topic' } },
          { kind: 'Field', name: { kind: 'Name', value: 'content_markdown' } },
          { kind: 'Field', name: { kind: 'Name', value: 'images' } },
          { kind: 'Field', name: { kind: 'Name', value: 'audio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'position' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetChapterWithArticlesForPreviewQuery,
  GetChapterWithArticlesForPreviewQueryVariables
>
export const GetChaptersWithCriteriaDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetChaptersWithCriteria' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'categories' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'position' },
                      value: { kind: 'EnumValue', value: 'asc_nulls_last' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'title' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'chapters' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'chapter_position' },
                      value: { kind: 'EnumValue', value: 'asc_nulls_last' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category_slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slider' } },
                { kind: 'Field', name: { kind: 'Name', value: 'baby_age_min_weeks' } },
                { kind: 'Field', name: { kind: 'Name', value: 'baby_age_max_weeks' } },
                { kind: 'Field', name: { kind: 'Name', value: 'selection_criterion' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'articles' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetChaptersWithCriteriaQuery, GetChaptersWithCriteriaQueryVariables>
export const UpdateChapterCriteriaDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateChapterCriteria' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'slider' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'baby_age_min_weeks' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'baby_age_max_weeks' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'selection_class' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'jsonb' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'selection_criterion' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'jsonb' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_chapters' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'slug' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'slider' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'slider' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'baby_age_min_weeks' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'baby_age_min_weeks' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'baby_age_max_weeks' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'baby_age_max_weeks' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'selection_class' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'selection_class' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'selection_criterion' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'selection_criterion' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateChapterCriteriaMutation, UpdateChapterCriteriaMutationVariables>
export const GetMidwifeAppointmentsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetMidwifeAppointments' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'midwife_user_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointments' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'midwife_user_id' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'start_time' } },
                { kind: 'Field', name: { kind: 'Name', value: 'end_time' } },
                { kind: 'Field', name: { kind: 'Name', value: 'patient_user_id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetMidwifeAppointmentsQuery, GetMidwifeAppointmentsQueryVariables>
export const InsertAppointmentsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'InsertAppointments' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'objects' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'appointments_insert_input' },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insert_appointments' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'objects' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'objects' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'returning' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InsertAppointmentsMutation, InsertAppointmentsMutationVariables>
export const DeleteAppointmentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteAppointment' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'delete_appointments_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteAppointmentMutation, DeleteAppointmentMutationVariables>
export const ReleaseAppointmentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ReleaseAppointment' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_appointments_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pk_columns' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'patient_user_id' },
                      value: { kind: 'NullValue' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'patient_user_id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ReleaseAppointmentMutation, ReleaseAppointmentMutationVariables>
export const GetConnectedMidwifeForBookingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetConnectedMidwifeForBooking' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user_profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'connected_midwife_id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetConnectedMidwifeForBookingQuery,
  GetConnectedMidwifeForBookingQueryVariables
>
export const GetMyBookedAppointmentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetMyBookedAppointment' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointments' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'patient_user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'start_time' } },
                { kind: 'Field', name: { kind: 'Name', value: 'end_time' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetMyBookedAppointmentQuery, GetMyBookedAppointmentQueryVariables>
export const BookAppointmentDirectDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BookAppointmentDirect' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'appointmentId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'patientUserId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_appointments_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pk_columns' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'appointmentId' } },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'patient_user_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'patientUserId' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'patient_user_id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BookAppointmentDirectMutation, BookAppointmentDirectMutationVariables>
export const CancelMyAppointmentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CancelMyAppointment' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'appointmentId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_appointments_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pk_columns' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'appointmentId' } },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'patient_user_id' },
                      value: { kind: 'NullValue' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'patient_user_id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CancelMyAppointmentMutation, CancelMyAppointmentMutationVariables>
export const EnsureUserProfileDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'EnsureUserProfile' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insert_user_profiles_one' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'object' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'on_conflict' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'constraint' },
                      value: { kind: 'EnumValue', value: 'user_profiles_user_id_key' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'update_columns' },
                      value: { kind: 'ListValue', values: [] },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EnsureUserProfileMutation, EnsureUserProfileMutationVariables>
export const ChatMessagesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'ChatMessages' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'patientUserId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'midwifeUserId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'chat_messages' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'patient_user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'patientUserId' },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'midwife_user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'midwifeUserId' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'created_at' },
                      value: { kind: 'EnumValue', value: 'desc' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'IntValue', value: '300' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sender_user_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'body' } },
                { kind: 'Field', name: { kind: 'Name', value: 'read_at' } },
                { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ChatMessagesSubscription, ChatMessagesSubscriptionVariables>
export const UnreadChatMessagesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'UnreadChatMessages' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'chat_messages' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sender_user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_neq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'read_at' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_is_null' },
                            value: { kind: 'BooleanValue', value: true },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'patient_user_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'midwife_user_id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UnreadChatMessagesSubscription,
  UnreadChatMessagesSubscriptionVariables
>
export const LatestChatMessagesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'LatestChatMessages' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'chat_messages' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'distinct_on' },
                value: { kind: 'EnumValue', value: 'patient_user_id' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ListValue',
                  values: [
                    {
                      kind: 'ObjectValue',
                      fields: [
                        {
                          kind: 'ObjectField',
                          name: { kind: 'Name', value: 'patient_user_id' },
                          value: { kind: 'EnumValue', value: 'asc' },
                        },
                      ],
                    },
                    {
                      kind: 'ObjectValue',
                      fields: [
                        {
                          kind: 'ObjectField',
                          name: { kind: 'Name', value: 'created_at' },
                          value: { kind: 'EnumValue', value: 'desc' },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'patient_user_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sender_user_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'body' } },
                { kind: 'Field', name: { kind: 'Name', value: 'read_at' } },
                { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LatestChatMessagesSubscription,
  LatestChatMessagesSubscriptionVariables
>
export const SendChatMessageAsWomanDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SendChatMessageAsWoman' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'body' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insert_chat_messages_one' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'object' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'body' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'body' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SendChatMessageAsWomanMutation,
  SendChatMessageAsWomanMutationVariables
>
export const SendChatMessageAsMidwifeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SendChatMessageAsMidwife' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'patientUserId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'body' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insert_chat_messages_one' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'object' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'patient_user_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'patientUserId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'body' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'body' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SendChatMessageAsMidwifeMutation,
  SendChatMessageAsMidwifeMutationVariables
>
export const MarkChatMessagesReadDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'MarkChatMessagesRead' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ids' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'readAt' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'timestamptz' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_chat_messages' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_in' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'ids' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'read_at' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'readAt' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'returning' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'read_at' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MarkChatMessagesReadMutation, MarkChatMessagesReadMutationVariables>
export const GetChatConnectionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetChatConnection' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user_profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'connected_midwife_id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetChatConnectionQuery, GetChatConnectionQueryVariables>
export const GetChatPartnerDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetChatPartner' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'users' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetChatPartnerQuery, GetChatPartnerQueryVariables>
export const GetChatPatientsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetChatPatients' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user_profiles' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'user_id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetChatPatientsQuery, GetChatPatientsQueryVariables>
export const LatestChatMessageWithMidwifeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'LatestChatMessageWithMidwife' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'midwifeUserId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'chat_messages' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'midwife_user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'midwifeUserId' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'created_at' },
                      value: { kind: 'EnumValue', value: 'desc' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sender_user_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'body' } },
                { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LatestChatMessageWithMidwifeSubscription,
  LatestChatMessageWithMidwifeSubscriptionVariables
>
export const FeedbackMessagesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'FeedbackMessages' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'memberUserId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'feedback_messages' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'member_user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'memberUserId' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'created_at' },
                      value: { kind: 'EnumValue', value: 'desc' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'IntValue', value: '300' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'is_from_member' } },
                { kind: 'Field', name: { kind: 'Name', value: 'body' } },
                { kind: 'Field', name: { kind: 'Name', value: 'read_at' } },
                { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FeedbackMessagesSubscription, FeedbackMessagesSubscriptionVariables>
export const UnreadFeedbackMessagesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'UnreadFeedbackMessages' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'fromMember' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'feedback_messages' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'is_from_member' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'fromMember' },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'read_at' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_is_null' },
                            value: { kind: 'BooleanValue', value: true },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'member_user_id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UnreadFeedbackMessagesSubscription,
  UnreadFeedbackMessagesSubscriptionVariables
>
export const LatestFeedbackMessagesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'LatestFeedbackMessages' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'feedback_messages' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'distinct_on' },
                value: { kind: 'EnumValue', value: 'member_user_id' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ListValue',
                  values: [
                    {
                      kind: 'ObjectValue',
                      fields: [
                        {
                          kind: 'ObjectField',
                          name: { kind: 'Name', value: 'member_user_id' },
                          value: { kind: 'EnumValue', value: 'asc' },
                        },
                      ],
                    },
                    {
                      kind: 'ObjectValue',
                      fields: [
                        {
                          kind: 'ObjectField',
                          name: { kind: 'Name', value: 'created_at' },
                          value: { kind: 'EnumValue', value: 'desc' },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'member_user_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'is_from_member' } },
                { kind: 'Field', name: { kind: 'Name', value: 'body' } },
                { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LatestFeedbackMessagesSubscription,
  LatestFeedbackMessagesSubscriptionVariables
>
export const SendFeedbackAsMemberDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SendFeedbackAsMember' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'body' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insert_feedback_messages_one' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'object' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'body' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'body' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SendFeedbackAsMemberMutation, SendFeedbackAsMemberMutationVariables>
export const SendFeedbackAsInstituteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SendFeedbackAsInstitute' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'memberUserId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'body' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insert_feedback_messages_one' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'object' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'member_user_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'memberUserId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'body' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'body' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SendFeedbackAsInstituteMutation,
  SendFeedbackAsInstituteMutationVariables
>
export const MarkFeedbackMessagesReadDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'MarkFeedbackMessagesRead' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ids' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'readAt' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'timestamptz' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_feedback_messages' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_in' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'ids' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'read_at' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'readAt' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'returning' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'read_at' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MarkFeedbackMessagesReadMutation,
  MarkFeedbackMessagesReadMutationVariables
>
export const GetFeedbackMembersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetFeedbackMembers' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'womenIds' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'users' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: '_or' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'defaultRole' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: '_eq' },
                                      value: {
                                        kind: 'StringValue',
                                        value: 'midwife',
                                        block: false,
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'id' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: '_in' },
                                      value: {
                                        kind: 'Variable',
                                        name: { kind: 'Name', value: 'womenIds' },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'defaultRole' } },
                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetFeedbackMembersQuery, GetFeedbackMembersQueryVariables>
export const GetFeedbackMemberDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetFeedbackMember' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'users' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'defaultRole' } },
                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetFeedbackMemberQuery, GetFeedbackMemberQueryVariables>
export const SaveProgressDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SaveProgress' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'chapterSlug' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'articleSlug' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'audioPosition' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insert_user_profiles_one' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'object' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'current_chapter_slug' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'chapterSlug' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'current_article_slug' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'articleSlug' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'current_audio_position' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'audioPosition' } },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'on_conflict' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'constraint' },
                      value: { kind: 'EnumValue', value: 'user_profiles_user_id_key' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'update_columns' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          { kind: 'EnumValue', value: 'current_chapter_slug' },
                          { kind: 'EnumValue', value: 'current_article_slug' },
                          { kind: 'EnumValue', value: 'current_audio_position' },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SaveProgressMutation, SaveProgressMutationVariables>
export const GetUserProgressDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetUserProgress' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user_profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'current_chapter_slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'current_article_slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'current_audio_position' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetUserProgressQuery, GetUserProgressQueryVariables>
export const GetLastReadingPositionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetLastReadingPosition' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user_profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'current_chapter_slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'current_article_slug' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetLastReadingPositionQuery, GetLastReadingPositionQueryVariables>
export const GetLearningProgressDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetLearningProgress' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'article_progress' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'article_slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'chapter_slug' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user_profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completed_chapters' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetLearningProgressQuery, GetLearningProgressQueryVariables>
export const MarkArticleCompleteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'MarkArticleComplete' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'articleSlug' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'chapterSlug' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insert_article_progress_one' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'object' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'article_slug' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'articleSlug' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'chapter_slug' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'chapterSlug' } },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'on_conflict' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'constraint' },
                      value: {
                        kind: 'EnumValue',
                        value: 'article_progress_user_id_article_slug_key',
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'update_columns' },
                      value: { kind: 'ListValue', values: [] },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'article_slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'chapter_slug' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MarkArticleCompleteMutation, MarkArticleCompleteMutationVariables>
export const SetCompletedChaptersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetCompletedChapters' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'chapters' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'jsonb' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insert_user_profiles_one' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'object' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'completed_chapters' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'chapters' } },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'on_conflict' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'constraint' },
                      value: { kind: 'EnumValue', value: 'user_profiles_user_id_key' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'update_columns' },
                      value: {
                        kind: 'ListValue',
                        values: [{ kind: 'EnumValue', value: 'completed_chapters' }],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completed_chapters' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SetCompletedChaptersMutation, SetCompletedChaptersMutationVariables>
export const AdvanceCurrentChapterDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AdvanceCurrentChapter' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'chapterSlug' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insert_user_profiles_one' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'object' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'current_chapter_slug' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'chapterSlug' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'current_article_slug' },
                      value: { kind: 'NullValue' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'current_audio_position' },
                      value: { kind: 'IntValue', value: '0' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'on_conflict' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'constraint' },
                      value: { kind: 'EnumValue', value: 'user_profiles_user_id_key' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'update_columns' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          { kind: 'EnumValue', value: 'current_chapter_slug' },
                          { kind: 'EnumValue', value: 'current_article_slug' },
                          { kind: 'EnumValue', value: 'current_audio_position' },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AdvanceCurrentChapterMutation, AdvanceCurrentChapterMutationVariables>
export const GetVorbereitungCourseDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetVorbereitungCourse' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'chapters' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'category_slug' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'StringValue', value: 'vorbereitung', block: false },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'articles' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'live' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: '_eq' },
                                  value: { kind: 'BooleanValue', value: true },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'chapter_position' },
                      value: { kind: 'EnumValue', value: 'asc_nulls_last' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'created_at' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hook' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChapterCoverFields' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'content_type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'merken' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'articles' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'order_by' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'article_position' },
                            value: { kind: 'EnumValue', value: 'asc' },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'where' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'live' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: '_eq' },
                                  value: { kind: 'BooleanValue', value: true },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hook' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sections' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'topic' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'categories' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'slug' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'StringValue', value: 'vorbereitung', block: false },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'title' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChapterCoverFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'chapters' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'cover' },
            name: { kind: 'Name', value: 'articles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'article_position' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'image_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'image_alt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetVorbereitungCourseQuery, GetVorbereitungCourseQueryVariables>
export const GetDiscoverChaptersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetDiscoverChapters' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'chapters' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'chapter_position' },
                      value: { kind: 'EnumValue', value: 'asc_nulls_last' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'created_at' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'articles' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'live' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: '_eq' },
                                  value: { kind: 'BooleanValue', value: true },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hook' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChapterCoverFields' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category_slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'content_type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'merken' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'articles' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'where' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'live' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: '_eq' },
                                  value: { kind: 'BooleanValue', value: true },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hook' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sections' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'topic' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'categories' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'position' },
                      value: { kind: 'EnumValue', value: 'asc_nulls_last' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'title' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'position' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChapterCoverFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'chapters' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'cover' },
            name: { kind: 'Name', value: 'articles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'article_position' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'image_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'image_alt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetDiscoverChaptersQuery, GetDiscoverChaptersQueryVariables>
export const GetMyTitlesChaptersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetMyTitlesChapters' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'chapters' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'chapter_position' },
                      value: { kind: 'EnumValue', value: 'asc_nulls_last' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'created_at' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'articles' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'live' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: '_eq' },
                                  value: { kind: 'BooleanValue', value: true },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChapterCoverFields' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'content_type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category_slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'merken' } },
                { kind: 'Field', name: { kind: 'Name', value: 'merken_at' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'articles' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'where' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'live' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: '_eq' },
                                  value: { kind: 'BooleanValue', value: true },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'order_by' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'article_position' },
                            value: { kind: 'EnumValue', value: 'asc_nulls_last' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'image_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'image_alt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'article_position' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sections' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'topic' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'categories' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'position' },
                      value: { kind: 'EnumValue', value: 'asc_nulls_last' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'title' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChapterCoverFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'chapters' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'cover' },
            name: { kind: 'Name', value: 'articles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'article_position' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'image_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'image_alt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetMyTitlesChaptersQuery, GetMyTitlesChaptersQueryVariables>
export const GetSliderChaptersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetSliderChapters' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'chapters' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'chapter_position' },
                      value: { kind: 'EnumValue', value: 'asc_nulls_last' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'created_at' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'articles' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'live' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: '_eq' },
                                  value: { kind: 'BooleanValue', value: true },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hook' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChapterCoverFields' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'content_type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category_slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slider' } },
                { kind: 'Field', name: { kind: 'Name', value: 'merken' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'articles' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'where' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'live' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: '_eq' },
                                  value: { kind: 'BooleanValue', value: true },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hook' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sections' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'topic' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChapterCoverFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'chapters' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'cover' },
            name: { kind: 'Name', value: 'articles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'article_position' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'image_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'image_alt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetSliderChaptersQuery, GetSliderChaptersQueryVariables>
export const GetAllChapterSlugsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetAllChapterSlugs' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'chapters' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'chapter_position' },
                      value: { kind: 'EnumValue', value: 'asc_nulls_last' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'articles' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'live' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: '_eq' },
                                  value: { kind: 'BooleanValue', value: true },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category_slug' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAllChapterSlugsQuery, GetAllChapterSlugsQueryVariables>
export const GetChapterSlugsForReadingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetChapterSlugsForReading' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'chapters' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'chapter_position' },
                      value: { kind: 'EnumValue', value: 'asc_nulls_last' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'articles' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'live' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: '_eq' },
                                  value: { kind: 'BooleanValue', value: true },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetChapterSlugsForReadingQuery,
  GetChapterSlugsForReadingQueryVariables
>
export const GetChapterWithArticlesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetChapterWithArticles' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'chapters' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'slug' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hook' } },
                { kind: 'Field', name: { kind: 'Name', value: 'takeaway' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChapterCoverFields' } },
                { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'articles' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'order_by' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'article_position' },
                            value: { kind: 'EnumValue', value: 'asc' },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'where' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'live' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: '_eq' },
                                  value: { kind: 'BooleanValue', value: true },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'article_position' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hook' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'takeaway' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sections' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'topic' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChapterCoverFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'chapters' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'cover' },
            name: { kind: 'Name', value: 'articles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'article_position' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'image_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'image_alt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetChapterWithArticlesQuery, GetChapterWithArticlesQueryVariables>
export const GetChapterArticlesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetChapterArticles' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'chapterSlug' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'chapters' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'slug' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'chapterSlug' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hook' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'merken' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'articles' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'order_by' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'article_position' },
                            value: { kind: 'EnumValue', value: 'asc' },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'where' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'live' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: '_eq' },
                                  value: { kind: 'BooleanValue', value: true },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'content_markdown' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sources' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'audio' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'article_position' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hook' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'takeaway' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'image_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'image_alt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sections' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'order_by' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'position' },
                                  value: { kind: 'EnumValue', value: 'asc' },
                                },
                              ],
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'ArticleSectionFields' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ArticleSectionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'article_sections' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'section_type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'topic' } },
          { kind: 'Field', name: { kind: 'Name', value: 'content_markdown' } },
          { kind: 'Field', name: { kind: 'Name', value: 'images' } },
          { kind: 'Field', name: { kind: 'Name', value: 'audio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'position' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetChapterArticlesQuery, GetChapterArticlesQueryVariables>
export const GetShortChapterArticlesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetShortChapterArticles' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'chapters' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'slug' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'articles' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'order_by' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'article_position' },
                            value: { kind: 'EnumValue', value: 'asc' },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'where' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'live' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: '_eq' },
                                  value: { kind: 'BooleanValue', value: true },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ShortChapterArticleFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ArticleSectionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'article_sections' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'section_type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'topic' } },
          { kind: 'Field', name: { kind: 'Name', value: 'content_markdown' } },
          { kind: 'Field', name: { kind: 'Name', value: 'images' } },
          { kind: 'Field', name: { kind: 'Name', value: 'audio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'position' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ShortChapterArticleFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'articles' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'content_markdown' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sources' } },
          { kind: 'Field', name: { kind: 'Name', value: 'audio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          { kind: 'Field', name: { kind: 'Name', value: 'article_position' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hook' } },
          { kind: 'Field', name: { kind: 'Name', value: 'takeaway' } },
          { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sections' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'position' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ArticleSectionFields' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetShortChapterArticlesQuery, GetShortChapterArticlesQueryVariables>
export const GetShortChapterDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetShortChapter' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'chapters' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'slug' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hook' } },
                { kind: 'Field', name: { kind: 'Name', value: 'takeaway' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChapterCoverFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChapterCoverFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'chapters' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'cover' },
            name: { kind: 'Name', value: 'articles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'article_position' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'image_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'image_alt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetShortChapterQuery, GetShortChapterQueryVariables>
export const GetArticleVisibilityDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetArticleVisibilityData' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'matching_question_with_chapter' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'answer_key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'article_slugs' } },
                { kind: 'Field', name: { kind: 'Name', value: 'criterion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'exclusive' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'preparation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'miscarriage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'starchild' } },
                { kind: 'Field', name: { kind: 'Name', value: 'abortionmedical' } },
                { kind: 'Field', name: { kind: 'Name', value: 'abortioncriminal' } },
                { kind: 'Field', name: { kind: 'Name', value: 'adoption' } },
                { kind: 'Field', name: { kind: 'Name', value: 'induce' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sagging' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sharedcare' } },
                { kind: 'Field', name: { kind: 'Name', value: 'betterPre' } },
                { kind: 'Field', name: { kind: 'Name', value: 'personalreason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rawmilk' } },
                { kind: 'Field', name: { kind: 'Name', value: 'magnesium' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amalgam' } },
                { kind: 'Field', name: { kind: 'Name', value: 'piercing' } },
                { kind: 'Field', name: { kind: 'Name', value: 'herpes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fungus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'throat' } },
                { kind: 'Field', name: { kind: 'Name', value: 'diabetes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pcos' } },
                { kind: 'Field', name: { kind: 'Name', value: 'accessory' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contraindication' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sectio' } },
                { kind: 'Field', name: { kind: 'Name', value: 'preemie' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lkg' } },
                { kind: 'Field', name: { kind: 'Name', value: 'trisomie' } },
                { kind: 'Field', name: { kind: 'Name', value: 'drugs' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetArticleVisibilityDataQuery, GetArticleVisibilityDataQueryVariables>
export const UpdateChapterMerkenDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateChapterMerken' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'merken' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'merkenAt' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'timestamptz' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_chapters' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'merken' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'merken' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'merken_at' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'merkenAt' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'returning' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'merken' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'merken_at' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateChapterMerkenMutation, UpdateChapterMerkenMutationVariables>
export const SetMerkenForChaptersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetMerkenForChapters' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ids' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'merken' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'merkenAt' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'timestamptz' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_chapters' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_in' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'ids' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'merken' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'merken' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'merken_at' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'merkenAt' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'returning' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'merken' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'merken_at' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SetMerkenForChaptersMutation, SetMerkenForChaptersMutationVariables>
export const GetUsersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetUsers' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'users' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'defaultRole' } },
                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user_profile' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'paid' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetUsersQuery, GetUsersQueryVariables>
export const GetMidwifeCodeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetMidwifeCode' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'midwife_profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'midwife_code' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetMidwifeCodeQuery, GetMidwifeCodeQueryVariables>
export const GetConnectedPatientsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetConnectedPatients' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user_profiles' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'user_id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetConnectedPatientsQuery, GetConnectedPatientsQueryVariables>
export const GetPatientTrackingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetPatientTracking' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'user_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user_profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'user_id' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'qm_consent_at' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ai_consent_at' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tracking_birth' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'user_id' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'birth_date' } },
                { kind: 'Field', name: { kind: 'Name', value: 'birth_weight' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sex' } },
                { kind: 'Field', name: { kind: 'Name', value: 'bf_first_hour' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tracking_nursing' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'user_id' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'timestamp' },
                      value: { kind: 'EnumValue', value: 'desc' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'IntValue', value: '20' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duration_minutes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'side' } },
                { kind: 'Field', name: { kind: 'Name', value: 'position' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pain' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pain_level' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tracking_weight' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'user_id' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'timestamp' },
                      value: { kind: 'EnumValue', value: 'desc' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'IntValue', value: '10' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'weight_grams' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tracking_diaper' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'user_id' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'timestamp' },
                      value: { kind: 'EnumValue', value: 'desc' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'IntValue', value: '20' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'wet' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stool' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stool_color' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tracking_breast' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'user_id' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'timestamp' },
                      value: { kind: 'EnumValue', value: 'desc' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'IntValue', value: '10' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'side' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pain' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pain_level' } },
                { kind: 'Field', name: { kind: 'Name', value: 'engorgement' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lumps' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPatientTrackingQuery, GetPatientTrackingQueryVariables>
export const GetMidwifeProfileDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetMidwifeProfile' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'midwife_profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'midwife_code' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetMidwifeProfileQuery, GetMidwifeProfileQueryVariables>
export const GetQmEntriesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetQmEntries' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'qm_entries' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'created_at' },
                      value: { kind: 'EnumValue', value: 'desc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'structured_data' } },
                { kind: 'Field', name: { kind: 'Name', value: 'transcript' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetQmEntriesQuery, GetQmEntriesQueryVariables>
export const InsertQmEntryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'InsertQmEntry' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'category' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'structured_data' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'jsonb' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'transcript' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insert_qm_entries_one' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'object' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'category' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'category' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'structured_data' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'structured_data' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'transcript' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'transcript' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'status' },
                      value: { kind: 'StringValue', value: 'confirmed', block: false },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InsertQmEntryMutation, InsertQmEntryMutationVariables>
export const DeleteQmEntryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteQmEntry' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'delete_qm_entries_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteQmEntryMutation, DeleteQmEntryMutationVariables>
export const GetCompanionStateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetCompanionState' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tracking_birth' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user_profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'due_date' } },
                { kind: 'Field', name: { kind: 'Name', value: 'connected_midwife_id' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'preparation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCompanionStateQuery, GetCompanionStateQueryVariables>
export const UpsertDueDateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpsertDueDate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'dueDate' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'date' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insert_user_profiles_one' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'object' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'due_date' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'dueDate' } },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'on_conflict' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'constraint' },
                      value: { kind: 'EnumValue', value: 'user_profiles_user_id_key' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'update_columns' },
                      value: {
                        kind: 'ListValue',
                        values: [{ kind: 'EnumValue', value: 'due_date' }],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'due_date' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpsertDueDateMutation, UpsertDueDateMutationVariables>
export const GetConsentsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetConsents' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user_profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'qm_consent_at' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ai_consent_at' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetConsentsQuery, GetConsentsQueryVariables>
export const UpsertConsentsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpsertConsents' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'qmConsentAt' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'timestamptz' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'aiConsentAt' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'timestamptz' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insert_user_profiles_one' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'object' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'qm_consent_at' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'qmConsentAt' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ai_consent_at' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'aiConsentAt' } },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'on_conflict' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'constraint' },
                      value: { kind: 'EnumValue', value: 'user_profiles_user_id_key' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'update_columns' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          { kind: 'EnumValue', value: 'qm_consent_at' },
                          { kind: 'EnumValue', value: 'ai_consent_at' },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'qm_consent_at' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ai_consent_at' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpsertConsentsMutation, UpsertConsentsMutationVariables>
export const SaveBirthOnboardingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SaveBirthOnboarding' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'dueDate' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'date' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'birthDate' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'date' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'bornAt' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'timestamptz' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'birthWeight' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sex' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'bfFirstHour' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insert_user_profiles_one' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'object' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'due_date' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'dueDate' } },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'on_conflict' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'constraint' },
                      value: { kind: 'EnumValue', value: 'user_profiles_user_id_key' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'update_columns' },
                      value: {
                        kind: 'ListValue',
                        values: [{ kind: 'EnumValue', value: 'due_date' }],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'due_date' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insert_tracking_birth_one' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'object' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'birth_date' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'birthDate' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'born_at' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'bornAt' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'birth_weight' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'birthWeight' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sex' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'sex' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'bf_first_hour' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'bfFirstHour' } },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'on_conflict' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'constraint' },
                      value: { kind: 'EnumValue', value: 'tracking_birth_user_id_key' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'update_columns' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          { kind: 'EnumValue', value: 'birth_date' },
                          { kind: 'EnumValue', value: 'born_at' },
                          { kind: 'EnumValue', value: 'birth_weight' },
                          { kind: 'EnumValue', value: 'sex' },
                          { kind: 'EnumValue', value: 'bf_first_hour' },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SaveBirthOnboardingMutation, SaveBirthOnboardingMutationVariables>
export const GetPreparationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetPreparation' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'preparation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'miscarriage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'starchild' } },
                { kind: 'Field', name: { kind: 'Name', value: 'abortionmedical' } },
                { kind: 'Field', name: { kind: 'Name', value: 'abortioncriminal' } },
                { kind: 'Field', name: { kind: 'Name', value: 'adoption' } },
                { kind: 'Field', name: { kind: 'Name', value: 'induce' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sagging' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sharedcare' } },
                { kind: 'Field', name: { kind: 'Name', value: 'betterPre' } },
                { kind: 'Field', name: { kind: 'Name', value: 'personalreason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rawmilk' } },
                { kind: 'Field', name: { kind: 'Name', value: 'magnesium' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amalgam' } },
                { kind: 'Field', name: { kind: 'Name', value: 'piercing' } },
                { kind: 'Field', name: { kind: 'Name', value: 'herpes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fungus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'throat' } },
                { kind: 'Field', name: { kind: 'Name', value: 'diabetes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pcos' } },
                { kind: 'Field', name: { kind: 'Name', value: 'accessory' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contraindication' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sectio' } },
                { kind: 'Field', name: { kind: 'Name', value: 'preemie' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lkg' } },
                { kind: 'Field', name: { kind: 'Name', value: 'trisomie' } },
                { kind: 'Field', name: { kind: 'Name', value: 'drugs' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPreparationQuery, GetPreparationQueryVariables>
export const InsertPreparationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'InsertPreparation' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insert_preparation_one' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'object' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'status' },
                      value: { kind: 'StringValue', value: 'draft', block: false },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InsertPreparationMutation, InsertPreparationMutationVariables>
export const UpdatePreparationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdatePreparation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'set' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'preparation_set_input' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_preparation_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pk_columns' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'set' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdatePreparationMutation, UpdatePreparationMutationVariables>
export const GetUserPaidStatusDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetUserPaidStatus' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user_profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'paid' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetUserPaidStatusQuery, GetUserPaidStatusQueryVariables>
export const SetUserPaidDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetUserPaid' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insert_user_profiles_one' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'object' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'paid' },
                      value: { kind: 'BooleanValue', value: true },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'on_conflict' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'constraint' },
                      value: { kind: 'EnumValue', value: 'user_profiles_user_id_key' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'update_columns' },
                      value: { kind: 'ListValue', values: [{ kind: 'EnumValue', value: 'paid' }] },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'paid' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SetUserPaidMutation, SetUserPaidMutationVariables>
export const GetUserProfileDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetUserProfile' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user_profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'avatar_file_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'paid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'connected_midwife_id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetUserProfileQuery, GetUserProfileQueryVariables>
export const GetUserProfileInternalDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetUserProfileInternal' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user_profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'avatar_file_id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetUserProfileInternalQuery, GetUserProfileInternalQueryVariables>
export const UpsertUserProfileDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpsertUserProfile' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'avatarFileId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insert_user_profiles_one' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'object' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'avatar_file_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'avatarFileId' } },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'on_conflict' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'constraint' },
                      value: { kind: 'EnumValue', value: 'user_profiles_user_id_key' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'update_columns' },
                      value: {
                        kind: 'ListValue',
                        values: [{ kind: 'EnumValue', value: 'avatar_file_id' }],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'avatar_file_id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpsertUserProfileMutation, UpsertUserProfileMutationVariables>
export const GetBirthDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetBirthData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tracking_birth' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'birth_date' } },
                { kind: 'Field', name: { kind: 'Name', value: 'born_at' } },
                { kind: 'Field', name: { kind: 'Name', value: 'birth_weight' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sex' } },
                { kind: 'Field', name: { kind: 'Name', value: 'bf_first_hour' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetBirthDataQuery, GetBirthDataQueryVariables>
export const UpsertBirthDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpsertBirthData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'birthDate' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'date' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'bornAt' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'timestamptz' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'birthWeight' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sex' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'bfFirstHour' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insert_tracking_birth_one' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'object' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'birth_date' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'birthDate' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'born_at' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'bornAt' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'birth_weight' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'birthWeight' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sex' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'sex' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'bf_first_hour' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'bfFirstHour' } },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'on_conflict' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'constraint' },
                      value: { kind: 'EnumValue', value: 'tracking_birth_user_id_key' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'update_columns' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          { kind: 'EnumValue', value: 'birth_date' },
                          { kind: 'EnumValue', value: 'born_at' },
                          { kind: 'EnumValue', value: 'birth_weight' },
                          { kind: 'EnumValue', value: 'sex' },
                          { kind: 'EnumValue', value: 'bf_first_hour' },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpsertBirthDataMutation, UpsertBirthDataMutationVariables>
export const DeleteBirthDataAndTrackingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteBirthDataAndTracking' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'delete_tracking_nursing' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'delete_tracking_diaper' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'delete_tracking_breast' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'delete_tracking_weight' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'delete_tracking_substance' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'delete_tracking_mental_health' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'delete_tracking_tonguetie' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'delete_tracking_birth' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteBirthDataAndTrackingMutation,
  DeleteBirthDataAndTrackingMutationVariables
>
export const GetMidwifeByIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetMidwifeById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'users' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetMidwifeByIdQuery, GetMidwifeByIdQueryVariables>
export const GetMidwifeByCodeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetMidwifeByCode' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'code' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'midwife_profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'midwife_code' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'code' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'user_id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetMidwifeByCodeQuery, GetMidwifeByCodeQueryVariables>
export const UpdateConnectedMidwifeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateConnectedMidwife' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'midwifeId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_user_profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'connected_midwife_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'midwifeId' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'returning' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'connected_midwife_id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateConnectedMidwifeMutation,
  UpdateConnectedMidwifeMutationVariables
>
export const TogglePaidStatusDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'TogglePaidStatus' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'paid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insert_user_profiles_one' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'object' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'paid' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'paid' } },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'on_conflict' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'constraint' },
                      value: { kind: 'EnumValue', value: 'user_profiles_user_id_key' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'update_columns' },
                      value: { kind: 'ListValue', values: [{ kind: 'EnumValue', value: 'paid' }] },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'paid' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TogglePaidStatusMutation, TogglePaidStatusMutationVariables>
export const ClearCompletedChaptersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ClearCompletedChapters' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_user_profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'completed_chapters' },
                      value: { kind: 'ListValue', values: [] },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'returning' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'completed_chapters' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ClearCompletedChaptersMutation,
  ClearCompletedChaptersMutationVariables
>
export const UpdateUserNameDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateUserName' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'metadata' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'jsonb' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pk_columns' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'metadata' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'metadata' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateUserNameMutation, UpdateUserNameMutationVariables>
export const GetTrackingBirthDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetTrackingBirthData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'user_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tracking_birth' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'user_id' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'birth_date' } },
                { kind: 'Field', name: { kind: 'Name', value: 'born_at' } },
                { kind: 'Field', name: { kind: 'Name', value: 'birth_weight' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sex' } },
                { kind: 'Field', name: { kind: 'Name', value: 'bf_first_hour' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetTrackingBirthDataQuery, GetTrackingBirthDataQueryVariables>
export const GetPainAndBirthDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetPainAndBirthData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'user_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tracking_nursing' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'user_id' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'pain' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'BooleanValue', value: true },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'timestamp' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pain_level' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duration_minutes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'side' } },
                { kind: 'Field', name: { kind: 'Name', value: 'position' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tools' } },
                { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tracking_breast' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'user_id' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'pain' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'BooleanValue', value: true },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'timestamp' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pain_level' } },
                { kind: 'Field', name: { kind: 'Name', value: 'side' } },
                { kind: 'Field', name: { kind: 'Name', value: 'engorgement' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lumps' } },
                { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tracking_mental_health' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'user_id' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'timestamp' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'level' } },
                { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tracking_birth' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'user_id' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'birth_date' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPainAndBirthDataQuery, GetPainAndBirthDataQueryVariables>
export const GetWeightAndBirthDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetWeightAndBirthData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'user_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tracking_weight' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'user_id' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'timestamp' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'weight_grams' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tracking_birth' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'user_id' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'birth_date' } },
                { kind: 'Field', name: { kind: 'Name', value: 'birth_weight' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sex' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetWeightAndBirthDataQuery, GetWeightAndBirthDataQueryVariables>
export const GetBreastSideAndBirthDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetBreastSideAndBirthData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'user_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'since' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'timestamptz' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tracking_nursing' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'user_id' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'side' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_is_null' },
                            value: { kind: 'BooleanValue', value: false },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'timestamp' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_gte' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'since' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'timestamp' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'side' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tracking_breast' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'user_id' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'side' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_is_null' },
                            value: { kind: 'BooleanValue', value: false },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'timestamp' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_gte' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'since' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'timestamp' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'side' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tracking_birth' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'user_id' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'birth_date' } },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'lastNursingSide' },
            name: { kind: 'Name', value: 'tracking_nursing' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'user_id' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'side' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_is_null' },
                            value: { kind: 'BooleanValue', value: false },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'timestamp' },
                      value: { kind: 'EnumValue', value: 'desc' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'side' } },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'lastBreastSide' },
            name: { kind: 'Name', value: 'tracking_breast' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'user_id' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'side' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_is_null' },
                            value: { kind: 'BooleanValue', value: false },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'timestamp' },
                      value: { kind: 'EnumValue', value: 'desc' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'side' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetBreastSideAndBirthDataQuery,
  GetBreastSideAndBirthDataQueryVariables
>
export const GetNursingDiaperAndBirthDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetNursingDiaperAndBirthData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'user_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'since' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'timestamptz' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tracking_nursing' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'user_id' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'timestamp' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_gte' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'since' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'timestamp' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tracking_bottle' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'user_id' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'timestamp' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_gte' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'since' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'timestamp' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'milk_type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'milk_source' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tracking_diaper' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'user_id' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'timestamp' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_gte' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'since' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'timestamp' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tracking_birth' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'user_id' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'birth_date' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetNursingDiaperAndBirthDataQuery,
  GetNursingDiaperAndBirthDataQueryVariables
>
export const GetTrackingDashboardDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetTrackingDashboardData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'user_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'today_start' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'timestamptz' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'today_end' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'timestamptz' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'nursing_today' },
            name: { kind: 'Name', value: 'tracking_nursing' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'user_id' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'timestamp' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_gte' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'today_start' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_lte' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'today_end' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'pain_nursing' },
            name: { kind: 'Name', value: 'tracking_nursing' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'user_id' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'pain' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'BooleanValue', value: true },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'timestamp' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pain_level' } },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'pain_breast' },
            name: { kind: 'Name', value: 'tracking_breast' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'user_id' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'pain' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'BooleanValue', value: true },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'timestamp' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pain_level' } },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'weight_all' },
            name: { kind: 'Name', value: 'tracking_weight' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'user_id' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'timestamp' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'weight_grams' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'birth_data' },
            name: { kind: 'Name', value: 'tracking_birth' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'user_id' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'birth_weight' } },
                { kind: 'Field', name: { kind: 'Name', value: 'birth_date' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetTrackingDashboardDataQuery, GetTrackingDashboardDataQueryVariables>
export const GetBirthMilestoneDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetBirthMilestoneData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'user_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tracking_weight' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'user_id' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'timestamp' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'weight_grams' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tracking_tonguetie' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'user_id' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'timestamp' },
                      value: { kind: 'EnumValue', value: 'desc' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'consideration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'diagnosed' } },
                { kind: 'Field', name: { kind: 'Name', value: 'anterior' } },
                { kind: 'Field', name: { kind: 'Name', value: 'posterior' } },
                { kind: 'Field', name: { kind: 'Name', value: 'treated' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetBirthMilestoneDataQuery, GetBirthMilestoneDataQueryVariables>
export const GetMamaPainTodayDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetMamaPainTodayData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'user_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tracking_nursing' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'user_id' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'pain' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'BooleanValue', value: true },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'timestamp' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pain_level' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tracking_breast' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'user_id' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'pain' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'BooleanValue', value: true },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'timestamp' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pain_level' } },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'lastNursingSide' },
            name: { kind: 'Name', value: 'tracking_nursing' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'user_id' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'side' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_is_null' },
                            value: { kind: 'BooleanValue', value: false },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'timestamp' },
                      value: { kind: 'EnumValue', value: 'desc' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'side' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetMamaPainTodayDataQuery, GetMamaPainTodayDataQueryVariables>
export const GetNursingWeekDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetNursingWeekData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'user_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'since' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'timestamptz' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tracking_nursing' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'user_id' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'timestamp' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_gte' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'since' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetNursingWeekDataQuery, GetNursingWeekDataQueryVariables>
export const GetSubstancesAndToolsDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetSubstancesAndToolsData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'user_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'since' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'timestamptz' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tracking_substance' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'user_id' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'timestamp' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_gte' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'since' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tracking_nursing' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'user_id' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'timestamp' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_gte' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'since' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tools' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetSubstancesAndToolsDataQuery,
  GetSubstancesAndToolsDataQueryVariables
>
export const GetTrackingEventsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetTrackingEvents' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'user_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'since' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'timestamptz' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'until' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'timestamptz' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tracking_nursing' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'user_id' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'timestamp' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_gte' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'since' } },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_lte' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'until' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'timestamp' },
                      value: { kind: 'EnumValue', value: 'desc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duration_minutes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'side' } },
                { kind: 'Field', name: { kind: 'Name', value: 'position' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tools' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pain' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pain_level' } },
                { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tracking_weight' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'user_id' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'timestamp' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_gte' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'since' } },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_lte' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'until' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'timestamp' },
                      value: { kind: 'EnumValue', value: 'desc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'weight_grams' } },
                { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tracking_diaper' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'user_id' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'timestamp' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_gte' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'since' } },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_lte' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'until' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'timestamp' },
                      value: { kind: 'EnumValue', value: 'desc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'wet' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stool' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stool_color' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stool_consistency' } },
                { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tracking_breast' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'user_id' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'timestamp' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_gte' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'since' } },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_lte' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'until' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'timestamp' },
                      value: { kind: 'EnumValue', value: 'desc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'side' } },
                { kind: 'Field', name: { kind: 'Name', value: 'engorgement' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pain' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pain_level' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lumps' } },
                { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetTrackingEventsQuery, GetTrackingEventsQueryVariables>
export const GetSubstanceEventsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetSubstanceEvents' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'user_id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'since' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'timestamptz' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'until' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'timestamptz' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tracking_substance' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'user_id' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'timestamp' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_gte' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'since' } },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_lte' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'until' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'timestamp' },
                      value: { kind: 'EnumValue', value: 'desc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tracking_nursing' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'user_id' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'tools' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_is_null' },
                            value: { kind: 'BooleanValue', value: false },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'timestamp' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_gte' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'since' } },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_lte' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'until' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'timestamp' },
                      value: { kind: 'EnumValue', value: 'desc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tools' } },
                { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetSubstanceEventsQuery, GetSubstanceEventsQueryVariables>
export const InsertNursingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'InsertNursing' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'object' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'tracking_nursing_insert_input' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insert_tracking_nursing_one' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'object' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'object' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InsertNursingMutation, InsertNursingMutationVariables>
export const UpdateNursingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateNursing' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'timestamp' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'timestamptz' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'duration_minutes' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'side' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'position' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tools' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'jsonb' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pain' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pain_level' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'notes' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_tracking_nursing_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pk_columns' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'timestamp' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'timestamp' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'duration_minutes' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'duration_minutes' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'side' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'side' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'position' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'position' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'tools' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'tools' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'pain' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'pain' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'pain_level' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'pain_level' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'notes' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'notes' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duration_minutes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'side' } },
                { kind: 'Field', name: { kind: 'Name', value: 'position' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tools' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pain' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pain_level' } },
                { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateNursingMutation, UpdateNursingMutationVariables>
export const InsertWeightDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'InsertWeight' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'object' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'tracking_weight_insert_input' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insert_tracking_weight_one' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'object' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'object' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InsertWeightMutation, InsertWeightMutationVariables>
export const UpdateWeightDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateWeight' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'weight_grams' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'timestamp' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'timestamptz' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'notes' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_tracking_weight_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pk_columns' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'weight_grams' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'weight_grams' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'timestamp' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'timestamp' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'notes' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'notes' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'weight_grams' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateWeightMutation, UpdateWeightMutationVariables>
export const InsertDiaperDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'InsertDiaper' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'object' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'tracking_diaper_insert_input' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insert_tracking_diaper_one' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'object' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'object' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InsertDiaperMutation, InsertDiaperMutationVariables>
export const InsertBreastDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'InsertBreast' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'object' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'tracking_breast_insert_input' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insert_tracking_breast_one' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'object' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'object' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InsertBreastMutation, InsertBreastMutationVariables>
export const UpdateBreastDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateBreast' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'timestamp' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'timestamptz' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'side' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'engorgement' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pain' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pain_level' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'lumps' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'notes' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_tracking_breast_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pk_columns' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'timestamp' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'timestamp' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'side' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'side' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'engorgement' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'engorgement' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'pain' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'pain' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'pain_level' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'pain_level' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'lumps' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'lumps' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'notes' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'notes' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'side' } },
                { kind: 'Field', name: { kind: 'Name', value: 'engorgement' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pain' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pain_level' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lumps' } },
                { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateBreastMutation, UpdateBreastMutationVariables>
export const InsertSubstanceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'InsertSubstance' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'object' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'tracking_substance_insert_input' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insert_tracking_substance_one' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'object' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'object' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InsertSubstanceMutation, InsertSubstanceMutationVariables>
export const InsertMentalHealthDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'InsertMentalHealth' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'object' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'tracking_mental_health_insert_input' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insert_tracking_mental_health_one' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'object' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'object' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InsertMentalHealthMutation, InsertMentalHealthMutationVariables>
export const UpdateMentalHealthDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateMentalHealth' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'timestamp' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'timestamptz' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'level' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'notes' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_tracking_mental_health_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pk_columns' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'timestamp' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'timestamp' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'level' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'level' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'notes' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'notes' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'level' } },
                { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateMentalHealthMutation, UpdateMentalHealthMutationVariables>
export const InsertTongueTieDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'InsertTongueTie' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'object' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'tracking_tonguetie_insert_input' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insert_tracking_tonguetie_one' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'object' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'object' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InsertTongueTieMutation, InsertTongueTieMutationVariables>
export const UpdateTongueTieDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateTongueTie' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'timestamp' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'timestamptz' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'consideration' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'diagnosed' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'anterior' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'posterior' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'treated' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'treated_by' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'notes' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_tracking_tonguetie_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pk_columns' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'timestamp' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'timestamp' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'consideration' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'consideration' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'diagnosed' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'diagnosed' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'anterior' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'anterior' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'posterior' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'posterior' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'treated' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'treated' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'treated_by' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'treated_by' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'notes' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'notes' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'consideration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'diagnosed' } },
                { kind: 'Field', name: { kind: 'Name', value: 'anterior' } },
                { kind: 'Field', name: { kind: 'Name', value: 'posterior' } },
                { kind: 'Field', name: { kind: 'Name', value: 'treated' } },
                { kind: 'Field', name: { kind: 'Name', value: 'treated_by' } },
                { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateTongueTieMutation, UpdateTongueTieMutationVariables>
export const DeleteNursingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteNursing' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'delete_tracking_nursing_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteNursingMutation, DeleteNursingMutationVariables>
export const DeleteWeightDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteWeight' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'delete_tracking_weight_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteWeightMutation, DeleteWeightMutationVariables>
export const DeleteDiaperDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteDiaper' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'delete_tracking_diaper_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteDiaperMutation, DeleteDiaperMutationVariables>
export const DeleteBreastDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteBreast' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'delete_tracking_breast_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteBreastMutation, DeleteBreastMutationVariables>
export const DeleteSubstanceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteSubstance' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'delete_tracking_substance_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteSubstanceMutation, DeleteSubstanceMutationVariables>
export const DeleteMentalHealthDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteMentalHealth' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'delete_tracking_mental_health_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteMentalHealthMutation, DeleteMentalHealthMutationVariables>
export const DeleteFutureWeightsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteFutureWeights' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ids' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'delete_tracking_weight' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_in' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'ids' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'returning' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteFutureWeightsMutation, DeleteFutureWeightsMutationVariables>
export const InsertBottleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'InsertBottle' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'object' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'tracking_bottle_insert_input' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insert_tracking_bottle_one' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'object' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'object' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InsertBottleMutation, InsertBottleMutationVariables>
export const GetReadingPreferencesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetReadingPreferences' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user_profiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hide_intro_sections' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hide_outro_sections' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetReadingPreferencesQuery, GetReadingPreferencesQueryVariables>
export const SetReadingPreferencesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetReadingPreferences' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'uuid' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'hideIntro' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'hideOutro' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insert_user_profiles_one' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'object' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'hide_intro_sections' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'hideIntro' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'hide_outro_sections' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'hideOutro' } },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'on_conflict' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'constraint' },
                      value: { kind: 'EnumValue', value: 'user_profiles_user_id_key' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'update_columns' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          { kind: 'EnumValue', value: 'hide_intro_sections' },
                          { kind: 'EnumValue', value: 'hide_outro_sections' },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hide_intro_sections' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hide_outro_sections' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SetReadingPreferencesMutation, SetReadingPreferencesMutationVariables>
